
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jhLgK", function(module, exports) {

$parcel$export(module.exports, "SearchResultsPage", function () { return $c8c5adfd0a9290d0$export$d52600bdf78c25ef; });

var $loA2J = parcelRequire("loA2J");

var $dyZbY = parcelRequire("dyZbY");

var $kex29 = parcelRequire("kex29");

var $cP0Yq = parcelRequire("cP0Yq");

var $kxMYq = parcelRequire("kxMYq");
const $c8c5adfd0a9290d0$export$d52600bdf78c25ef = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dyZbY.default), {
        name: "search-page",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cP0Yq.default), {
                isShowTryNowLink: true,
                isShowSearchButton: false,
                productKey: "search"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kxMYq.SearchTemplate), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kex29.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("kxMYq", function(module, exports) {

$parcel$export(module.exports, "SearchTemplate", function () { return $9a55afc0c7f82465$export$b55d021038bb528d; });
/* search-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $dFnC9 = parcelRequire("dFnC9");
var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $jFQmg = parcelRequire("jFQmg");

var $ih47h = parcelRequire("ih47h");

var $bQawl = parcelRequire("bQawl");

var $5ohHq = parcelRequire("5ohHq");

var $f7hB9 = parcelRequire("f7hB9");

var $gFK1O = parcelRequire("gFK1O");

var $9iWJ8 = parcelRequire("9iWJ8");

var $1MbAx = parcelRequire("1MbAx");

var $gAJUc = parcelRequire("gAJUc");

var $hrScA = parcelRequire("hrScA");

var $2G853 = parcelRequire("2G853");

var $2G4Ap = parcelRequire("2G4Ap");
parcelRequire("cr5Az");
var $5bIhp = parcelRequire("5bIhp");
const $9a55afc0c7f82465$var$ALGOLIA_SEARCH_INDEX_NAME_V3 = "www.atlassian.com.v3";
const $9a55afc0c7f82465$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 = "www.atlassian.com.v3-2";
const $9a55afc0c7f82465$var$ALGOLIA_DEV_SEARCH_INDEX_V3 = "www.atlassian.com.v3_dev";
const $9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_CATEGORY = "category";
const $9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_LOCALE = "locale";
const $9a55afc0c7f82465$export$45f7e7a192bc5fa5 = [
    "All",
    "Articles",
    "Developer Resources",
    "Events",
    "Marketplace",
    "Purchasing FAQ"
];
const $9a55afc0c7f82465$export$97f3b895db7ef4f3 = (numResults, latestSearchText, currFilter)=>{
    if (numResults === 0) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "wac.search.pages.num.results.zero",
        defaultMessage: "0 results for {latestSearchText}. Try again with a different term.",
        values: {
            latestSearchText: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
    else if (numResults === 1) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "wac.search.pages.num.results.one",
        defaultMessage: "{numResults} result for {latestSearchText} in {currentFilter}",
        values: {
            numResults: numResults,
            latestSearchText: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
    else return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
        id: "wac.search.pages.num.results.many",
        defaultMessage: "{numResults} results for {latestSearchText} in {currentFilter}",
        values: {
            numResults: numResults,
            latestSearchText: /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
}; // eslint-disable-next-line complexity
const $9a55afc0c7f82465$export$b55d021038bb528d = ()=>{
    const [numberOfHits, setTotalNumberOfHits] = (0, $iSvIT.useState)(0);
    const [hits, setHits] = (0, $iSvIT.useState)([]);
    const [searchText, setSearchText] = (0, $iSvIT.useState)("");
    const [latestSearchText, setLatestSearchText] = (0, $iSvIT.useState)("");
    const [searchState, setSearchState] = (0, $iSvIT.useState)(null);
    const [currFilter, setCurrFilter] = (0, $iSvIT.useState)("All");
    const [facetValues, setFacetValues] = (0, $iSvIT.useState)({});
    const searchHelper = (0, $iSvIT.useRef)();
    const analyticsClient = (0, $jFQmg.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [queryId, setQueryId] = (0, $iSvIT.useState)("");
    const [isActive, setIsActive] = (0, $iSvIT.useState)(false);
    const searchInputRef = (0, $iSvIT.useRef)(null);
    const handleFocus = ()=>setIsActive(true);
    const handleBlur = ()=>setIsActive(false);
    const handleChange = (e)=>{
        setSearchText(e.target.value);
    };
    const handleClear = ()=>{
        setSearchText("");
        setIsActive(false);
    };
    const wacAISearchSummaryExperiment = (0, $9iWJ8.useExperiment)((0, $9iWJ8.experiments).wacAISearchSummary);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment.type === "enrolled" && wacAISearchSummaryExperiment.value;
    const { fireUIEvent: fireUIEvent } = (0, $ih47h.useFireAnalyticsEvents)();
    const intl = (0, $f6qj2.default)(); // Use ref to track current fireUIEvent to avoid recreating SearchHelper
    const fireUIEventRef = (0, $iSvIT.useRef)(fireUIEvent);
    fireUIEventRef.current = fireUIEvent;
    const isSearchIndexV3_2Enabled = (0, $hrScA.checkFeatureFlagGate)((0, $gAJUc.featureFlags).wacSearchIndexV3_2);
    const searchIndex = isSearchIndexV3_2Enabled ? $9a55afc0c7f82465$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 : $9a55afc0c7f82465$var$ALGOLIA_SEARCH_INDEX_NAME_V3;
    const facets = [
        $9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_CATEGORY,
        $9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_LOCALE
    ];
    (0, $1MbAx.useFeatureExposed)("wac-search-indexv3", "Test");
    (0, $iSvIT.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            eventName: "searchText",
            eventType: "track",
            action: "loaded",
            actionSubject: "searchPage",
            actionSubjectId: "searchPageForm",
            source: "searchPage",
            eventContainer: "load",
            attributes: {
                searchText: searchText,
                product: "search",
                index: {
                    searchIndex: searchIndex
                }
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    (0, $iSvIT.useEffect)(()=>{
        var _searchHelper_current;
        searchHelper.current = new (0, $2G4Ap.SearchHelper)(searchIndex, facets); // TODO: fetch filter category names from Algolia instead of hard-coding
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.receiveUpdate((results)=>{
            const numberOfHits = results.nbHits;
            const localHits = results.hits.map((hit)=>{
                return (0, $6iHNw._)((0, $7Knp0._)({}, hit), {
                    queryID: results.queryID
                });
            });
            const hasNextPage = results.nbPages - 1 > results.page;
            const queryId = results.queryID;
            const facetValuesResponse = results.getFacetValues($9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_CATEGORY, {}); // check if this is a filtered
            const refinements = results.getRefinements() || [];
            const isUsingFilter = !!refinements.find((refinement)=>refinement.attributeName === "category"); // don't reset filter values if an existing search is just being filtered
            if (Array.isArray(facetValuesResponse) && !isUsingFilter) {
                let newFacetValuesState = {};
                facetValuesResponse.forEach((result)=>{
                    newFacetValuesState = (0, $6iHNw._)((0, $7Knp0._)({}, newFacetValuesState), {
                        [result.name]: result.count
                    });
                });
                setFacetValues(newFacetValuesState);
            }
            if (hasNextPage) setSearchState("hasMoreResult");
            else if (localHits.length === 0) setSearchState("noResult");
            else setSearchState("hasResult");
            setTotalNumberOfHits(numberOfHits);
            setHits((prevResult)=>[
                    ...prevResult,
                    ...localHits
                ]);
            setQueryId(queryId); // Use ref to get the current fireUIEvent function
            fireUIEventRef.current({
                eventName: "searchResultsPopulated",
                eventType: "ui",
                action: "populated",
                actionSubject: "searchResults",
                source: "searchPage",
                eventContainer: "searchResults",
                attributes: {
                    resultsCount: numberOfHits,
                    searchQuery: results.query || latestSearchText,
                    queryId: results.queryID,
                    currentFilter: currFilter,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            });
        }); // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        window.addEventListener("popstate", ()=>{
            setSearchResults();
        });
        setSearchResults(); // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setSearchResults = ()=>{
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const searchParam = params.get("q");
        const facet = params.get("f") || ""; // if facet it present on original page load, set a facetValue so that it displays in filters
        if (facet) setFacetValues({
            [facet]: 1
        });
        if (searchParam) {
            var _searchHelper_current;
            const filter = facet ? facet : "All";
            resetState(searchParam, filter);
            const keywordSearchQuery = isAISearchSummaryEnabled ? ((_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.getNamedEntityQuery(searchParam)) || searchParam : searchParam;
            triggerSearch(filter, keywordSearchQuery);
            createAnalyticsEvent({
                eventName: "browserButton",
                eventType: "ui",
                action: "clicked",
                actionSubject: "browserButton",
                source: "searchPage",
                eventContainer: "browser",
                attributes: {
                    searchText: searchParam,
                    keywordSearchQuery: keywordSearchQuery,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            }).fire();
        }
    };
    function resetState(searchParam, filter) {
        setHits([]);
        setSearchState("loading");
        setSearchText(searchParam);
        setLatestSearchText(searchParam);
        setCurrFilter(filter);
    }
    function triggerSearch(filter, searchParam) {
        var _searchHelper_current, _searchHelper_current1, _searchHelper_current2, _searchHelper_current3, _searchHelper_current4;
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.removeFacet($9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_CATEGORY);
        (_searchHelper_current1 = searchHelper.current) === null || _searchHelper_current1 === void 0 ? void 0 : _searchHelper_current1.setQuery(searchParam);
        (_searchHelper_current2 = searchHelper.current) === null || _searchHelper_current2 === void 0 ? void 0 : _searchHelper_current2.setFacet($9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_LOCALE, intl.locale || "en");
        if (filter && filter != "All") (_searchHelper_current3 = searchHelper.current) === null || _searchHelper_current3 === void 0 ? void 0 : _searchHelper_current3.setFacet($9a55afc0c7f82465$var$ALGOLIA_FACET_KEY_CATEGORY, filter);
        (_searchHelper_current4 = searchHelper.current) === null || _searchHelper_current4 === void 0 ? void 0 : _searchHelper_current4.search();
    }
    function onSearch(filter) {
        if (searchText) {
            var _searchHelper_current;
            if (!filter) filter = "All";
            resetState(searchText, filter);
            const keywordSearchQuery = isAISearchSummaryEnabled ? ((_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.getNamedEntityQuery(searchText)) || searchText : searchText;
            triggerSearch(filter, keywordSearchQuery);
            setLatestSearchText(searchText);
            if (filter && filter != "All") window.history.pushState({}, "", `?q=${searchText}&f=${filter}`);
            else window.history.pushState({}, "", `?q=${searchText}`);
            createAnalyticsEvent({
                eventName: "searchText",
                eventType: "ui",
                action: "submitted",
                actionSubject: "searchInput",
                actionSubjectId: "searchPageForm",
                source: "searchPage",
                eventContainer: "searchInput",
                attributes: {
                    searchText: searchText,
                    keywordSearchQuery: keywordSearchQuery,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            }).fire();
            if (searchInputRef.current) searchInputRef.current.blur();
        }
        setIsActive(true);
    }
    const renderClearButton = ()=>{
        if (searchText) return /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
            onClick: handleClear,
            "aria-label": "Clear search suggestions",
            "data-testid": "clear-search-button",
            className: (0, $esG4f.default)([
                "_kqswstnw _1xi24bvh _154i1ssb _t9ec1i34 _bfhk1j28 _19itglyw _syaz1hap _80omtlke _1wybf6fq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbdlk8 _4t3idlk8 _2rko1ssb"
            ]),
            style: {
                "--_k3797e": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light700"))
            },
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1bsbyh40 _4t3idlk8 _bfhk1hlo _2rkot94y",
                        "_t9ecjyd4"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    }
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_kqswstnw _1bsbyh40 _4t3idlk8 _bfhk1hlo _2rkot94y",
                        "_t9eczk8b"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    }
                })
            ]
        });
        return null;
    };
    function gotoNextPage() {
        var _searchHelper_current;
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.goToNextPage();
    }
    function onSearchLinkClick(objectId, position) {
        var _searchHelper_current;
        const anonymousId = (0, $gFK1O.Cookie).readCookie("ajs_anonymous_id");
        let decodedAnonymousId;
        if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
        decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.sendClickEvent({
            objectId: objectId,
            position: position,
            queryId: queryId,
            userToken: decodedAnonymousId
        });
    }
    const translated = {
        searchAtlassian: intl.formatMessage({
            id: "wac.search.pages.search.atlassian",
            defaultMessage: "Search Atlassian"
        }),
        submitSearch: intl.formatMessage({
            id: "wac.search.pages.submit",
            defaultMessage: "Submit"
        }),
        viewMore: intl.formatMessage({
            id: "wac.search.pages.view.more",
            defaultMessage: "View more"
        }),
        endOfResults: intl.formatMessage({
            id: "wac.search.pages.end.of.result",
            defaultMessage: "End of results"
        })
    };
    const filterTranslationMap = {
        "All": intl.formatMessage({
            id: "wac.search.pages.filter.all",
            defaultMessage: "All"
        }),
        "Articles": intl.formatMessage({
            id: "wac.search.pages.filter.developer.articles",
            defaultMessage: "Articles"
        }),
        "Developer Resources": intl.formatMessage({
            id: "wac.search.pages.filter.developer.resources",
            defaultMessage: "Developer Resources"
        }),
        "Events": intl.formatMessage({
            id: "wac.search.pages.filter.events",
            defaultMessage: "Events"
        }),
        "Marketplace": intl.formatMessage({
            id: "wac.search.pages.filter.marketplace",
            defaultMessage: "Marketplace"
        }),
        "Purchasing FAQ": intl.formatMessage({
            id: "wac.search.pages.filter.purchasing.faq",
            defaultMessage: "Purchasing FAQ"
        })
    };
    const searchStateWithResultAndIsNotLoading = (searchState)=>{
        return searchState && searchState != "noResult" && searchState != "loading";
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_p12f4tsx _195g1wug _1tke8stt _1e0c1txw _o5kc1h6o",
            "ais-InstantSearch"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1rjczwfg _1bah1h6o _1bsbcv93 _1u2qftgi _1rkb1sa4"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _4cvr1h6o _kqswh2mm _1bsb1osq _195ggktf _1s4p1wug"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        className: (0, $esG4f.default)([
                            "_vchhusvi _1e0c1txw _kqswh2mm _4cvr1h6o _1bsb1osq _y4ti14y2 _otyr19bv _ik7h13el _5m7p1osq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                type: "text",
                                value: searchText,
                                onChange: handleChange,
                                onFocus: handleFocus,
                                onBlur: handleBlur,
                                onKeyDown: (e)=>{
                                    if (e.key == "Enter") onSearch();
                                },
                                placeholder: intl.formatMessage({
                                    id: "wac.search.pages.placeholder",
                                    defaultMessage: "Search Keywords"
                                }),
                                "data-testid": "search-input",
                                className: (0, $esG4f.default)([
                                    "_19itglyw _4cvr1h6o _bfhk1hxd _1bsb1osq _2rko1ylp _1e0c1txw _vwz41x4e _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _u5f31ylp _4t3ior1b _1bah1yb4 _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _1wyb7vkz _k48p1nn1 _syaz5k8o _ect41kw7 _1n5ddoyu _13kcdlk8 _1irci2wt _dueq7vkz _1iaezwfg _1lh2gktf _858uxxzy"
                                ]),
                                style: {
                                    "--_1ntr8rj": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.dark200"))
                                }
                            }),
                            renderClearButton(),
                            /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                                type: "submit",
                                onClick: ()=>onSearch(),
                                onKeyDown: (e)=>{
                                    if (e.key == "Enter") onSearch();
                                },
                                "aria-label": translated.submitSearch,
                                "data-testid": "submit-search-button",
                                className: (0, $esG4f.default)([
                                    "_1wpz1h6o _bfhk1j28 _19itglyw _4t3izwfg _1bsbzwfg _1xi219bv _kqswstnw _154i1ssb _t9ec1i34 _d0altlke",
                                    isAISearchSummaryEnabled && "_vwz419bv _12l2ftgi"
                                ]),
                                children: isAISearchSummaryEnabled ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $f7hB9.default), {
                                    className: (0, $esG4f.default)([
                                        "_1bsbf6fq _4t3if6fq"
                                    ])
                                }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_4t3if6fq _1bsbf6fq _2rko1ssb _19it1axk _kqswstnw _1pfhzeo2 _ahbq1lpd _bfhk1j28",
                                                isActive ? "_19it8djs _syaz17la" : "_19ityxmz _syaz1hlo"
                                            ]),
                                            style: {
                                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue")),
                                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_kqswstnw _1bsb1v6z _4t3iyh40 _bfhk1hlo _t9ecjyd4 _1pfh1v6z _ahbqftgi _2rkoyh40",
                                                isActive && "_bfhk17la"
                                            ]),
                                            style: {
                                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black")),
                                                "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1bsb1osq _1e0c1txw _zulp7vkz _1n261g80 _n7zlglyw _n3td19bv _195ggktf _19pk14y2 _1rfm1wug",
                        !isAISearchSummaryEnabled && !!searchStateWithResultAndIsNotLoading(searchState) && "_n7zl5y0l"
                    ]),
                    style: {
                        "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                    },
                    children: !!searchStateWithResultAndIsNotLoading(searchState) && Object.entries(filterTranslationMap).map(([filterName, translatedFilterName])=>(facetValues.hasOwnProperty(filterName) || filterName === "All") && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                            onClick: ()=>{
                                onSearch(filterName);
                            },
                            className: (0, $esG4f.default)([
                                "_1e0c1txw _4cvr1h6o _4t3i14no _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _2rko53f4 _1dqoglyw _bfhk150w _80omtlke",
                                currFilter == filterName && "_bfhk1t97"
                            ]),
                            style: {
                                "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                            },
                            children: translatedFilterName
                        }, filterName))
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_195ggktf _1q51dlk8 _1bsb1osq _1rfm1wug"
                    ]),
                    children: [
                        isAISearchSummaryEnabled && latestSearchText !== "" && currFilter === "All" && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $2G853.AISummary), {
                                    query: latestSearchText
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                                    className: (0, $esG4f.default)([
                                        "_1pfh1ejb _6rth1ejb _19it5y0l"
                                    ]),
                                    style: {
                                        "--_8nj8hf": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light200"))
                                    }
                                })
                            ]
                        }),
                        searchState && searchState !== "loading" && $9a55afc0c7f82465$export$97f3b895db7ef4f3(numberOfHits, latestSearchText, currFilter),
                        hits.map(({ objectID: objectID, title: title, description: description, url: url, queryID: queryID }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5bIhp.Result), {
                                index: index,
                                title: title,
                                description: description,
                                href: url,
                                objectId: objectID,
                                queryId: queryID,
                                onSearchLinkClick: onSearchLinkClick,
                                isExperimentVariant: true
                            }, objectID)),
                        /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                            children: [
                                !!searchState && searchState != "loading" && (searchState === "hasMoreResult" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQawl.default), {
                                    text: translated.viewMore,
                                    inputType: "button",
                                    onClick: gotoNextPage,
                                    dataEventProps: {
                                        "data-event-component": "linkButton",
                                        "data-event-container": "supportSection",
                                        "data-product-key": "search",
                                        "data-label": "view-more",
                                        "data-event": "clicked"
                                    },
                                    "aria-label": translated.viewMore,
                                    className: (0, $esG4f.default)([
                                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _2rko1ylp _bfhkjk2v _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg"
                                    ]),
                                    style: {
                                        "--_1b67llw": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue700"))
                                    }
                                }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_19pk10yn _y3gn1h6o"
                                    ]),
                                    children: searchState && searchState != "noResult" && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        children: translated.endOfResults
                                    })
                                })),
                                searchState && searchState == "loading" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1bah1h6o _1mou12am"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                        className: (0, $esG4f.default)([
                                            "_1bsb1x4e _4t3i1x4e _19ithovc _179r1j28 _2rko1ssb _1e0c1o8l _kqswh2mm _y44vzg4r _aetrb3bt _18postnw _eq4311qw _3mxo1v6z _13pw17la _clh31p70"
                                        ]),
                                        style: {
                                            "--_1r6llbg": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.blue"))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* Styles */ const $9a55afc0c7f82465$var$containerCss = null;
const $9a55afc0c7f82465$var$searchContainerCss = null;
const $9a55afc0c7f82465$var$searchBarContainerCss = null;
const $9a55afc0c7f82465$var$searchInputContainerCss = null;
const $9a55afc0c7f82465$var$searchInputCss = null;
const $9a55afc0c7f82465$var$searchSubmitCss = null;
const $9a55afc0c7f82465$var$searchIconTopCss = null;
const $9a55afc0c7f82465$var$searchIconBottomCss = null;
const $9a55afc0c7f82465$var$searchIconDefaultColor = null;
const $9a55afc0c7f82465$var$searchIconActiveColor = null;
const $9a55afc0c7f82465$var$searchIconBottomActiveCss = null;
const $9a55afc0c7f82465$var$clearButtonCss = null;
const $9a55afc0c7f82465$var$lineCss = null;
const $9a55afc0c7f82465$var$line1Css = null;
const $9a55afc0c7f82465$var$line2Css = null;
const $9a55afc0c7f82465$var$spinnerContainerCss = null;
const $9a55afc0c7f82465$var$rotation = null;
const $9a55afc0c7f82465$var$spinnerCss = null;
const $9a55afc0c7f82465$var$endOfResultCss = null;
const $9a55afc0c7f82465$var$filtersContainerCss = null;
const $9a55afc0c7f82465$var$filtersContainerWithResultCss = null;
const $9a55afc0c7f82465$var$filterButtonsCss = null;
const $9a55afc0c7f82465$var$selectedFilterCss = null;
const $9a55afc0c7f82465$var$buttonCss = null;
const $9a55afc0c7f82465$var$resultsContainerCss = null;
const $9a55afc0c7f82465$var$aiEnabledSearchIconCss = null;
const $9a55afc0c7f82465$var$aiEnabledSearchButtonCss = null;

});
parcelRegister("2G853", function(module, exports) {

$parcel$export(module.exports, "AISummary", function () { return $e91a8a3d0ccf6f86$export$cf24cd585162fa67; });
/* ai-summary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $cGDYS = parcelRequire("cGDYS");

var $g9kzu = parcelRequire("g9kzu");

var $263ZO = parcelRequire("263ZO");

var $c7YE1 = parcelRequire("c7YE1");

var $3nnYi = parcelRequire("3nnYi");
const $e91a8a3d0ccf6f86$export$cf24cd585162fa67 = ({ query: query })=>{
    const csmAiBaseUrl = "https://www.atlassian.com/gateway/api";
    const cloudId = "9957edf0-7205-4ec3-bd4d-ff871e460fea";
    const agentId = "b4db6a3b-6006-37db-a214-0be400970e38";
    const [isLoading, setIsLoading] = (0, $iSvIT.useState)(true);
    const isFirstResponseRef = (0, $iSvIT.useRef)(true);
    const [showAdditionalSummary, setShowAdditionalSummary] = (0, $iSvIT.useState)(false);
    const [traceResponse, setTraceResponse] = (0, $iSvIT.useState)(undefined);
    const abortControllerRef = (0, $iSvIT.useRef)(null);
    const [aiSummary, setAiSummary] = (0, $iSvIT.useState)("");
    const [sources, setSources] = (0, $iSvIT.useState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const intl = (0, $f6qj2.default)(); // eslint-disable-next-line complexity
    const processLine = (0, $iSvIT.useCallback)((line)=>{
        try {
            var _parsed_message, _parsed_message1, _parsed_message2, _parsed_message3;
            const parsed = JSON.parse(line);
            if (parsed.type === "TRACE" && ((_parsed_message = parsed.message) === null || _parsed_message === void 0 ? void 0 : _parsed_message.content)) {
                // TRACE contains the initial loading messages
                let traceContent = parsed.message.content;
                if (traceContent.includes(": ")) traceContent = traceContent.split(": ")[1];
                if (traceContent.endsWith(".")) traceContent = traceContent.slice(0, -1);
                setTraceResponse(traceContent);
            } else if (parsed.type === "FINAL_RESPONSE" && (((_parsed_message1 = parsed.message) === null || _parsed_message1 === void 0 ? void 0 : _parsed_message1.sources) || ((_parsed_message2 = parsed.message) === null || _parsed_message2 === void 0 ? void 0 : _parsed_message2.message.sources))) {
                var _parsed_message4, _parsed_message_message, _parsed_message5;
                // FINAL_RESPONSE contains the entire summary, sources, and additional info LLM info
                const sources = ((_parsed_message4 = parsed.message) === null || _parsed_message4 === void 0 ? void 0 : _parsed_message4.sources) || ((_parsed_message5 = parsed.message) === null || _parsed_message5 === void 0 ? void 0 : (_parsed_message_message = _parsed_message5.message) === null || _parsed_message_message === void 0 ? void 0 : _parsed_message_message.sources);
                setSources(sources);
                setTraceResponse(undefined);
            } else if (parsed.type === "ANSWER_PART" && ((_parsed_message3 = parsed.message) === null || _parsed_message3 === void 0 ? void 0 : _parsed_message3.content)) {
                setAiSummary((prev)=>prev + parsed.message.content);
                setTraceResponse(undefined);
            }
        } catch (error) {
            console.warn("Failed to parse line as JSON:", line);
            setAiSummary((prev)=>prev + "\n" + line);
        }
    }, []);
    const fetchAISummary = (0, $iSvIT.useCallback)(// eslint-disable-next-line complexity
    async (query)=>{
        var _abortControllerRef_current;
        setIsLoading(true);
        setShowAdditionalSummary(false);
        setTraceResponse(undefined);
        setSources(undefined);
        setAiSummary("");
        (_abortControllerRef_current = abortControllerRef.current) === null || _abortControllerRef_current === void 0 ? void 0 : _abortControllerRef_current.abort();
        abortControllerRef.current = new AbortController();
        isFirstResponseRef.current = true;
        const queryWithUserContext = `${query} \n {"user_locale": "${intl.locale || "en"}"}`;
        let reader = null;
        try {
            var _abortControllerRef_current1;
            const uuid = (0, $cGDYS.default)();
            const response = await fetch(`${csmAiBaseUrl}/assist/csm/v2/chat/channel/${uuid}/message/stream`, {
                method: "POST",
                credentials: "omit",
                signal: (_abortControllerRef_current1 = abortControllerRef.current) === null || _abortControllerRef_current1 === void 0 ? void 0 : _abortControllerRef_current1.signal,
                headers: {
                    "x-cloudid": cloudId,
                    "x-product": "jira",
                    "x-experience-id": "csm-ai",
                    "content-type": "application/json;charset=UTF-8"
                },
                body: JSON.stringify({
                    content: {
                        version: 1,
                        type: "doc",
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        type: "text",
                                        text: queryWithUserContext
                                    }
                                ]
                            }
                        ]
                    },
                    recipient_agent_named_id: "atlassian_wac_agent",
                    agent_id: agentId,
                    mimeType: "text/adf",
                    store_message: false,
                    citations_enabled: true
                })
            });
            createAnalyticsEvent({
                eventName: "aiSummary",
                eventType: "track",
                action: "loaded",
                actionSubject: "searchAiSummary",
                actionSubjectId: "searchAiSummaryLoaded",
                source: "searchPage",
                eventContainer: "load",
                attributes: {
                    responseCode: response.status,
                    responseBodyAvailable: response.body ? true : false
                }
            }).fire();
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            if (!response.body) throw new Error("Response body is not available for streaming");
            reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";
            while(true){
                const { done: done, value: value } = await reader.read();
                if (done) {
                    if (buffer.trim()) {
                        processLine(buffer.trim());
                        setIsLoading(false);
                    }
                    break;
                }
                const chunk = decoder.decode(value, {
                    stream: true
                });
                buffer += chunk;
                const lines = buffer.split("\n");
                buffer = lines.pop() || "";
                for (const line of lines){
                    const trimmedLine = line.trim();
                    if (trimmedLine) {
                        processLine(trimmedLine);
                        setIsLoading(false);
                    }
                }
            }
        } catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") return;
            console.error("Error processing AI summary stream:", error);
            setAiSummary((prev)=>prev + "\nAtlassian Intelligence can't provide a response right now.");
        } finally{
            reader === null || reader === void 0 ? void 0 : reader.releaseLock();
            setIsLoading(false);
        }
    }, [
        createAnalyticsEvent,
        processLine
    ]);
    (0, $iSvIT.useEffect)(()=>{
        fetchAISummary(query);
    }, [
        query,
        fetchAISummary
    ]);
    const isLoadingOrTraceResponse = Boolean(isLoading || traceResponse);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3nnYi.AIAnswerSearchBorder), {
            isLoading: isLoadingOrTraceResponse,
            isStreaming: !!traceResponse,
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1yt4utpp _1bsb1osq _kqswh2mm"
                ]),
                children: [
                    isLoadingOrTraceResponse && /*#__PURE__*/ (0, $loA2J.jsx)((0, $c7YE1.AISummaryLoadingAnimation), {
                        traceResponse: traceResponse
                    }),
                    !isLoadingOrTraceResponse && /*#__PURE__*/ (0, $loA2J.jsx)((0, $263ZO.AISummaryAnswer), {
                        aiSummary: aiSummary,
                        sources: sources,
                        showAdditionalSummary: showAdditionalSummary,
                        setShowAdditionalSummary: setShowAdditionalSummary
                    })
                ]
            })
        })
    });
};
const $e91a8a3d0ccf6f86$var$aiSummaryBoxStyle = null;

});
parcelRegister("263ZO", function(module, exports) {

$parcel$export(module.exports, "AISummaryAnswer", function () { return $ec9698c9b8c7e14e$export$7df2d776cc7f9957; });
/* ai-summary-answer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $g9kzu = parcelRequire("g9kzu");

var $5XkWH = parcelRequire("5XkWH");

var $38C5g = parcelRequire("38C5g");

var $1lZ6p = parcelRequire("1lZ6p");

var $eG457 = parcelRequire("eG457");

var $7h0X3 = parcelRequire("7h0X3");

var $iSjV6 = parcelRequire("iSjV6");

var $fKhJX = parcelRequire("fKhJX");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $2lBNa = parcelRequire("2lBNa");

var $9qcBT = parcelRequire("9qcBT");
const $ec9698c9b8c7e14e$var$sourceIconStyle = null;
const $ec9698c9b8c7e14e$var$sourceIconTooltipStyle = null;
const $ec9698c9b8c7e14e$var$SourceIcon = ({ identifier: identifier, sources: sources })=>{
    var _sources_;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const handleClick = ()=>{
        var _sources_sourceIndex;
        const sourceIndex = identifier - 1; // Convert 1-based citation to 0-based array index
        if (sources && ((_sources_sourceIndex = sources[sourceIndex]) === null || _sources_sourceIndex === void 0 ? void 0 : _sources_sourceIndex.url)) {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "searchAiSummaryInlineSourceLink",
                source: "searchAiSummary",
                attributes: {
                    sourceIndex: sourceIndex,
                    sourceTitle: sources[sourceIndex].title,
                    sourceUrl: sources[sourceIndex].url
                }
            }).fire();
            window.open(sources[sourceIndex].url, "_blank", "noopener,noreferrer");
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1nu9 _11ko1nu9"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSjV6.default), {
            content: sources === null || sources === void 0 ? void 0 : (_sources_ = sources[identifier - 1]) === null || _sources_ === void 0 ? void 0 : _sources_.title,
            children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                onClick: handleClick,
                className: (0, $esG4f.default)([
                    "_19ityze2 _2rko1b66 _k48p8n31 _1wybutpp _1bsbf6fq _4t3if6fq _vwz4o7ao _1e0c1o8l _18zrt94y _y3gn1h6o _195gidpf _80omtlke _irr31ybm"
                ]),
                style: {
                    "--_o8nmkh": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue500")),
                    "--_1hkddbi": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue100"))
                },
                children: identifier
            })
        })
    });
};
const $ec9698c9b8c7e14e$var$StatusComponent = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($ec9698c9b8c7e14e$var$SourceIcon, {
        identifier: parseInt(props.text || "1", 10),
        sources: props.sources
    });
const $ec9698c9b8c7e14e$var$fullContent = null;
const $ec9698c9b8c7e14e$var$defaultContent = null;
const $ec9698c9b8c7e14e$var$blurOverlayStyle = null;
const $ec9698c9b8c7e14e$var$blurTextStyle = null;
const $ec9698c9b8c7e14e$var$aiSummaryFooterStyle = null;
const $ec9698c9b8c7e14e$var$aiSummaryFooterSectionStyle = null;
const $ec9698c9b8c7e14e$var$disclaimerTextStyle = null;
const $ec9698c9b8c7e14e$var$FeedbackThumpsUpIcon = (iconProps, feedbackState)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7h0X3))), (0, $6iHNw._)((0, $7Knp0._)({}, iconProps), {
        color: feedbackState === "thumbsUp" ? "var(--ds-icon-selected, #0C66E4)" : undefined
    }));
};
const $ec9698c9b8c7e14e$var$FeedbackThumpsDownIcon = (iconProps, feedbackState)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eG457))), (0, $6iHNw._)((0, $7Knp0._)({}, iconProps), {
        color: feedbackState === "thumbsDown" ? "var(--ds-icon-selected, #0C66E4)" : undefined
    }));
};
const $ec9698c9b8c7e14e$export$409c83e49353f3fb = ({ aiSummary: aiSummary })=>{
    const intl = (0, $f6qj2.default)();
    const href = (0, $3FBn4.useLocalizedHref)("/trust/atlassian-intelligence");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const aiDisclaimerText = intl.formatMessage({
        id: "ai.summary.answer.footer.disclaimer",
        defaultMessage: "Uses AI. Verify results."
    });
    const handleCopy = async ()=>{
        try {
            // Remove citation markers like [1], [2], etc. from the text
            const textToCopy = aiSummary.replace(/\[\d+\]/g, "").trim();
            await navigator.clipboard.writeText(textToCopy);
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };
    const thumbsUpText = intl.formatMessage({
        id: "ai.summary.answer.footer.thumbsUp",
        defaultMessage: "Good response"
    });
    const thumbsDownText = intl.formatMessage({
        id: "ai.summary.answer.footer.thumbsDown",
        defaultMessage: "Bad response"
    });
    const copyText = intl.formatMessage({
        id: "ai.summary.answer.footer.copy",
        defaultMessage: "Copy"
    });
    const [feedbackState, setFeedbackState] = (0, $iSvIT.useState)(null);
    const handleFeedbackClick = (event, state)=>{
        event.preventDefault();
        setFeedbackState(state);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "feedbackButton",
            actionSubjectId: "searchAiSummaryFeedbackClicked",
            source: "searchAiSummary",
            attributes: {
                feedback: state
            }
        }).fire();
    };
    (0, $iSvIT.useEffect)(()=>{
        (0, $fKhJX.Tracking).autoTrackLinks(true);
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _1yt41b66 _13t3183y"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1y6m _zulp1b66"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1lZ6p))), {
                        color: "var(--ds-icon-subtlest, #626F86)",
                        size: "medium",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                        text: aiDisclaimerText,
                        type: "anchor",
                        href: href,
                        ariaLabel: aiDisclaimerText,
                        anchorProps: {
                            target: "_blank"
                        },
                        dataEventProps: {
                            "data-product-key": "search",
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "searchAiSummary",
                            "data-label-english": "Uses AI"
                        },
                        className: (0, $esG4f.default)([
                            "_syaz131l _1wybdlk8"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _1bah1y6m _zulp1b66"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5XkWH.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$ec9698c9b8c7e14e$var$FeedbackThumpsUpIcon(iconProps, feedbackState),
                        label: thumbsUpText,
                        onClick: (event)=>handleFeedbackClick(event, "thumbsUp"),
                        isTooltipDisabled: false
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5XkWH.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$ec9698c9b8c7e14e$var$FeedbackThumpsDownIcon(iconProps, feedbackState),
                        label: thumbsDownText,
                        onClick: (event)=>handleFeedbackClick(event, "thumbsDown"),
                        isTooltipDisabled: false
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5XkWH.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($38C5g))),
                        label: copyText,
                        onClick: handleCopy,
                        isTooltipDisabled: false
                    })
                ]
            })
        ]
    });
};
const $ec9698c9b8c7e14e$var$dividerStyle = null;
const $ec9698c9b8c7e14e$var$markdownContainerStyle = null;
const $ec9698c9b8c7e14e$var$sourceStyle = null;
const $ec9698c9b8c7e14e$export$7df2d776cc7f9957 = ({ aiSummary: aiSummary, sources: sources, showAdditionalSummary: _showAdditionalSummary, setShowAdditionalSummary: _setShowAdditionalSummary })=>{
    const [isExpanded, setIsExpanded] = (0, $iSvIT.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $iSvIT.useState)(false);
    const contentRef = (0, $iSvIT.useRef)(null);
    const intl = (0, $f6qj2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const [selected, setSelected] = (0, $iSvIT.useState)(0);
    const setTab = (0, $iSvIT.useCallback)((index)=>{
        setSelected(index);
        if (index === 1) createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "tab",
            actionSubjectId: "searchAiSummarySourcesTabClicked",
            source: "searchAiSummary"
        }).fire();
    }, [
        setSelected,
        createAnalyticsEvent
    ]);
    const statusComponent = (0, $iSvIT.useCallback)((props)=>/*#__PURE__*/ (0, $loA2J.jsx)($ec9698c9b8c7e14e$var$StatusComponent, (0, $6iHNw._)((0, $7Knp0._)({}, props), {
            sources: sources
        })), [
        sources
    ]);
    const renderMarkdownContent = (text)=>{
        // Use the search-ai approach: encodeAdf + Atlaskit renderer
        // This handles both markdown formatting and citations properly
        return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_vt411ymi"
            ]),
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9qcBT.MarkdownRenderer), {
                answerString: text,
                statusComponent: statusComponent
            })
        });
    };
    (0, $iSvIT.useEffect)(()=>{
        if (!contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if (contentRef.current) {
                const wrapperHeight = contentRef.current.offsetHeight;
                const contentHeight = contentRef.current.scrollHeight;
                setIsTruncated(contentHeight > wrapperHeight);
            }
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        aiSummary
    ]);
    const handleToggleExpansion = ()=>{
        setIsExpanded(!isExpanded);
        createAnalyticsEvent({
            eventName: isExpanded ? "searchAiSummaryReadLessClicked" : "searchAiSummaryReadMoreClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: isExpanded ? "searchAiSummaryReadLess" : "searchAiSummaryReadMore",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                labelEnglish: isExpanded ? "Read less" : "Read more"
            }
        }).fire();
    };
    const handleSourceLinkClick = (source, index)=>{
        createAnalyticsEvent({
            eventName: "searchAiSummarySourceLinkClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "searchAiSummarySourceLink",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                sourceUrl: source.url,
                sourceTitle: source.title,
                sourceIndex: index
            }
        }).fire();
    };
    const readMoreText = intl.formatMessage({
        id: "ai.summary.answer.readMore",
        defaultMessage: "Read more"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2lBNa.AISummaryTabs), {
                answerPanel: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                        ref: contentRef,
                        className: (0, $esG4f.default)([
                            "_c71lbv7e _1reo15vq _18m915vq _kqswh2mm",
                            isExpanded && "_c71l1ns9"
                        ]),
                        children: [
                            renderMarkdownContent(aiSummary),
                            isTruncated && !isExpanded && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                className: (0, $esG4f.default)([
                                    "_11q7b662 _1bsb1osq _1e0c1txw _1bah1y6m _kqswstnw _152tnagk _80omtlke _85i51b66 _1q51xy5q _syaz1fxt"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                    onClick: handleToggleExpansion,
                                    href: "#",
                                    ignoreHref: true,
                                    text: readMoreText,
                                    ariaLabel: readMoreText,
                                    type: "anchor",
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1bah1y6m _y4ti1b66"
                                    ])
                                })
                            })
                        ]
                    })
                }),
                sourcesPanel: sources === null || sources === void 0 ? void 0 : sources.map((source, i)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        className: (0, $esG4f.default)([
                            "_1yt41bpf _k48pbfng _1joiidpf _81oiidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: i + 1 + ". " + source.title,
                            type: "primary",
                            href: source.url,
                            onClick: ()=>handleSourceLinkClick(source, i)
                        })
                    }, source.url)),
                selected: selected,
                onChange: setTab
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_179r1k0a _18s8zu5n"
                ]),
                style: {
                    "--_1lmj1bv": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light300"))
                }
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)($ec9698c9b8c7e14e$export$409c83e49353f3fb, {
                aiSummary: aiSummary
            })
        ]
    });
};

});
parcelRegister("38C5g", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $248fa91f827c5373$var$_react = $248fa91f827c5373$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $248fa91f827c5373$var$_baseNew = $248fa91f827c5373$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $248fa91f827c5373$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $248fa91f827c5373$var$CopyIcon = (props)=>/*#__PURE__*/ $248fa91f827c5373$var$_react.default.createElement($248fa91f827c5373$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$248fa91f827c5373$var$CopyIcon.displayName = "CopyIcon";
var $248fa91f827c5373$var$_default = module.exports.default = $248fa91f827c5373$var$CopyIcon;

});

parcelRegister("1lZ6p", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0fc726477ca8709d$var$_react = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $0fc726477ca8709d$var$_baseNew = $0fc726477ca8709d$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $0fc726477ca8709d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0fc726477ca8709d$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $0fc726477ca8709d$var$_react.default.createElement($0fc726477ca8709d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$0fc726477ca8709d$var$InformationCircleIcon.displayName = "InformationCircleIcon";
var $0fc726477ca8709d$var$_default = module.exports.default = $0fc726477ca8709d$var$InformationCircleIcon;

});

parcelRegister("eG457", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a6c601e24c01efd86daa4bd04d7c20b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaf8276d1e3488f3$var$_react = $aaf8276d1e3488f3$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $aaf8276d1e3488f3$var$_baseNew = $aaf8276d1e3488f3$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $aaf8276d1e3488f3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaf8276d1e3488f3$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $aaf8276d1e3488f3$var$_react.default.createElement($aaf8276d1e3488f3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.292 13.406a.5.5 0 0 0 .77-.15l2.438-4.69V2.5H4.128c-.492 0-.927.32-1.073.79L1.726 7.54A1.125 1.125 0 0 0 2.8 9h3.45a.75.75 0 0 1 .75.75v3.175a.5.5 0 0 0 .174.38zM12 2.5V8h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-.295 7-2.313 4.45a2 2 0 0 1-3.076.596l-.118-.101a2 2 0 0 1-.698-1.519V10.5H2.8A2.625 2.625 0 0 1 .295 7.092l1.328-4.25A2.625 2.625 0 0 1 4.128 1H14a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2z" clip-rule="evenodd"/>`
    }, props));
$aaf8276d1e3488f3$var$ThumbsDownIcon.displayName = "ThumbsDownIcon";
var $aaf8276d1e3488f3$var$_default = module.exports.default = $aaf8276d1e3488f3$var$ThumbsDownIcon;

});

parcelRegister("7h0X3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $54badbe44d1d0e08$var$_react = $54badbe44d1d0e08$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $54badbe44d1d0e08$var$_baseNew = $54badbe44d1d0e08$var$_interopRequireDefault((parcelRequire("2zXTv")));
function $54badbe44d1d0e08$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $54badbe44d1d0e08$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $54badbe44d1d0e08$var$_react.default.createElement($54badbe44d1d0e08$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$54badbe44d1d0e08$var$ThumbsUpIcon.displayName = "ThumbsUpIcon";
var $54badbe44d1d0e08$var$_default = module.exports.default = $54badbe44d1d0e08$var$ThumbsUpIcon;

});

parcelRegister("2lBNa", function(module, exports) {

$parcel$export(module.exports, "AISummaryTabs", function () { return $c5b312922e0a9894$export$681e2ecfbcedbb69; });
/* ai-summary-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $lD5of = parcelRequire("lD5of");
var $76h2Z = parcelRequire("76h2Z");
var $28wqY = parcelRequire("28wqY");
var $lnew6 = parcelRequire("lnew6");
const $c5b312922e0a9894$export$681e2ecfbcedbb69 = ({ answerPanel: answerPanel, sourcesPanel: sourcesPanel, selected: selected, onChange: onChange })=>{
    const intl = (0, $f6qj2.default)();
    const answerText = intl.formatMessage({
        id: "ai.summary.tabs.answer",
        defaultMessage: "AI Answer"
    });
    const sourcesText = intl.formatMessage({
        id: "ai.summary.tabs.sources",
        defaultMessage: "Sources"
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $lD5of.default), {
        id: "ai-summary-tabs",
        selected: selected,
        onChange: onChange,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $28wqY.default), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $76h2Z.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _1iqs1jhh _ect48q0o _1wyb7vkz _zg8l4jg8 _k48pl8b6 _vwz41tcg _1e0c1txw _ca0qidpf _u5f3ftgi _n3tdftgi _19bvftgi _zulp1b66"
                            ]),
                            children: answerText
                        })
                    }),
                    sourcesPanel && /*#__PURE__*/ (0, $loA2J.jsx)((0, $76h2Z.default), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_y3gn1h6o _1iqs1jhh _ect48q0o _1wyb7vkz _zg8l4jg8 _k48pl8b6 _vwz41tcg _1e0c1txw _ca0qidpf _u5f3ftgi _n3tdftgi _19bvftgi _zulp1b66"
                            ]),
                            children: sourcesText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $lnew6.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1bsb1osq _1q517vkz"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: answerPanel
                    })
                })
            }),
            sourcesPanel && /*#__PURE__*/ (0, $loA2J.jsx)((0, $lnew6.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1bsb1osq _1q517vkz"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: sourcesPanel
                    })
                })
            })
        ]
    });
};
const $c5b312922e0a9894$var$tabStyle = null;
const $c5b312922e0a9894$var$panelStyle = null;

});
parcelRegister("76h2Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52b65125f3d3cbb5$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $2ZUkg = parcelRequire("2ZUkg");

var $7oink = parcelRequire("7oink");

var $5zI8w = parcelRequire("5zI8w");

var $3l2qu = parcelRequire("3l2qu");
function $52b65125f3d3cbb5$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTab = (0, $3l2qu.useTab)(), onClick = _useTab.onClick, id = _useTab.id, ariaControls = _useTab["aria-controls"], ariaPosinset = _useTab["aria-posinset"], ariaSelected = _useTab["aria-selected"], ariaSetsize = _useTab["aria-setsize"], onMouseDown = _useTab.onMouseDown, onKeyDown = _useTab.onKeyDown, role = _useTab.role, tabIndex = _useTab.tabIndex;
    return (0, $2ZUkg.jsx)((0, $5zI8w.default), {
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onMouseDown: onMouseDown,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, (0, $2ZUkg.jsx)((0, $7oink.default), {
        shouldTruncate: true,
        UNSAFE_style: {
            color: "inherit"
        }
    }, children));
}

});
parcelRegister("5zI8w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f2753738c47ac8$export$2e2bcd8739ae039; });

var $f1EiB = parcelRequire("f1EiB");

var $8J0Sm = parcelRequire("8J0Sm");

var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $70YDI = parcelRequire("70YDI");

var $hA8ey = parcelRequire("hA8ey");

var $e3rTl = parcelRequire("e3rTl");
var $40f2753738c47ac8$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $40f2753738c47ac8$var$_excluded2 = [
    "className"
];
var $40f2753738c47ac8$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $8J0Sm.default)(_ref, $40f2753738c47ac8$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $8J0Sm.default)(htmlAttributes, $40f2753738c47ac8$var$_excluded2);
    var className = xcss && (0, $hA8ey.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $2ZUkg.jsx)(Component, (0, $f1EiB.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $40f2753738c47ac8$var$baseStyles,
            backgroundColor && (0, $70YDI.backgroundColorStylesMap)[backgroundColor],
            (0, $70YDI.isSurfaceColorToken)(backgroundColor) && (0, $70YDI.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $70YDI.paddingStylesMap).padding[padding],
            paddingBlock && (0, $70YDI.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $70YDI.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $70YDI.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $70YDI.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $70YDI.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $70YDI.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $2ZUkg.jsx)((0, $e3rTl.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $40f2753738c47ac8$export$2e2bcd8739ae039 = $40f2753738c47ac8$export$e71c4d32a2263218;
var $40f2753738c47ac8$var$baseStyles = (0, $2ZUkg.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("f1EiB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af063589980c80bd$export$2e2bcd8739ae039; });
function $af063589980c80bd$export$2e2bcd8739ae039() {
    return $af063589980c80bd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $af063589980c80bd$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("70YDI", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $51b7923d871fe7b5$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "spaceMap", function () { return $51b7923d871fe7b5$export$1f52408f03b1c9b4; });
$parcel$export(module.exports, "borderColorMap", function () { return $51b7923d871fe7b5$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $51b7923d871fe7b5$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "shadowMap", function () { return $51b7923d871fe7b5$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "textColorMap", function () { return $51b7923d871fe7b5$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $51b7923d871fe7b5$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $51b7923d871fe7b5$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $51b7923d871fe7b5$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $51b7923d871fe7b5$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $51b7923d871fe7b5$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $51b7923d871fe7b5$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $51b7923d871fe7b5$export$5e65a44e5b6ecadb; });

var $4J9Jx = parcelRequire("4J9Jx");

var $2ZUkg = parcelRequire("2ZUkg");

var $3JCeP = parcelRequire("3JCeP");
var $51b7923d871fe7b5$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $51b7923d871fe7b5$export$1f52408f03b1c9b4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $51b7923d871fe7b5$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $51b7923d871fe7b5$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $51b7923d871fe7b5$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $51b7923d871fe7b5$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $51b7923d871fe7b5$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $51b7923d871fe7b5$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)"
};
var $51b7923d871fe7b5$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $51b7923d871fe7b5$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $51b7923d871fe7b5$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $51b7923d871fe7b5$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $51b7923d871fe7b5$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $51b7923d871fe7b5$export$6cc560b4dedf3816 = {
    "font.size.050": "var(--ds-font-size-050, 11px)",
    "font.size.075": "var(--ds-font-size-075, 12px)",
    "font.size.100": "var(--ds-font-size-100, 14px)",
    "font.size.200": "var(--ds-font-size-200, 16px)",
    "font.size.300": "var(--ds-font-size-300, 20px)",
    "font.size.400": "var(--ds-font-size-400, 24px)",
    "font.size.500": "var(--ds-font-size-500, 29px)",
    "font.size.600": "var(--ds-font-size-600, 35px)"
};
var $51b7923d871fe7b5$export$303e322c6b1ed114 = {
    "font.weight.bold": "var(--ds-font-weight-bold, 700)",
    "font.weight.medium": "var(--ds-font-weight-medium, 500)",
    "font.weight.regular": "var(--ds-font-weight-regular, 400)",
    "font.weight.semibold": "var(--ds-font-weight-semibold, 600)"
};
var $51b7923d871fe7b5$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand": "var(--ds-font-family-brand, Charlie Sans)",
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.monospace": 'var(--ds-font-family-monospace, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.sans": 'var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif)'
};
var $51b7923d871fe7b5$export$360c29a380c1a34 = {
    "font.lineHeight.1": "var(--ds-font-lineHeight-1, 1)",
    "font.lineHeight.100": "var(--ds-font-lineHeight-100, 16px)",
    "font.lineHeight.200": "var(--ds-font-lineHeight-200, 20px)",
    "font.lineHeight.300": "var(--ds-font-lineHeight-300, 24px)",
    "font.lineHeight.400": "var(--ds-font-lineHeight-400, 28px)",
    "font.lineHeight.500": "var(--ds-font-lineHeight-500, 32px)",
    "font.lineHeight.600": "var(--ds-font-lineHeight-600, 40px)"
};
var $51b7923d871fe7b5$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    "body.large": "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    "body.small": "var(--ds-font-body-small, normal 400 11px/20px var(--ds-font-family-body))"
};
var $51b7923d871fe7b5$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    "ui.small": "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $51b7923d871fe7b5$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $51b7923d871fe7b5$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $2ZUkg.css)((0, $4J9Jx.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $51b7923d871fe7b5$export$e615f061ca585a6c = $51b7923d871fe7b5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $51b7923d871fe7b5$var$getSerializedStylesMap(spacingProperty, $51b7923d871fe7b5$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $51b7923d871fe7b5$export$bf46c3f9eeafc71f = $51b7923d871fe7b5$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $51b7923d871fe7b5$var$getSerializedStylesMap(spacingProperty, $51b7923d871fe7b5$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $51b7923d871fe7b5$export$e7af83bafe7f9e63 = $51b7923d871fe7b5$var$getSerializedStylesMap("backgroundColor", $51b7923d871fe7b5$export$d1d79bf68ac056bd);
var $51b7923d871fe7b5$export$3a1bcba60b23d7f0 = $51b7923d871fe7b5$var$getSerializedStylesMap("color", $51b7923d871fe7b5$export$8473307aa00d6ea1);
var $51b7923d871fe7b5$export$f7183c9e2dbc2543 = $51b7923d871fe7b5$var$getSerializedStylesMap("fontSize", $51b7923d871fe7b5$export$6cc560b4dedf3816);
var $51b7923d871fe7b5$export$45f3f4fe16f9f7d5 = $51b7923d871fe7b5$var$getSerializedStylesMap("fontWeight", $51b7923d871fe7b5$export$303e322c6b1ed114);
var $51b7923d871fe7b5$export$68cc305da27dbaa4 = $51b7923d871fe7b5$var$getSerializedStylesMap("fontFamily", $51b7923d871fe7b5$export$3c7e9587132614b4);
var $51b7923d871fe7b5$export$8be4a21014f48eb1 = $51b7923d871fe7b5$var$getSerializedStylesMap("lineHeight", $51b7923d871fe7b5$export$360c29a380c1a34);
var $51b7923d871fe7b5$export$a1962444bbf058e = $51b7923d871fe7b5$var$getSerializedStylesMap("font", $51b7923d871fe7b5$export$b5bac06d7d8fd0d1);
var $51b7923d871fe7b5$export$ca3e246f24657bd6 = $51b7923d871fe7b5$var$getSerializedStylesMap("font", $51b7923d871fe7b5$export$b27166c9cf2c9f74);
var $51b7923d871fe7b5$export$ff257d957d48c421 = $51b7923d871fe7b5$var$getSerializedStylesMap((0, $3JCeP.CURRENT_SURFACE_CSS_VAR), $51b7923d871fe7b5$export$41a358c9c2356760);
var $51b7923d871fe7b5$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $51b7923d871fe7b5$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("3JCeP", function(module, exports) {

$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $2b833c5975ec821e$export$9d7b58831ae93caa; });
var $2b833c5975ec821e$export$4ef52930e33717cd = "data-theme";
var $2b833c5975ec821e$export$a00eac3f8684bcd0 = "data-color-mode";
var $2b833c5975ec821e$export$2112803007239c61 = "data-contrast-mode";
var $2b833c5975ec821e$export$352e418ed5b6193a = "data-custom-theme";
var $2b833c5975ec821e$export$2faeed762aac6741 = "light";
var $2b833c5975ec821e$export$6f0c6fb8c80fcc92 = "ds";
var $2b833c5975ec821e$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $2b833c5975ec821e$export$dddac1532e822863 = "--".concat($2b833c5975ec821e$export$6f0c6fb8c80fcc92, "-token-not-found");
var $2b833c5975ec821e$export$9d7b58831ae93caa = "--".concat($2b833c5975ec821e$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("hA8ey", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $cccc2f7d0c21378c$export$a9c84988c8f81f2d; });

var $4J9Jx = parcelRequire("4J9Jx");

var $jTVYe = parcelRequire("jTVYe");

var $gEQb4 = parcelRequire("gEQb4");

var $2ZUkg = parcelRequire("2ZUkg");

var $70YDI = parcelRequire("70YDI");

var $XAEGR = parcelRequire("XAEGR");
var $cccc2f7d0c21378c$var$tokensMap = {
    backgroundColor: (0, $70YDI.backgroundColorMap),
    blockSize: (0, $70YDI.dimensionMap),
    borderColor: (0, $70YDI.borderColorMap),
    borderRadius: (0, $70YDI.borderRadiusMap),
    borderWidth: (0, $70YDI.borderWidthMap),
    bottom: (0, $70YDI.spaceMap),
    boxShadow: (0, $70YDI.shadowMap),
    color: (0, $70YDI.textColorMap),
    columnGap: (0, $70YDI.spaceMap),
    gap: (0, $70YDI.spaceMap),
    height: (0, $70YDI.dimensionMap),
    inlineSize: (0, $70YDI.dimensionMap),
    inset: (0, $70YDI.spaceMap),
    insetBlock: (0, $70YDI.spaceMap),
    insetBlockEnd: (0, $70YDI.spaceMap),
    insetBlockStart: (0, $70YDI.spaceMap),
    insetInline: (0, $70YDI.spaceMap),
    insetInlineEnd: (0, $70YDI.spaceMap),
    insetInlineStart: (0, $70YDI.spaceMap),
    margin: (0, $70YDI.spaceMap),
    marginBlock: (0, $70YDI.spaceMap),
    marginBlockEnd: (0, $70YDI.spaceMap),
    marginBlockStart: (0, $70YDI.spaceMap),
    marginBottom: (0, $70YDI.spaceMap),
    marginInline: (0, $70YDI.spaceMap),
    marginInlineEnd: (0, $70YDI.spaceMap),
    marginInlineStart: (0, $70YDI.spaceMap),
    marginLeft: (0, $70YDI.spaceMap),
    marginRight: (0, $70YDI.spaceMap),
    marginTop: (0, $70YDI.spaceMap),
    left: (0, $70YDI.spaceMap),
    maxBlockSize: (0, $70YDI.dimensionMap),
    maxHeight: (0, $70YDI.dimensionMap),
    maxInlineSize: (0, $70YDI.dimensionMap),
    maxWidth: (0, $70YDI.dimensionMap),
    minBlockSize: (0, $70YDI.dimensionMap),
    minHeight: (0, $70YDI.dimensionMap),
    minInlineSize: (0, $70YDI.dimensionMap),
    minWidth: (0, $70YDI.dimensionMap),
    outlineOffset: (0, $70YDI.spaceMap),
    outlineWidth: (0, $70YDI.borderWidthMap),
    outlineColor: (0, $70YDI.borderColorMap),
    padding: (0, $70YDI.spaceMap),
    paddingBlock: (0, $70YDI.spaceMap),
    paddingBlockEnd: (0, $70YDI.spaceMap),
    paddingBlockStart: (0, $70YDI.spaceMap),
    paddingBottom: (0, $70YDI.spaceMap),
    paddingInline: (0, $70YDI.spaceMap),
    paddingInlineEnd: (0, $70YDI.spaceMap),
    paddingInlineStart: (0, $70YDI.spaceMap),
    paddingLeft: (0, $70YDI.spaceMap),
    paddingRight: (0, $70YDI.spaceMap),
    paddingTop: (0, $70YDI.spaceMap),
    right: (0, $70YDI.spaceMap),
    rowGap: (0, $70YDI.spaceMap),
    top: (0, $70YDI.spaceMap),
    width: (0, $70YDI.dimensionMap),
    zIndex: (0, $70YDI.layerMap)
};
var $cccc2f7d0c21378c$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $cccc2f7d0c21378c$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $XAEGR === "undefined" ? "undefined" : (0, $gEQb4.default)($XAEGR)) === "object" && (0, $gEQb4.default)($XAEGR.env) === "object" && false;
};
var $cccc2f7d0c21378c$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $cccc2f7d0c21378c$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $cccc2f7d0c21378c$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $gEQb4.default)(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $jTVYe.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $gEQb4.default)(value) === "object" && $cccc2f7d0c21378c$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($cccc2f7d0c21378c$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($cccc2f7d0c21378c$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $cccc2f7d0c21378c$var$tokensMap)) return;
        var tokenValue = $cccc2f7d0c21378c$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $cccc2f7d0c21378c$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $cccc2f7d0c21378c$var$transformStyles(style);
    return (0, $4J9Jx.default)({}, $cccc2f7d0c21378c$var$uniqueSymbol, (0, $2ZUkg.css)(transformedStyles));
};
var $cccc2f7d0c21378c$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$cccc2f7d0c21378c$var$uniqueSymbol];
    typeof $XAEGR === "undefined" || (0, $gEQb4.default)($XAEGR);
    return styles;
};
function $cccc2f7d0c21378c$export$f6c783d06584602c(style) {
    return $cccc2f7d0c21378c$var$baseXcss(style);
}

});

parcelRegister("e3rTl", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $a3b6fb2f837917d1$export$1ca2a26fecb070ae; });

var $iSvIT = parcelRequire("iSvIT");
var $a3b6fb2f837917d1$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $iSvIT.createContext)("elevation.surface");
var $a3b6fb2f837917d1$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $iSvIT.useContext)($a3b6fb2f837917d1$export$1ca2a26fecb070ae);
};
$a3b6fb2f837917d1$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});



parcelRegister("lnew6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8f701b22311a9c9$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $iSvIT = parcelRequire("iSvIT");

var $2ZUkg = parcelRequire("2ZUkg");

var $5zI8w = parcelRequire("5zI8w");

var $3l2qu = parcelRequire("3l2qu");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $f8f701b22311a9c9$var$TabPanel = function TabPanel(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTabPanel = (0, $3l2qu.useTabPanel)(), role = _useTabPanel.role, id = _useTabPanel.id, hidden = _useTabPanel.hidden, ariaLabelledBy = _useTabPanel["aria-labelledby"], onMouseDown = _useTabPanel.onMouseDown, tabIndex = _useTabPanel.tabIndex;
    return (0, $2ZUkg.jsx)((0, $5zI8w.default), {
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex
    }, (0, $2ZUkg.jsx)((0, $iSvIT.Fragment), null, children));
};
var $f8f701b22311a9c9$export$2e2bcd8739ae039 = $f8f701b22311a9c9$var$TabPanel;

});


parcelRegister("9qcBT", function(module, exports) {

$parcel$export(module.exports, "MarkdownRenderer", function () { return $912ea2224075f650$export$22c2c977437cf477; });

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $e1odK = parcelRequire("e1odK");

const $912ea2224075f650$var$AkReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>(parcelRequire("jZKXN")).then(({ ReactRenderer: ReactRenderer })=>({
            default: ReactRenderer
        })));
const $912ea2224075f650$var$MediaComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {});
const $912ea2224075f650$var$MediaSingleComponent = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {});
const $912ea2224075f650$export$22c2c977437cf477 = ({ answerString: answerString, statusComponent: statusComponent })=>{
    const docContent = (0, $iSvIT.useMemo)(()=>(0, $e1odK.encodeAdf)(answerString, false), [
        answerString
    ]);
    const config = {
        document: docContent,
        nodeComponents: {
            status: statusComponent,
            media: $912ea2224075f650$var$MediaComponent,
            mediaSingle: $912ea2224075f650$var$MediaSingleComponent
        },
        smartLinks: {
            ssr: true
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
        fallback: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {}),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($912ea2224075f650$var$AkReactRenderer, (0, $7Knp0._)({}, config))
    });
};

});
parcelRegister("e1odK", function(module, exports) {

$parcel$export(module.exports, "encodeAdf", function () { return $b14e43e3fd8542a6$export$53ded0b846f45216; });

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $3eTbH = parcelRequire("3eTbH");

var $87jJy = parcelRequire("87jJy");

var $bXM4W = parcelRequire("bXM4W");
const $b14e43e3fd8542a6$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== "string" && "type" in content && content.type === "doc";
    } catch (e) {
        return false;
    }
};
const $b14e43e3fd8542a6$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($b14e43e3fd8542a6$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: "paragraph",
            content: [
                {
                    type: "text",
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return (0, $6iHNw._)((0, $7Knp0._)({}, content), {
            content: updatedContent
        });
    }
    return `${content}\n\n${suggestionContent}`;
};
const $b14e43e3fd8542a6$var$pluginConfig = {
    linkify: {
        findFilepaths: $3eTbH.findFilepaths,
        isLinkInMatches: $3eTbH.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $b14e43e3fd8542a6$export$3374c63d7715b4ce = new (0, $87jJy.ADFEncoder)((schema)=>new (0, $bXM4W.AiMateMarkdownTransformer)(schema, $b14e43e3fd8542a6$var$pluginConfig, false));
const $b14e43e3fd8542a6$var$streamingAdfEncoder = new (0, $87jJy.ADFEncoder)((schema)=>new (0, $bXM4W.AiMateMarkdownTransformer)(schema, $b14e43e3fd8542a6$var$pluginConfig, true));
const $b14e43e3fd8542a6$export$53ded0b846f45216 = (content, streaming)=>{
    if ($b14e43e3fd8542a6$export$d801201dc544181(content)) return content;
    return streaming ? $b14e43e3fd8542a6$var$streamingAdfEncoder.encode(content) : $b14e43e3fd8542a6$export$3374c63d7715b4ce.encode(content);
};

});
parcelRegister("3eTbH", function(module, exports) {

$parcel$export(module.exports, "findFilepaths", function () { return $25bd7d04a45e8e8d$export$d37783fe63e2f0fe; });
$parcel$export(module.exports, "isLinkInMatches", function () { return $25bd7d04a45e8e8d$export$5e652e74655163e5; });

var $2JtHW = parcelRequire("2JtHW");

var $9ZtAp = parcelRequire("9ZtAp");

var $jctNi = parcelRequire("jctNi");

var $8Qwvz = parcelRequire("8Qwvz");

var $gMkmq = parcelRequire("gMkmq");

var $iUClD = parcelRequire("iUClD");
var $25bd7d04a45e8e8d$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
var $25bd7d04a45e8e8d$export$dabcc234035f6703 = /^(\$|{)/;
var $25bd7d04a45e8e8d$export$4490385c12bf3d4 = /*#__PURE__*/ function() {
    function LinkMatcher() {
        (0, $2JtHW.default)(this, LinkMatcher);
    }
    return (0, $9ZtAp.default)(LinkMatcher, null, [
        {
            key: "create",
            value: function create() {
                var LinkMatcherRegex = /*#__PURE__*/ function() {
                    function LinkMatcherRegex() {
                        (0, $2JtHW.default)(this, LinkMatcherRegex);
                    }
                    return (0, $9ZtAp.default)(LinkMatcherRegex, [
                        {
                            key: "exec",
                            value: function exec(str) {
                                var stringsBySpace = str.slice(0, str.length - 1).split(" ");
                                var lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                                var isLastStringValid = lastStringBeforeSpace.length > 0;
                                if (!str.endsWith(" ") || !isLastStringValid) return null;
                                if ($25bd7d04a45e8e8d$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                                var links = (0, $jctNi.linkify).match(lastStringBeforeSpace);
                                if (!links || links.length === 0) return null;
                                var lastMatch = links[links.length - 1];
                                var lastLink = links[links.length - 1];
                                lastLink.input = str.substring(lastMatch.index);
                                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                                return lastLink;
                            }
                        }
                    ]);
                }();
                return new LinkMatcherRegex();
            }
        }
    ]);
}();
function $25bd7d04a45e8e8d$export$6535eb414fa2c8b6(url) {
    if (!url) return "";
    if ((0, $jctNi.isSafeUrl)(url)) return url;
    return (0, $jctNi.normalizeUrl)(url);
}
function $25bd7d04a45e8e8d$export$5a511fa58fab15e6(schema) {
    return function(slice) {
        return (0, $iUClD.mapSlice)(slice, function(node, parent) {
            var isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            var link = node.type.schema.marks.link;
            if (link === undefined) throw new Error("Link not in schema - unable to linkify content");
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                var linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var text = node.text;
                var matches = $25bd7d04a45e8e8d$var$findLinkMatches(text).filter((0, $gMkmq.shouldAutoLinkifyMatch));
                var pos = 0;
                var filepaths = $25bd7d04a45e8e8d$export$d37783fe63e2f0fe(text);
                matches.forEach(function(match) {
                    if ($25bd7d04a45e8e8d$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $25bd7d04a45e8e8d$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
    };
}
function $25bd7d04a45e8e8d$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, "");
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var withoutWWW = withoutProtocol.replace(/^(www\.)/, "");
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, "");
}
function $25bd7d04a45e8e8d$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    var currentDomain = window.location.hostname;
    var linkDomain = $25bd7d04a45e8e8d$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $25bd7d04a45e8e8d$var$findLinkMatches(text) {
    if (text === "") return [];
    return (0, $jctNi.linkify).match(text) || [];
}
var $25bd7d04a45e8e8d$export$d37783fe63e2f0fe = function findFilepaths(text) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var localRegExp = new RegExp($25bd7d04a45e8e8d$export$893fccbed37586dd);
    var match;
    var matchesList = [];
    var maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        var start = match.index + offset;
        var end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
var $25bd7d04a45e8e8d$export$5e652e74655163e5 = function isLinkInMatches(linkStart, matchesList) {
    for(var i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $25bd7d04a45e8e8d$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $8Qwvz.ACTION).INSERTED,
        actionSubject: (0, $8Qwvz.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $8Qwvz.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $25bd7d04a45e8e8d$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $8Qwvz.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $25bd7d04a45e8e8d$export$238a6141b3685c21(url)
        }
    };
}
var $25bd7d04a45e8e8d$export$b7392a423e62dc8c = function canLinkBeCreatedInRange(from, to) {
    return function(state) {
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            var $from = state.doc.resolve(from);
            var $to = state.doc.resolve(to);
            var link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    var allowed = true;
                    state.doc.nodesBetween(from, to, function(node) {
                        allowed = allowed && !node.marks.some(function(m) {
                            return m.type.excludes(link);
                        });
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };
};

});
parcelRegister("2JtHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fd6d41a5650308f$export$2e2bcd8739ae039; });
function $1fd6d41a5650308f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("9ZtAp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7460c2c1d8f51a0f$export$2e2bcd8739ae039; });

var $6PLYa = parcelRequire("6PLYa");
function $7460c2c1d8f51a0f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $6PLYa.default)(o.key), o);
    }
}
function $7460c2c1d8f51a0f$export$2e2bcd8739ae039(e, r, t) {
    return r && $7460c2c1d8f51a0f$var$_defineProperties(e.prototype, r), t && $7460c2c1d8f51a0f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("6PLYa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9cb73a4b11496e$export$2e2bcd8739ae039; });

var $8eMch = parcelRequire("8eMch");

var $ljhhK = parcelRequire("ljhhK");
function $4f9cb73a4b11496e$export$2e2bcd8739ae039(t) {
    var i = (0, $ljhhK.default)(t, "string");
    return "symbol" == (0, $8eMch.default)(i) ? i : i + "";
}

});
parcelRegister("8eMch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ff5047c826ae2e0$export$2e2bcd8739ae039; });
function $5ff5047c826ae2e0$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5ff5047c826ae2e0$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ff5047c826ae2e0$export$2e2bcd8739ae039(o);
}

});

parcelRegister("ljhhK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f838c7cc31025f1e$export$2e2bcd8739ae039; });

var $8eMch = parcelRequire("8eMch");
function $f838c7cc31025f1e$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8eMch.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8eMch.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("jctNi", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", function () { return $dfa63fc930ce7c34$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "linkify", function () { return $dfa63fc930ce7c34$export$8ccbde94d5c7f8e7; });
$parcel$export(module.exports, "linkifyMatch", function () { return $dfa63fc930ce7c34$export$6f7d7761b97f967; });
$parcel$export(module.exports, "normalizeUrl", function () { return $dfa63fc930ce7c34$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $dfa63fc930ce7c34$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $6OjU6 = parcelRequire("6OjU6");
var $dfa63fc930ce7c34$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $dfa63fc930ce7c34$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dfa63fc930ce7c34$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $dfa63fc930ce7c34$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($6OjU6)))();
$dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.add("sourcetree:", "http:");
$dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.add("jamfselfservice:", "http:");
var $dfa63fc930ce7c34$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.add("tel:", $dfa63fc930ce7c34$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.add("file:", $dfa63fc930ce7c34$var$urlWithoutSpacesValidator);
$dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.add("notes:", "http:");
var $dfa63fc930ce7c34$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
var $dfa63fc930ce7c34$var$tlds2Char = "a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
$dfa63fc930ce7c34$var$tlds.push($dfa63fc930ce7c34$var$tlds2Char);
$dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.tlds($dfa63fc930ce7c34$var$tlds, false);
var $dfa63fc930ce7c34$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $dfa63fc930ce7c34$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$dfa63fc930ce7c34$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($dfa63fc930ce7c34$export$746d02eae03c72e1) || [
            ""
        ])[0];
        if (link) {
            var index = substr.search($dfa63fc930ce7c34$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ""
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dfa63fc930ce7c34$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $dfa63fc930ce7c34$export$6f7d7761b97f967(str);
    if (!match.length) match = $dfa63fc930ce7c34$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dfa63fc930ce7c34$export$6535eb414fa2c8b6(url) {
    var match = $dfa63fc930ce7c34$export$ce9ae45aed3e4ec(url);
    return match && match.url || "";
}
function $dfa63fc930ce7c34$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith("/") || url === "#top" || url === "#";
}

});
parcelRegister("6OjU6", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $4f56da1356ff4f3b$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $4f56da1356ff4f3b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $4f56da1356ff4f3b$var$isString(obj) {
    return $4f56da1356ff4f3b$var$_class(obj) === "[object String]";
}
function $4f56da1356ff4f3b$var$isObject(obj) {
    return $4f56da1356ff4f3b$var$_class(obj) === "[object Object]";
}
function $4f56da1356ff4f3b$var$isRegExp(obj) {
    return $4f56da1356ff4f3b$var$_class(obj) === "[object RegExp]";
}
function $4f56da1356ff4f3b$var$isFunction(obj) {
    return $4f56da1356ff4f3b$var$_class(obj) === "[object Function]";
}
function $4f56da1356ff4f3b$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $4f56da1356ff4f3b$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $4f56da1356ff4f3b$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $4f56da1356ff4f3b$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $4f56da1356ff4f3b$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $4f56da1356ff4f3b$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $4f56da1356ff4f3b$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $4f56da1356ff4f3b$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $4f56da1356ff4f3b$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $4f56da1356ff4f3b$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $4f56da1356ff4f3b$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("8DdQZ"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($4f56da1356ff4f3b$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($4f56da1356ff4f3b$var$isObject(val)) {
            if ($4f56da1356ff4f3b$var$isRegExp(val.validate)) compiled.validate = $4f56da1356ff4f3b$var$createValidator(val.validate);
            else if ($4f56da1356ff4f3b$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($4f56da1356ff4f3b$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $4f56da1356ff4f3b$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($4f56da1356ff4f3b$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $4f56da1356ff4f3b$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($4f56da1356ff4f3b$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $4f56da1356ff4f3b$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $4f56da1356ff4f3b$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $4f56da1356ff4f3b$var$createMatch(self, shift) {
    var match = new $4f56da1356ff4f3b$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $4f56da1356ff4f3b$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $4f56da1356ff4f3b$var$LinkifyIt)) return new $4f56da1356ff4f3b$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($4f56da1356ff4f3b$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $4f56da1356ff4f3b$var$assign({}, $4f56da1356ff4f3b$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $4f56da1356ff4f3b$var$assign({}, $4f56da1356ff4f3b$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $4f56da1356ff4f3b$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $4f56da1356ff4f3b$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $4f56da1356ff4f3b$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $4f56da1356ff4f3b$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($4f56da1356ff4f3b$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($4f56da1356ff4f3b$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $4f56da1356ff4f3b$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $4f56da1356ff4f3b$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $4f56da1356ff4f3b$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $4f56da1356ff4f3b$var$LinkifyIt;

});
parcelRegister("8DdQZ", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("9ABC1")).source;
    re.src_Cc = (parcelRequire("hpbR5")).source;
    re.src_Z = (parcelRequire("ay1D7")).source;
    re.src_P = (parcelRequire("5Ulqw")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-]).|" + // allow `I'm_king` if no pair found
    "\\.{2,4}[a-zA-Z0-9%/]|" + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + "\\,(?!" + re.src_ZCc + ").|" + // allow `,,,` in paths
    "\\!(?!" + re.src_ZCc + "|[!]).|" + "\\?(?!" + re.src_ZCc + "|[?])." + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});
parcelRegister("9ABC1", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("hpbR5", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("ay1D7", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("5Ulqw", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("8Qwvz", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", function () { return $670c657ca2bf7ecb$export$76a2e4c433c23bb9; });
$parcel$export(module.exports, "ACTION", function () { return $670c657ca2bf7ecb$export$9523889e0a5da4ba; });
$parcel$export(module.exports, "ACTION_SUBJECT", function () { return $670c657ca2bf7ecb$export$7525482b5931e326; });
$parcel$export(module.exports, "ACTION_SUBJECT_ID", function () { return $670c657ca2bf7ecb$export$9957974f8b4d8f74; });
var $670c657ca2bf7ecb$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $670c657ca2bf7ecb$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $670c657ca2bf7ecb$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $670c657ca2bf7ecb$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $670c657ca2bf7ecb$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $670c657ca2bf7ecb$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $670c657ca2bf7ecb$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $670c657ca2bf7ecb$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $670c657ca2bf7ecb$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("gMkmq", function(module, exports) {

$parcel$export(module.exports, "shouldAutoLinkifyMatch", function () { return $c370ec431fe4b7b8$export$e19a09e301eaa6bb; });
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ var $c370ec431fe4b7b8$var$tldsToNotAutoLinkify = [
    "name",
    "zip",
    "doc",
    "mov",
    // Ensure common 2 character file extensions aren't linkified without https prefix
    "md",
    // Postscript
    "ps",
    // C++
    "cc",
    // C#
    "cs",
    // f#
    "fs",
    // Go
    "go",
    // JavaScript
    "js",
    // Perl
    "pl",
    // Perl module
    "pm",
    // Python
    "py",
    // Ruby
    "rb",
    // Rust
    "rs",
    // Bash
    "sh",
    // Typescript
    "ts",
    // C#
    "cs",
    // Visual Basic
    "vb"
];
function $c370ec431fe4b7b8$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        var hostname = new URL("https://".concat(url)).hostname;
        var parts = hostname.split(".");
        var tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === "") // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$c370ec431fe4b7b8$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $c370ec431fe4b7b8$export$e19a09e301eaa6bb(match) {
    return $c370ec431fe4b7b8$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("iUClD", function(module, exports) {

$parcel$export(module.exports, "mapSlice", function () { return $dc4b340ee7feaa98$export$d8264570c5933bbf; });

var $ax952 = parcelRequire("ax952");

var $dcNr3 = parcelRequire("dcNr3");
function $dc4b340ee7feaa98$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $dc4b340ee7feaa98$export$81fe6b3b714fd0bf(content, callback) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var children = [];
    for(var i = 0, size = content.childCount; i < size; i++){
        var _node = content.child(i);
        var transformed = _node.isLeaf ? callback(_node, parent, i) : callback(_node.copy($dc4b340ee7feaa98$export$81fe6b3b714fd0bf(_node.content, callback, _node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $dcNr3.Fragment)) children.push.apply(children, (0, $ax952.default)($dc4b340ee7feaa98$export$7b8536c35e9eb7d2(transformed)));
            else if (Array.isArray(transformed)) children.push.apply(children, (0, $ax952.default)(transformed));
            else children.push(transformed);
        }
    }
    return (0, $dcNr3.Fragment).fromArray(children);
}
function $dc4b340ee7feaa98$export$d8264570c5933bbf(slice, callback) {
    var fragment = $dc4b340ee7feaa98$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $dcNr3.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $dc4b340ee7feaa98$export$c575791007f9dbd1(fragment, callback) {
    var fragmentContent = [];
    for(var i = 0; i < fragment.childCount; i++){
        var child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push.apply(fragmentContent, (0, $ax952.default)(child));
        else fragmentContent.push(child);
    }
    return (0, $dcNr3.Fragment).fromArray(fragmentContent);
}
function $dc4b340ee7feaa98$export$e0baa27f47733a4a(node, callback) {
    var array = [];
    for(var i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $dcNr3.Fragment) ? node : node.content));
    return array;
}
var $dc4b340ee7feaa98$var$findNode = function findNode(predicate) {
    return function(slice) {
        var foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, function(node) {
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
};
var $dc4b340ee7feaa98$export$b6ae752d7894ad08 = function hasNode(predicate) {
    return function(slice) {
        return !!$dc4b340ee7feaa98$var$findNode(predicate)(slice);
    };
};

});
parcelRegister("ax952", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ab4079c4b4cca15$export$2e2bcd8739ae039; });

var $6tmSt = parcelRequire("6tmSt");

var $dZwwW = parcelRequire("dZwwW");

var $jSUFH = parcelRequire("jSUFH");

var $8IGjI = parcelRequire("8IGjI");
function $7ab4079c4b4cca15$export$2e2bcd8739ae039(r) {
    return (0, $6tmSt.default)(r) || (0, $dZwwW.default)(r) || (0, $jSUFH.default)(r) || (0, $8IGjI.default)();
}

});
parcelRegister("6tmSt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b673288c45a8c11$export$2e2bcd8739ae039; });

var $4Pcke = parcelRequire("4Pcke");
function $4b673288c45a8c11$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $4Pcke.default)(r);
}

});
parcelRegister("4Pcke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38357c634930a5b4$export$2e2bcd8739ae039; });
function $38357c634930a5b4$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dZwwW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2fa34b800024282$export$2e2bcd8739ae039; });
function $a2fa34b800024282$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("jSUFH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e79f053f439e38da$export$2e2bcd8739ae039; });

var $4Pcke = parcelRequire("4Pcke");
function $e79f053f439e38da$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $4Pcke.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $4Pcke.default)(r, a) : void 0;
    }
}

});

parcelRegister("8IGjI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6593420ec5fb7231$export$2e2bcd8739ae039; });
function $6593420ec5fb7231$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("dcNr3", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $99d2be2bd165361e$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Slice", function () { return $99d2be2bd165361e$export$b3f2e2de3a8baa1e; });
$parcel$export(module.exports, "Node", function () { return $99d2be2bd165361e$export$85c928794f8d04d4; });
$parcel$export(module.exports, "MarkType", function () { return $99d2be2bd165361e$export$b6a78689043c6521; });
$parcel$export(module.exports, "Schema", function () { return $99d2be2bd165361e$export$19342e026b58ebb7; });
$parcel$export(module.exports, "DOMParser", function () { return $99d2be2bd165361e$export$1059c6e7d2ce5669; });

var $73qKE = parcelRequire("73qKE");
function $99d2be2bd165361e$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $99d2be2bd165361e$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $99d2be2bd165361e$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $99d2be2bd165361e$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $99d2be2bd165361e$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $99d2be2bd165361e$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $99d2be2bd165361e$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $99d2be2bd165361e$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $99d2be2bd165361e$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $99d2be2bd165361e$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $99d2be2bd165361e$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $99d2be2bd165361e$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $99d2be2bd165361e$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $99d2be2bd165361e$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $99d2be2bd165361e$var$retIndex(0, pos);
        if (pos == this.size) return $99d2be2bd165361e$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $99d2be2bd165361e$var$retIndex(i + 1, end);
                return $99d2be2bd165361e$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $99d2be2bd165361e$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $99d2be2bd165361e$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $99d2be2bd165361e$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $99d2be2bd165361e$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $99d2be2bd165361e$export$ffb0004e005737fa.empty;
        if (nodes instanceof $99d2be2bd165361e$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $99d2be2bd165361e$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $99d2be2bd165361e$export$ffb0004e005737fa.empty = new $99d2be2bd165361e$export$ffb0004e005737fa([], 0);
const $99d2be2bd165361e$var$found = {
    index: 0,
    offset: 0
};
function $99d2be2bd165361e$var$retIndex(index, offset) {
    $99d2be2bd165361e$var$found.index = index;
    $99d2be2bd165361e$var$found.offset = offset;
    return $99d2be2bd165361e$var$found;
}
function $99d2be2bd165361e$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$99d2be2bd165361e$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$99d2be2bd165361e$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $99d2be2bd165361e$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $99d2be2bd165361e$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
        if (marks instanceof $99d2be2bd165361e$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $99d2be2bd165361e$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $99d2be2bd165361e$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $99d2be2bd165361e$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $99d2be2bd165361e$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $99d2be2bd165361e$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $99d2be2bd165361e$export$b3f2e2de3a8baa1e($99d2be2bd165361e$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $99d2be2bd165361e$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $99d2be2bd165361e$export$b3f2e2de3a8baa1e($99d2be2bd165361e$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $99d2be2bd165361e$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $99d2be2bd165361e$export$b3f2e2de3a8baa1e.empty = new $99d2be2bd165361e$export$b3f2e2de3a8baa1e($99d2be2bd165361e$export$ffb0004e005737fa.empty, 0, 0);
function $99d2be2bd165361e$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($99d2be2bd165361e$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $99d2be2bd165361e$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $99d2be2bd165361e$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $99d2be2bd165361e$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $99d2be2bd165361e$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $99d2be2bd165361e$export$6de0e778727af3f2("Inconsistent open depths");
    return $99d2be2bd165361e$var$replaceOuter($from, $to, slice, 0);
}
function $99d2be2bd165361e$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $99d2be2bd165361e$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $99d2be2bd165361e$var$close(node, $99d2be2bd165361e$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $99d2be2bd165361e$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $99d2be2bd165361e$var$prepareSliceForReplace(slice, $from);
        return $99d2be2bd165361e$var$close(node, $99d2be2bd165361e$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $99d2be2bd165361e$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $99d2be2bd165361e$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $99d2be2bd165361e$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $99d2be2bd165361e$var$checkJoin(node, $after.node(depth));
    return node;
}
function $99d2be2bd165361e$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $99d2be2bd165361e$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $99d2be2bd165361e$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$99d2be2bd165361e$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $99d2be2bd165361e$var$addNode($end.nodeBefore, target);
}
function $99d2be2bd165361e$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $99d2be2bd165361e$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $99d2be2bd165361e$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $99d2be2bd165361e$var$joinable($end, $to, depth + 1);
    let content = [];
    $99d2be2bd165361e$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $99d2be2bd165361e$var$checkJoin(openStart, openEnd);
        $99d2be2bd165361e$var$addNode($99d2be2bd165361e$var$close(openStart, $99d2be2bd165361e$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $99d2be2bd165361e$var$addNode($99d2be2bd165361e$var$close(openStart, $99d2be2bd165361e$var$replaceTwoWay($from, $start, depth + 1)), content);
        $99d2be2bd165361e$var$addRange($start, $end, depth, content);
        if (openEnd) $99d2be2bd165361e$var$addNode($99d2be2bd165361e$var$close(openEnd, $99d2be2bd165361e$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $99d2be2bd165361e$var$addRange($to, null, depth, content);
    return new $99d2be2bd165361e$export$ffb0004e005737fa(content);
}
function $99d2be2bd165361e$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $99d2be2bd165361e$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $99d2be2bd165361e$var$joinable($from, $to, depth + 1);
        $99d2be2bd165361e$var$addNode($99d2be2bd165361e$var$close(type, $99d2be2bd165361e$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $99d2be2bd165361e$var$addRange($to, null, depth, content);
    return new $99d2be2bd165361e$export$ffb0004e005737fa(content);
}
function $99d2be2bd165361e$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($99d2be2bd165361e$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $99d2be2bd165361e$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $99d2be2bd165361e$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $99d2be2bd165361e$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $99d2be2bd165361e$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $99d2be2bd165361e$var$resolveCache.set(doc, cache = new $99d2be2bd165361e$var$ResolveCache);
        let result = cache.elts[cache.i] = $99d2be2bd165361e$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $99d2be2bd165361e$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $99d2be2bd165361e$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $99d2be2bd165361e$var$resolveCacheSize = 12, $99d2be2bd165361e$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $99d2be2bd165361e$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $99d2be2bd165361e$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $99d2be2bd165361e$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $99d2be2bd165361e$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $99d2be2bd165361e$var$emptyAttrs) && $99d2be2bd165361e$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $99d2be2bd165361e$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $99d2be2bd165361e$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $99d2be2bd165361e$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $99d2be2bd165361e$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $99d2be2bd165361e$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $99d2be2bd165361e$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $99d2be2bd165361e$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $99d2be2bd165361e$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $99d2be2bd165361e$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $99d2be2bd165361e$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$99d2be2bd165361e$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $99d2be2bd165361e$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $99d2be2bd165361e$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $99d2be2bd165361e$export$ffb0004e005737fa.empty;
    }
}
$99d2be2bd165361e$export$85c928794f8d04d4.prototype.text = undefined;
class $99d2be2bd165361e$var$TextNode extends $99d2be2bd165361e$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $99d2be2bd165361e$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $99d2be2bd165361e$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $99d2be2bd165361e$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $99d2be2bd165361e$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $99d2be2bd165361e$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $99d2be2bd165361e$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $99d2be2bd165361e$export$364ed450558d7ec4.empty;
        let expr = $99d2be2bd165361e$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $99d2be2bd165361e$var$dfa($99d2be2bd165361e$var$nfa(expr));
        $99d2be2bd165361e$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $99d2be2bd165361e$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $99d2be2bd165361e$export$364ed450558d7ec4.empty = new $99d2be2bd165361e$export$364ed450558d7ec4(true);
class $99d2be2bd165361e$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $99d2be2bd165361e$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($99d2be2bd165361e$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $99d2be2bd165361e$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($99d2be2bd165361e$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $99d2be2bd165361e$var$parseExprSubscript(stream) {
    let expr = $99d2be2bd165361e$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $99d2be2bd165361e$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $99d2be2bd165361e$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $99d2be2bd165361e$var$parseExprRange(stream, expr) {
    let min = $99d2be2bd165361e$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $99d2be2bd165361e$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $99d2be2bd165361e$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $99d2be2bd165361e$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $99d2be2bd165361e$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $99d2be2bd165361e$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $99d2be2bd165361e$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $99d2be2bd165361e$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $99d2be2bd165361e$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($99d2be2bd165361e$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $99d2be2bd165361e$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($99d2be2bd165361e$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $99d2be2bd165361e$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $99d2be2bd165361e$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($99d2be2bd165361e$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $99d2be2bd165361e$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $99d2be2bd165361e$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $99d2be2bd165361e$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $99d2be2bd165361e$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $99d2be2bd165361e$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $99d2be2bd165361e$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $99d2be2bd165361e$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $99d2be2bd165361e$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $99d2be2bd165361e$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $99d2be2bd165361e$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $99d2be2bd165361e$export$ffb0004e005737fa.from(content), $99d2be2bd165361e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $99d2be2bd165361e$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $99d2be2bd165361e$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $99d2be2bd165361e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $99d2be2bd165361e$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($99d2be2bd165361e$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $99d2be2bd165361e$export$85c928794f8d04d4(this, attrs, content.append(after), $99d2be2bd165361e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $99d2be2bd165361e$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $99d2be2bd165361e$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $99d2be2bd165361e$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $99d2be2bd165361e$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $99d2be2bd165361e$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $99d2be2bd165361e$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $99d2be2bd165361e$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $99d2be2bd165361e$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $99d2be2bd165361e$export$c9d15bcfc6d42044(this, $99d2be2bd165361e$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $99d2be2bd165361e$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $99d2be2bd165361e$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $99d2be2bd165361e$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $99d2be2bd165361e$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $99d2be2bd165361e$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $99d2be2bd165361e$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $99d2be2bd165361e$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $99d2be2bd165361e$var$TextNode(type, type.defaultAttrs, text, $99d2be2bd165361e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $99d2be2bd165361e$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $99d2be2bd165361e$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $73qKE.default).from(spec.nodes), instanceSpec.marks = (0, $73qKE.default).from(spec.marks || {}), this.nodes = $99d2be2bd165361e$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $99d2be2bd165361e$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $99d2be2bd165361e$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $99d2be2bd165361e$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $99d2be2bd165361e$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $99d2be2bd165361e$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $99d2be2bd165361e$var$isTagRule(rule) {
    return rule.tag != null;
}
function $99d2be2bd165361e$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $99d2be2bd165361e$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $99d2be2bd165361e$var$ParseContext(this, options, false);
        context.addAll(dom, $99d2be2bd165361e$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $99d2be2bd165361e$var$ParseContext(this, options, true);
        context.addAll(dom, $99d2be2bd165361e$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $99d2be2bd165361e$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($99d2be2bd165361e$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $99d2be2bd165361e$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $99d2be2bd165361e$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $99d2be2bd165361e$export$1059c6e7d2ce5669(schema, $99d2be2bd165361e$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($99d2be2bd165361e$var$isTagRule(rule)) this.tags.push(rule);
            else if ($99d2be2bd165361e$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $99d2be2bd165361e$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $99d2be2bd165361e$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $99d2be2bd165361e$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $99d2be2bd165361e$var$OPT_PRESERVE_WS = 1, $99d2be2bd165361e$var$OPT_PRESERVE_WS_FULL = 2, $99d2be2bd165361e$var$OPT_OPEN_LEFT = 4;
function $99d2be2bd165361e$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $99d2be2bd165361e$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $99d2be2bd165361e$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $99d2be2bd165361e$var$OPT_PRESERVE_WS | $99d2be2bd165361e$var$OPT_PRESERVE_WS_FULL : base & ~$99d2be2bd165361e$var$OPT_OPEN_LEFT;
}
class $99d2be2bd165361e$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($99d2be2bd165361e$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $99d2be2bd165361e$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $99d2be2bd165361e$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($99d2be2bd165361e$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$99d2be2bd165361e$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $99d2be2bd165361e$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $99d2be2bd165361e$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $99d2be2bd165361e$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $99d2be2bd165361e$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($99d2be2bd165361e$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $99d2be2bd165361e$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $99d2be2bd165361e$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($99d2be2bd165361e$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $99d2be2bd165361e$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $99d2be2bd165361e$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $99d2be2bd165361e$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $99d2be2bd165361e$var$OPT_OPEN_LEFT;
        let applyMarks = $99d2be2bd165361e$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $99d2be2bd165361e$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $99d2be2bd165361e$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $99d2be2bd165361e$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $99d2be2bd165361e$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $99d2be2bd165361e$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $99d2be2bd165361e$var$NodeContext(topNode.type, topNode.attrs, $99d2be2bd165361e$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $99d2be2bd165361e$var$NodeContext(null, null, $99d2be2bd165361e$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $99d2be2bd165361e$var$NodeContext(parser.schema.topNodeType, null, $99d2be2bd165361e$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $99d2be2bd165361e$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $99d2be2bd165361e$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $99d2be2bd165361e$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $99d2be2bd165361e$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $99d2be2bd165361e$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $99d2be2bd165361e$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $99d2be2bd165361e$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $99d2be2bd165361e$var$renderSpec($99d2be2bd165361e$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $99d2be2bd165361e$var$renderSpec($99d2be2bd165361e$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $99d2be2bd165361e$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $99d2be2bd165361e$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $99d2be2bd165361e$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $99d2be2bd165361e$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $99d2be2bd165361e$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $99d2be2bd165361e$var$doc(options) {
    return options.document || window.document;
}
const $99d2be2bd165361e$var$suspiciousAttributeCache = new WeakMap();
function $99d2be2bd165361e$var$suspiciousAttributes(attrs) {
    let value = $99d2be2bd165361e$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $99d2be2bd165361e$var$suspiciousAttributeCache.set(attrs, value = $99d2be2bd165361e$var$suspiciousAttributesInner(attrs));
    return value;
}
function $99d2be2bd165361e$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $99d2be2bd165361e$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $99d2be2bd165361e$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $99d2be2bd165361e$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("73qKE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522d9082591fa446$export$2e2bcd8739ae039; });
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $522d9082591fa446$var$OrderedMap(content) {
    this.content = content;
}
$522d9082591fa446$var$OrderedMap.prototype = {
    constructor: $522d9082591fa446$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $522d9082591fa446$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $522d9082591fa446$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $522d9082591fa446$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $522d9082591fa446$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $522d9082591fa446$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $522d9082591fa446$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $522d9082591fa446$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $522d9082591fa446$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $522d9082591fa446$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $522d9082591fa446$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$522d9082591fa446$var$OrderedMap.from = function(value) {
    if (value instanceof $522d9082591fa446$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $522d9082591fa446$var$OrderedMap(content);
};
var $522d9082591fa446$export$2e2bcd8739ae039 = $522d9082591fa446$var$OrderedMap;

});




parcelRegister("87jJy", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", function () { return $01866c87bdcad3d6$export$bcf771b83128eae7; });
$parcel$export(module.exports, "getText", function () { return $01866c87bdcad3d6$export$c72d34660a162238; });
$parcel$export(module.exports, "getEventHandler", function () { return $01866c87bdcad3d6$export$eee20638634729b3; });
$parcel$export(module.exports, "findInTree", function () { return $01866c87bdcad3d6$export$38b61ebf4950cd39; });

var $ecJAY = parcelRequire("ecJAY");

var $cnuD2 = parcelRequire("cnuD2");

var $3sovF = parcelRequire("3sovF");

var $eZ2Jv = parcelRequire("eZ2Jv");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $01866c87bdcad3d6$var$createEncoder(parser, encoder) {
    return function(value) {
        return encoder.encode(parser.parse(value));
    };
}
var $01866c87bdcad3d6$export$bcf771b83128eae7 = /*#__PURE__*/ (0, $ecJAY.default)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ADFEncoder(createTransformerWithSchema) {
    (0, $cnuD2.default)(this, ADFEncoder);
    var transformer = createTransformerWithSchema((0, $3sovF.defaultSchema));
    this.encode = $01866c87bdcad3d6$var$createEncoder(transformer, new (0, $eZ2Jv.JSONTransformer)());
});
var $01866c87bdcad3d6$export$c72d34660a162238 = function getText(node) {
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || "[".concat(typeof node.type === "string" ? node.type : node.type.name, "]");
};
var $01866c87bdcad3d6$export$eee20638634729b3 = function getEventHandler(eventHandlers, type) {
    var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "onClick";
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $01866c87bdcad3d6$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $01866c87bdcad3d6$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("ecJAY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5758df6b5510417$export$2e2bcd8739ae039; });

var $fVEiC = parcelRequire("fVEiC");
function $a5758df6b5510417$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $fVEiC.default)(o.key), o);
    }
}
function $a5758df6b5510417$export$2e2bcd8739ae039(e, r, t) {
    return r && $a5758df6b5510417$var$_defineProperties(e.prototype, r), t && $a5758df6b5510417$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("fVEiC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98b70830c1d9661$export$2e2bcd8739ae039; });

var $bo26J = parcelRequire("bo26J");

var $bxuqw = parcelRequire("bxuqw");
function $b98b70830c1d9661$export$2e2bcd8739ae039(t) {
    var i = (0, $bxuqw.default)(t, "string");
    return "symbol" == (0, $bo26J.default)(i) ? i : i + "";
}

});
parcelRegister("bo26J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84a3921f453bc165$export$2e2bcd8739ae039; });
function $84a3921f453bc165$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $84a3921f453bc165$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $84a3921f453bc165$export$2e2bcd8739ae039(o);
}

});

parcelRegister("bxuqw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866a60ebc9a970cb$export$2e2bcd8739ae039; });

var $bo26J = parcelRequire("bo26J");
function $866a60ebc9a970cb$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $bo26J.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bo26J.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("cnuD2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $902f64350ea4ff50$export$2e2bcd8739ae039; });
function $902f64350ea4ff50$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("3sovF", function(module, exports) {

$parcel$export(module.exports, "getSchemaBasedOnStage", function () { return $2846ffb9f9acc89d$export$fd147e7d448dea03; });
$parcel$export(module.exports, "defaultSchema", function () { return $2846ffb9f9acc89d$export$1db618b7b2275ea1; });

var $fV0Sg = parcelRequire("fV0Sg");

var $hAe68 = parcelRequire("hAe68");
var $7kwhx = parcelRequire("7kwhx");
var $RyvU3 = parcelRequire("RyvU3");
var $i46Fe = parcelRequire("i46Fe");
var $3t6uD = parcelRequire("3t6uD");

var $8Joc2 = parcelRequire("8Joc2");
var $2846ffb9f9acc89d$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            "doc",
            "paragraph",
            "text",
            "bulletList",
            "orderedList",
            "listItem",
            "heading",
            "blockquote",
            "codeBlock",
            "panel",
            "rule",
            "image",
            "caption",
            "mention",
            "media",
            "mediaGroup",
            "mediaSingle",
            "mediaInline",
            "confluenceUnsupportedBlock",
            "confluenceUnsupportedInline",
            "confluenceJiraIssue",
            "expand",
            "nestedExpand",
            "extension",
            "inlineExtension",
            "bodiedExtension",
            "hardBreak",
            "emoji",
            "table",
            "tableCell",
            "tableHeader",
            "tableRow",
            "decisionList",
            "decisionItem",
            "taskList",
            "taskItem",
            "unknownBlock",
            "date",
            "status",
            "placeholder",
            "layoutSection",
            "layoutColumn",
            "inlineCard",
            "blockCard",
            "embedCard",
            "unsupportedBlock",
            "unsupportedInline"
        ],
        marks: [
            "link",
            "em",
            "strong",
            "strike",
            "subsup",
            "underline",
            "code",
            "textColor",
            "backgroundColor",
            "confluenceInlineComment",
            "breakout",
            "alignment",
            "indentation",
            "annotation",
            "dataConsumer",
            "border",
            "unsupportedMark",
            "unsupportedNodeAttribute",
            "typeAheadQuery",
            // https://product-fabric.atlassian.net/browse/ED-10214,
            "fragment"
        ]
    };
    return defaultSchemaConfig;
};
var $2846ffb9f9acc89d$export$e4e3ac1fa64862db = $2846ffb9f9acc89d$var$getDefaultSchemaConfig();
var $2846ffb9f9acc89d$export$fd147e7d448dea03 = (0, $fV0Sg.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "final";
    var defaultSchemaConfig = $2846ffb9f9acc89d$var$getDefaultSchemaConfig();
    if (stage === "stage0") defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $RyvU3.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $7kwhx.multiBodiedExtension),
        extensionFrame: (0, $7kwhx.extensionFrame),
        expand: (0, $hAe68.expandWithNestedExpand),
        listItem: (0, $i46Fe.listItemWithDecisionStage0),
        table: (0, $3t6uD.tableWithNestedTable),
        tableRow: (0, $3t6uD.tableRowWithNestedTable),
        tableCell: (0, $3t6uD.tableCellWithNestedTable),
        tableHeader: (0, $3t6uD.tableHeaderWithNestedTable)
    };
    return (0, $8Joc2.createSchema)(defaultSchemaConfig);
});
var $2846ffb9f9acc89d$export$1db618b7b2275ea1 = $2846ffb9f9acc89d$export$fd147e7d448dea03();

});
parcelRegister("hAe68", function(module, exports) {

$parcel$export(module.exports, "expand", function () { return $ccd0bc02781d431f$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "expandWithNestedExpand", function () { return $ccd0bc02781d431f$export$7b80cba28d10b2c1; });
$parcel$export(module.exports, "toJSON", function () { return $ccd0bc02781d431f$export$54fd2c36b5cc6731; });

var $lb7vQ = parcelRequire("lb7vQ");

var $7ock2 = parcelRequire("7ock2");
function $ccd0bc02781d431f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ccd0bc02781d431f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ccd0bc02781d431f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ccd0bc02781d431f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $ccd0bc02781d431f$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true
    };
}
var $ccd0bc02781d431f$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: "table//",
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ccd0bc02781d431f$var$getExpandAttrs
        },
        {
            context: "expand//",
            tag: '[data-node-type="expand"]',
            getAttrs: $ccd0bc02781d431f$var$getExpandAttrs
        },
        {
            context: "nestedExpand//",
            tag: '[data-node-type="expand"]',
            getAttrs: $ccd0bc02781d431f$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ccd0bc02781d431f$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "expand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $ccd0bc02781d431f$export$9f77e0932fb78f72 = (0, $7ock2.expandWithoutNestedExpand)($ccd0bc02781d431f$var$nodeSpecOptions);
var $ccd0bc02781d431f$export$7b80cba28d10b2c1 = (0, $7ock2.expand)($ccd0bc02781d431f$var$nodeSpecOptions);
var $ccd0bc02781d431f$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith("__");
        }).reduce(function(obj, key) {
            return $ccd0bc02781d431f$var$_objectSpread($ccd0bc02781d431f$var$_objectSpread({}, obj), {}, (0, $lb7vQ.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("lb7vQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6b073e35e5a6dc9$export$2e2bcd8739ae039; });

var $iTroX = parcelRequire("iTroX");
function $f6b073e35e5a6dc9$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $iTroX.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("iTroX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc129e6913e53af6$export$2e2bcd8739ae039; });

var $4dbRV = parcelRequire("4dbRV");

var $kT1QP = parcelRequire("kT1QP");
function $dc129e6913e53af6$export$2e2bcd8739ae039(t) {
    var i = (0, $kT1QP.default)(t, "string");
    return "symbol" == (0, $4dbRV.default)(i) ? i : i + "";
}

});
parcelRegister("4dbRV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31119531903a8117$export$2e2bcd8739ae039; });
function $31119531903a8117$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $31119531903a8117$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $31119531903a8117$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kT1QP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f34a6147b5e1f7b0$export$2e2bcd8739ae039; });

var $4dbRV = parcelRequire("4dbRV");
function $f34a6147b5e1f7b0$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4dbRV.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4dbRV.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("7ock2", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $561455382f227adf$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $561455382f227adf$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $561455382f227adf$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", function () { return $561455382f227adf$export$a91509d1c739c16f; });
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", function () { return $561455382f227adf$export$32b1dde15f5fe85b; });
$parcel$export(module.exports, "bodiedExtension", function () { return $561455382f227adf$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $561455382f227adf$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $561455382f227adf$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $561455382f227adf$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $561455382f227adf$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $561455382f227adf$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $561455382f227adf$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $561455382f227adf$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $561455382f227adf$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $561455382f227adf$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $561455382f227adf$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $561455382f227adf$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $561455382f227adf$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $561455382f227adf$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "expandWithoutNestedExpand", function () { return $561455382f227adf$export$63c0f3992661097b; });
$parcel$export(module.exports, "extension", function () { return $561455382f227adf$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $561455382f227adf$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $561455382f227adf$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $561455382f227adf$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $561455382f227adf$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $561455382f227adf$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $561455382f227adf$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $561455382f227adf$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $561455382f227adf$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $561455382f227adf$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $561455382f227adf$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $561455382f227adf$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $561455382f227adf$export$df876f0305235056; });
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", function () { return $561455382f227adf$export$171e9ff2be159af7; });
$parcel$export(module.exports, "media", function () { return $561455382f227adf$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $561455382f227adf$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $561455382f227adf$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $561455382f227adf$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $561455382f227adf$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $561455382f227adf$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $561455382f227adf$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $561455382f227adf$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $561455382f227adf$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $561455382f227adf$export$63cadbf5f4296627; });
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", function () { return $561455382f227adf$export$15ebf236772fa336; });
$parcel$export(module.exports, "orderedList", function () { return $561455382f227adf$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $561455382f227adf$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", function () { return $561455382f227adf$export$220c665c23b9541b; });
$parcel$export(module.exports, "paragraph", function () { return $561455382f227adf$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $561455382f227adf$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $561455382f227adf$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $561455382f227adf$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "table", function () { return $561455382f227adf$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $561455382f227adf$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $561455382f227adf$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $561455382f227adf$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $561455382f227adf$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $561455382f227adf$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $561455382f227adf$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $561455382f227adf$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $561455382f227adf$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $561455382f227adf$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $561455382f227adf$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $561455382f227adf$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $561455382f227adf$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $boMuE = parcelRequire("boMuE");
var $561455382f227adf$export$c4c2f833baaebdb8 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $561455382f227adf$export$67dc04e652a298ca = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    group: "block",
    selectable: true,
    defining: true
});
var $561455382f227adf$export$199922e5af8e9a6 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    selectable: true,
    defining: true
});
var $561455382f227adf$export$a91509d1c739c16f = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | orderedList | bulletList | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    selectable: true,
    defining: true
});
var $561455382f227adf$export$32b1dde15f5fe85b = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    selectable: true,
    defining: true
});
var $561455382f227adf$export$27903d543b563e39 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $561455382f227adf$export$e7320d153c538837 = (0, $boMuE.createPMNodeSpecFactory)({
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $561455382f227adf$export$a140c94e5ea26bee = (0, $boMuE.createPMNodeSpecFactory)({
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    selectable: false
});
var $561455382f227adf$export$8e3c2dfdc4f0453d = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*",
    marks: "_",
    selectable: false,
    isolating: true
});
var $561455382f227adf$export$7bb0d5c671655cc4 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $561455382f227adf$export$e4f1c66d84049f8b = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $561455382f227adf$export$daf889beb5092f95 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ""
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $561455382f227adf$export$e6e4878f43c27cab = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $561455382f227adf$export$3e6d667072febc87 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $561455382f227adf$export$324d90190a8b822a = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        timestamp: {
            default: ""
        }
    },
    selectable: true
});
var $561455382f227adf$export$47988d68fe575725 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        timestamp: {
            default: ""
        }
    },
    selectable: true
});
var $561455382f227adf$export$6959e16eeff859b4 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "DECIDED"
        }
    },
    defining: true
});
var $561455382f227adf$export$62d45a65fb43d95e = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(decisionItem | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: ""
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$2a111da947c407d2 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(block | codeBlock | layoutSection | blockRootOnly | expand)+",
    marks: "unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout"
});
var $561455382f227adf$export$be4283d9a1cb1ff6 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        url: {
            default: ""
        },
        layout: {
            default: "center"
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$a19185d1233fc4b2 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        }
    },
    selectable: true
});
var $561455382f227adf$export$f5574b5d45fc2112 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        }
    },
    selectable: true
});
var $561455382f227adf$export$9f77e0932fb78f72 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    group: "block",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $561455382f227adf$export$7e3788972005cc72 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $561455382f227adf$export$63c0f3992661097b = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    group: "block",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $561455382f227adf$export$1b45514b112dd749 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$a8baf338431a691 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$b555be60c7703afb = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $561455382f227adf$export$371da9dd35aba193 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: "\n"
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $561455382f227adf$export$46e4a324ac90507f = (0, $boMuE.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border",
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$1b0c1557b234fa00 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$85461f751c457cc2 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$2b380a0f7e250af1 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$5c452ff88e35e47d = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        src: {
            default: ""
        },
        alt: {
            default: ""
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $561455382f227adf$export$cbf8224b64e0d942 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $561455382f227adf$export$2f4e72b9459914ad = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $561455382f227adf$export$16b353b2649bd8d9 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$b3b1e36c2105006d = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$ab76e7c03cd6f650 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(block | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment",
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
var $561455382f227adf$export$b3b6a70a7fa4a5be = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    isolating: true
});
var $561455382f227adf$export$cdae19acb0a520fd = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){2,3}",
    marks: "unsupportedMark unsupportedNodeAttribute",
    isolating: true
});
var $561455382f227adf$export$206007566ca0aca5 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
var $561455382f227adf$export$76c7e83ecc9cdf05 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    defining: true
});
var $561455382f227adf$export$df876f0305235056 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    selectable: false,
    defining: true
});
var $561455382f227adf$export$171e9ff2be159af7 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    defining: true
});
var $561455382f227adf$export$987d49ffe1b0900f = (0, $boMuE.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: "file"
        },
        id: {
            default: ""
        },
        alt: {
            default: ""
        },
        collection: {
            default: ""
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$2855e964765eac9 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(media | unsupportedBlock)+",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {},
    selectable: false
});
var $561455382f227adf$export$38bab695e3f720f1 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        type: {
            default: "file"
        },
        url: {
            default: null
        },
        id: {
            default: ""
        },
        alt: {
            default: ""
        },
        collection: {
            default: ""
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $561455382f227adf$export$969fe3781ca15058 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        layout: {
            default: "center"
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: "media|unsupportedBlock+|media unsupportedBlock+",
    marks: "annotation border link unsupportedMark unsupportedNodeAttribute"
});
var $561455382f227adf$export$8d067f22dc2d1254 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: false,
    attrs: {
        layout: {
            default: "center"
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$7e767666f2ce108a = (0, $boMuE.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: "center"
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$4bd9a38995f6bf50 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media unsupportedBlock+",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: "center"
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$db83999c14438df4 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        localId: {
            default: null
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$46f790bd65f760d0 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        localId: {
            default: null
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$750e45819f66d9d0 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "extensionFrame+",
    marks: "unsupportedNodeAttribute unsupportedMark",
    group: "blockRootOnly",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $561455382f227adf$export$63cadbf5f4296627 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $561455382f227adf$export$f03786aa6312d1e4 = (0, $boMuE.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $561455382f227adf$export$15ebf236772fa336 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $561455382f227adf$export$a5dc81035676e7a = (0, $boMuE.createPMNodeSpecFactory)({
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
var $561455382f227adf$export$21f42ab9b6679f44 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    group: "block",
    attrs: {
        panelType: {
            default: "info"
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$220c665c23b9541b = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        panelType: {
            default: "info"
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
var $561455382f227adf$export$9c206ddddb32a9b = (0, $boMuE.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $561455382f227adf$export$4f98472e6dc14293 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $561455382f227adf$export$ea332b61641b0588 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $561455382f227adf$export$a1f41dc4901771f8 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $561455382f227adf$export$c7187bbd1a7a9244 = (0, $boMuE.createPMNodeSpecFactory)({
    marks: "",
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        }
    },
    selectable: false
});
var $561455382f227adf$export$fbeb3a3956e8a3c7 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block"
});
var $561455382f227adf$export$471f7ae5c4103ae1 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: ""
        },
        style: {
            default: ""
        }
    },
    selectable: true
});
var $561455382f227adf$export$b6ce52be8d7a261 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: ""
        },
        style: {
            default: ""
        }
    },
    selectable: true
});
var $561455382f227adf$export$9852986a3ec5f6a0 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "tableRow+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: "table"
});
var $561455382f227adf$export$ce086a560a1d05f5 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "tableRow+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: "table"
});
var $561455382f227adf$export$e1e720e5f4603e6a = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "cell"
});
var $561455382f227adf$export$abf39ca178940ff3 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "cell"
});
var $561455382f227adf$export$48884d2a5190dc73 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "header_cell"
});
var $561455382f227adf$export$2a5a518232fa1a97 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "header_cell"
});
var $561455382f227adf$export$ce666bf02318c957 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    tableRole: "row"
});
var $561455382f227adf$export$7d657479499397 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    selectable: false,
    tableRole: "row"
});
var $561455382f227adf$export$6d8b0ef52e2e6390 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "TODO"
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$375b6afcc5f4d291 = (0, $boMuE.createPMNodeSpecFactory)({
    content: "(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: ""
        }
    },
    selectable: false,
    defining: true
});
var $561455382f227adf$export$6f093cfa640b7166 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline"
});
var $561455382f227adf$export$5ea06bc686c59dc2 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline"
});
var $561455382f227adf$export$93256a4c17b33a82 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline"
});
var $561455382f227adf$export$a12828d0f14a2762 = (0, $boMuE.createPMNodeSpecFactory)({});
var $561455382f227adf$export$44b79b0979d0f0f7 = (0, $boMuE.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $561455382f227adf$export$310ebe0d80122e9b = (0, $boMuE.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("boMuE", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $84c78d656fa75377$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $84c78d656fa75377$export$cf5823ed4e9f4c6f; });

var $lb7vQ = parcelRequire("lb7vQ");
function $84c78d656fa75377$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84c78d656fa75377$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84c78d656fa75377$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84c78d656fa75377$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $84c78d656fa75377$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $84c78d656fa75377$var$_objectSpread($84c78d656fa75377$var$_objectSpread($84c78d656fa75377$var$_objectSpread($84c78d656fa75377$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $84c78d656fa75377$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $84c78d656fa75377$var$_objectSpread($84c78d656fa75377$var$_objectSpread($84c78d656fa75377$var$_objectSpread($84c78d656fa75377$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});



parcelRegister("7kwhx", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", function () { return $5563712a6f027364$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $5563712a6f027364$export$c3c04d555a8b9013; });

var $hnNxG = parcelRequire("hnNxG");

var $7ock2 = parcelRequire("7ock2");
var $5563712a6f027364$export$4fdcae991fd743e7 = (0, $7ock2.extensionFrameStage0)({
    parseDOM: [
        {
            context: "extensionFrame//",
            tag: "div[data-extension-frame]",
            skip: true
        },
        {
            tag: "div[data-extension-frame]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-extension-frame": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $5563712a6f027364$export$c3c04d555a8b9013 = (0, $7ock2.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: "multiBodiedExtension//",
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $hnNxG.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "multi-bodied-extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});
parcelRegister("hnNxG", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", function () { return $ca7b03b6cde3705e$export$1765e2758fc47004; });
var $ca7b03b6cde3705e$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        "default",
        "wide",
        "full-width"
    ].includes(name);
};
var $ca7b03b6cde3705e$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute("data-extension-type");
    var extensionKey = dom.getAttribute("data-extension-key");
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute("data-text") || undefined,
        parameters: JSON.parse(dom.getAttribute("data-parameters") || "{}"),
        localId: dom.getAttribute("data-local-id") || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute("data-layout");
        attrs.layout = $ca7b03b6cde3705e$export$d5f21755dc782a4a(rawLayout) ? rawLayout : "default";
    }
    return attrs;
};

});


parcelRegister("RyvU3", function(module, exports) {

$parcel$export(module.exports, "layoutSection", function () { return $0a0fb90712ff7d2e$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $0a0fb90712ff7d2e$export$4f9d8f623ff17117; });

var $7ock2 = parcelRequire("7ock2");
var $0a0fb90712ff7d2e$export$b3b6a70a7fa4a5be = (0, $7ock2.layoutSection)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $0a0fb90712ff7d2e$export$cdae19acb0a520fd = (0, $7ock2.layoutSectionFull)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $0a0fb90712ff7d2e$export$4f9d8f623ff17117 = (0, $7ock2.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute("data-column-rule-style");
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            "data-layout-section": "true",
            "data-column-rule-style": columnRuleStyle || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("i46Fe", function(module, exports) {

$parcel$export(module.exports, "listItem", function () { return $d26dc50fb76c4b72$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithTask", function () { return $d26dc50fb76c4b72$export$58dca2f0678302a4; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $d26dc50fb76c4b72$export$b2cd54d5ce935ddb; });
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", function () { return $d26dc50fb76c4b72$export$171e9ff2be159af7; });

var $7ock2 = parcelRequire("7ock2");
var $d26dc50fb76c4b72$export$76c7e83ecc9cdf05 = (0, $7ock2.listItem)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});
var $d26dc50fb76c4b72$export$58dca2f0678302a4 = $d26dc50fb76c4b72$export$76c7e83ecc9cdf05;
var $d26dc50fb76c4b72$export$b2cd54d5ce935ddb = (0, $7ock2.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});
var $d26dc50fb76c4b72$export$171e9ff2be159af7 = (0, $7ock2.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});

});

parcelRegister("3t6uD", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", function () { return $28691de83c57f24c$export$9cfceb893b24742a; });
$parcel$export(module.exports, "tableCellSelector", function () { return $28691de83c57f24c$export$69cb4c3f80383763; });
$parcel$export(module.exports, "tableHeaderSelector", function () { return $28691de83c57f24c$export$7b07d37d879c957f; });
$parcel$export(module.exports, "tableCellContentWrapperSelector", function () { return $28691de83c57f24c$export$8dd42a84cd52da07; });
$parcel$export(module.exports, "tableCellContentDomSelector", function () { return $28691de83c57f24c$export$5e26a5c19f0865d8; });
$parcel$export(module.exports, "getCellAttrs", function () { return $28691de83c57f24c$export$43977bde391e007; });
$parcel$export(module.exports, "getCellDomAttrs", function () { return $28691de83c57f24c$export$363c8dda799bfe9c; });
$parcel$export(module.exports, "tableBackgroundColorNames", function () { return $28691de83c57f24c$export$8cc2833b5b349a1e; });
$parcel$export(module.exports, "tableBackgroundColorPalette", function () { return $28691de83c57f24c$export$219b7f492ad209f8; });
$parcel$export(module.exports, "tableBackgroundBorderColor", function () { return $28691de83c57f24c$export$95e9c925fbf01d1c; });
$parcel$export(module.exports, "table", function () { return $28691de83c57f24c$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithCustomWidth", function () { return $28691de83c57f24c$export$90e634fbace1f0c4; });
$parcel$export(module.exports, "tableStage0", function () { return $28691de83c57f24c$export$3862de5c8c9098cf; });
$parcel$export(module.exports, "tableToJSON", function () { return $28691de83c57f24c$export$1f92a2f429e06fa8; });
$parcel$export(module.exports, "tableRow", function () { return $28691de83c57f24c$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $28691de83c57f24c$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "toJSONTableCell", function () { return $28691de83c57f24c$export$2ac34c099660f1a8; });
$parcel$export(module.exports, "tableHeader", function () { return $28691de83c57f24c$export$48884d2a5190dc73; });
$parcel$export(module.exports, "toJSONTableHeader", function () { return $28691de83c57f24c$export$2af48797a1010bb1; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $28691de83c57f24c$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $28691de83c57f24c$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $28691de83c57f24c$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $28691de83c57f24c$export$2a5a518232fa1a97; });

var $lb7vQ = parcelRequire("lb7vQ");

var $i6ZYA = parcelRequire("i6ZYA");

var $4B2aM = parcelRequire("4B2aM");

var $1xksd = parcelRequire("1xksd");

var $aNDXa = parcelRequire("aNDXa");

var $3gUtn = parcelRequire("3gUtn");

var $7ock2 = parcelRequire("7ock2");
function $28691de83c57f24c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28691de83c57f24c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28691de83c57f24c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28691de83c57f24c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $28691de83c57f24c$export$9cfceb893b24742a = "pm-table";
var $28691de83c57f24c$export$69cb4c3f80383763 = "".concat($28691de83c57f24c$export$9cfceb893b24742a, "-cell-content-wrap");
var $28691de83c57f24c$export$7b07d37d879c957f = "".concat($28691de83c57f24c$export$9cfceb893b24742a, "-header-content-wrap");
var $28691de83c57f24c$export$8dd42a84cd52da07 = "".concat($28691de83c57f24c$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $28691de83c57f24c$export$5e26a5c19f0865d8 = "".concat($28691de83c57f24c$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $28691de83c57f24c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $1xksd.N20).toLocaleLowerCase();
var $28691de83c57f24c$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute("data-colwidth");
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute("colspan") || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute("data-cell-background");
    var dataCellBackgroundHexCode = dataCellBackground && (0, $1xksd.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes("--ds-background-neutral")) backgroundColor = "";
    else if (backgroundColor && (0, $1xksd.isRgb)(backgroundColor)) {
        var result = (0, $1xksd.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues["background"] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute("rowspan") || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
var $28691de83c57f24c$var$testGlobalTheme;
var $28691de83c57f24c$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $28691de83c57f24c$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $28691de83c57f24c$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($28691de83c57f24c$var$testGlobalTheme) return {
        colorMode: $28691de83c57f24c$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $28691de83c57f24c$var$cssVariablePattern = /^var\(--.*\)$/;
var $28691de83c57f24c$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs["data-colwidth"] = node.attrs.colwidth.join(",");
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === "tableHeader" && background === $28691de83c57f24c$export$8cc2833b5b349a1e.get("light gray") || nodeType === "tableCell" && background === $28691de83c57f24c$export$8cc2833b5b349a1e.get("white") || nodeType === "tableHeader" && background.includes("--ds-background-neutral");
        if (ignored) attrs.style = "";
        else {
            var color = (0, $1xksd.isRgb)(background) && (0, $1xksd.rgbToHex)(background) ? (0, $1xksd.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $4B2aM.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $28691de83c57f24c$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($28691de83c57f24c$var$getGlobalTheme().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $3gUtn.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs["data-cell-background"] = color;
            attrs.colorname = $28691de83c57f24c$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === "tableHeader") attrs.class = $28691de83c57f24c$export$7b07d37d879c957f;
    else attrs.class = $28691de83c57f24c$export$69cb4c3f80383763;
    return attrs;
};
var $28691de83c57f24c$export$219b7f492ad209f8 = new Map();
var $28691de83c57f24c$export$95e9c925fbf01d1c = (0, $1xksd.hexToRgba)((0, $1xksd.N800), 0.12) || (0, $1xksd.N0);
var $28691de83c57f24c$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $1xksd.N0),
        "White"
    ],
    [
        (0, $1xksd.B50),
        "Light blue"
    ],
    [
        (0, $1xksd.T50),
        "Light teal"
    ],
    [
        (0, $1xksd.G50),
        "Light green"
    ],
    [
        (0, $1xksd.Y50),
        "Light yellow"
    ],
    [
        (0, $1xksd.R50),
        "Light red"
    ],
    [
        (0, $1xksd.P50),
        "Light purple"
    ],
    [
        (0, $1xksd.N20),
        "Light gray"
    ],
    [
        (0, $1xksd.B75),
        "Blue"
    ],
    [
        (0, $1xksd.T75),
        "Teal"
    ],
    [
        (0, $1xksd.G75),
        "Green"
    ],
    [
        (0, $1xksd.Y75),
        "Yellow"
    ],
    [
        (0, $1xksd.R75),
        "Red"
    ],
    [
        (0, $1xksd.P75),
        "Purple"
    ],
    [
        (0, $1xksd.N60),
        "Gray"
    ],
    [
        (0, $1xksd.B100),
        "Dark blue"
    ],
    [
        (0, $1xksd.T100),
        "Dark teal"
    ],
    [
        (0, $1xksd.G200),
        "Dark green"
    ],
    [
        (0, $1xksd.Y200),
        "Dark yellow"
    ],
    [
        (0, $1xksd.R100),
        "Dark red"
    ],
    [
        (0, $1xksd.P100),
        "Dark purple"
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $i6ZYA.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $28691de83c57f24c$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $28691de83c57f24c$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $28691de83c57f24c$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: "table",
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute("data-number-column") === "true",
                    layout: // copying from editor
                    dom.getAttribute("data-layout") || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute("data-layout")) || "default",
                    __autoSize: dom.getAttribute("data-autosize") === "true",
                    localId: dom.getAttribute("data-table-local-id") || (0, $aNDXa.uuid).generate(),
                    width: Number(dom.getAttribute("data-table-width")) || null,
                    displayMode: dom.getAttribute("data-table-display-mode") || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-number-column": node.attrs.isNumberColumnEnabled,
            "data-layout": node.attrs.layout,
            "data-autosize": node.attrs.__autoSize,
            "data-table-local-id": node.attrs.localId,
            "data-table-width": node.attrs.width,
            "data-table-display-mode": node.attrs.displayMode
        };
        return [
            "table",
            attrs,
            [
                "tbody",
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $28691de83c57f24c$var$createTableSpec = function createTableSpec() {
    return (0, $7ock2.table)($28691de83c57f24c$var$tableNodeSpecOptions);
};
var $28691de83c57f24c$export$9852986a3ec5f6a0 = $28691de83c57f24c$var$createTableSpec();
var $28691de83c57f24c$export$90e634fbace1f0c4 = $28691de83c57f24c$var$createTableSpec();
var $28691de83c57f24c$export$3862de5c8c9098cf = $28691de83c57f24c$var$createTableSpec();
var $28691de83c57f24c$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith("__") && (key !== "localId" || !!value);
};
var $28691de83c57f24c$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $28691de83c57f24c$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $28691de83c57f24c$var$_objectSpread($28691de83c57f24c$var$_objectSpread({}, obj), {}, (0, $lb7vQ.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $28691de83c57f24c$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: "tr"
        }
    ],
    toDOM: function toDOM() {
        return [
            "tr",
            0
        ];
    }
};
var $28691de83c57f24c$export$ce666bf02318c957 = (0, $7ock2.tableRow)($28691de83c57f24c$var$tableRowNodeSpecOptions);
var $28691de83c57f24c$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
var $28691de83c57f24c$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: ".ak-renderer-table-number-column",
            ignore: true
        },
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return $28691de83c57f24c$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            $28691de83c57f24c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $28691de83c57f24c$export$e1e720e5f4603e6a = (0, $7ock2.tableCell)($28691de83c57f24c$var$tableCellNodeSpecOptions);
var $28691de83c57f24c$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($28691de83c57f24c$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $28691de83c57f24c$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return $28691de83c57f24c$export$43977bde391e007(dom, {
                    background: $28691de83c57f24c$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            $28691de83c57f24c$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $28691de83c57f24c$export$48884d2a5190dc73 = (0, $7ock2.tableHeader)($28691de83c57f24c$var$tableHeaderNodeSpecOptions);
var $28691de83c57f24c$export$2af48797a1010bb1 = $28691de83c57f24c$export$2ac34c099660f1a8;
var $28691de83c57f24c$export$ce086a560a1d05f5 = (0, $7ock2.tableWithNestedTable)($28691de83c57f24c$var$tableNodeSpecOptions);
var $28691de83c57f24c$export$7d657479499397 = (0, $7ock2.tableRowWithNestedTable)($28691de83c57f24c$var$tableRowNodeSpecOptions);
var $28691de83c57f24c$export$abf39ca178940ff3 = (0, $7ock2.tableCellWithNestedTable)($28691de83c57f24c$var$tableCellNodeSpecOptions);
var $28691de83c57f24c$export$2a5a518232fa1a97 = (0, $7ock2.tableHeaderWithNestedTable)($28691de83c57f24c$var$tableHeaderNodeSpecOptions);

});
parcelRegister("i6ZYA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d2f8dcbbb7e666e9$export$2e2bcd8739ae039; });

var $1Z6de = parcelRequire("1Z6de");

var $43es5 = parcelRequire("43es5");

var $m5pMH = parcelRequire("m5pMH");

var $zxCN4 = parcelRequire("zxCN4");
function $d2f8dcbbb7e666e9$export$2e2bcd8739ae039(r, e) {
    return (0, $1Z6de.default)(r) || (0, $43es5.default)(r, e) || (0, $m5pMH.default)(r, e) || (0, $zxCN4.default)();
}

});
parcelRegister("1Z6de", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $17204e9af3752969$export$2e2bcd8739ae039; });
function $17204e9af3752969$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("43es5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f32a717b6f5ece0$export$2e2bcd8739ae039; });
function $2f32a717b6f5ece0$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("m5pMH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04264178923d9d14$export$2e2bcd8739ae039; });

var $3rQG0 = parcelRequire("3rQG0");
function $04264178923d9d14$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3rQG0.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3rQG0.default)(r, a) : void 0;
    }
}

});
parcelRegister("3rQG0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $282cc128186bf052$export$2e2bcd8739ae039; });
function $282cc128186bf052$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("zxCN4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06ad5a278d37fe06$export$2e2bcd8739ae039; });
function $06ad5a278d37fe06$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("4B2aM", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $358c4d9b12c32548$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $358c4d9b12c32548$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $358c4d9b12c32548$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $358c4d9b12c32548$export$a270511a0e7fd61a; });

var $4LHd8 = parcelRequire("4LHd8");
function $358c4d9b12c32548$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $358c4d9b12c32548$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $358c4d9b12c32548$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ "#091E4224": "var(--ds-border, #091E4224)",
    /** gray */ "#758195": "var(--ds-border-bold, #758195)",
    /** gray - bold */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $358c4d9b12c32548$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $358c4d9b12c32548$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $358c4d9b12c32548$export$57fa5089caad992 = {
    /** blue - light */ "#B3D4FF": "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    /** blue - medium */ "#4C9AFF": "var(--ds-icon-accent-blue, #4C9AFF)",
    /** blue - strong */ "#0747A6": "var(--ds-text-accent-blue, #0747A6)",
    /** teal - light */ "#B3F5FF": "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    /** teal - medium */ "#00B8D9": "var(--ds-icon-accent-teal, #00B8D9)",
    /** teal - strong */ "#008DA6": "var(--ds-text-accent-teal, #008DA6)",
    /** green - light */ "#ABF5D1": "var(--ds-background-accent-green-subtler, #ABF5D1)",
    /** green - medium */ "#36B37E": "var(--ds-icon-accent-green, #36B37E)",
    /** green - strong */ "#006644": "var(--ds-text-accent-green, #006644)",
    /** yellowOrange - light */ "#FFF0B3": "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    /** yellowOrange - medium */ "#FFC400": "var(--ds-background-accent-orange-subtle, #FFC400)",
    /** yellowOrange - strong */ "#FF991F": "var(--ds-icon-accent-orange, #FF991F)",
    /** red - light */ "#FFBDAD": "var(--ds-background-accent-red-subtler, #FFBDAD)",
    /** red - medium */ "#FF5630": "var(--ds-icon-accent-red, #FF5630)",
    /** red - strong */ "#BF2600": "var(--ds-text-accent-red, #BF2600)",
    /** purple - light */ "#EAE6FF": "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    /** purple - medium */ "#6554C0": "var(--ds-icon-accent-purple, #6554C0)",
    /** purple - strong */ "#403294": "var(--ds-text-accent-purple, #403294)",
    /** whiteGray - light */ "#FFFFFF": "var(--ds-text-inverse, #FFFFFF)",
    /** whiteGray - medium */ "#97A0AF": "var(--ds-icon-accent-gray, #97A0AF)",
    /** whiteGray - strong */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $358c4d9b12c32548$export$8b58ff1b36bb75e0(hexColor) {
    var orangeToYellowEnabled = (0, $4LHd8.default).getExperimentValue("editor_text_highlight_orange_to_yellow", "cohort", "control", {
        fireExperimentExposure: true
    });
    if (orangeToYellowEnabled === "test") $358c4d9b12c32548$export$12a518ff137dd389["#FEDEC8"] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $358c4d9b12c32548$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $358c4d9b12c32548$export$12a518ff137dd389 = {
    /** Gray - light */ "#DCDFE4": "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ "#C6EDFB": "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ "#D3F1A7": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ "#FEDEC8": "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ "#FDD0EC": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ "#DFD8FD": "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $358c4d9b12c32548$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $358c4d9b12c32548$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $358c4d9b12c32548$export$2462741d70e6a62f = {
    /** blue - light */ "#DEEBFF": {
        getValue: function getValue() {
            return "#DEEBFF";
        },
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    /** blue - medium */ "#B3D4FF": {
        getValue: function getValue() {
            return "#B3D4FF";
        },
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    /** blue - strong */ "#4C9AFF": {
        getValue: function getValue() {
            return "#4C9AFF";
        },
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    /** teal - light */ "#E6FCFF": {
        getValue: function getValue() {
            return "#E6FCFF";
        },
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
    },
    /** teal - medium */ "#B3F5FF": {
        getValue: function getValue() {
            return "#B3F5FF";
        },
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
    },
    /** teal - strong */ "#79E2F2": {
        getValue: function getValue() {
            return "#79E2F2";
        },
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
    },
    /** green - light */ "#E3FCEF": {
        getValue: function getValue() {
            return "#E3FCEF";
        },
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
    },
    /** green - medium */ "#ABF5D1": {
        getValue: function getValue() {
            return "#ABF5D1";
        },
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
    },
    /** green - strong */ "#57D9A3": {
        getValue: function getValue() {
            return "#57D9A3";
        },
        token: "var(--ds-background-accent-green-subtle, #57D9A3)"
    },
    /** yellowOrange - light */ "#FFFAE6": {
        getValue: function getValue() {
            return "#FFFAE6";
        },
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
    },
    /** yellowOrange - medium */ "#FFF0B3": {
        getValue: function getValue() {
            return "#FFF0B3";
        },
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
    },
    /** yellowOrange - strong */ "#FFC400": {
        getValue: function getValue() {
            return "#FFC400";
        },
        token: "var(--ds-background-accent-orange-subtle, #FFC400)"
    },
    /** red - light */ "#FFEBE6": {
        getValue: function getValue() {
            return "#FFEBE6";
        },
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
    },
    /** red - medium */ "#FFBDAD": {
        getValue: function getValue() {
            return "#FFBDAD";
        },
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
    },
    /** red - strong */ "#FF8F73": {
        getValue: function getValue() {
            return "#FF8F73";
        },
        token: "var(--ds-background-accent-red-subtle, #FF8F73)"
    },
    /** purple - light */ "#EAE6FF": {
        getValue: function getValue() {
            return "#EAE6FF";
        },
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
    },
    /** purple - medium */ "#C0B6F2": {
        getValue: function getValue() {
            return "#C0B6F2";
        },
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
    },
    /** purple - strong */ "#998DD9": {
        getValue: function getValue() {
            return "#998DD9";
        },
        token: "var(--ds-background-accent-purple-subtle, #998DD9)"
    },
    /** whiteGray - light */ "#FFFFFF": {
        getValue: function getValue() {
            return "#FFFFFF";
        },
        token: "var(--ds-surface, #FFFFFF)"
    },
    /** whiteGray - medium */ "#F4F5F7": {
        getValue: function getValue() {
            return "#F4F5F7";
        },
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
    },
    /** whiteGray - strong */ "#B3BAC5": {
        getValue: function getValue() {
            return "#B3BAC5";
        },
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
    }
};

});

parcelRegister("1xksd", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $11e8bd429e6a7c1d$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $11e8bd429e6a7c1d$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $11e8bd429e6a7c1d$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $11e8bd429e6a7c1d$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $11e8bd429e6a7c1d$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $11e8bd429e6a7c1d$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $11e8bd429e6a7c1d$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $11e8bd429e6a7c1d$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y400", function () { return $11e8bd429e6a7c1d$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $11e8bd429e6a7c1d$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $11e8bd429e6a7c1d$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $11e8bd429e6a7c1d$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $11e8bd429e6a7c1d$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $11e8bd429e6a7c1d$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $11e8bd429e6a7c1d$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $11e8bd429e6a7c1d$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $11e8bd429e6a7c1d$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $11e8bd429e6a7c1d$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $11e8bd429e6a7c1d$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $11e8bd429e6a7c1d$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $11e8bd429e6a7c1d$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $11e8bd429e6a7c1d$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $11e8bd429e6a7c1d$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $11e8bd429e6a7c1d$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $11e8bd429e6a7c1d$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $11e8bd429e6a7c1d$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $11e8bd429e6a7c1d$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $11e8bd429e6a7c1d$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $11e8bd429e6a7c1d$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $11e8bd429e6a7c1d$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $11e8bd429e6a7c1d$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $11e8bd429e6a7c1d$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $11e8bd429e6a7c1d$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $11e8bd429e6a7c1d$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $11e8bd429e6a7c1d$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $11e8bd429e6a7c1d$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $11e8bd429e6a7c1d$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $11e8bd429e6a7c1d$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $11e8bd429e6a7c1d$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $11e8bd429e6a7c1d$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $11e8bd429e6a7c1d$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $11e8bd429e6a7c1d$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $11e8bd429e6a7c1d$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $11e8bd429e6a7c1d$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $11e8bd429e6a7c1d$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $11e8bd429e6a7c1d$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $11e8bd429e6a7c1d$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $11e8bd429e6a7c1d$export$9665a07d9187b414; });

var $i6ZYA = parcelRequire("i6ZYA");

var $1PZpd = parcelRequire("1PZpd");
var $11e8bd429e6a7c1d$export$4b84fd0e2c617bd = "#FFEBE6";
var $11e8bd429e6a7c1d$export$b34b069eff244586 = "#FFBDAD";
var $11e8bd429e6a7c1d$export$be802dd0d8b57f35 = "#FF8F73";
var $11e8bd429e6a7c1d$export$4a7404f376229999 = "#FF5630";
var $11e8bd429e6a7c1d$export$2010d0fb4295b346 = "#DE350B";
var $11e8bd429e6a7c1d$export$2837b5a1a71d5c02 = "#BF2600";
var $11e8bd429e6a7c1d$export$8d9596b529bbb9cf = "#FFFAE6";
var $11e8bd429e6a7c1d$export$41060a744ab0b7ae = "#FFF0B3";
var $11e8bd429e6a7c1d$export$5aae31392d72caaa = "#FFC400";
var $11e8bd429e6a7c1d$export$59619663aa6500fb = "#FF991F";
var $11e8bd429e6a7c1d$export$874739ea9e379ab6 = "#FF8B00";
var $11e8bd429e6a7c1d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $11e8bd429e6a7c1d$export$69a3bf21b9686c2b = "#ABF5D1";
var $11e8bd429e6a7c1d$export$747d86715d4175de = "#57D9A3";
var $11e8bd429e6a7c1d$export$940e1f69e873f202 = "#36B37E";
var $11e8bd429e6a7c1d$export$a49394138f7b8e85 = "#00875A";
var $11e8bd429e6a7c1d$export$6fa04827ac68a4fb = "#006644";
var $11e8bd429e6a7c1d$export$226de0355ed012f8 = "#DEEBFF";
var $11e8bd429e6a7c1d$export$8c13c2ee36917869 = "#B3D4FF";
var $11e8bd429e6a7c1d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $11e8bd429e6a7c1d$export$b3de0ae08da2ce64 = "#0052CC";
var $11e8bd429e6a7c1d$export$a6ee3d71bc067634 = "#0747A6";
var $11e8bd429e6a7c1d$export$f72948ef771f6f15 = "#D3F1A7";
var $11e8bd429e6a7c1d$export$29a4f05edc054374 = "#FFFFFF";
var $11e8bd429e6a7c1d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $11e8bd429e6a7c1d$export$3e51e8f1440314ba = "#EBECF0";
var $11e8bd429e6a7c1d$export$1ce2d1575d444ceb = "#DFE1E6";
var $11e8bd429e6a7c1d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $11e8bd429e6a7c1d$export$c2e91cbeada39b8b = "#B3BAC5";
var $11e8bd429e6a7c1d$export$eaa8c8a70ac22806 = "#97A0AF";
var $11e8bd429e6a7c1d$export$7c87d337fb91a97d = "#8993A4";
var $11e8bd429e6a7c1d$export$f563ee71e9ee74cd = "#6B778C";
var $11e8bd429e6a7c1d$export$e2ef2124cf4024b1 = "#5E6C84";
var $11e8bd429e6a7c1d$export$1ae1cebe22dcedb4 = "#DCDFE4";
var $11e8bd429e6a7c1d$export$13609db0e6812ab8 = "#091E4224";
var $11e8bd429e6a7c1d$export$c39c0fe0f26207ae = "#42526E";
var $11e8bd429e6a7c1d$export$7090862dc3038a9f = "#758195";
var $11e8bd429e6a7c1d$export$7d61b15e0da132af = "#172B4D";
var $11e8bd429e6a7c1d$export$f78789c8b01753cd = "#172B4D";
var $11e8bd429e6a7c1d$export$a19f0c33186f7767 = "#FDD0EC";
var $11e8bd429e6a7c1d$export$51716a84e62e022c = "#FEDEC8";
var $11e8bd429e6a7c1d$export$363e4475840015bb = "#EAE6FF";
var $11e8bd429e6a7c1d$export$4b0a4417ed59760f = "#C0B6F2";
var $11e8bd429e6a7c1d$export$6011520a64d9a187 = "#998DD9";
var $11e8bd429e6a7c1d$export$a7175d4e9206bc80 = "#DFD8FD";
var $11e8bd429e6a7c1d$export$b48405b95304b5a1 = "#6554C0";
var $11e8bd429e6a7c1d$export$c71e4279dd54a18d = "#5243AA";
var $11e8bd429e6a7c1d$export$147899de772240ec = "#403294";
var $11e8bd429e6a7c1d$export$2cf711fe14c66f06 = "#E6FCFF";
var $11e8bd429e6a7c1d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $11e8bd429e6a7c1d$export$776c9c497ef08533 = "#79E2F2";
var $11e8bd429e6a7c1d$export$69cb3ca10c1e330e = "#C6EDFB";
var $11e8bd429e6a7c1d$export$9dc1ef0f3f48059b = "#00B8D9";
var $11e8bd429e6a7c1d$export$6036577f95c3877e = "#008DA6";
function $11e8bd429e6a7c1d$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($11e8bd429e6a7c1d$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split("").map(function(c) {
            return c === "#" ? "#" : "".concat(c).concat(c);
        }).join("");
    } else if ($11e8bd429e6a7c1d$export$e698776ec826343(color)) return $11e8bd429e6a7c1d$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === "default") return null;
        else if ($1PZpd.default && $1PZpd.default[color]) color = $1PZpd.default[color];
        else if ($1PZpd && $1PZpd[color]) color = $1PZpd[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $11e8bd429e6a7c1d$export$5a544e13ad4e1fa5(color) {
    if (!$11e8bd429e6a7c1d$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split("");
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join("")));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $11e8bd429e6a7c1d$export$9665a07d9187b414(rawColor, alpha) {
    var color = $11e8bd429e6a7c1d$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(","), ")");
}
function $11e8bd429e6a7c1d$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $i6ZYA.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return "#" + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $11e8bd429e6a7c1d$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $11e8bd429e6a7c1d$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("1PZpd", function(module, exports) {
module.exports = JSON.parse('{"aliceblue":"#f0f8ff","antiquewhite":"#faebd7","aqua":"#00ffff","aquamarine":"#7fffd4","azure":"#f0ffff","beige":"#f5f5dc","bisque":"#ffe4c4","black":"#000000","blanchedalmond":"#ffebcd","blue":"#0000ff","blueviolet":"#8a2be2","brown":"#a52a2a","burlywood":"#deb887","cadetblue":"#5f9ea0","chartreuse":"#7fff00","chocolate":"#d2691e","coral":"#ff7f50","cornflowerblue":"#6495ed","cornsilk":"#fff8dc","crimson":"#dc143c","cyan":"#00ffff","darkblue":"#00008b","darkcyan":"#008b8b","darkgoldenrod":"#b8860b","darkgray":"#a9a9a9","darkgreen":"#006400","darkgrey":"#a9a9a9","darkkhaki":"#bdb76b","darkmagenta":"#8b008b","darkolivegreen":"#556b2f","darkorange":"#ff8c00","darkorchid":"#9932cc","darkred":"#8b0000","darksalmon":"#e9967a","darkseagreen":"#8fbc8f","darkslateblue":"#483d8b","darkslategray":"#2f4f4f","darkslategrey":"#2f4f4f","darkturquoise":"#00ced1","darkviolet":"#9400d3","deeppink":"#ff1493","deepskyblue":"#00bfff","dimgray":"#696969","dimgrey":"#696969","dodgerblue":"#1e90ff","firebrick":"#b22222","floralwhite":"#fffaf0","forestgreen":"#228b22","fuchsia":"#ff00ff","gainsboro":"#dcdcdc","ghostwhite":"#f8f8ff","gold":"#ffd700","goldenrod":"#daa520","gray":"#808080","green":"#008000","greenyellow":"#adff2f","grey":"#808080","honeydew":"#f0fff0","hotpink":"#ff69b4","indianred":"#cd5c5c","indigo":"#4b0082","ivory":"#fffff0","khaki":"#f0e68c","lavender":"#e6e6fa","lavenderblush":"#fff0f5","lawngreen":"#7cfc00","lemonchiffon":"#fffacd","lightblue":"#add8e6","lightcoral":"#f08080","lightcyan":"#e0ffff","lightgoldenrodyellow":"#fafad2","lightgray":"#d3d3d3","lightgreen":"#90ee90","lightgrey":"#d3d3d3","lightpink":"#ffb6c1","lightsalmon":"#ffa07a","lightseagreen":"#20b2aa","lightskyblue":"#87cefa","lightslategray":"#778899","lightslategrey":"#778899","lightsteelblue":"#b0c4de","lightyellow":"#ffffe0","lime":"#00ff00","limegreen":"#32cd32","linen":"#faf0e6","magenta":"#ff00ff","maroon":"#800000","mediumaquamarine":"#66cdaa","mediumblue":"#0000cd","mediumorchid":"#ba55d3","mediumpurple":"#9370db","mediumseagreen":"#3cb371","mediumslateblue":"#7b68ee","mediumspringgreen":"#00fa9a","mediumturquoise":"#48d1cc","mediumvioletred":"#c71585","midnightblue":"#191970","mintcream":"#f5fffa","mistyrose":"#ffe4e1","moccasin":"#ffe4b5","navajowhite":"#ffdead","navy":"#000080","oldlace":"#fdf5e6","olive":"#808000","olivedrab":"#6b8e23","orange":"#ffa500","orangered":"#ff4500","orchid":"#da70d6","palegoldenrod":"#eee8aa","palegreen":"#98fb98","paleturquoise":"#afeeee","palevioletred":"#db7093","papayawhip":"#ffefd5","peachpuff":"#ffdab9","peru":"#cd853f","pink":"#ffc0cb","plum":"#dda0dd","powderblue":"#b0e0e6","purple":"#800080","rebeccapurple":"#663399","red":"#ff0000","rosybrown":"#bc8f8f","royalblue":"#4169e1","saddlebrown":"#8b4513","salmon":"#fa8072","sandybrown":"#f4a460","seagreen":"#2e8b57","seashell":"#fff5ee","sienna":"#a0522d","silver":"#c0c0c0","skyblue":"#87ceeb","slateblue":"#6a5acd","slategray":"#708090","slategrey":"#708090","snow":"#fffafa","springgreen":"#00ff7f","steelblue":"#4682b4","tan":"#d2b48c","teal":"#008080","thistle":"#d8bfd8","tomato":"#ff6347","turquoise":"#40e0d0","violet":"#ee82ee","wheat":"#f5deb3","white":"#ffffff","whitesmoke":"#f5f5f5","yellow":"#ffff00","yellowgreen":"#9acd32"}');

});


parcelRegister("aNDXa", function(module, exports) {

$parcel$export(module.exports, "generateUuid", function () { return $7dcd78e489118774$export$1c3aefb711c3a4cc; });
$parcel$export(module.exports, "uuid", function () { return $7dcd78e489118774$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $7dcd78e489118774$export$1c3aefb711c3a4cc = function generateUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $7dcd78e489118774$var$staticValue = false;
var $7dcd78e489118774$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $7dcd78e489118774$var$staticValue = value;
    },
    generate: function generate() {
        return $7dcd78e489118774$var$staticValue || $7dcd78e489118774$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("3gUtn", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $261eac0b871f8f0f$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $261eac0b871f8f0f$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $261eac0b871f8f0f$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $261eac0b871f8f0f$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $261eac0b871f8f0f$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $261eac0b871f8f0f$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $261eac0b871f8f0f$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $261eac0b871f8f0f$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $261eac0b871f8f0f$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $261eac0b871f8f0f$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $261eac0b871f8f0f$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $261eac0b871f8f0f$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $261eac0b871f8f0f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $261eac0b871f8f0f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $261eac0b871f8f0f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $261eac0b871f8f0f$var$rgbToLch = function rgbToLch(rgb) {
    return $261eac0b871f8f0f$var$labToLch($261eac0b871f8f0f$var$xyzToLab($261eac0b871f8f0f$var$rgbToXyz(rgb)));
};
var $261eac0b871f8f0f$var$lchToRgb = function lchToRgb(lch) {
    return $261eac0b871f8f0f$var$xyzToRgb($261eac0b871f8f0f$var$labToXyz($261eac0b871f8f0f$var$lchToLab(lch)));
};
var $261eac0b871f8f0f$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $261eac0b871f8f0f$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $261eac0b871f8f0f$var$rgbToLch(rgb);
    lch.l = $261eac0b871f8f0f$var$clamp(newPercent, 0, 100);
    return $261eac0b871f8f0f$var$rgbToHex($261eac0b871f8f0f$var$lchToRgb(lch));
};
var $261eac0b871f8f0f$var$getLightness = function getLightness(color) {
    var rgb = $261eac0b871f8f0f$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $261eac0b871f8f0f$var$rgbToLch(rgb);
    return lch.l;
};
var $261eac0b871f8f0f$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $261eac0b871f8f0f$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $261eac0b871f8f0f$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("8Joc2", function(module, exports) {

$parcel$export(module.exports, "createSchema", function () { return $65b54af82a2dd63c$export$5f4ce795563f4211; });

var $iks2Q = parcelRequire("iks2Q");

var $iw0m5 = parcelRequire("iw0m5");

var $913Aj = parcelRequire("913Aj");

var $1wv9P = parcelRequire("1wv9P");
var $jhq6p = parcelRequire("jhq6p");
var $xxHC9 = parcelRequire("xxHC9");
var $dNM70 = parcelRequire("dNM70");
var $7VIdP = parcelRequire("7VIdP");
var $9rNMQ = parcelRequire("9rNMQ");
var $gYcSK = parcelRequire("gYcSK");
var $aNjCV = parcelRequire("aNjCV");
var $1cjut = parcelRequire("1cjut");
var $480Pe = parcelRequire("480Pe");
var $cyuqo = parcelRequire("cyuqo");
var $dKqYB = parcelRequire("dKqYB");
var $coMR1 = parcelRequire("coMR1");
var $fB8Ns = parcelRequire("fB8Ns");
var $jF8Fw = parcelRequire("jF8Fw");
var $8Aj9z = parcelRequire("8Aj9z");
var $i3rCo = parcelRequire("i3rCo");
var $c3zEJ = parcelRequire("c3zEJ");
var $dgJK8 = parcelRequire("dgJK8");
var $aIaZE = parcelRequire("aIaZE");

var $3gLga = parcelRequire("3gLga");
var $aIlVh = parcelRequire("aIlVh");
var $gMvMs = parcelRequire("gMvMs");
var $3NGHX = parcelRequire("3NGHX");
var $i5M8n = parcelRequire("i5M8n");
var $jm1NE = parcelRequire("jm1NE");
var $8jTUK = parcelRequire("8jTUK");
var $1F0TT = parcelRequire("1F0TT");
var $90cY1 = parcelRequire("90cY1");
var $fXchj = parcelRequire("fXchj");
var $2ij4H = parcelRequire("2ij4H");
var $1cLwK = parcelRequire("1cLwK");
var $5Qdtg = parcelRequire("5Qdtg");
var $lAbHs = parcelRequire("lAbHs");
var $hAe68 = parcelRequire("hAe68");
var $6aZsU = parcelRequire("6aZsU");
var $fIfwP = parcelRequire("fIfwP");
var $hNHSh = parcelRequire("hNHSh");
var $7kwhx = parcelRequire("7kwhx");
var $4Atby = parcelRequire("4Atby");
var $6eriT = parcelRequire("6eriT");
var $6MUwd = parcelRequire("6MUwd");
var $ggZ1g = parcelRequire("ggZ1g");
var $cCTAq = parcelRequire("cCTAq");
var $cZppu = parcelRequire("cZppu");
var $RyvU3 = parcelRequire("RyvU3");
var $i46Fe = parcelRequire("i46Fe");
var $l5UW2 = parcelRequire("l5UW2");
var $dEwsT = parcelRequire("dEwsT");
var $dPLzN = parcelRequire("dPLzN");
var $cea0W = parcelRequire("cea0W");
var $2hW23 = parcelRequire("2hW23");
var $dKUxU = parcelRequire("dKUxU");
var $bPGVA = parcelRequire("bPGVA");
var $koTFc = parcelRequire("koTFc");
var $hjZVB = parcelRequire("hjZVB");
var $ahPRM = parcelRequire("ahPRM");
var $6q36U = parcelRequire("6q36U");
var $3t6uD = parcelRequire("3t6uD");
var $2YXnv = parcelRequire("2YXnv");
var $hvLof = parcelRequire("hvLof");
var $eXoFB = parcelRequire("eXoFB");
var $9LWfX = parcelRequire("9LWfX");
var $9SYbN = parcelRequire("9SYbN");
var $7s3bA = parcelRequire("7s3bA");
function $65b54af82a2dd63c$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $65b54af82a2dd63c$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $65b54af82a2dd63c$var$markGroupDeclarations = [
    $65b54af82a2dd63c$var$groupDeclaration((0, $iw0m5.COLOR)),
    $65b54af82a2dd63c$var$groupDeclaration((0, $iw0m5.FONT_STYLE)),
    $65b54af82a2dd63c$var$groupDeclaration((0, $iw0m5.SEARCH_QUERY)),
    $65b54af82a2dd63c$var$groupDeclaration((0, $iw0m5.LINK))
];
var $65b54af82a2dd63c$var$markGroupDeclarationsNames = $65b54af82a2dd63c$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $65b54af82a2dd63c$var$nodesInOrder = [
    {
        name: "doc",
        spec: (0, $1cLwK.doc)
    },
    {
        name: "paragraph",
        spec: (0, $koTFc.paragraph)
    },
    {
        name: "text",
        spec: (0, $eXoFB.text)
    },
    {
        name: "bulletList",
        spec: (0, $gMvMs.bulletList)
    },
    {
        name: "orderedList",
        spec: (0, $bPGVA.orderedListWithOrder)
    },
    {
        name: "listItem",
        spec: (0, $i46Fe.listItemWithTask)
    },
    {
        name: "heading",
        spec: (0, $6eriT.heading)
    },
    {
        name: "blockquote",
        spec: (0, $6aZsU.extendedBlockquote)
    },
    {
        name: "codeBlock",
        spec: (0, $i5M8n.codeBlock)
    },
    {
        name: "panel",
        spec: (0, $fIfwP.extendedPanel)(true)
    },
    {
        name: "rule",
        spec: (0, $ahPRM.rule)
    },
    {
        name: "image",
        spec: (0, $6MUwd.image)
    },
    {
        name: "mention",
        spec: (0, $2hW23.mention)
    },
    {
        name: "caption",
        spec: (0, $3NGHX.caption)
    },
    {
        name: "media",
        spec: (0, $l5UW2.media)
    },
    {
        name: "mediaGroup",
        spec: (0, $dEwsT.mediaGroup)
    },
    {
        name: "mediaSingle",
        spec: (0, $cea0W.mediaSingleFull)
    },
    {
        name: "mediaInline",
        spec: (0, $dPLzN.mediaInline)
    },
    {
        name: "placeholder",
        spec: (0, $hjZVB.placeholder)
    },
    {
        name: "layoutSection",
        spec: (0, $RyvU3.layoutSection)
    },
    {
        name: "layoutColumn",
        spec: (0, $cZppu.layoutColumn)
    },
    {
        name: "hardBreak",
        spec: (0, $4Atby.hardBreak)
    },
    {
        name: "emoji",
        spec: (0, $lAbHs.emoji)
    },
    {
        name: "table",
        spec: (0, $3t6uD.table)
    },
    {
        name: "tableCell",
        spec: (0, $3t6uD.tableCell)
    },
    {
        name: "tableRow",
        spec: (0, $3t6uD.tableRow)
    },
    {
        name: "tableHeader",
        spec: (0, $3t6uD.tableHeader)
    },
    {
        name: "confluenceJiraIssue",
        spec: (0, $jm1NE.confluenceJiraIssue)
    },
    {
        name: "confluenceUnsupportedInline",
        spec: (0, $1F0TT.confluenceUnsupportedInline)
    },
    {
        name: "confluenceUnsupportedBlock",
        spec: (0, $8jTUK.confluenceUnsupportedBlock)
    },
    {
        name: "decisionList",
        spec: (0, $2ij4H.decisionList)
    },
    {
        name: "decisionItem",
        spec: (0, $fXchj.decisionItem)
    },
    {
        name: "taskList",
        spec: (0, $hvLof.taskList)
    },
    {
        name: "taskItem",
        spec: (0, $2YXnv.taskItem)
    },
    {
        name: "date",
        spec: (0, $90cY1.date)
    },
    {
        name: "status",
        spec: (0, $6q36U.status)
    },
    {
        name: "expand",
        spec: (0, $hAe68.expandWithNestedExpand)
    },
    {
        name: "nestedExpand",
        spec: (0, $dKUxU.nestedExpand)
    },
    {
        name: "extension",
        spec: (0, $hNHSh.extension)
    },
    {
        name: "inlineExtension",
        spec: (0, $cCTAq.inlineExtension)
    },
    {
        name: "bodiedExtension",
        spec: (0, $aIlVh.bodiedExtension)
    },
    {
        name: "multiBodiedExtension",
        spec: (0, $7kwhx.multiBodiedExtension)
    },
    {
        name: "extensionFrame",
        spec: (0, $7kwhx.extensionFrame)
    },
    {
        name: "inlineCard",
        spec: (0, $ggZ1g.inlineCard)
    },
    {
        name: "blockCard",
        spec: (0, $3gLga.blockCard)
    },
    {
        name: "embedCard",
        spec: (0, $5Qdtg.embedCard)
    },
    {
        name: "unknownBlock",
        spec: (0, $9LWfX.default)
    },
    {
        name: "unsupportedBlock",
        spec: (0, $9SYbN.unsupportedBlock)
    },
    {
        name: "unsupportedInline",
        spec: (0, $7s3bA.unsupportedInline)
    }
];
var $65b54af82a2dd63c$var$marksInOrder = [
    {
        name: "link",
        spec: (0, $dKqYB.link)
    },
    {
        name: "em",
        spec: (0, $1cjut.em)
    },
    {
        name: "strong",
        spec: (0, $fB8Ns.strong)
    },
    {
        name: "textColor",
        spec: (0, $8Aj9z.textColor)
    },
    {
        name: "backgroundColor",
        spec: (0, $xxHC9.backgroundColor)
    },
    {
        name: "strike",
        spec: (0, $coMR1.strike)
    },
    {
        name: "subsup",
        spec: (0, $jF8Fw.subsup)
    },
    {
        name: "underline",
        spec: (0, $c3zEJ.underline)
    },
    {
        name: "code",
        spec: (0, $9rNMQ.code)
    },
    {
        name: "typeAheadQuery",
        spec: (0, $i3rCo.typeAheadQuery)
    },
    {
        name: "alignment",
        spec: (0, $1wv9P.alignment)
    },
    {
        name: "annotation",
        spec: (0, $jhq6p.annotation)
    },
    {
        name: "confluenceInlineComment",
        spec: (0, $gYcSK.confluenceInlineComment)
    }
].concat($65b54af82a2dd63c$var$markGroupDeclarations, [
    {
        name: "breakout",
        spec: (0, $7VIdP.breakout)
    },
    {
        name: "dataConsumer",
        spec: (0, $aNjCV.dataConsumer)
    },
    {
        name: "fragment",
        spec: (0, $480Pe.fragment)
    },
    {
        name: "indentation",
        spec: (0, $cyuqo.indentation)
    },
    {
        name: "border",
        spec: (0, $dNM70.border)
    },
    {
        name: "unsupportedMark",
        spec: (0, $dgJK8.unsupportedMark)
    },
    {
        name: "unsupportedNodeAttribute",
        spec: (0, $aIaZE.unsupportedNodeAttribute)
    }
]);
function $65b54af82a2dd63c$export$2d0c32a809131488() {
    var nodes = $65b54af82a2dd63c$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $65b54af82a2dd63c$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $65b54af82a2dd63c$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($65b54af82a2dd63c$var$markGroupDeclarationsNames);
    var nodes = $65b54af82a2dd63c$var$addItems($65b54af82a2dd63c$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $65b54af82a2dd63c$var$addItems($65b54af82a2dd63c$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $913Aj.sanitizeNodes)(nodes, marks);
    return new (0, $iks2Q.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $65b54af82a2dd63c$export$c77b6d30da5276a1 = true;

});
parcelRegister("iks2Q", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d57fd95f8ec84109$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $d57fd95f8ec84109$export$19342e026b58ebb7; });

var $73qKE = parcelRequire("73qKE");
function $d57fd95f8ec84109$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $d57fd95f8ec84109$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $d57fd95f8ec84109$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $d57fd95f8ec84109$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $d57fd95f8ec84109$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $d57fd95f8ec84109$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $d57fd95f8ec84109$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $d57fd95f8ec84109$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $d57fd95f8ec84109$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $d57fd95f8ec84109$var$retIndex(0, pos);
        if (pos == this.size) return $d57fd95f8ec84109$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $d57fd95f8ec84109$var$retIndex(i + 1, end);
                return $d57fd95f8ec84109$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $d57fd95f8ec84109$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $d57fd95f8ec84109$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $d57fd95f8ec84109$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $d57fd95f8ec84109$export$ffb0004e005737fa.empty;
        if (nodes instanceof $d57fd95f8ec84109$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $d57fd95f8ec84109$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $d57fd95f8ec84109$export$ffb0004e005737fa.empty = new $d57fd95f8ec84109$export$ffb0004e005737fa([], 0);
const $d57fd95f8ec84109$var$found = {
    index: 0,
    offset: 0
};
function $d57fd95f8ec84109$var$retIndex(index, offset) {
    $d57fd95f8ec84109$var$found.index = index;
    $d57fd95f8ec84109$var$found.offset = offset;
    return $d57fd95f8ec84109$var$found;
}
function $d57fd95f8ec84109$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$d57fd95f8ec84109$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$d57fd95f8ec84109$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $d57fd95f8ec84109$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $d57fd95f8ec84109$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
        if (marks instanceof $d57fd95f8ec84109$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $d57fd95f8ec84109$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $d57fd95f8ec84109$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $d57fd95f8ec84109$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $d57fd95f8ec84109$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $d57fd95f8ec84109$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $d57fd95f8ec84109$export$b3f2e2de3a8baa1e($d57fd95f8ec84109$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $d57fd95f8ec84109$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $d57fd95f8ec84109$export$b3f2e2de3a8baa1e($d57fd95f8ec84109$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $d57fd95f8ec84109$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $d57fd95f8ec84109$export$b3f2e2de3a8baa1e.empty = new $d57fd95f8ec84109$export$b3f2e2de3a8baa1e($d57fd95f8ec84109$export$ffb0004e005737fa.empty, 0, 0);
function $d57fd95f8ec84109$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($d57fd95f8ec84109$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $d57fd95f8ec84109$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $d57fd95f8ec84109$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $d57fd95f8ec84109$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $d57fd95f8ec84109$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $d57fd95f8ec84109$export$6de0e778727af3f2("Inconsistent open depths");
    return $d57fd95f8ec84109$var$replaceOuter($from, $to, slice, 0);
}
function $d57fd95f8ec84109$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $d57fd95f8ec84109$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $d57fd95f8ec84109$var$close(node, $d57fd95f8ec84109$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $d57fd95f8ec84109$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $d57fd95f8ec84109$var$prepareSliceForReplace(slice, $from);
        return $d57fd95f8ec84109$var$close(node, $d57fd95f8ec84109$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $d57fd95f8ec84109$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $d57fd95f8ec84109$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $d57fd95f8ec84109$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $d57fd95f8ec84109$var$checkJoin(node, $after.node(depth));
    return node;
}
function $d57fd95f8ec84109$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $d57fd95f8ec84109$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $d57fd95f8ec84109$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$d57fd95f8ec84109$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $d57fd95f8ec84109$var$addNode($end.nodeBefore, target);
}
function $d57fd95f8ec84109$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $d57fd95f8ec84109$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $d57fd95f8ec84109$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $d57fd95f8ec84109$var$joinable($end, $to, depth + 1);
    let content = [];
    $d57fd95f8ec84109$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $d57fd95f8ec84109$var$checkJoin(openStart, openEnd);
        $d57fd95f8ec84109$var$addNode($d57fd95f8ec84109$var$close(openStart, $d57fd95f8ec84109$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $d57fd95f8ec84109$var$addNode($d57fd95f8ec84109$var$close(openStart, $d57fd95f8ec84109$var$replaceTwoWay($from, $start, depth + 1)), content);
        $d57fd95f8ec84109$var$addRange($start, $end, depth, content);
        if (openEnd) $d57fd95f8ec84109$var$addNode($d57fd95f8ec84109$var$close(openEnd, $d57fd95f8ec84109$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $d57fd95f8ec84109$var$addRange($to, null, depth, content);
    return new $d57fd95f8ec84109$export$ffb0004e005737fa(content);
}
function $d57fd95f8ec84109$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $d57fd95f8ec84109$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $d57fd95f8ec84109$var$joinable($from, $to, depth + 1);
        $d57fd95f8ec84109$var$addNode($d57fd95f8ec84109$var$close(type, $d57fd95f8ec84109$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $d57fd95f8ec84109$var$addRange($to, null, depth, content);
    return new $d57fd95f8ec84109$export$ffb0004e005737fa(content);
}
function $d57fd95f8ec84109$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($d57fd95f8ec84109$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $d57fd95f8ec84109$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $d57fd95f8ec84109$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $d57fd95f8ec84109$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $d57fd95f8ec84109$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $d57fd95f8ec84109$var$resolveCache.set(doc, cache = new $d57fd95f8ec84109$var$ResolveCache);
        let result = cache.elts[cache.i] = $d57fd95f8ec84109$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $d57fd95f8ec84109$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $d57fd95f8ec84109$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $d57fd95f8ec84109$var$resolveCacheSize = 12, $d57fd95f8ec84109$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $d57fd95f8ec84109$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $d57fd95f8ec84109$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $d57fd95f8ec84109$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $d57fd95f8ec84109$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $d57fd95f8ec84109$var$emptyAttrs) && $d57fd95f8ec84109$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $d57fd95f8ec84109$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $d57fd95f8ec84109$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $d57fd95f8ec84109$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $d57fd95f8ec84109$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $d57fd95f8ec84109$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $d57fd95f8ec84109$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $d57fd95f8ec84109$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $d57fd95f8ec84109$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $d57fd95f8ec84109$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $d57fd95f8ec84109$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$d57fd95f8ec84109$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $d57fd95f8ec84109$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $d57fd95f8ec84109$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $d57fd95f8ec84109$export$ffb0004e005737fa.empty;
    }
}
$d57fd95f8ec84109$export$85c928794f8d04d4.prototype.text = undefined;
class $d57fd95f8ec84109$var$TextNode extends $d57fd95f8ec84109$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $d57fd95f8ec84109$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $d57fd95f8ec84109$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $d57fd95f8ec84109$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $d57fd95f8ec84109$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $d57fd95f8ec84109$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $d57fd95f8ec84109$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $d57fd95f8ec84109$export$364ed450558d7ec4.empty;
        let expr = $d57fd95f8ec84109$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $d57fd95f8ec84109$var$dfa($d57fd95f8ec84109$var$nfa(expr));
        $d57fd95f8ec84109$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $d57fd95f8ec84109$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $d57fd95f8ec84109$export$364ed450558d7ec4.empty = new $d57fd95f8ec84109$export$364ed450558d7ec4(true);
class $d57fd95f8ec84109$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $d57fd95f8ec84109$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($d57fd95f8ec84109$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $d57fd95f8ec84109$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($d57fd95f8ec84109$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $d57fd95f8ec84109$var$parseExprSubscript(stream) {
    let expr = $d57fd95f8ec84109$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $d57fd95f8ec84109$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $d57fd95f8ec84109$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $d57fd95f8ec84109$var$parseExprRange(stream, expr) {
    let min = $d57fd95f8ec84109$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $d57fd95f8ec84109$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $d57fd95f8ec84109$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $d57fd95f8ec84109$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $d57fd95f8ec84109$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $d57fd95f8ec84109$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $d57fd95f8ec84109$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $d57fd95f8ec84109$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $d57fd95f8ec84109$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($d57fd95f8ec84109$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $d57fd95f8ec84109$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($d57fd95f8ec84109$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $d57fd95f8ec84109$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $d57fd95f8ec84109$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($d57fd95f8ec84109$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $d57fd95f8ec84109$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $d57fd95f8ec84109$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $d57fd95f8ec84109$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $d57fd95f8ec84109$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $d57fd95f8ec84109$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $d57fd95f8ec84109$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $d57fd95f8ec84109$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $d57fd95f8ec84109$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $d57fd95f8ec84109$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $d57fd95f8ec84109$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $d57fd95f8ec84109$export$ffb0004e005737fa.from(content), $d57fd95f8ec84109$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $d57fd95f8ec84109$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $d57fd95f8ec84109$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $d57fd95f8ec84109$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $d57fd95f8ec84109$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($d57fd95f8ec84109$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $d57fd95f8ec84109$export$85c928794f8d04d4(this, attrs, content.append(after), $d57fd95f8ec84109$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $d57fd95f8ec84109$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $d57fd95f8ec84109$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $d57fd95f8ec84109$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $d57fd95f8ec84109$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $d57fd95f8ec84109$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $d57fd95f8ec84109$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $d57fd95f8ec84109$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $d57fd95f8ec84109$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $d57fd95f8ec84109$export$c9d15bcfc6d42044(this, $d57fd95f8ec84109$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $d57fd95f8ec84109$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $d57fd95f8ec84109$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $d57fd95f8ec84109$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $d57fd95f8ec84109$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $d57fd95f8ec84109$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $d57fd95f8ec84109$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $d57fd95f8ec84109$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $d57fd95f8ec84109$var$TextNode(type, type.defaultAttrs, text, $d57fd95f8ec84109$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $d57fd95f8ec84109$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $d57fd95f8ec84109$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $73qKE.default).from(spec.nodes), instanceSpec.marks = (0, $73qKE.default).from(spec.marks || {}), this.nodes = $d57fd95f8ec84109$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $d57fd95f8ec84109$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $d57fd95f8ec84109$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $d57fd95f8ec84109$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $d57fd95f8ec84109$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $d57fd95f8ec84109$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $d57fd95f8ec84109$var$isTagRule(rule) {
    return rule.tag != null;
}
function $d57fd95f8ec84109$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $d57fd95f8ec84109$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $d57fd95f8ec84109$var$ParseContext(this, options, false);
        context.addAll(dom, $d57fd95f8ec84109$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $d57fd95f8ec84109$var$ParseContext(this, options, true);
        context.addAll(dom, $d57fd95f8ec84109$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $d57fd95f8ec84109$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($d57fd95f8ec84109$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $d57fd95f8ec84109$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $d57fd95f8ec84109$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $d57fd95f8ec84109$export$1059c6e7d2ce5669(schema, $d57fd95f8ec84109$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($d57fd95f8ec84109$var$isTagRule(rule)) this.tags.push(rule);
            else if ($d57fd95f8ec84109$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $d57fd95f8ec84109$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $d57fd95f8ec84109$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $d57fd95f8ec84109$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $d57fd95f8ec84109$var$OPT_PRESERVE_WS = 1, $d57fd95f8ec84109$var$OPT_PRESERVE_WS_FULL = 2, $d57fd95f8ec84109$var$OPT_OPEN_LEFT = 4;
function $d57fd95f8ec84109$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $d57fd95f8ec84109$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $d57fd95f8ec84109$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $d57fd95f8ec84109$var$OPT_PRESERVE_WS | $d57fd95f8ec84109$var$OPT_PRESERVE_WS_FULL : base & ~$d57fd95f8ec84109$var$OPT_OPEN_LEFT;
}
class $d57fd95f8ec84109$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($d57fd95f8ec84109$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $d57fd95f8ec84109$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $d57fd95f8ec84109$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($d57fd95f8ec84109$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$d57fd95f8ec84109$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $d57fd95f8ec84109$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $d57fd95f8ec84109$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $d57fd95f8ec84109$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $d57fd95f8ec84109$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($d57fd95f8ec84109$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $d57fd95f8ec84109$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $d57fd95f8ec84109$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($d57fd95f8ec84109$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $d57fd95f8ec84109$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $d57fd95f8ec84109$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $d57fd95f8ec84109$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $d57fd95f8ec84109$var$OPT_OPEN_LEFT;
        let applyMarks = $d57fd95f8ec84109$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $d57fd95f8ec84109$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $d57fd95f8ec84109$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $d57fd95f8ec84109$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $d57fd95f8ec84109$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $d57fd95f8ec84109$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $d57fd95f8ec84109$var$NodeContext(topNode.type, topNode.attrs, $d57fd95f8ec84109$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $d57fd95f8ec84109$var$NodeContext(null, null, $d57fd95f8ec84109$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $d57fd95f8ec84109$var$NodeContext(parser.schema.topNodeType, null, $d57fd95f8ec84109$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $d57fd95f8ec84109$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $d57fd95f8ec84109$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $d57fd95f8ec84109$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $d57fd95f8ec84109$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $d57fd95f8ec84109$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $d57fd95f8ec84109$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $d57fd95f8ec84109$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $d57fd95f8ec84109$var$renderSpec($d57fd95f8ec84109$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $d57fd95f8ec84109$var$renderSpec($d57fd95f8ec84109$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $d57fd95f8ec84109$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $d57fd95f8ec84109$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $d57fd95f8ec84109$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $d57fd95f8ec84109$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $d57fd95f8ec84109$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $d57fd95f8ec84109$var$doc(options) {
    return options.document || window.document;
}
const $d57fd95f8ec84109$var$suspiciousAttributeCache = new WeakMap();
function $d57fd95f8ec84109$var$suspiciousAttributes(attrs) {
    let value = $d57fd95f8ec84109$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $d57fd95f8ec84109$var$suspiciousAttributeCache.set(attrs, value = $d57fd95f8ec84109$var$suspiciousAttributesInner(attrs));
    return value;
}
function $d57fd95f8ec84109$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $d57fd95f8ec84109$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $d57fd95f8ec84109$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $d57fd95f8ec84109$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("iw0m5", function(module, exports) {

$parcel$export(module.exports, "FONT_STYLE", function () { return $d7ab7db26b0bb75c$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $d7ab7db26b0bb75c$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $d7ab7db26b0bb75c$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $d7ab7db26b0bb75c$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $d7ab7db26b0bb75c$export$4498a6080fed604c = "fontStyle";
var $d7ab7db26b0bb75c$export$f8e8a5f34f6ea725 = "searchQuery";
var $d7ab7db26b0bb75c$export$b395009ca7f092c7 = "link";
var $d7ab7db26b0bb75c$export$9b982809044276a6 = "color";
var $d7ab7db26b0bb75c$export$470d0905851e47a1 = "alignment";
var $d7ab7db26b0bb75c$export$bacb7f4b06a06b22 = "indentation";

});

parcelRegister("913Aj", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", function () { return $6906fcdfcd660d5a$export$daf54fed04c8fb77; });

var $lb7vQ = parcelRequire("lb7vQ");
function $6906fcdfcd660d5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6906fcdfcd660d5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6906fcdfcd660d5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6906fcdfcd660d5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6906fcdfcd660d5a$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $6906fcdfcd660d5a$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== "_") nodeSpec.marks = nodeSpec.marks.split(" ").filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(" ");
        if (nodeSpec.content) nodeSpec.content = $6906fcdfcd660d5a$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $6906fcdfcd660d5a$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, " ");
    var contentKeys = content.split(" ");
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$6906fcdfcd660d5a$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $6906fcdfcd660d5a$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $6906fcdfcd660d5a$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || "";
    if (!content || !content.match(/\w/)) return "";
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, "g"), "").replace("  ", " ").trim();
}
function $6906fcdfcd660d5a$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("1wv9P", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", function () { return $11c0f2d6db9dcaab$export$be9cf49015769bbd; });
$parcel$export(module.exports, "alignment", function () { return $11c0f2d6db9dcaab$export$8e53000a4ec837; });

var $9heO7 = parcelRequire("9heO7");
var $11c0f2d6db9dcaab$export$be9cf49015769bbd = {
    end: "right",
    right: "end",
    center: "center"
};
var $11c0f2d6db9dcaab$export$8e53000a4ec837 = (0, $9heO7.alignment)({
    parseDOM: [
        {
            tag: "div.fabric-editor-block-mark",
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute("data-align");
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                "data-align": mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("9heO7", function(module, exports) {

$parcel$export(module.exports, "alignment", function () { return $6c113000431f75a0$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $6c113000431f75a0$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $6c113000431f75a0$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $6c113000431f75a0$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $6c113000431f75a0$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $6c113000431f75a0$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $6c113000431f75a0$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $6c113000431f75a0$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $6c113000431f75a0$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $6c113000431f75a0$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $6c113000431f75a0$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $6c113000431f75a0$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $6c113000431f75a0$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $6c113000431f75a0$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $6c113000431f75a0$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $6c113000431f75a0$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $6c113000431f75a0$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $6c113000431f75a0$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $6c113000431f75a0$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $6c113000431f75a0$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $boMuE = parcelRequire("boMuE");
var $6c113000431f75a0$export$8e53000a4ec837 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: "alignment indentation",
    group: "alignment"
});
var $6c113000431f75a0$export$8512c9afa7b24c3b = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ""
        },
        annotationType: {
            default: "inlineComment"
        }
    },
    inclusive: true,
    excludes: "",
    group: "annotation"
});
var $6c113000431f75a0$export$8c5a050822fd698c = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: "color",
    group: "color"
});
var $6c113000431f75a0$export$1edee58a52776cd9 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $6c113000431f75a0$export$89015c65f1c75e3f = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: "wide"
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $6c113000431f75a0$export$6565f9f03506010b = (0, $boMuE.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: "fontStyle link searchQuery color"
});
var $6c113000431f75a0$export$f3b72f8fc4684ecd = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ""
        }
    },
    inclusive: false,
    excludes: ""
});
var $6c113000431f75a0$export$3024f02c495408d6 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $6c113000431f75a0$export$c63c6f932822f543 = (0, $boMuE.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $6c113000431f75a0$export$f00aeb236b6f05af = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ""
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ""
});
var $6c113000431f75a0$export$480c699bd4ec0d86 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: "indentation alignment",
    group: "indentation"
});
var $6c113000431f75a0$export$9c30223ca0a664fb = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: "link",
    group: "link"
});
var $6c113000431f75a0$export$4899a95d70ec5056 = (0, $boMuE.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $6c113000431f75a0$export$59ae2c325a998f89 = (0, $boMuE.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $6c113000431f75a0$export$b3401ee80eb31041 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: "sub"
        }
    },
    inclusive: true,
    group: "fontStyle"
});
var $6c113000431f75a0$export$32f78bffcd82ff28 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: "color"
});
var $6c113000431f75a0$export$20af3dabbb5538df = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ""
        }
    },
    inclusive: true,
    group: "searchQuery"
});
var $6c113000431f75a0$export$425327af25286e5e = (0, $boMuE.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $6c113000431f75a0$export$30d78d5eb6719bb8 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ""
});
var $6c113000431f75a0$export$a316dc07ff5182a2 = (0, $boMuE.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("jhq6p", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", function () { return $e093da377806829b$export$94aa2fc69ad33d19; });
$parcel$export(module.exports, "AnnotationMarkStates", function () { return $e093da377806829b$export$4bab14797673da9f; });
$parcel$export(module.exports, "buildDataAttributes", function () { return $e093da377806829b$export$93a98caa8bc6cb07; });
$parcel$export(module.exports, "annotation", function () { return $e093da377806829b$export$8512c9afa7b24c3b; });

var $lb7vQ = parcelRequire("lb7vQ");

var $9heO7 = parcelRequire("9heO7");
function $e093da377806829b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e093da377806829b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e093da377806829b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e093da377806829b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e093da377806829b$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $e093da377806829b$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $e093da377806829b$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        "data-mark-type": "annotation",
        "data-mark-annotation-type": annotationType,
        "data-id": id
    };
    if (state) return $e093da377806829b$var$_objectSpread($e093da377806829b$var$_objectSpread({}, data), {}, {
        "data-mark-annotation-state": state
    });
    return data;
}
var $e093da377806829b$export$8512c9afa7b24c3b = (0, $9heO7.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: "annotation",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-id"),
                    annotationType: dom.getAttribute("data-mark-annotation-type")
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            "span",
            $e093da377806829b$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                "class": "fabric-editor-annotation"
            }, $e093da377806829b$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("xxHC9", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", function () { return $064d39c9aca2630d$export$8c5a050822fd698c; });

var $lb7vQ = parcelRequire("lb7vQ");

var $i6ZYA = parcelRequire("i6ZYA");

var $9heO7 = parcelRequire("9heO7");

var $4B2aM = parcelRequire("4B2aM");

var $1xksd = parcelRequire("1xksd");

var $8Aj9z = parcelRequire("8Aj9z");

var $3gUtn = parcelRequire("3gUtn");
/**
 * @name backgroundColor_mark
 */ var $064d39c9aca2630d$var$colorArrayPalette = [
    [
        (0, $1xksd.Neutral300),
        "Gray"
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $1xksd.T200),
        "Teal"
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $1xksd.L200),
        "Lime"
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $1xksd.O200),
        "Orange"
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $1xksd.M200),
        "Magenta"
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $1xksd.P200),
        "Purple"
    ] // token: color.background.accent.purple.subtler
];
var $064d39c9aca2630d$export$14ec3f21a268e497 = new Map();
$064d39c9aca2630d$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $i6ZYA.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $064d39c9aca2630d$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $064d39c9aca2630d$export$8c5a050822fd698c = (0, $9heO7.backgroundColor)({
    parseDOM: [
        {
            style: "background-color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $1xksd.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $064d39c9aca2630d$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: ".fabric-background-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $064d39c9aca2630d$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $4B2aM.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $8Aj9z.getGlobalTheme)().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $3gUtn.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, $lb7vQ.default)({
                class: "fabric-background-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-background-custom-color", mark.attrs.color)
        ];
    }
});

});
parcelRegister("8Aj9z", function(module, exports) {

$parcel$export(module.exports, "getGlobalTheme", function () { return $64008aff30ba3041$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $64008aff30ba3041$export$32f78bffcd82ff28; });

var $lb7vQ = parcelRequire("lb7vQ");

var $i6ZYA = parcelRequire("i6ZYA");

var $9heO7 = parcelRequire("9heO7");

var $4B2aM = parcelRequire("4B2aM");

var $1xksd = parcelRequire("1xksd");

var $3gUtn = parcelRequire("3gUtn");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $64008aff30ba3041$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $1xksd.B500),
        "Dark blue"
    ],
    // Chore coat
    [
        (0, $1xksd.T500),
        "Dark teal"
    ],
    // Shabby chic
    [
        (0, $1xksd.G500),
        "Dark green"
    ],
    // Keen green
    [
        (0, $1xksd.Y400),
        "Orange"
    ],
    // Cheezy blasters
    [
        (0, $1xksd.R500),
        "Dark red"
    ],
    // Dragon's blood
    [
        (0, $1xksd.P500),
        "Dark purple"
    ],
    // Prince
    // row 2
    [
        (0, $1xksd.N80),
        "Light gray"
    ],
    // Spooky ghost
    [
        (0, $1xksd.B100),
        "Blue"
    ],
    // Arvo breeze
    [
        (0, $1xksd.T300),
        "Teal"
    ],
    // Tamarama
    [
        (0, $1xksd.G300),
        "Green"
    ],
    // Fine pine
    [
        (0, $1xksd.Y200),
        "Yellow"
    ],
    // Pub mix
    [
        (0, $1xksd.R300),
        "Red"
    ],
    // Poppy surprise
    [
        (0, $1xksd.P300),
        "Purple"
    ],
    // Da' juice
    // row 3
    [
        (0, $1xksd.N0),
        "White"
    ],
    [
        (0, $1xksd.B75),
        "Light blue"
    ],
    // Schwag
    [
        (0, $1xksd.T75),
        "Light teal"
    ],
    // Arctic chill
    [
        (0, $1xksd.G75),
        "Light green"
    ],
    // Mintie
    [
        (0, $1xksd.Y75),
        "Light yellow"
    ],
    // Dandelion whisper
    [
        (0, $1xksd.R75),
        "Light red"
    ],
    // Bondi sunburn
    [
        (0, $1xksd.P50),
        "Light purple"
    ] // Lavender secret
];
var $64008aff30ba3041$export$569885e57444f84a = new Map();
var $64008aff30ba3041$export$81e5ed9e84fe2e28 = $64008aff30ba3041$export$569885e57444f84a;
$64008aff30ba3041$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $i6ZYA.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $64008aff30ba3041$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $64008aff30ba3041$var$testGlobalTheme;
var $64008aff30ba3041$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $64008aff30ba3041$var$testGlobalTheme = theme;
};
var $64008aff30ba3041$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($64008aff30ba3041$var$testGlobalTheme) return {
        colorMode: $64008aff30ba3041$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $64008aff30ba3041$export$32f78bffcd82ff28 = (0, $9heO7.textColor)({
    parseDOM: [
        {
            style: "color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $1xksd.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $64008aff30ba3041$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: ".fabric-text-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $64008aff30ba3041$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $4B2aM.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($64008aff30ba3041$export$813ecdf77207a053().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $3gUtn.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, $lb7vQ.default)({
                class: "fabric-text-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-text-custom-color", mark.attrs.color)
        ];
    }
});

});


parcelRegister("dNM70", function(module, exports) {

$parcel$export(module.exports, "border", function () { return $a0c52bfcf04d19ba$export$1edee58a52776cd9; });

var $i6ZYA = parcelRequire("i6ZYA");

var $9heO7 = parcelRequire("9heO7");

var $4B2aM = parcelRequire("4B2aM");

var $1xksd = parcelRequire("1xksd");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $a0c52bfcf04d19ba$var$borderColorArrayPalette = [
    [
        (0, $1xksd.N300A),
        "Subtle gray"
    ],
    [
        (0, $1xksd.N600),
        "Gray"
    ],
    [
        (0, $1xksd.N1000),
        "Bold gray"
    ]
];
var $a0c52bfcf04d19ba$export$e4e044c989c86ca7 = new Map();
$a0c52bfcf04d19ba$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $i6ZYA.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $a0c52bfcf04d19ba$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $a0c52bfcf04d19ba$export$1edee58a52776cd9 = (0, $9heO7.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute("data-color")) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : "").toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute("data-size")) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : "0");
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $a0c52bfcf04d19ba$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? "span" : "div";
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $4B2aM.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                "data-mark-type": "border",
                "data-color": mark.attrs.color,
                "data-size": mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("7VIdP", function(module, exports) {

$parcel$export(module.exports, "breakout", function () { return $5c6028da94ed87f3$export$89015c65f1c75e3f; });

var $9heO7 = parcelRequire("9heO7");
var $5c6028da94ed87f3$var$allowedTypes = [
    "wide",
    "full-width"
];
var $5c6028da94ed87f3$export$89015c65f1c75e3f = (0, $9heO7.breakout)({
    parseDOM: [
        {
            tag: "div.fabric-editor-breakout-mark",
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute("data-mode");
                var width = dom.getAttribute("data-width");
                return {
                    mode: $5c6028da94ed87f3$var$allowedTypes.indexOf(mode || "") === -1 ? "wide" : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            "div",
            {
                class: "fabric-editor-breakout-mark",
                "data-mode": mark.attrs.mode,
                "data-width": (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("9rNMQ", function(module, exports) {

$parcel$export(module.exports, "code", function () { return $6e0d41484fbc5438$export$6565f9f03506010b; });

var $9heO7 = parcelRequire("9heO7");
var $6e0d41484fbc5438$export$6565f9f03506010b = (0, $9heO7.code)({
    parseDOM: [
        {
            tag: "span.code",
            preserveWhitespace: true
        },
        {
            tag: "code",
            preserveWhitespace: true
        },
        {
            tag: "tt",
            preserveWhitespace: true
        },
        {
            tag: "span",
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre") return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "span",
            {
                class: "code",
                spellcheck: "false"
            }
        ];
    }
});

});

parcelRegister("gYcSK", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", function () { return $c5ac3e0bd80abc1b$export$f3b72f8fc4684ecd; });

var $9heO7 = parcelRequire("9heO7");
var $c5ac3e0bd80abc1b$export$f3b72f8fc4684ecd = (0, $9heO7.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("aNjCV", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", function () { return $7dbdb476e91dda8e$export$3024f02c495408d6; });

var $lb7vQ = parcelRequire("lb7vQ");

var $9heO7 = parcelRequire("9heO7");

var $jqk9j = parcelRequire("jqk9j");
function $7dbdb476e91dda8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7dbdb476e91dda8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7dbdb476e91dda8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7dbdb476e91dda8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $7dbdb476e91dda8e$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $jqk9j.isDOMElement)(maybeValue) && maybeValue.getAttribute("data-sources");
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $7dbdb476e91dda8e$export$3024f02c495408d6 = (0, $9heO7.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $7dbdb476e91dda8e$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "dataConsumer",
                "data-sources": JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $7dbdb476e91dda8e$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === "sources" && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $7dbdb476e91dda8e$var$_objectSpread($7dbdb476e91dda8e$var$_objectSpread({}, acc), {}, (0, $lb7vQ.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("jqk9j", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", function () { return $e240134322ba3e95$export$c296e2d4365c37a5; });
var $e240134322ba3e95$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("1cjut", function(module, exports) {

$parcel$export(module.exports, "em", function () { return $0df607de7099b4d8$export$c63c6f932822f543; });

var $9heO7 = parcelRequire("9heO7");
/**
 * @name em_mark
 */ var $0df607de7099b4d8$var$emDOM = [
    "em"
];
var $0df607de7099b4d8$export$c63c6f932822f543 = (0, $9heO7.em)({
    parseDOM: [
        {
            tag: "i"
        },
        {
            tag: "em"
        },
        {
            style: "font-style=italic"
        }
    ],
    toDOM: function toDOM() {
        return $0df607de7099b4d8$var$emDOM;
    }
});

});

parcelRegister("480Pe", function(module, exports) {

$parcel$export(module.exports, "fragment", function () { return $30188cb0d9bbfca3$export$f00aeb236b6f05af; });

var $lb7vQ = parcelRequire("lb7vQ");

var $9heO7 = parcelRequire("9heO7");

var $jqk9j = parcelRequire("jqk9j");
function $30188cb0d9bbfca3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30188cb0d9bbfca3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30188cb0d9bbfca3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30188cb0d9bbfca3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $30188cb0d9bbfca3$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $jqk9j.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute("data-name")) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute("data-localId");
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $30188cb0d9bbfca3$export$f00aeb236b6f05af = (0, $9heO7.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $30188cb0d9bbfca3$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "fragment",
                "data-name": mark.attrs.name,
                "data-localId": mark.attrs.localId
            }
        ];
    }
});
var $30188cb0d9bbfca3$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $30188cb0d9bbfca3$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("cyuqo", function(module, exports) {

$parcel$export(module.exports, "indentation", function () { return $924042b7425501bc$export$480c699bd4ec0d86; });

var $9heO7 = parcelRequire("9heO7");
var $924042b7425501bc$export$480c699bd4ec0d86 = (0, $9heO7.indentation)({
    parseDOM: [
        {
            tag: "div.fabric-editor-indentation-mark",
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute("data-level") || "0");
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-indentation-mark",
                "data-level": mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("dKqYB", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $a0247f2fe35ca07e$export$9c30223ca0a664fb; });

var $lb7vQ = parcelRequire("lb7vQ");

var $9heO7 = parcelRequire("9heO7");

var $jctNi = parcelRequire("jctNi");
function $a0247f2fe35ca07e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0247f2fe35ca07e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0247f2fe35ca07e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0247f2fe35ca07e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a0247f2fe35ca07e$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || "";
        var attrs = {
            __confluenceMetadata: dom.hasAttribute("__confluenceMetadata") ? JSON.parse(dom.getAttribute("__confluenceMetadata") || "") : undefined
        };
        if (!(0, $jctNi.isSafeUrl)(href)) return false;
        if ((0, $jctNi.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $jctNi.normalizeUrl)(href);
        return attrs;
    };
};
var $a0247f2fe35ca07e$export$9c30223ca0a664fb = (0, $9heO7.link)({
    parseDOM: [
        {
            tag: "[data-block-link]",
            getAttrs: $a0247f2fe35ca07e$export$b5f67017585d1431("data-block-link"),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute("data-block-link");
                clone.setAttribute("data-skip-paste", "true");
                var wrapper = document.createElement("div");
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: "a[href]",
            getAttrs: $a0247f2fe35ca07e$export$b5f67017585d1431("href")
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === "__confluenceMetadata") {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === "href") attrs[key] = (0, $jctNi.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            "a",
            attrs
        ];
        return [
            "a",
            $a0247f2fe35ca07e$var$_objectSpread($a0247f2fe35ca07e$var$_objectSpread({}, attrs), {}, (0, $lb7vQ.default)((0, $lb7vQ.default)({}, "data-block-link", "true"), "class", "blockLink")),
            0
        ];
    }
});
var $a0247f2fe35ca07e$var$OPTIONAL_ATTRS = [
    "title",
    "id",
    "collection",
    "occurrenceKey",
    "__confluenceMetadata"
];
var $a0247f2fe35ca07e$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($a0247f2fe35ca07e$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});

parcelRegister("coMR1", function(module, exports) {

$parcel$export(module.exports, "strike", function () { return $906d9f5dd3de5f1f$export$4899a95d70ec5056; });

var $9heO7 = parcelRequire("9heO7");
var $906d9f5dd3de5f1f$export$4899a95d70ec5056 = (0, $9heO7.strike)({
    parseDOM: [
        {
            tag: "strike"
        },
        {
            tag: "s"
        },
        {
            tag: "del"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "line-through" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "s"
        ];
    }
});

});

parcelRegister("fB8Ns", function(module, exports) {

$parcel$export(module.exports, "strong", function () { return $b5b1228e9957d1c7$export$59ae2c325a998f89; });

var $9heO7 = parcelRequire("9heO7");
/**
 * @name strong_mark
 */ var $b5b1228e9957d1c7$var$strongDOM = [
    "strong"
];
var $b5b1228e9957d1c7$export$59ae2c325a998f89 = (0, $9heO7.strong)({
    parseDOM: [
        {
            tag: "strong"
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: "b",
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== "normal" && null;
            }
        },
        {
            tag: "span",
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === "string" && (fontWeight === "bold" || fontWeight === "bolder" || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $b5b1228e9957d1c7$var$strongDOM;
    }
});

});

parcelRegister("jF8Fw", function(module, exports) {

$parcel$export(module.exports, "subsup", function () { return $e508921ad9420550$export$b3401ee80eb31041; });

var $9heO7 = parcelRequire("9heO7");
/**
 * @name subsup_mark
 */ function $e508921ad9420550$var$getAttrFromVerticalAlign(node) {
    if (node === "sub") return {
        type: "sub"
    };
    if (node === "super") return {
        type: "sup"
    };
    return false;
}
var $e508921ad9420550$export$b3401ee80eb31041 = (0, $9heO7.subsup)({
    parseDOM: [
        {
            tag: "sub",
            attrs: {
                type: "sub"
            }
        },
        {
            tag: "sup",
            attrs: {
                type: "sup"
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: "vertical-align=super",
            getAttrs: function getAttrs(node) {
                return $e508921ad9420550$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: "vertical-align=sub",
            getAttrs: function getAttrs(node) {
                return $e508921ad9420550$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("i3rCo", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", function () { return $d24dee3498b52600$export$20af3dabbb5538df; });

var $9heO7 = parcelRequire("9heO7");

var $1xksd = parcelRequire("1xksd");
var $d24dee3498b52600$export$20af3dabbb5538df = (0, $9heO7.typeAheadQuery)({
    parseDOM: [
        {
            tag: "span[data-type-ahead-query]"
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-type-ahead-query": "true",
                "data-trigger": node.attrs.trigger,
                style: "color: ".concat((0, $1xksd.B400))
            }
        ];
    }
});

});

parcelRegister("c3zEJ", function(module, exports) {

$parcel$export(module.exports, "underline", function () { return $8c716c61ba11d555$export$425327af25286e5e; });

var $9heO7 = parcelRequire("9heO7");
var $8c716c61ba11d555$export$425327af25286e5e = (0, $9heO7.underline)({
    parseDOM: [
        {
            tag: "u"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "underline" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "u"
        ];
    }
});

});

parcelRegister("dgJK8", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", function () { return $9a9040971d75b7a3$export$30d78d5eb6719bb8; });

var $9heO7 = parcelRequire("9heO7");
var $9a9040971d75b7a3$export$30d78d5eb6719bb8 = (0, $9heO7.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            "span"
        ];
    }
});

});

parcelRegister("aIaZE", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $7cc68a7a6be81289$export$a316dc07ff5182a2; });

var $9heO7 = parcelRequire("9heO7");
var $7cc68a7a6be81289$export$a316dc07ff5182a2 = (0, $9heO7.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            "span"
        ];
    }
});

});

parcelRegister("3gLga", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $26178688aff36ea2$export$c4c2f833baaebdb8; });

var $lb7vQ = parcelRequire("lb7vQ");

var $7ock2 = parcelRequire("7ock2");
function $26178688aff36ea2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $26178688aff36ea2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $26178688aff36ea2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $26178688aff36ea2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $26178688aff36ea2$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute("data-card-data");
    var datasource = anchor.getAttribute("data-datasource");
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute("data-layout") || undefined : undefined,
        width: Number(dom.getAttribute("data-width")) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $26178688aff36ea2$export$c4c2f833baaebdb8 = (0, $7ock2.blockCard)({
    parseDOM: [
        {
            tag: "a[data-block-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $26178688aff36ea2$var$_objectSpread({
                    url: anchor.getAttribute("href") || undefined
                }, $26178688aff36ea2$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: "div[data-block-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $26178688aff36ea2$var$_objectSpread({
                    url: anchor.getAttribute("data-card-url") || undefined
                }, $26178688aff36ea2$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            "data-block-card": "",
            href: url || "",
            "data-card-data": data ? JSON.stringify(data) : "",
            "data-datasource": datasource ? JSON.stringify(datasource) : "",
            "data-layout": layout,
            "data-width": "".concat(width)
        };
        return [
            "a",
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || " "
        ];
    }
});

});

parcelRegister("aIlVh", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", function () { return $7ccf04df12ef751e$export$27903d543b563e39; });

var $hnNxG = parcelRequire("hnNxG");

var $7ock2 = parcelRequire("7ock2");
var $7ccf04df12ef751e$export$27903d543b563e39 = (0, $7ock2.bodiedExtension)({
    parseDOM: [
        {
            context: "bodiedExtension//",
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $hnNxG.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "bodied-extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("gMvMs", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", function () { return $c379c7fff47a63d9$export$5f25a39efab3b58b; });
$parcel$export(module.exports, "bulletList", function () { return $c379c7fff47a63d9$export$a140c94e5ea26bee; });

var $7ock2 = parcelRequire("7ock2");
var $c379c7fff47a63d9$export$5f25a39efab3b58b = ".ak-ul";
var $c379c7fff47a63d9$export$a140c94e5ea26bee = (0, $7ock2.bulletList)({
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $c379c7fff47a63d9$export$5f25a39efab3b58b.substr(1)
        };
        return [
            "ul",
            attrs,
            0
        ];
    }
});

});

parcelRegister("3NGHX", function(module, exports) {

$parcel$export(module.exports, "caption", function () { return $2c4713a069609ced$export$8e3c2dfdc4f0453d; });

var $7ock2 = parcelRequire("7ock2");
var $2c4713a069609ced$export$8e3c2dfdc4f0453d = (0, $7ock2.caption)({
    parseDOM: [
        {
            tag: "figcaption[data-caption]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-caption": "true"
        };
        return [
            "figcaption",
            attrs,
            0
        ];
    }
});

});

parcelRegister("i5M8n", function(module, exports) {

$parcel$export(module.exports, "codeBlock", function () { return $d2be08085d5530cb$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "toJSON", function () { return $d2be08085d5530cb$export$54fd2c36b5cc6731; });

var $iks2Q = parcelRequire("iks2Q");

var $7ock2 = parcelRequire("7ock2");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $d2be08085d5530cb$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute("data-language") || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $d2be08085d5530cb$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains("codehilite")) // code block html from Bitbucket always contains an extra new line
    return $d2be08085d5530cb$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $d2be08085d5530cb$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === "CODE") return firstChild.getAttribute("data-language") || undefined;
};
var $d2be08085d5530cb$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $d2be08085d5530cb$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains("codehilite")) dom.textContent = dom.textContent.replace(/\n$/, "");
    return dom;
};
function $d2be08085d5530cb$var$parseCodeFromHtml(node) {
    var code = "";
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === "div" || tagName === "p") // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += "\n";
            }
            if (tagName === "br") code += "\n";
            else code += $d2be08085d5530cb$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $d2be08085d5530cb$export$7bb0d5c671655cc4 = (0, $7ock2.codeBlock)({
    parseDOM: [
        {
            tag: "pre",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $d2be08085d5530cb$var$getLanguageFromBitbucketStyle(dom.parentElement) || $d2be08085d5530cb$var$getLanguageFromEditorStyle(dom.parentElement) || $d2be08085d5530cb$var$getLanguageFromCode(dom) || dom.getAttribute("data-language");
                dom = $d2be08085d5530cb$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: "div[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre" || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $d2be08085d5530cb$var$parseCodeFromHtml(domNode);
                return code ? (0, $iks2Q.Fragment).from(schema.text(code)) : (0, $iks2Q.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: "table[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: "div.code-block",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll(".react-syntax-highlighter-line-number");
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "pre",
            [
                "code",
                {
                    "data-language": node.attrs.language
                },
                0
            ]
        ];
    }
});
var $d2be08085d5530cb$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === "uniqueId") return memo;
            if (key === "language" && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};

});

parcelRegister("jm1NE", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", function () { return $e17177d034f3690e$export$daf889beb5092f95; });

var $7ock2 = parcelRequire("7ock2");
var $e17177d034f3690e$var$name = "confluenceJiraIssue";
var $e17177d034f3690e$export$daf889beb5092f95 = (0, $7ock2.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: 'span[data-node-type="'.concat($e17177d034f3690e$var$name, '"]'),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $e17177d034f3690e$var$name,
            "data-macro-id": node.attrs.macroId,
            "data-schema-version": node.attrs.schemaVersion,
            "data-server": node.attrs.server,
            "data-server-id": node.attrs.serverId,
            "data-jira-issue": node.attrs.issueKey
        };
        return [
            "span",
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("8jTUK", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $60eb787914399d48$export$e6e4878f43c27cab; });

var $7ock2 = parcelRequire("7ock2");
var $60eb787914399d48$var$name = "confluenceUnsupportedBlock";
var $60eb787914399d48$export$e6e4878f43c27cab = (0, $7ock2.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            "data-node-type": $60eb787914399d48$var$name,
            "data-confluence-unsupported": "block",
            "data-confluence-unsupported-block-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($60eb787914399d48$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-block-cxhtml")
                };
            }
        }
    ]
});

});

parcelRegister("1F0TT", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $135a519ec609fdc0$export$3e6d667072febc87; });

var $7ock2 = parcelRequire("7ock2");
var $135a519ec609fdc0$var$name = "confluenceUnsupportedInline";
var $135a519ec609fdc0$export$3e6d667072febc87 = (0, $7ock2.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $135a519ec609fdc0$var$name,
            "data-confluence-unsupported": "inline",
            "data-confluence-unsupported-inline-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($135a519ec609fdc0$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-inline-cxhtml")
                };
            }
        }
    ]
});

});

parcelRegister("90cY1", function(module, exports) {

$parcel$export(module.exports, "date", function () { return $68de2c2498d5abb0$export$324d90190a8b822a; });

var $7ock2 = parcelRequire("7ock2");
var $68de2c2498d5abb0$export$324d90190a8b822a = (0, $7ock2.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute("data-timestamp")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "date",
            "data-timestamp": node.attrs.timestamp
        };
        return [
            "span",
            attrs
        ];
    }
});

});

parcelRegister("fXchj", function(module, exports) {

$parcel$export(module.exports, "decisionItem", function () { return $b9d5e3e948982470$export$6959e16eeff859b4; });

var $aNDXa = parcelRequire("aNDXa");

var $7ock2 = parcelRequire("7ock2");
var $b9d5e3e948982470$export$6959e16eeff859b4 = (0, $7ock2.decisionItem)({
    parseDOM: [
        {
            tag: "li[data-decision-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $aNDXa.uuid).generate(),
                    state: dom.getAttribute("data-decision-state")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-decision-local-id": localId || "local-decision",
            "data-decision-state": state
        };
        return [
            "li",
            attrs,
            0
        ];
    }
});

});

parcelRegister("2ij4H", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", function () { return $1abc0f10f8f0ed43$export$a5393ce68c2ff601; });
$parcel$export(module.exports, "decisionList", function () { return $1abc0f10f8f0ed43$export$62d45a65fb43d95e; });

var $aNDXa = parcelRequire("aNDXa");

var $7ock2 = parcelRequire("7ock2");
/**
 * @name decisionList_node
 */ var $1abc0f10f8f0ed43$var$name = "decisionList";
var $1abc0f10f8f0ed43$export$a5393ce68c2ff601 = '[data-node-type="'.concat($1abc0f10f8f0ed43$var$name, '"]');
var $1abc0f10f8f0ed43$export$62d45a65fb43d95e = (0, $7ock2.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($1abc0f10f8f0ed43$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $aNDXa.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $1abc0f10f8f0ed43$var$name,
            "data-decision-list-local-id": localId || "local-decision-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("1cLwK", function(module, exports) {

$parcel$export(module.exports, "doc", function () { return $0e0bc759f9ff983c$export$2a111da947c407d2; });

var $7ock2 = parcelRequire("7ock2");
var $0e0bc759f9ff983c$export$2a111da947c407d2 = (0, $7ock2.doc)({});

});

parcelRegister("5Qdtg", function(module, exports) {

$parcel$export(module.exports, "embedCard", function () { return $440c422911733e42$export$be4283d9a1cb1ff6; });

var $7ock2 = parcelRequire("7ock2");
var $440c422911733e42$export$be4283d9a1cb1ff6 = (0, $7ock2.embedCard)({
    parseDOM: [
        {
            tag: "div[data-embed-card]",
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute("data-card-url"),
                    layout: dom.getAttribute("data-layout") || "center",
                    width: Number(dom.getAttribute("data-width")) || null,
                    originalWidth: Number(dom.getAttribute("data-card-original-width")) || null,
                    originalHeight: Number(dom.getAttribute("data-card-original-height")) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            "data-embed-card": "",
            "data-card-url": url,
            "data-layout": layout,
            "data-width": width,
            "data-original-width": originalWidth,
            "data-original-height": originalHeight
        };
        return [
            "div",
            attrs
        ];
    }
});

});

parcelRegister("lAbHs", function(module, exports) {

$parcel$export(module.exports, "emoji", function () { return $fb66092163506799$export$a19185d1233fc4b2; });

var $9eSqV = parcelRequire("9eSqV");

var $7ock2 = parcelRequire("7ock2");
var $fb66092163506799$export$a19185d1233fc4b2 = (0, $7ock2.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: "div.ak-editor-panel__icon span",
            ignore: true
        },
        {
            tag: "span[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $fb66092163506799$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $fb66092163506799$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $fb66092163506799$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: "img[data-emoticon-name]",
            getAttrs: function getAttrs(dom) {
                return (0, $9eSqV.acNameToEmoji)(dom.getAttribute("data-emoticon-name"));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: "img[data-hipchat-emoticon]",
            getAttrs: function getAttrs(dom) {
                return (0, $9eSqV.acShortcutToEmoji)(dom.getAttribute("data-hipchat-emoticon"));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: "img.emoji[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $fb66092163506799$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $fb66092163506799$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $fb66092163506799$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            "data-emoji-short-name": shortName,
            "data-emoji-id": id,
            "data-emoji-text": text,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});
parcelRegister("9eSqV", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", function () { return $6b9fa531787e3d34$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $6b9fa531787e3d34$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $6b9fa531787e3d34$var$DEFAULT_EMOJI_ID = "2b50";
// Default ac:name for emoticons as a fallback is `blue-star`
var $6b9fa531787e3d34$var$DEFAULT_EMOJI_ACNAME = "blue-star";
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $6b9fa531787e3d34$var$HC_EMOTICON_PREFIX = "atlassian-";
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $6b9fa531787e3d34$var$acNameToEmojiMap = {
    smile: [
        "1f642",
        ":slight_smile:",
        "\uD83D\uDE42"
    ],
    sad: [
        "1f641",
        ":slight_frown:",
        "\uD83D\uDE41"
    ],
    cheeky: [
        "1f61b",
        ":stuck_out_tongue:",
        "\uD83D\uDE1B"
    ],
    laugh: [
        "1f600",
        ":grinning:",
        "\uD83D\uDE00"
    ],
    wink: [
        "1f609",
        ":wink:",
        "\uD83D\uDE09"
    ],
    information: [
        "2139",
        ":information_source:",
        "\u2139"
    ],
    tick: [
        "2705",
        ":white_check_mark:",
        "\u2705"
    ],
    cross: [
        "274c",
        ":x:",
        "\u274C"
    ],
    warning: [
        "26a0",
        ":warning:",
        "\u26A0"
    ],
    plus: [
        "2795",
        ":heavy_plus_sign:",
        "\u2795"
    ],
    minus: [
        "2796",
        ":heavy_minus_sign:",
        "\u2796"
    ],
    question: [
        "2753",
        ":question:",
        "?"
    ],
    "thumbs-up": [
        "1f44d",
        ":thumbsup:",
        "\uD83D\uDC4D"
    ],
    "thumbs-down": [
        "1f44e",
        ":thumbsdown:",
        "\uD83D\uDC4E"
    ],
    "light-on": [
        "1f4a1",
        ":bulb:",
        "\uD83D\uDCA1"
    ],
    "yellow-star": [
        "2b50",
        ":star:",
        "\uD83D\uDC9B"
    ],
    "light-off": [
        "1f6ab",
        ":no_entry_sign:",
        "\uD83D\uDEAB"
    ],
    "red-star": [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "green-star": [
        "1f49a",
        ":green_heart:",
        "\uD83D\uDC9A"
    ],
    "blue-star": [
        "1f499",
        ":blue_heart:",
        "\uD83D\uDC99"
    ],
    heart: [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "broken-heart": [
        "1f494",
        ":broken_heart:",
        "\uD83D\uDC94"
    ]
};
function $6b9fa531787e3d34$export$f61e93bda2a8b420(acName) {
    var emojiData = $6b9fa531787e3d34$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $6b9fa531787e3d34$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ""
    };
}
function $6b9fa531787e3d34$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $6b9fa531787e3d34$var$acNameToEmojiMap[acName] ? $6b9fa531787e3d34$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($6b9fa531787e3d34$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $6b9fa531787e3d34$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($6b9fa531787e3d34$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ""
    };
}
function $6b9fa531787e3d34$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ":" ? 1 : 0, shortName[shortName.length - 1] === ":" ? -1 : shortName.length);
}
function $6b9fa531787e3d34$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($6b9fa531787e3d34$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $6b9fa531787e3d34$var$getAcNameFromShortName(shortName);
        if (possibleName in $6b9fa531787e3d34$var$acNameToEmojiMap) return possibleName;
    }
    return $6b9fa531787e3d34$export$bc94e44ec0e7bd82(id) || $6b9fa531787e3d34$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("6aZsU", function(module, exports) {

$parcel$export(module.exports, "blockquote", function () { return $47f35af43d483231$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", function () { return $47f35af43d483231$export$c4d50234112df933; });
$parcel$export(module.exports, "extendedBlockquote", function () { return $47f35af43d483231$export$70a64939da3e8455; });
$parcel$export(module.exports, "blockquoteWithList", function () { return $47f35af43d483231$export$9b4686c4b9672643; });
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", function () { return $47f35af43d483231$export$32b1dde15f5fe85b; });

var $7ock2 = parcelRequire("7ock2");
/**
 * @name blockquote_node
 */ var $47f35af43d483231$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: "blockquote"
        }
    ],
    toDOM: function toDOM() {
        return [
            "blockquote",
            0
        ];
    }
};
var $47f35af43d483231$export$67dc04e652a298ca = (0, $7ock2.blockquoteLegacy)($47f35af43d483231$var$nodeSpecOptions);
var $47f35af43d483231$export$c4d50234112df933 = (0, $7ock2.blockquoteWithoutNonBodiedMacros)($47f35af43d483231$var$nodeSpecOptions);
var $47f35af43d483231$export$70a64939da3e8455 = (0, $7ock2.blockquote)($47f35af43d483231$var$nodeSpecOptions);
var $47f35af43d483231$export$9b4686c4b9672643 = (0, $7ock2.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: "blockquote"
        }
    ],
    toDOM: function toDOM() {
        return [
            "blockquote",
            0
        ];
    }
});
var $47f35af43d483231$export$32b1dde15f5fe85b = (0, $7ock2.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: "blockquote"
        }
    ],
    toDOM: function toDOM() {
        return [
            "blockquote",
            0
        ];
    }
});

});

parcelRegister("fIfwP", function(module, exports) {

$parcel$export(module.exports, "PanelType", function () { return $b70702b06f0face3$export$969277cf61e5a7aa; });
$parcel$export(module.exports, "extendedPanel", function () { return $b70702b06f0face3$export$ce20b13564211141; });
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", function () { return $b70702b06f0face3$export$220c665c23b9541b; });

var $lb7vQ = parcelRequire("lb7vQ");

var $7ock2 = parcelRequire("7ock2");
function $b70702b06f0face3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b70702b06f0face3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b70702b06f0face3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b70702b06f0face3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b70702b06f0face3$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $b70702b06f0face3$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        "data-panel-type": nodeAttrs.panelType,
        "data-panel-icon": nodeAttrs.panelIcon,
        "data-panel-icon-id": nodeAttrs.panelIconId,
        "data-panel-icon-text": nodeAttrs.panelIconText,
        "data-panel-color": nodeAttrs.panelColor
    };
    return attrs;
};
var $b70702b06f0face3$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute("data-panel-type")
    };
    if (allowCustomPanel) parseDOMAttrs = $b70702b06f0face3$var$_objectSpread($b70702b06f0face3$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute("data-panel-icon"),
        panelIconId: dom.getAttribute("data-panel-icon-id"),
        panelIconText: dom.getAttribute("data-panel-icon-text"),
        panelColor: dom.getAttribute("data-panel-color")
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $b70702b06f0face3$export$969277cf61e5a7aa.CUSTOM ? $b70702b06f0face3$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $b70702b06f0face3$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel) {
    return {
        parseDOM: [
            {
                tag: "div[data-panel-type]",
                getAttrs: function getAttrs(dom) {
                    return $b70702b06f0face3$var$getParseDOMAttrs(allowCustomPanel, dom);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $b70702b06f0face3$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                "data-panel-content": "true"
            };
            return [
                "div",
                attrs,
                [
                    "div",
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $b70702b06f0face3$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $7ock2.panel)($b70702b06f0face3$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $b70702b06f0face3$export$220c665c23b9541b = function panelWithoutNestedNonBodiedMacros(allowCustomPanel) {
    return (0, $7ock2.panelWithoutNestedNonBodiedMacros)($b70702b06f0face3$var$createPanelNodeSpecOptions(allowCustomPanel));
};

});

parcelRegister("hNHSh", function(module, exports) {

$parcel$export(module.exports, "extension", function () { return $cf590bcf7cfc2d14$export$1b45514b112dd749; });

var $hnNxG = parcelRequire("hnNxG");

var $7ock2 = parcelRequire("7ock2");
var $cf590bcf7cfc2d14$export$1b45514b112dd749 = (0, $7ock2.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $hnNxG.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs
        ];
    }
});

});

parcelRegister("4Atby", function(module, exports) {

$parcel$export(module.exports, "hardBreak", function () { return $357129ce9a502a7a$export$371da9dd35aba193; });

var $7ock2 = parcelRequire("7ock2");
var $357129ce9a502a7a$export$371da9dd35aba193 = (0, $7ock2.hardBreak)({
    parseDOM: [
        {
            tag: "br"
        }
    ],
    toDOM: function toDOM() {
        return [
            "br"
        ];
    }
});

});

parcelRegister("6eriT", function(module, exports) {

$parcel$export(module.exports, "heading", function () { return $48993ad7bcdcf02b$export$46e4a324ac90507f; });

var $7ock2 = parcelRequire("7ock2");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $48993ad7bcdcf02b$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute("data-local-id") || ((_heading$attrs = $48993ad7bcdcf02b$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $48993ad7bcdcf02b$export$46e4a324ac90507f = (0, $7ock2.heading)({
    parseDOM: [
        {
            tag: "h1",
            getAttrs: $48993ad7bcdcf02b$var$getAttrs(1)
        },
        {
            tag: "h2",
            getAttrs: $48993ad7bcdcf02b$var$getAttrs(2)
        },
        {
            tag: "h3",
            getAttrs: $48993ad7bcdcf02b$var$getAttrs(3)
        },
        {
            tag: "h4",
            getAttrs: $48993ad7bcdcf02b$var$getAttrs(4)
        },
        {
            tag: "h5",
            getAttrs: $48993ad7bcdcf02b$var$getAttrs(5)
        },
        {
            tag: "h6",
            getAttrs: $48993ad7bcdcf02b$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = "h" + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("6MUwd", function(module, exports) {

$parcel$export(module.exports, "image", function () { return $4f1311338849812e$export$5c452ff88e35e47d; });

var $7ock2 = parcelRequire("7ock2");
var $4f1311338849812e$export$5c452ff88e35e47d = (0, $7ock2.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: "img[src]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute("src"),
                    alt: dom.getAttribute("alt"),
                    title: dom.getAttribute("title")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "img",
            node.attrs
        ];
    }
});

});

parcelRegister("ggZ1g", function(module, exports) {

$parcel$export(module.exports, "inlineCard", function () { return $bd8d792719d7bd0c$export$cbf8224b64e0d942; });

var $7ock2 = parcelRequire("7ock2");
var $bd8d792719d7bd0c$export$cbf8224b64e0d942 = (0, $7ock2.inlineCard)({
    parseDOM: [
        {
            tag: "a[data-inline-card], span[data-inline-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute("href") || anchor.getAttribute("data-card-url") || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: "div[data-inline-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                return {
                    url: anchor.getAttribute("data-card-url"),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-inline-card": "",
            href: node.attrs.url || "",
            "data-card-data": node.attrs.data ? JSON.stringify(node.attrs.data) : ""
        };
        if (node.attrs.url) return [
            "a",
            attrs,
            node.attrs.url
        ];
        else return [
            "a",
            attrs
        ];
    }
});

});

parcelRegister("cCTAq", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", function () { return $931426fc904ff382$export$16b353b2649bd8d9; });

var $hnNxG = parcelRequire("hnNxG");

var $7ock2 = parcelRequire("7ock2");
var $931426fc904ff382$export$16b353b2649bd8d9 = (0, $7ock2.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: "span[data-extension-type]",
            getAttrs: function getAttrs(domNode) {
                return (0, $hnNxG.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-local-id:": node.attrs.localId,
            contenteditable: "false"
        };
        return [
            "span",
            attrs
        ];
    }
});

});

parcelRegister("cZppu", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", function () { return $974ee476a690fdda$export$ab76e7c03cd6f650; });

var $7ock2 = parcelRequire("7ock2");
var $974ee476a690fdda$export$ab76e7c03cd6f650 = (0, $7ock2.layoutColumn)({
    parseDOM: [
        {
            context: "layoutColumn//",
            tag: "div[data-layout-column]",
            skip: true
        },
        {
            tag: "div[data-layout-column]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute("data-column-width")) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-layout-column": "true"
        };
        var width = node.attrs.width;
        if (width) {
            attrs["style"] = "flex-basis: ".concat(width, "%");
            attrs["data-column-width"] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            "data-layout-content": "true"
        };
        return [
            "div",
            attrs,
            [
                "div",
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("l5UW2", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", function () { return $f5b63ab5b37f82c8$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "copyPrivateAttributes", function () { return $f5b63ab5b37f82c8$export$111130fa8968d741; });
$parcel$export(module.exports, "media", function () { return $f5b63ab5b37f82c8$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "toJSON", function () { return $f5b63ab5b37f82c8$export$54fd2c36b5cc6731; });

var $1xksd = parcelRequire("1xksd");

var $7ock2 = parcelRequire("7ock2");
var $f5b63ab5b37f82c8$export$bb3fe706be61f640 = (0, $7ock2.media)({}).attrs;
var $f5b63ab5b37f82c8$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var domNodeType = inline ? "span" : "div";
    var nodeName = inline ? "mediaInline" : "media";
    var parseDOM = [
        {
            tag: "".concat(domNodeType, '[data-node-type="').concat(nodeName, '"]'),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $f5b63ab5b37f82c8$export$f84fdfb973c05bd8(k).replace(/^__/, "");
                    var value = dom.getAttribute("data-".concat(key)) || "";
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== "undefined" && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== "undefined" && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            "data-id": node.attrs.id,
            "data-node-type": "".concat(nodeName),
            "data-type": node.attrs.type,
            "data-collection": node.attrs.collection,
            "data-occurrence-key": node.attrs.occurrenceKey,
            "data-width": node.attrs.width,
            "data-height": node.attrs.height,
            "data-url": node.attrs.url,
            "data-alt": node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: "Attachment",
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $1xksd.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $f5b63ab5b37f82c8$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($f5b63ab5b37f82c8$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $7ock2.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $7ock2.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: "img:not(.smart-link-icon)",
                getAttrs: function getAttrs(dom) {
                    return {
                        type: "external",
                        url: dom.getAttribute("src") || "",
                        alt: dom.getAttribute("alt") || ""
                    };
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $f5b63ab5b37f82c8$export$987d49ffe1b0900f = $f5b63ab5b37f82c8$export$35bdbf5bc8caa677($f5b63ab5b37f82c8$export$bb3fe706be61f640, false);
var $f5b63ab5b37f82c8$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $f5b63ab5b37f82c8$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($f5b63ab5b37f82c8$export$987d49ffe1b0900f.attrs) Object.keys($f5b63ab5b37f82c8$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === "_" && key[1] === "_" && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $f5b63ab5b37f82c8$var$optionalAttributes = [
    "occurrenceKey",
    "width",
    "height",
    "url",
    "alt"
];
var $f5b63ab5b37f82c8$var$externalOnlyAttributes = [
    "type",
    "url",
    "width",
    "height",
    "alt"
];
var $f5b63ab5b37f82c8$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === "_" && key[1] === "_");
        }).reduce(function(obj, key) {
            if (node.attrs.type === "external" && $f5b63ab5b37f82c8$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($f5b63ab5b37f82c8$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === "")) return obj;
            if ([
                "width",
                "height"
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("dEwsT", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", function () { return $9f0831a7f026f59c$export$2855e964765eac9; });

var $7ock2 = parcelRequire("7ock2");
var $9f0831a7f026f59c$export$2855e964765eac9 = (0, $7ock2.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": "mediaGroup"
            },
            0
        ];
    }
});

});

parcelRegister("dPLzN", function(module, exports) {

$parcel$export(module.exports, "mediaInline", function () { return $a124f17160efa109$export$38bab695e3f720f1; });

var $l5UW2 = parcelRequire("l5UW2");

var $7ock2 = parcelRequire("7ock2");
var $a124f17160efa109$export$38bab695e3f720f1 = (0, $l5UW2.createMediaSpec)((0, $7ock2.mediaInline)({}).attrs, true);

});

parcelRegister("cea0W", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", function () { return $8e6e8f73895b5d1c$export$5a1e124099b60c6b; });
$parcel$export(module.exports, "mediaSingle", function () { return $8e6e8f73895b5d1c$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleWithCaption", function () { return $8e6e8f73895b5d1c$export$d35e6c006d4abdfb; });
$parcel$export(module.exports, "mediaSingleWithWidthType", function () { return $8e6e8f73895b5d1c$export$9c58e19811ce4cf5; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $8e6e8f73895b5d1c$export$7e767666f2ce108a; });
$parcel$export(module.exports, "toJSON", function () { return $8e6e8f73895b5d1c$export$54fd2c36b5cc6731; });

var $lb7vQ = parcelRequire("lb7vQ");

var $1DjzH = parcelRequire("1DjzH");

var $jqk9j = parcelRequire("jqk9j");

var $7ock2 = parcelRequire("7ock2");
function $8e6e8f73895b5d1c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e6e8f73895b5d1c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e6e8f73895b5d1c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e6e8f73895b5d1c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e6e8f73895b5d1c$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: "center"
    }
};
var $8e6e8f73895b5d1c$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $jqk9j.isDOMElement)(dom)) // this should never happen
        return {
            layout: "center"
        };
        var layout = dom.getAttribute("data-layout") || "center";
        var width = Number(dom.getAttribute("data-width")) || null;
        var widthType = dom.getAttribute("data-width-type");
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $1DjzH.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            "data-node-type": "mediaSingle",
            "data-layout": layout,
            "data-width": ""
        };
        if (width) attrs["data-width"] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $8e6e8f73895b5d1c$var$_objectSpread($8e6e8f73895b5d1c$var$_objectSpread({}, attrs), {}, {
                "data-width-type": widthType || (0, $1DjzH.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $7ock2.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $7ock2.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $7ock2.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $7ock2.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $8e6e8f73895b5d1c$export$969fe3781ca15058 = $8e6e8f73895b5d1c$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $8e6e8f73895b5d1c$export$d35e6c006d4abdfb = $8e6e8f73895b5d1c$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $8e6e8f73895b5d1c$export$9c58e19811ce4cf5 = $8e6e8f73895b5d1c$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $8e6e8f73895b5d1c$export$7e767666f2ce108a = $8e6e8f73895b5d1c$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $8e6e8f73895b5d1c$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("1DjzH", function(module, exports) {

$parcel$export(module.exports, "WidthType", function () { return $13089e1a37a18d34$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $13089e1a37a18d34$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("2hW23", function(module, exports) {

$parcel$export(module.exports, "mention", function () { return $1aaa2f43e6ac70b8$export$db83999c14438df4; });
$parcel$export(module.exports, "toJSON", function () { return $1aaa2f43e6ac70b8$export$54fd2c36b5cc6731; });

var $lb7vQ = parcelRequire("lb7vQ");

var $aNDXa = parcelRequire("aNDXa");

var $7ock2 = parcelRequire("7ock2");
function $1aaa2f43e6ac70b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1aaa2f43e6ac70b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1aaa2f43e6ac70b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lb7vQ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1aaa2f43e6ac70b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1aaa2f43e6ac70b8$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $1aaa2f43e6ac70b8$export$db83999c14438df4 = (0, $7ock2.mention)({
    parseDOM: [
        {
            tag: "span[data-mention-id]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-mention-id") || $1aaa2f43e6ac70b8$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $1aaa2f43e6ac70b8$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute("data-access-level") || $1aaa2f43e6ac70b8$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $aNDXa.uuid).generate()
                };
                var userType = dom.getAttribute("data-user-type");
                if ($1aaa2f43e6ac70b8$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            "data-mention-id": id,
            "data-access-level": accessLevel,
            contenteditable: "false"
        };
        if (localId) attrs["data-local-id"] = localId;
        if (userType) attrs["data-user-type"] = userType;
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $1aaa2f43e6ac70b8$var$isOptional = function isOptional(key) {
    return [
        "userType",
        "localId"
    ].indexOf(key) > -1;
};
var $1aaa2f43e6ac70b8$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($1aaa2f43e6ac70b8$var$isOptional(key) && !node.attrs[key]) return obj;
            return $1aaa2f43e6ac70b8$var$_objectSpread($1aaa2f43e6ac70b8$var$_objectSpread({}, obj), {}, (0, $lb7vQ.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("dKUxU", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", function () { return $a03b6f124f22ae0a$export$63cadbf5f4296627; });
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", function () { return $a03b6f124f22ae0a$export$15ebf236772fa336; });

var $7ock2 = parcelRequire("7ock2");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $a03b6f124f22ae0a$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true
    };
}
var $a03b6f124f22ae0a$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: "nestedExpand//",
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $a03b6f124f22ae0a$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $a03b6f124f22ae0a$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "nestedExpand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $a03b6f124f22ae0a$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: "nestedExpand//",
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $a03b6f124f22ae0a$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $a03b6f124f22ae0a$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "nestedExpand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $a03b6f124f22ae0a$export$63cadbf5f4296627 = (0, $7ock2.nestedExpand)($a03b6f124f22ae0a$var$nestedExpandFactoryOptions);
var $a03b6f124f22ae0a$export$15ebf236772fa336 = (0, $7ock2.nestedExpandWithoutNonBodiedMacros)($a03b6f124f22ae0a$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("bPGVA", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", function () { return $89d5c1b937c26839$export$4e7125c7ff595be5; });
$parcel$export(module.exports, "orderedList", function () { return $89d5c1b937c26839$export$a5dc81035676e7a; });
$parcel$export(module.exports, "orderedListWithOrder", function () { return $89d5c1b937c26839$export$b9ab759e8298198f; });

var $7ock2 = parcelRequire("7ock2");
var $89d5c1b937c26839$export$4e7125c7ff595be5 = ".ak-ol";
var $89d5c1b937c26839$export$a5dc81035676e7a = (0, $7ock2.orderedList)({
    parseDOM: [
        {
            tag: "ol"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $89d5c1b937c26839$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $89d5c1b937c26839$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $89d5c1b937c26839$export$b9ab759e8298198f = (0, $7ock2.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute("start");
                if (startDOMAttr) {
                    var start = $89d5c1b937c26839$var$resolveStart(startDOMAttr);
                    if (typeof start === "number") return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var start = $89d5c1b937c26839$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        var attrs = {
            start: typeof start === "number" ? String(start) : undefined,
            class: $89d5c1b937c26839$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("koTFc", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $eda13a26c664a18c$export$9c206ddddb32a9b; });

var $7ock2 = parcelRequire("7ock2");
var $eda13a26c664a18c$export$9c206ddddb32a9b = (0, $7ock2.paragraph)({
    parseDOM: [
        {
            tag: "p",
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute("data-local-id") || ((_paragraph$attrs = $eda13a26c664a18c$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = "p";
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("hjZVB", function(module, exports) {

$parcel$export(module.exports, "placeholder", function () { return $c9c43faa5fbde895$export$c7187bbd1a7a9244; });

var $7ock2 = parcelRequire("7ock2");
var $c9c43faa5fbde895$export$c7187bbd1a7a9244 = (0, $7ock2.placeholder)({
    parseDOM: [
        {
            tag: "span[data-placeholder]",
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute("data-placeholder") || $c9c43faa5fbde895$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            "data-placeholder": text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: "true"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});

parcelRegister("ahPRM", function(module, exports) {

$parcel$export(module.exports, "rule", function () { return $77d3b986edcaca61$export$fbeb3a3956e8a3c7; });

var $7ock2 = parcelRequire("7ock2");
/**
 * @name rule_node
 */ var $77d3b986edcaca61$var$hrDOM = [
    "hr"
];
var $77d3b986edcaca61$export$fbeb3a3956e8a3c7 = (0, $7ock2.rule)({
    parseDOM: [
        {
            tag: "hr"
        }
    ],
    toDOM: function toDOM() {
        return $77d3b986edcaca61$var$hrDOM;
    }
});

});

parcelRegister("6q36U", function(module, exports) {

$parcel$export(module.exports, "status", function () { return $4ac79570c3ad34ad$export$471f7ae5c4103ae1; });

var $aNDXa = parcelRequire("aNDXa");

var $7ock2 = parcelRequire("7ock2");
var $4ac79570c3ad34ad$export$471f7ae5c4103ae1 = (0, $7ock2.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, "").trim(),
                    color: dom.getAttribute("data-color"),
                    localId: (0, $aNDXa.uuid).generate(),
                    style: dom.getAttribute("data-style")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            "data-node-type": "status",
            "data-color": color,
            "data-local-id": localId,
            "data-style": style,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});

parcelRegister("2YXnv", function(module, exports) {

$parcel$export(module.exports, "taskItem", function () { return $22bf3e9d2dd187b2$export$6d8b0ef52e2e6390; });

var $aNDXa = parcelRequire("aNDXa");

var $7ock2 = parcelRequire("7ock2");
var $22bf3e9d2dd187b2$export$6d8b0ef52e2e6390 = (0, $7ock2.taskItem)({
    parseDOM: [
        {
            tag: "div[data-task-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $aNDXa.uuid).generate(),
                    state: dom.getAttribute("data-task-state") || "TODO"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-task-local-id": localId || "local-task",
            "data-task-state": state || "TODO"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("hvLof", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", function () { return $cbfa179b25adbb18$export$c0ec71adb7a18fb2; });
$parcel$export(module.exports, "taskList", function () { return $cbfa179b25adbb18$export$375b6afcc5f4d291; });

var $aNDXa = parcelRequire("aNDXa");

var $7ock2 = parcelRequire("7ock2");
/**
 * @name taskList_node
 */ var $cbfa179b25adbb18$var$name = "actionList";
var $cbfa179b25adbb18$export$c0ec71adb7a18fb2 = '[data-node-type="'.concat($cbfa179b25adbb18$var$name, '"]');
var $cbfa179b25adbb18$export$375b6afcc5f4d291 = (0, $7ock2.taskList)({
    parseDOM: [
        {
            tag: "div".concat($cbfa179b25adbb18$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $aNDXa.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $cbfa179b25adbb18$var$name,
            "data-task-list-local-id": localId || "local-task-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("eXoFB", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $ae39b659db29d6af$export$6f093cfa640b7166; });

var $7ock2 = parcelRequire("7ock2");
var $ae39b659db29d6af$export$6f093cfa640b7166 = (0, $7ock2.text)({
    toDebugString: function() {
        return "text_node";
    }
});

});

parcelRegister("9LWfX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $71d5b1578c78a1e4$export$2e2bcd8739ae039; });
var $71d5b1578c78a1e4$var$name = "unknownBlock";
var $71d5b1578c78a1e4$export$2e2bcd8739ae039 = {
    group: "block",
    content: "inline+",
    marks: "_",
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": $71d5b1578c78a1e4$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($71d5b1578c78a1e4$var$name, '"]')
        }
    ]
};

});

parcelRegister("9SYbN", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", function () { return $7327d88a3e0cde9d$export$44b79b0979d0f0f7; });

var $7ock2 = parcelRequire("7ock2");
var $7327d88a3e0cde9d$export$44b79b0979d0f0f7 = (0, $7ock2.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedBlock",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    }
});

});

parcelRegister("7s3bA", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", function () { return $56cd9e99d95ca283$export$310ebe0d80122e9b; });

var $7ock2 = parcelRequire("7ock2");
var $56cd9e99d95ca283$export$310ebe0d80122e9b = (0, $7ock2.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedInline",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "span",
            attrs,
            "Unsupported content"
        ];
    }
});

});



parcelRegister("eZ2Jv", function(module, exports) {

$parcel$export(module.exports, "JSONTransformer", function () { return $ae88e1e36258345d$export$98cb1d9308d0944d; });

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $bo26J = parcelRequire("bo26J");

var $jR3qz = parcelRequire("jR3qz");

var $6THua = parcelRequire("6THua");

var $iTkT1 = parcelRequire("iTkT1");

var $hCSPY = parcelRequire("hCSPY");
var $ki8RA = parcelRequire("ki8RA");
var $8G05O = parcelRequire("8G05O");
var $boWpd = parcelRequire("boWpd");
var $1RQCT = parcelRequire("1RQCT");
var $gVZPw = parcelRequire("gVZPw");
var $dA2jn = parcelRequire("dA2jn");
var $8stLs = parcelRequire("8stLs");
var $bqzKK = parcelRequire("bqzKK");

var $6tVVd = parcelRequire("6tVVd");

var $buJff = parcelRequire("buJff");

var $3muWh = parcelRequire("3muWh");
function $ae88e1e36258345d$var$_toPropertyKey(t) {
    var i = $ae88e1e36258345d$var$_toPrimitive(t, "string");
    return "symbol" == (0, $bo26J.default)(i) ? i : i + "";
}
function $ae88e1e36258345d$var$_toPrimitive(t, r) {
    if ("object" != (0, $bo26J.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $bo26J.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ae88e1e36258345d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae88e1e36258345d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae88e1e36258345d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae88e1e36258345d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ae88e1e36258345d$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
var $ae88e1e36258345d$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
// Create a Set of node types that should have empty attrs removed
var $ae88e1e36258345d$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    "paragraph",
    "layoutSection",
    "blockquote",
    "nestedExpand",
    "bulletList",
    "listItem",
    "orderedList",
    "rule",
    "caption",
    "tableRow",
    "media",
    "mediaSingle",
    "mediaInline"
]);
var $ae88e1e36258345d$var$isCodeBlock = $ae88e1e36258345d$var$isType("codeBlock");
var $ae88e1e36258345d$var$isMediaNode = $ae88e1e36258345d$var$isType("media");
var $ae88e1e36258345d$var$isMediaInline = $ae88e1e36258345d$var$isType("mediaInline");
var $ae88e1e36258345d$var$isMediaSingleNode = $ae88e1e36258345d$var$isType("mediaSingle");
var $ae88e1e36258345d$var$isMentionNode = $ae88e1e36258345d$var$isType("mention");
var $ae88e1e36258345d$var$isParagraph = $ae88e1e36258345d$var$isType("paragraph");
var $ae88e1e36258345d$var$isHeading = $ae88e1e36258345d$var$isType("heading");
var $ae88e1e36258345d$var$isTable = $ae88e1e36258345d$var$isType("table");
var $ae88e1e36258345d$var$isTableCell = $ae88e1e36258345d$var$isType("tableCell");
var $ae88e1e36258345d$var$isTableHeader = $ae88e1e36258345d$var$isType("tableHeader");
var $ae88e1e36258345d$var$isLinkMark = $ae88e1e36258345d$var$isType("link");
var $ae88e1e36258345d$var$isUnsupportedMark = $ae88e1e36258345d$var$isType("unsupportedMark");
var $ae88e1e36258345d$var$isUnsupportedNodeAttributeMark = $ae88e1e36258345d$var$isType("unsupportedNodeAttribute");
var $ae88e1e36258345d$var$isExpand = $ae88e1e36258345d$var$isType("expand");
var $ae88e1e36258345d$var$isNestedExpand = $ae88e1e36258345d$var$isType("nestedExpand");
var $ae88e1e36258345d$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $ae88e1e36258345d$var$isType("unsupportedBlock")(node) || $ae88e1e36258345d$var$isType("unsupportedInline")(node);
};
var $ae88e1e36258345d$var$isDataConsumer = $ae88e1e36258345d$var$isType("dataConsumer");
var $ae88e1e36258345d$var$isFragmentMark = $ae88e1e36258345d$var$isType("fragment");
var $ae88e1e36258345d$var$isHardBreak = $ae88e1e36258345d$var$isType("hardBreak");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $ae88e1e36258345d$var$_filterNull = function filterNull(subject) {
    var output = $ae88e1e36258345d$var$_objectSpread({}, subject);
    // eslint-disable-next-line guard-for-in
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, $jR3qz.default)(_output, [
                key
            ].map($ae88e1e36258345d$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, $bo26J.default)(current) === "object" && !Array.isArray(current)) output[key] = $ae88e1e36258345d$var$_filterNull(current);
    }
    return output;
};
var $ae88e1e36258345d$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: "doc",
        content: content || []
    };
};
var $ae88e1e36258345d$var$emptyDoc = $ae88e1e36258345d$var$createDocFromContent([
    {
        type: "paragraph",
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ var $ae88e1e36258345d$export$3a858d3babd60825 = function toJSON(node, mentionMap) {
    var obj = {
        type: node.type.name
    };
    if ($ae88e1e36258345d$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($ae88e1e36258345d$var$isMediaNode(node)) obj.attrs = (0, $dA2jn.toJSON)(node).attrs;
    else if ($ae88e1e36258345d$var$isMediaSingleNode(node)) obj.attrs = (0, $gVZPw.toJSON)(node).attrs;
    else if ($ae88e1e36258345d$var$isMediaInline(node)) obj.attrs = (0, $dA2jn.toJSON)(node).attrs;
    else if ($ae88e1e36258345d$var$isMentionNode(node)) obj.attrs = (0, $8stLs.toJSON)(node).attrs;
    else if ($ae88e1e36258345d$var$isCodeBlock(node)) obj.attrs = (0, $hCSPY.toJSON)(node).attrs;
    else if ($ae88e1e36258345d$var$isTable(node)) obj.attrs = (0, $bqzKK.tableToJSON)(node).attrs;
    else if ($ae88e1e36258345d$var$isTableCell(node)) obj.attrs = (0, $bqzKK.toJSONTableCell)(node).attrs;
    else if ($ae88e1e36258345d$var$isTableHeader(node)) obj.attrs = (0, $bqzKK.toJSONTableHeader)(node).attrs;
    else if ($ae88e1e36258345d$var$isExpand(node) || $ae88e1e36258345d$var$isNestedExpand(node)) obj.attrs = (0, $8G05O.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $ae88e1e36258345d$var$_filterNull(obj.attrs);
    if ($ae88e1e36258345d$var$isMentionNode(node) && mentionMap) {
        var _text, _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        var name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? "@".concat(mentionMap[node.attrs.id]) : "";
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var text = (_text = (_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) !== null && _text !== void 0 ? _text : "";
        obj.attrs = $ae88e1e36258345d$var$_objectSpread($ae88e1e36258345d$var$_objectSpread({}, obj.attrs), {}, {
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        });
    }
    if ($ae88e1e36258345d$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $ae88e1e36258345d$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push($ae88e1e36258345d$export$3a858d3babd60825(child, mentionMap));
    });
    if ($ae88e1e36258345d$var$isParagraph(node) || $ae88e1e36258345d$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($ae88e1e36258345d$var$isUnsupportedMark(mark)) return $ae88e1e36258345d$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($ae88e1e36258345d$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($ae88e1e36258345d$var$isLinkMark(mark)) return (0, $1RQCT.toJSON)(mark);
            else if ($ae88e1e36258345d$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $ki8RA.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($ae88e1e36258345d$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $boWpd.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($ae88e1e36258345d$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $ae88e1e36258345d$var$_objectSpread({}, $ae88e1e36258345d$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};
var $ae88e1e36258345d$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $buJff.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $ae88e1e36258345d$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $ae88e1e36258345d$var$_objectSpread($ae88e1e36258345d$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $ae88e1e36258345d$var$_objectSpread($ae88e1e36258345d$var$_objectSpread({}, attributes), {}, (0, $6THua.default)({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
var $ae88e1e36258345d$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ function JSONTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $6tVVd.defaultSchema);
        var mentionMap = arguments.length > 1 ? arguments[1] : undefined;
        (0, $cnuD2.default)(this, JSONTransformer);
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    return (0, $ecJAY.default)(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $3muWh.sanitizeNode)($ae88e1e36258345d$export$3a858d3babd60825(child, _this.mentionMap), options));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($iTkT1)))(content, $ae88e1e36258345d$var$emptyDoc.content)) return $ae88e1e36258345d$var$createDocFromContent([]);
                return $ae88e1e36258345d$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content, schema) {
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== "doc") throw new Error("Expected content format to be ADF");
                var schema = !!stage ? (0, $6tVVd.getSchemaBasedOnStage)(stage) : this.schema;
                if (!content.content || content.content.length === 0) return this.internalParse($ae88e1e36258345d$var$emptyDoc, schema);
                return this.internalParse(content, schema);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                return (0, $3muWh.sanitizeNode)($ae88e1e36258345d$export$3a858d3babd60825(node, this.mentionMap));
            }
        }
    ]);
}();

});
parcelRegister("jR3qz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e745a02f0cf59179$export$2e2bcd8739ae039; });

var $b7HhI = parcelRequire("b7HhI");
function $e745a02f0cf59179$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $b7HhI.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("b7HhI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8191ec97b0ff2463$export$2e2bcd8739ae039; });
function $8191ec97b0ff2463$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("6THua", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50599c734036949c$export$2e2bcd8739ae039; });

var $fVEiC = parcelRequire("fVEiC");
function $50599c734036949c$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $fVEiC.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("iTkT1", function(module, exports) {

var $5JKmU = parcelRequire("5JKmU");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $dc0d90adeb034e26$var$isEqual(value, other) {
    return $5JKmU(value, other);
}
module.exports = $dc0d90adeb034e26$var$isEqual;

});

parcelRegister("hCSPY", function(module, exports) {

$parcel$export(module.exports, "codeBlock", function () { return $cd5085d458b4d35e$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "toJSON", function () { return $cd5085d458b4d35e$export$54fd2c36b5cc6731; });

var $6Z794 = parcelRequire("6Z794");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $cd5085d458b4d35e$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute("data-language") || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $cd5085d458b4d35e$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains("codehilite")) // code block html from Bitbucket always contains an extra new line
    return $cd5085d458b4d35e$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $cd5085d458b4d35e$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === "CODE") return firstChild.getAttribute("data-language") || undefined;
};
var $cd5085d458b4d35e$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $cd5085d458b4d35e$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains("codehilite")) dom.textContent = dom.textContent.replace(/\n$/, "");
    return dom;
};
function $cd5085d458b4d35e$var$parseCodeFromHtml(node) {
    var code = "";
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === "div" || tagName === "p") // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += "\n";
            }
            if (tagName === "br") code += "\n";
            else code += $cd5085d458b4d35e$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $cd5085d458b4d35e$export$7bb0d5c671655cc4 = (0, $gtPcq.codeBlock)({
    parseDOM: [
        {
            tag: "pre",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $cd5085d458b4d35e$var$getLanguageFromBitbucketStyle(dom.parentElement) || $cd5085d458b4d35e$var$getLanguageFromEditorStyle(dom.parentElement) || $cd5085d458b4d35e$var$getLanguageFromCode(dom) || dom.getAttribute("data-language");
                dom = $cd5085d458b4d35e$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: "div[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre" || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $cd5085d458b4d35e$var$parseCodeFromHtml(domNode);
                return code ? (0, $6Z794.Fragment).from(schema.text(code)) : (0, $6Z794.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: "table[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: "div.code-block",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll(".react-syntax-highlighter-line-number");
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "pre",
            [
                "code",
                {
                    "data-language": node.attrs.language
                },
                0
            ]
        ];
    }
});
var $cd5085d458b4d35e$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === "uniqueId") return memo;
            if (key === "language" && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $cd5085d458b4d35e$export$3f75de798a0b5356 = (0, $gtPcq.codeBlock)({
    parseDOM: [
        {
            tag: "pre",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $cd5085d458b4d35e$var$getLanguageFromBitbucketStyle(dom.parentElement) || $cd5085d458b4d35e$var$getLanguageFromEditorStyle(dom.parentElement) || $cd5085d458b4d35e$var$getLanguageFromCode(dom) || dom.getAttribute("data-language");
                dom = $cd5085d458b4d35e$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: "div[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre" || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $cd5085d458b4d35e$var$parseCodeFromHtml(domNode);
                return code ? (0, $6Z794.Fragment).from(schema.text(code)) : (0, $6Z794.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: "table[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: "div.code-block",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll(".react-syntax-highlighter-line-number");
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "pre",
            attrs,
            [
                "code",
                {
                    "data-language": node.attrs.language
                },
                0
            ]
        ];
    }
});

});
parcelRegister("6Z794", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $515dfb7ce27922f4$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $515dfb7ce27922f4$export$19342e026b58ebb7; });

var $73qKE = parcelRequire("73qKE");
function $515dfb7ce27922f4$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $515dfb7ce27922f4$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $515dfb7ce27922f4$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $515dfb7ce27922f4$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $515dfb7ce27922f4$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $515dfb7ce27922f4$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $515dfb7ce27922f4$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $515dfb7ce27922f4$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $515dfb7ce27922f4$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $515dfb7ce27922f4$var$retIndex(0, pos);
        if (pos == this.size) return $515dfb7ce27922f4$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $515dfb7ce27922f4$var$retIndex(i + 1, end);
                return $515dfb7ce27922f4$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $515dfb7ce27922f4$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $515dfb7ce27922f4$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $515dfb7ce27922f4$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $515dfb7ce27922f4$export$ffb0004e005737fa.empty;
        if (nodes instanceof $515dfb7ce27922f4$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $515dfb7ce27922f4$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $515dfb7ce27922f4$export$ffb0004e005737fa.empty = new $515dfb7ce27922f4$export$ffb0004e005737fa([], 0);
const $515dfb7ce27922f4$var$found = {
    index: 0,
    offset: 0
};
function $515dfb7ce27922f4$var$retIndex(index, offset) {
    $515dfb7ce27922f4$var$found.index = index;
    $515dfb7ce27922f4$var$found.offset = offset;
    return $515dfb7ce27922f4$var$found;
}
function $515dfb7ce27922f4$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$515dfb7ce27922f4$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$515dfb7ce27922f4$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $515dfb7ce27922f4$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $515dfb7ce27922f4$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
        if (marks instanceof $515dfb7ce27922f4$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $515dfb7ce27922f4$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $515dfb7ce27922f4$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $515dfb7ce27922f4$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $515dfb7ce27922f4$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $515dfb7ce27922f4$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $515dfb7ce27922f4$export$b3f2e2de3a8baa1e($515dfb7ce27922f4$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $515dfb7ce27922f4$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $515dfb7ce27922f4$export$b3f2e2de3a8baa1e($515dfb7ce27922f4$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $515dfb7ce27922f4$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $515dfb7ce27922f4$export$b3f2e2de3a8baa1e.empty = new $515dfb7ce27922f4$export$b3f2e2de3a8baa1e($515dfb7ce27922f4$export$ffb0004e005737fa.empty, 0, 0);
function $515dfb7ce27922f4$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($515dfb7ce27922f4$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $515dfb7ce27922f4$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $515dfb7ce27922f4$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $515dfb7ce27922f4$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $515dfb7ce27922f4$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $515dfb7ce27922f4$export$6de0e778727af3f2("Inconsistent open depths");
    return $515dfb7ce27922f4$var$replaceOuter($from, $to, slice, 0);
}
function $515dfb7ce27922f4$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $515dfb7ce27922f4$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $515dfb7ce27922f4$var$close(node, $515dfb7ce27922f4$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $515dfb7ce27922f4$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $515dfb7ce27922f4$var$prepareSliceForReplace(slice, $from);
        return $515dfb7ce27922f4$var$close(node, $515dfb7ce27922f4$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $515dfb7ce27922f4$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $515dfb7ce27922f4$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $515dfb7ce27922f4$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $515dfb7ce27922f4$var$checkJoin(node, $after.node(depth));
    return node;
}
function $515dfb7ce27922f4$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $515dfb7ce27922f4$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $515dfb7ce27922f4$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$515dfb7ce27922f4$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $515dfb7ce27922f4$var$addNode($end.nodeBefore, target);
}
function $515dfb7ce27922f4$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $515dfb7ce27922f4$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $515dfb7ce27922f4$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $515dfb7ce27922f4$var$joinable($end, $to, depth + 1);
    let content = [];
    $515dfb7ce27922f4$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $515dfb7ce27922f4$var$checkJoin(openStart, openEnd);
        $515dfb7ce27922f4$var$addNode($515dfb7ce27922f4$var$close(openStart, $515dfb7ce27922f4$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $515dfb7ce27922f4$var$addNode($515dfb7ce27922f4$var$close(openStart, $515dfb7ce27922f4$var$replaceTwoWay($from, $start, depth + 1)), content);
        $515dfb7ce27922f4$var$addRange($start, $end, depth, content);
        if (openEnd) $515dfb7ce27922f4$var$addNode($515dfb7ce27922f4$var$close(openEnd, $515dfb7ce27922f4$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $515dfb7ce27922f4$var$addRange($to, null, depth, content);
    return new $515dfb7ce27922f4$export$ffb0004e005737fa(content);
}
function $515dfb7ce27922f4$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $515dfb7ce27922f4$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $515dfb7ce27922f4$var$joinable($from, $to, depth + 1);
        $515dfb7ce27922f4$var$addNode($515dfb7ce27922f4$var$close(type, $515dfb7ce27922f4$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $515dfb7ce27922f4$var$addRange($to, null, depth, content);
    return new $515dfb7ce27922f4$export$ffb0004e005737fa(content);
}
function $515dfb7ce27922f4$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($515dfb7ce27922f4$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $515dfb7ce27922f4$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $515dfb7ce27922f4$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $515dfb7ce27922f4$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $515dfb7ce27922f4$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $515dfb7ce27922f4$var$resolveCache.set(doc, cache = new $515dfb7ce27922f4$var$ResolveCache);
        let result = cache.elts[cache.i] = $515dfb7ce27922f4$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $515dfb7ce27922f4$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $515dfb7ce27922f4$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $515dfb7ce27922f4$var$resolveCacheSize = 12, $515dfb7ce27922f4$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $515dfb7ce27922f4$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $515dfb7ce27922f4$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $515dfb7ce27922f4$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $515dfb7ce27922f4$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $515dfb7ce27922f4$var$emptyAttrs) && $515dfb7ce27922f4$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $515dfb7ce27922f4$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $515dfb7ce27922f4$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $515dfb7ce27922f4$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $515dfb7ce27922f4$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $515dfb7ce27922f4$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $515dfb7ce27922f4$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $515dfb7ce27922f4$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $515dfb7ce27922f4$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $515dfb7ce27922f4$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $515dfb7ce27922f4$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$515dfb7ce27922f4$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $515dfb7ce27922f4$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $515dfb7ce27922f4$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $515dfb7ce27922f4$export$ffb0004e005737fa.empty;
    }
}
$515dfb7ce27922f4$export$85c928794f8d04d4.prototype.text = undefined;
class $515dfb7ce27922f4$var$TextNode extends $515dfb7ce27922f4$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $515dfb7ce27922f4$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $515dfb7ce27922f4$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $515dfb7ce27922f4$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $515dfb7ce27922f4$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $515dfb7ce27922f4$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $515dfb7ce27922f4$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $515dfb7ce27922f4$export$364ed450558d7ec4.empty;
        let expr = $515dfb7ce27922f4$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $515dfb7ce27922f4$var$dfa($515dfb7ce27922f4$var$nfa(expr));
        $515dfb7ce27922f4$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $515dfb7ce27922f4$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $515dfb7ce27922f4$export$364ed450558d7ec4.empty = new $515dfb7ce27922f4$export$364ed450558d7ec4(true);
class $515dfb7ce27922f4$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $515dfb7ce27922f4$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($515dfb7ce27922f4$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $515dfb7ce27922f4$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($515dfb7ce27922f4$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $515dfb7ce27922f4$var$parseExprSubscript(stream) {
    let expr = $515dfb7ce27922f4$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $515dfb7ce27922f4$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $515dfb7ce27922f4$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $515dfb7ce27922f4$var$parseExprRange(stream, expr) {
    let min = $515dfb7ce27922f4$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $515dfb7ce27922f4$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $515dfb7ce27922f4$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $515dfb7ce27922f4$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $515dfb7ce27922f4$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $515dfb7ce27922f4$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $515dfb7ce27922f4$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $515dfb7ce27922f4$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $515dfb7ce27922f4$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($515dfb7ce27922f4$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $515dfb7ce27922f4$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($515dfb7ce27922f4$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $515dfb7ce27922f4$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $515dfb7ce27922f4$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($515dfb7ce27922f4$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $515dfb7ce27922f4$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $515dfb7ce27922f4$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $515dfb7ce27922f4$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $515dfb7ce27922f4$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $515dfb7ce27922f4$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $515dfb7ce27922f4$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $515dfb7ce27922f4$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $515dfb7ce27922f4$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $515dfb7ce27922f4$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $515dfb7ce27922f4$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $515dfb7ce27922f4$export$ffb0004e005737fa.from(content), $515dfb7ce27922f4$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $515dfb7ce27922f4$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $515dfb7ce27922f4$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $515dfb7ce27922f4$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $515dfb7ce27922f4$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($515dfb7ce27922f4$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $515dfb7ce27922f4$export$85c928794f8d04d4(this, attrs, content.append(after), $515dfb7ce27922f4$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $515dfb7ce27922f4$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $515dfb7ce27922f4$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $515dfb7ce27922f4$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $515dfb7ce27922f4$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $515dfb7ce27922f4$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $515dfb7ce27922f4$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $515dfb7ce27922f4$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $515dfb7ce27922f4$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $515dfb7ce27922f4$export$c9d15bcfc6d42044(this, $515dfb7ce27922f4$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $515dfb7ce27922f4$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $515dfb7ce27922f4$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $515dfb7ce27922f4$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $515dfb7ce27922f4$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $515dfb7ce27922f4$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $515dfb7ce27922f4$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $515dfb7ce27922f4$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $515dfb7ce27922f4$var$TextNode(type, type.defaultAttrs, text, $515dfb7ce27922f4$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $515dfb7ce27922f4$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $515dfb7ce27922f4$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $73qKE.default).from(spec.nodes), instanceSpec.marks = (0, $73qKE.default).from(spec.marks || {}), this.nodes = $515dfb7ce27922f4$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $515dfb7ce27922f4$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $515dfb7ce27922f4$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $515dfb7ce27922f4$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $515dfb7ce27922f4$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $515dfb7ce27922f4$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $515dfb7ce27922f4$var$isTagRule(rule) {
    return rule.tag != null;
}
function $515dfb7ce27922f4$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $515dfb7ce27922f4$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $515dfb7ce27922f4$var$ParseContext(this, options, false);
        context.addAll(dom, $515dfb7ce27922f4$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $515dfb7ce27922f4$var$ParseContext(this, options, true);
        context.addAll(dom, $515dfb7ce27922f4$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $515dfb7ce27922f4$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($515dfb7ce27922f4$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $515dfb7ce27922f4$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $515dfb7ce27922f4$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $515dfb7ce27922f4$export$1059c6e7d2ce5669(schema, $515dfb7ce27922f4$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($515dfb7ce27922f4$var$isTagRule(rule)) this.tags.push(rule);
            else if ($515dfb7ce27922f4$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $515dfb7ce27922f4$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $515dfb7ce27922f4$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $515dfb7ce27922f4$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $515dfb7ce27922f4$var$OPT_PRESERVE_WS = 1, $515dfb7ce27922f4$var$OPT_PRESERVE_WS_FULL = 2, $515dfb7ce27922f4$var$OPT_OPEN_LEFT = 4;
function $515dfb7ce27922f4$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $515dfb7ce27922f4$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $515dfb7ce27922f4$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $515dfb7ce27922f4$var$OPT_PRESERVE_WS | $515dfb7ce27922f4$var$OPT_PRESERVE_WS_FULL : base & ~$515dfb7ce27922f4$var$OPT_OPEN_LEFT;
}
class $515dfb7ce27922f4$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($515dfb7ce27922f4$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $515dfb7ce27922f4$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $515dfb7ce27922f4$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($515dfb7ce27922f4$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$515dfb7ce27922f4$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $515dfb7ce27922f4$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $515dfb7ce27922f4$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $515dfb7ce27922f4$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $515dfb7ce27922f4$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($515dfb7ce27922f4$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $515dfb7ce27922f4$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $515dfb7ce27922f4$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($515dfb7ce27922f4$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $515dfb7ce27922f4$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $515dfb7ce27922f4$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $515dfb7ce27922f4$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $515dfb7ce27922f4$var$OPT_OPEN_LEFT;
        let applyMarks = $515dfb7ce27922f4$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $515dfb7ce27922f4$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $515dfb7ce27922f4$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $515dfb7ce27922f4$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $515dfb7ce27922f4$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $515dfb7ce27922f4$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $515dfb7ce27922f4$var$NodeContext(topNode.type, topNode.attrs, $515dfb7ce27922f4$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $515dfb7ce27922f4$var$NodeContext(null, null, $515dfb7ce27922f4$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $515dfb7ce27922f4$var$NodeContext(parser.schema.topNodeType, null, $515dfb7ce27922f4$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $515dfb7ce27922f4$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $515dfb7ce27922f4$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $515dfb7ce27922f4$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $515dfb7ce27922f4$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $515dfb7ce27922f4$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $515dfb7ce27922f4$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $515dfb7ce27922f4$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $515dfb7ce27922f4$var$renderSpec($515dfb7ce27922f4$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $515dfb7ce27922f4$var$renderSpec($515dfb7ce27922f4$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $515dfb7ce27922f4$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $515dfb7ce27922f4$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $515dfb7ce27922f4$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $515dfb7ce27922f4$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $515dfb7ce27922f4$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $515dfb7ce27922f4$var$doc(options) {
    return options.document || window.document;
}
const $515dfb7ce27922f4$var$suspiciousAttributeCache = new WeakMap();
function $515dfb7ce27922f4$var$suspiciousAttributes(attrs) {
    let value = $515dfb7ce27922f4$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $515dfb7ce27922f4$var$suspiciousAttributeCache.set(attrs, value = $515dfb7ce27922f4$var$suspiciousAttributesInner(attrs));
    return value;
}
function $515dfb7ce27922f4$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $515dfb7ce27922f4$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $515dfb7ce27922f4$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $515dfb7ce27922f4$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("gtPcq", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $bff711e65aa1abfb$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $bff711e65aa1abfb$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $bff711e65aa1abfb$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockTaskItem", function () { return $bff711e65aa1abfb$export$16018c61064a18df; });
$parcel$export(module.exports, "bodiedExtension", function () { return $bff711e65aa1abfb$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $bff711e65aa1abfb$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $bff711e65aa1abfb$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $bff711e65aa1abfb$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $bff711e65aa1abfb$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $bff711e65aa1abfb$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $bff711e65aa1abfb$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $bff711e65aa1abfb$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $bff711e65aa1abfb$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $bff711e65aa1abfb$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $bff711e65aa1abfb$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $bff711e65aa1abfb$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $bff711e65aa1abfb$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $bff711e65aa1abfb$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "extension", function () { return $bff711e65aa1abfb$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $bff711e65aa1abfb$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $bff711e65aa1abfb$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $bff711e65aa1abfb$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $bff711e65aa1abfb$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $bff711e65aa1abfb$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $bff711e65aa1abfb$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $bff711e65aa1abfb$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $bff711e65aa1abfb$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $bff711e65aa1abfb$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $bff711e65aa1abfb$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $bff711e65aa1abfb$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $bff711e65aa1abfb$export$df876f0305235056; });
$parcel$export(module.exports, "media", function () { return $bff711e65aa1abfb$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $bff711e65aa1abfb$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $bff711e65aa1abfb$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $bff711e65aa1abfb$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $bff711e65aa1abfb$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $bff711e65aa1abfb$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $bff711e65aa1abfb$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $bff711e65aa1abfb$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $bff711e65aa1abfb$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $bff711e65aa1abfb$export$63cadbf5f4296627; });
$parcel$export(module.exports, "orderedList", function () { return $bff711e65aa1abfb$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $bff711e65aa1abfb$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "paragraph", function () { return $bff711e65aa1abfb$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $bff711e65aa1abfb$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $bff711e65aa1abfb$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $bff711e65aa1abfb$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "syncBlockStage0", function () { return $bff711e65aa1abfb$export$3782866d5d058412; });
$parcel$export(module.exports, "table", function () { return $bff711e65aa1abfb$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $bff711e65aa1abfb$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $bff711e65aa1abfb$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $bff711e65aa1abfb$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $bff711e65aa1abfb$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $bff711e65aa1abfb$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $bff711e65aa1abfb$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $bff711e65aa1abfb$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $bff711e65aa1abfb$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $bff711e65aa1abfb$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $bff711e65aa1abfb$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $bff711e65aa1abfb$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $bff711e65aa1abfb$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $fAMXq = parcelRequire("fAMXq");
var $bff711e65aa1abfb$export$c4c2f833baaebdb8 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $bff711e65aa1abfb$export$67dc04e652a298ca = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $bff711e65aa1abfb$export$199922e5af8e9a6 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $bff711e65aa1abfb$export$16018c61064a18df = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | extension) (paragraph | extension)*",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "TODO"
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$27903d543b563e39 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $bff711e65aa1abfb$export$e7320d153c538837 = (0, $fAMXq.createPMNodeSpecFactory)({
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $bff711e65aa1abfb$export$a140c94e5ea26bee = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$8e3c2dfdc4f0453d = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*",
    marks: "_",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $bff711e65aa1abfb$export$7bb0d5c671655cc4 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $bff711e65aa1abfb$export$e4f1c66d84049f8b = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $bff711e65aa1abfb$export$daf889beb5092f95 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ""
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $bff711e65aa1abfb$export$e6e4878f43c27cab = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $bff711e65aa1abfb$export$3e6d667072febc87 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $bff711e65aa1abfb$export$324d90190a8b822a = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        timestamp: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$47988d68fe575725 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        timestamp: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$6959e16eeff859b4 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "DECIDED"
        }
    },
    defining: true
});
var $bff711e65aa1abfb$export$62d45a65fb43d95e = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(decisionItem | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: ""
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$2a111da947c407d2 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout"
});
var $bff711e65aa1abfb$export$be4283d9a1cb1ff6 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        url: {
            default: ""
        },
        layout: {
            default: "center"
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$a19185d1233fc4b2 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$f5574b5d45fc2112 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$9f77e0932fb78f72 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    group: "block",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $bff711e65aa1abfb$export$7e3788972005cc72 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $bff711e65aa1abfb$export$1b45514b112dd749 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$a8baf338431a691 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$b555be60c7703afb = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $bff711e65aa1abfb$export$371da9dd35aba193 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: "\n"
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $bff711e65aa1abfb$export$46e4a324ac90507f = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border",
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$1b0c1557b234fa00 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$85461f751c457cc2 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$2b380a0f7e250af1 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$5c452ff88e35e47d = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        src: {
            default: ""
        },
        alt: {
            default: ""
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $bff711e65aa1abfb$export$cbf8224b64e0d942 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $bff711e65aa1abfb$export$2f4e72b9459914ad = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $bff711e65aa1abfb$export$16b353b2649bd8d9 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$b3b1e36c2105006d = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$ab76e7c03cd6f650 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(block | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment",
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $bff711e65aa1abfb$export$b3b6a70a7fa4a5be = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $bff711e65aa1abfb$export$cdae19acb0a520fd = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){2,3}",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $bff711e65aa1abfb$export$206007566ca0aca5 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $bff711e65aa1abfb$export$76c7e83ecc9cdf05 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$df876f0305235056 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$987d49ffe1b0900f = (0, $fAMXq.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: "file"
        },
        localId: {
            default: null
        },
        id: {
            default: ""
        },
        alt: {
            default: ""
        },
        collection: {
            default: ""
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$2855e964765eac9 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(media | unsupportedBlock)+",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {},
    selectable: false
});
var $bff711e65aa1abfb$export$38bab695e3f720f1 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        type: {
            default: "file"
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ""
        },
        alt: {
            default: ""
        },
        collection: {
            default: ""
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$969fe3781ca15058 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        layout: {
            default: "center"
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: "media|unsupportedBlock+|media unsupportedBlock+",
    marks: "annotation border link unsupportedMark unsupportedNodeAttribute"
});
var $bff711e65aa1abfb$export$8d067f22dc2d1254 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: false,
    attrs: {
        layout: {
            default: "center"
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$7e767666f2ce108a = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: "center"
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$4bd9a38995f6bf50 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media unsupportedBlock+",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: "center"
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$db83999c14438df4 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        localId: {
            default: null
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$46f790bd65f760d0 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        localId: {
            default: null
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$750e45819f66d9d0 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "extensionFrame+",
    marks: "unsupportedNodeAttribute unsupportedMark",
    group: "blockRootOnly",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $bff711e65aa1abfb$export$63cadbf5f4296627 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $bff711e65aa1abfb$export$f03786aa6312d1e4 = (0, $fAMXq.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $bff711e65aa1abfb$export$a5dc81035676e7a = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$21f42ab9b6679f44 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    group: "block",
    attrs: {
        panelType: {
            default: "info"
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$9c206ddddb32a9b = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$4f98472e6dc14293 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$ea332b61641b0588 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$a1f41dc4901771f8 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$c7187bbd1a7a9244 = (0, $fAMXq.createPMNodeSpecFactory)({
    marks: "",
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $bff711e65aa1abfb$export$fbeb3a3956e8a3c7 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    }
});
var $bff711e65aa1abfb$export$471f7ae5c4103ae1 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: ""
        },
        style: {
            default: ""
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$b6ce52be8d7a261 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: ""
        },
        style: {
            default: ""
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$3782866d5d058412 = (0, $fAMXq.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ""
        },
        localId: {
            default: ""
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$9852986a3ec5f6a0 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "tableRow+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: "table"
});
var $bff711e65aa1abfb$export$ce086a560a1d05f5 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "tableRow+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: "table"
});
var $bff711e65aa1abfb$export$e1e720e5f4603e6a = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "cell"
});
var $bff711e65aa1abfb$export$abf39ca178940ff3 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "cell"
});
var $bff711e65aa1abfb$export$48884d2a5190dc73 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "header_cell"
});
var $bff711e65aa1abfb$export$2a5a518232fa1a97 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "header_cell"
});
var $bff711e65aa1abfb$export$ce666bf02318c957 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: "row"
});
var $bff711e65aa1abfb$export$7d657479499397 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: "row"
});
var $bff711e65aa1abfb$export$6d8b0ef52e2e6390 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "TODO"
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$375b6afcc5f4d291 = (0, $fAMXq.createPMNodeSpecFactory)({
    content: "(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: ""
        }
    },
    selectable: false,
    defining: true
});
var $bff711e65aa1abfb$export$6f093cfa640b7166 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline"
});
var $bff711e65aa1abfb$export$5ea06bc686c59dc2 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline"
});
var $bff711e65aa1abfb$export$93256a4c17b33a82 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline"
});
var $bff711e65aa1abfb$export$a12828d0f14a2762 = (0, $fAMXq.createPMNodeSpecFactory)({});
var $bff711e65aa1abfb$export$44b79b0979d0f0f7 = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $bff711e65aa1abfb$export$310ebe0d80122e9b = (0, $fAMXq.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("fAMXq", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $b5a031bd868ca17a$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $b5a031bd868ca17a$export$cf5823ed4e9f4c6f; });

var $2VHRc = parcelRequire("2VHRc");
function $b5a031bd868ca17a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5a031bd868ca17a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5a031bd868ca17a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5a031bd868ca17a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b5a031bd868ca17a$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $b5a031bd868ca17a$var$_objectSpread($b5a031bd868ca17a$var$_objectSpread($b5a031bd868ca17a$var$_objectSpread($b5a031bd868ca17a$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $b5a031bd868ca17a$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $b5a031bd868ca17a$var$_objectSpread($b5a031bd868ca17a$var$_objectSpread($b5a031bd868ca17a$var$_objectSpread($b5a031bd868ca17a$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});
parcelRegister("2VHRc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2222ecb7d5375943$export$2e2bcd8739ae039; });

var $37yjW = parcelRequire("37yjW");
function $2222ecb7d5375943$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $37yjW.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("37yjW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $245ca5e567c6df22$export$2e2bcd8739ae039; });

var $c6EQE = parcelRequire("c6EQE");

var $137IJ = parcelRequire("137IJ");
function $245ca5e567c6df22$export$2e2bcd8739ae039(t) {
    var i = (0, $137IJ.default)(t, "string");
    return "symbol" == (0, $c6EQE.default)(i) ? i : i + "";
}

});
parcelRegister("c6EQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d05bb29b0f0d448$export$2e2bcd8739ae039; });
function $8d05bb29b0f0d448$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $8d05bb29b0f0d448$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8d05bb29b0f0d448$export$2e2bcd8739ae039(o);
}

});

parcelRegister("137IJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c3c0f675fa9a709$export$2e2bcd8739ae039; });

var $c6EQE = parcelRequire("c6EQE");
function $0c3c0f675fa9a709$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $c6EQE.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $c6EQE.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("7fOn1", function(module, exports) {

$parcel$export(module.exports, "uuid", function () { return $5481019c49d76bf4$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $5481019c49d76bf4$export$1c3aefb711c3a4cc = function generateUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $5481019c49d76bf4$var$staticValue = false;
var $5481019c49d76bf4$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $5481019c49d76bf4$var$staticValue = value;
    },
    generate: function generate() {
        return $5481019c49d76bf4$var$staticValue || $5481019c49d76bf4$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("ki8RA", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", function () { return $ec5c5d2dd0f37a3f$export$3024f02c495408d6; });
$parcel$export(module.exports, "toJSON", function () { return $ec5c5d2dd0f37a3f$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $h2c1T = parcelRequire("h2c1T");

var $iyxgu = parcelRequire("iyxgu");
function $ec5c5d2dd0f37a3f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec5c5d2dd0f37a3f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec5c5d2dd0f37a3f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec5c5d2dd0f37a3f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $ec5c5d2dd0f37a3f$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $iyxgu.isDOMElement)(maybeValue) && maybeValue.getAttribute("data-sources");
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $ec5c5d2dd0f37a3f$export$3024f02c495408d6 = (0, $h2c1T.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $ec5c5d2dd0f37a3f$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "dataConsumer",
                "data-sources": JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $ec5c5d2dd0f37a3f$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === "sources" && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $ec5c5d2dd0f37a3f$var$_objectSpread($ec5c5d2dd0f37a3f$var$_objectSpread({}, acc), {}, (0, $2VHRc.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("h2c1T", function(module, exports) {

$parcel$export(module.exports, "alignment", function () { return $c66bf463d1f98784$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $c66bf463d1f98784$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $c66bf463d1f98784$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $c66bf463d1f98784$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $c66bf463d1f98784$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $c66bf463d1f98784$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $c66bf463d1f98784$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $c66bf463d1f98784$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $c66bf463d1f98784$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $c66bf463d1f98784$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $c66bf463d1f98784$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $c66bf463d1f98784$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $c66bf463d1f98784$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $c66bf463d1f98784$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $c66bf463d1f98784$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $c66bf463d1f98784$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $c66bf463d1f98784$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $c66bf463d1f98784$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $c66bf463d1f98784$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $c66bf463d1f98784$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $fAMXq = parcelRequire("fAMXq");
var $c66bf463d1f98784$export$8e53000a4ec837 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: "alignment indentation",
    group: "alignment"
});
var $c66bf463d1f98784$export$8512c9afa7b24c3b = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ""
        },
        annotationType: {
            default: "inlineComment"
        }
    },
    inclusive: true,
    excludes: "",
    group: "annotation"
});
var $c66bf463d1f98784$export$8c5a050822fd698c = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: "color",
    group: "color"
});
var $c66bf463d1f98784$export$1edee58a52776cd9 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $c66bf463d1f98784$export$89015c65f1c75e3f = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: "wide"
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $c66bf463d1f98784$export$6565f9f03506010b = (0, $fAMXq.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: "fontStyle link searchQuery color"
});
var $c66bf463d1f98784$export$f3b72f8fc4684ecd = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ""
        }
    },
    inclusive: false,
    excludes: ""
});
var $c66bf463d1f98784$export$3024f02c495408d6 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $c66bf463d1f98784$export$c63c6f932822f543 = (0, $fAMXq.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $c66bf463d1f98784$export$f00aeb236b6f05af = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ""
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ""
});
var $c66bf463d1f98784$export$480c699bd4ec0d86 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: "indentation alignment",
    group: "indentation"
});
var $c66bf463d1f98784$export$9c30223ca0a664fb = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: "link",
    group: "link"
});
var $c66bf463d1f98784$export$4899a95d70ec5056 = (0, $fAMXq.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $c66bf463d1f98784$export$59ae2c325a998f89 = (0, $fAMXq.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $c66bf463d1f98784$export$b3401ee80eb31041 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: "sub"
        }
    },
    inclusive: true,
    group: "fontStyle"
});
var $c66bf463d1f98784$export$32f78bffcd82ff28 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: "color"
});
var $c66bf463d1f98784$export$20af3dabbb5538df = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ""
        }
    },
    inclusive: true,
    group: "searchQuery"
});
var $c66bf463d1f98784$export$425327af25286e5e = (0, $fAMXq.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $c66bf463d1f98784$export$30d78d5eb6719bb8 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ""
});
var $c66bf463d1f98784$export$a316dc07ff5182a2 = (0, $fAMXq.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});

parcelRegister("iyxgu", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", function () { return $d82534b73a0f3055$export$c296e2d4365c37a5; });
var $d82534b73a0f3055$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("8G05O", function(module, exports) {

$parcel$export(module.exports, "expandWithNestedExpand", function () { return $6512516a809604c5$export$7b80cba28d10b2c1; });
$parcel$export(module.exports, "toJSON", function () { return $6512516a809604c5$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $6512516a809604c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6512516a809604c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6512516a809604c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6512516a809604c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $6512516a809604c5$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true
    };
}
var $6512516a809604c5$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: "table//",
            tag: 'div[data-node-type="expand"]',
            getAttrs: $6512516a809604c5$var$getExpandAttrs
        },
        {
            context: "expand//",
            tag: '[data-node-type="expand"]',
            getAttrs: $6512516a809604c5$var$getExpandAttrs
        },
        {
            context: "nestedExpand//",
            tag: '[data-node-type="expand"]',
            getAttrs: $6512516a809604c5$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $6512516a809604c5$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "expand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $6512516a809604c5$export$7b80cba28d10b2c1 = (0, $gtPcq.expand)($6512516a809604c5$var$nodeSpecOptions);
var $6512516a809604c5$export$2ae5e7565ff9ffa6 = (0, $gtPcq.expand)({
    parseDOM: [
        {
            context: "table//",
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6512516a809604c5$var$getExpandAttrs(dom);
                return $6512516a809604c5$var$_objectSpread($6512516a809604c5$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        },
        {
            context: "expand//",
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6512516a809604c5$var$getExpandAttrs(dom);
                return $6512516a809604c5$var$_objectSpread($6512516a809604c5$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        },
        {
            context: "nestedExpand//",
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6512516a809604c5$var$getExpandAttrs(dom);
                return $6512516a809604c5$var$_objectSpread($6512516a809604c5$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6512516a809604c5$var$getExpandAttrs(dom);
                return $6512516a809604c5$var$_objectSpread($6512516a809604c5$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-node-type": "expand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $6512516a809604c5$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith("__");
        }).reduce(function(obj, key) {
            return $6512516a809604c5$var$_objectSpread($6512516a809604c5$var$_objectSpread({}, obj), {}, (0, $2VHRc.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("boWpd", function(module, exports) {

$parcel$export(module.exports, "fragment", function () { return $84cf3dc279eb9f0f$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "toJSON", function () { return $84cf3dc279eb9f0f$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $h2c1T = parcelRequire("h2c1T");

var $iyxgu = parcelRequire("iyxgu");
function $84cf3dc279eb9f0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84cf3dc279eb9f0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84cf3dc279eb9f0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84cf3dc279eb9f0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $84cf3dc279eb9f0f$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $iyxgu.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute("data-name")) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute("data-localId");
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $84cf3dc279eb9f0f$export$f00aeb236b6f05af = (0, $h2c1T.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $84cf3dc279eb9f0f$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "fragment",
                "data-name": mark.attrs.name,
                "data-localId": mark.attrs.localId
            }
        ];
    }
});
var $84cf3dc279eb9f0f$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $84cf3dc279eb9f0f$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("1RQCT", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $15c3902939dccc54$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "toJSON", function () { return $15c3902939dccc54$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $h2c1T = parcelRequire("h2c1T");

var $hGBBc = parcelRequire("hGBBc");
function $15c3902939dccc54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15c3902939dccc54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15c3902939dccc54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15c3902939dccc54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $15c3902939dccc54$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || "";
        var attrs = {
            __confluenceMetadata: dom.hasAttribute("__confluenceMetadata") ? JSON.parse(dom.getAttribute("__confluenceMetadata") || "") : undefined
        };
        if (!(0, $hGBBc.isSafeUrl)(href)) return false;
        if ((0, $hGBBc.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $hGBBc.normalizeUrl)(href);
        return attrs;
    };
};
var $15c3902939dccc54$export$9c30223ca0a664fb = (0, $h2c1T.link)({
    parseDOM: [
        {
            tag: "[data-block-link]",
            getAttrs: $15c3902939dccc54$export$b5f67017585d1431("data-block-link"),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute("data-block-link");
                clone.setAttribute("data-skip-paste", "true");
                var wrapper = document.createElement("div");
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: "a[href]",
            getAttrs: $15c3902939dccc54$export$b5f67017585d1431("href")
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === "__confluenceMetadata") {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === "href") attrs[key] = (0, $hGBBc.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            "a",
            attrs
        ];
        return [
            "a",
            $15c3902939dccc54$var$_objectSpread($15c3902939dccc54$var$_objectSpread({}, attrs), {}, (0, $2VHRc.default)((0, $2VHRc.default)({}, "data-block-link", "true"), "class", "blockLink")),
            0
        ];
    }
});
var $15c3902939dccc54$var$OPTIONAL_ATTRS = [
    "title",
    "id",
    "collection",
    "occurrenceKey",
    "__confluenceMetadata"
];
var $15c3902939dccc54$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($15c3902939dccc54$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("hGBBc", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", function () { return $ce03864eadc7c9c6$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "normalizeUrl", function () { return $ce03864eadc7c9c6$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $ce03864eadc7c9c6$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $6OjU6 = parcelRequire("6OjU6");
var $ce03864eadc7c9c6$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $ce03864eadc7c9c6$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $ce03864eadc7c9c6$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $ce03864eadc7c9c6$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($6OjU6)))();
$ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.add("sourcetree:", "http:");
$ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.add("jamfselfservice:", "http:");
var $ce03864eadc7c9c6$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.add("tel:", $ce03864eadc7c9c6$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.add("file:", $ce03864eadc7c9c6$var$urlWithoutSpacesValidator);
$ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.add("notes:", "http:");
var $ce03864eadc7c9c6$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
var $ce03864eadc7c9c6$var$tlds2Char = "a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
$ce03864eadc7c9c6$var$tlds.push($ce03864eadc7c9c6$var$tlds2Char);
$ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.tlds($ce03864eadc7c9c6$var$tlds, false);
var $ce03864eadc7c9c6$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $ce03864eadc7c9c6$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$ce03864eadc7c9c6$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($ce03864eadc7c9c6$export$746d02eae03c72e1) || [
            ""
        ])[0];
        if (link) {
            var index = substr.search($ce03864eadc7c9c6$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ""
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $ce03864eadc7c9c6$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $ce03864eadc7c9c6$export$6f7d7761b97f967(str);
    if (!match.length) match = $ce03864eadc7c9c6$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $ce03864eadc7c9c6$export$6535eb414fa2c8b6(url) {
    var match = $ce03864eadc7c9c6$export$ce9ae45aed3e4ec(url);
    return match && match.url || "";
}
function $ce03864eadc7c9c6$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith("/") || url === "#top" || url === "#";
}

});


parcelRegister("gVZPw", function(module, exports) {

$parcel$export(module.exports, "mediaSingleFull", function () { return $c541ee637d761eb2$export$7e767666f2ce108a; });
$parcel$export(module.exports, "toJSON", function () { return $c541ee637d761eb2$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $KX0n2 = parcelRequire("KX0n2");

var $iyxgu = parcelRequire("iyxgu");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $c541ee637d761eb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c541ee637d761eb2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c541ee637d761eb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c541ee637d761eb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c541ee637d761eb2$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: "center"
    }
};
var $c541ee637d761eb2$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $iyxgu.isDOMElement)(dom)) // this should never happen
        return {
            layout: "center"
        };
        var layout = dom.getAttribute("data-layout") || "center";
        var width = Number(dom.getAttribute("data-width")) || null;
        var widthType = dom.getAttribute("data-width-type");
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $7fOn1.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $KX0n2.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            "data-node-type": "mediaSingle",
            "data-layout": layout,
            "data-width": ""
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs["data-local-id"] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs["data-width"] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $c541ee637d761eb2$var$_objectSpread($c541ee637d761eb2$var$_objectSpread({}, attrs), {}, {
                "data-width-type": widthType || (0, $KX0n2.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $gtPcq.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $gtPcq.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $gtPcq.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $gtPcq.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $c541ee637d761eb2$export$969fe3781ca15058 = $c541ee637d761eb2$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $c541ee637d761eb2$export$d35e6c006d4abdfb = $c541ee637d761eb2$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $c541ee637d761eb2$export$9c58e19811ce4cf5 = $c541ee637d761eb2$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $c541ee637d761eb2$export$7e767666f2ce108a = $c541ee637d761eb2$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $c541ee637d761eb2$export$75376a385837c942 = $c541ee637d761eb2$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $c541ee637d761eb2$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("KX0n2", function(module, exports) {

$parcel$export(module.exports, "WidthType", function () { return $08d21126cfca62a8$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $08d21126cfca62a8$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("dA2jn", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", function () { return $9e306e2e907e4421$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "media", function () { return $9e306e2e907e4421$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "toJSON", function () { return $9e306e2e907e4421$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $52rTH = parcelRequire("52rTH");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $9e306e2e907e4421$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e306e2e907e4421$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e306e2e907e4421$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e306e2e907e4421$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9e306e2e907e4421$export$bb3fe706be61f640 = (0, $gtPcq.media)({}).attrs;
var $9e306e2e907e4421$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? "span" : "div";
    var nodeName = inline ? "mediaInline" : "media";
    var parseDOM = [
        {
            tag: "".concat(domNodeType, '[data-node-type="').concat(nodeName, '"]'),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $9e306e2e907e4421$export$f84fdfb973c05bd8(k).replace(/^__/, "");
                    var value = dom.getAttribute("data-".concat(key)) || "";
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== "undefined" && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== "undefined" && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $7fOn1.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            "data-id": node.attrs.id,
            "data-node-type": "".concat(nodeName),
            "data-type": node.attrs.type,
            "data-collection": node.attrs.collection,
            "data-occurrence-key": node.attrs.occurrenceKey,
            "data-width": node.attrs.width,
            "data-height": node.attrs.height,
            "data-url": node.attrs.url,
            "data-alt": node.attrs.alt,
            "data-local-id": node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: "Attachment",
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $52rTH.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $9e306e2e907e4421$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($9e306e2e907e4421$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $gtPcq.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $gtPcq.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: "img:not(.smart-link-icon)",
                getAttrs: function getAttrs(dom) {
                    var attrs = {
                        type: "external",
                        url: dom.getAttribute("src") || "",
                        alt: dom.getAttribute("alt") || ""
                    };
                    if (generateLocalId) attrs.localId = (0, $7fOn1.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $9e306e2e907e4421$export$987d49ffe1b0900f = $9e306e2e907e4421$export$35bdbf5bc8caa677($9e306e2e907e4421$export$bb3fe706be61f640, false, false);
var $9e306e2e907e4421$export$8446e47a4c7fd000 = $9e306e2e907e4421$export$35bdbf5bc8caa677($9e306e2e907e4421$var$_objectSpread($9e306e2e907e4421$var$_objectSpread({}, $9e306e2e907e4421$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $7fOn1.uuid).generate()
    }
}), false, true);
var $9e306e2e907e4421$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $9e306e2e907e4421$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($9e306e2e907e4421$export$987d49ffe1b0900f.attrs) Object.keys($9e306e2e907e4421$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === "_" && key[1] === "_" && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $9e306e2e907e4421$var$optionalAttributes = [
    "occurrenceKey",
    "width",
    "height",
    "url",
    "alt",
    "localId"
];
var $9e306e2e907e4421$var$externalOnlyAttributes = [
    "type",
    "url",
    "width",
    "height",
    "alt",
    "localId"
];
var $9e306e2e907e4421$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === "_" && key[1] === "_");
        }).reduce(function(obj, key) {
            if (node.attrs.type === "external" && $9e306e2e907e4421$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($9e306e2e907e4421$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === "")) return obj;
            if ([
                "width",
                "height"
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("52rTH", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $3ab2c7783ae57f3c$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $3ab2c7783ae57f3c$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $3ab2c7783ae57f3c$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $3ab2c7783ae57f3c$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $3ab2c7783ae57f3c$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $3ab2c7783ae57f3c$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $3ab2c7783ae57f3c$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $3ab2c7783ae57f3c$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Yellow200", function () { return $3ab2c7783ae57f3c$export$fc857b6f8771648a; });
$parcel$export(module.exports, "Y400", function () { return $3ab2c7783ae57f3c$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $3ab2c7783ae57f3c$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $3ab2c7783ae57f3c$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $3ab2c7783ae57f3c$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $3ab2c7783ae57f3c$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $3ab2c7783ae57f3c$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $3ab2c7783ae57f3c$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $3ab2c7783ae57f3c$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $3ab2c7783ae57f3c$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $3ab2c7783ae57f3c$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $3ab2c7783ae57f3c$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $3ab2c7783ae57f3c$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $3ab2c7783ae57f3c$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $3ab2c7783ae57f3c$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $3ab2c7783ae57f3c$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $3ab2c7783ae57f3c$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $3ab2c7783ae57f3c$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $3ab2c7783ae57f3c$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $3ab2c7783ae57f3c$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $3ab2c7783ae57f3c$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $3ab2c7783ae57f3c$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $3ab2c7783ae57f3c$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $3ab2c7783ae57f3c$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $3ab2c7783ae57f3c$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $3ab2c7783ae57f3c$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $3ab2c7783ae57f3c$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $3ab2c7783ae57f3c$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $3ab2c7783ae57f3c$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $3ab2c7783ae57f3c$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $3ab2c7783ae57f3c$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $3ab2c7783ae57f3c$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $3ab2c7783ae57f3c$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $3ab2c7783ae57f3c$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $3ab2c7783ae57f3c$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $3ab2c7783ae57f3c$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $3ab2c7783ae57f3c$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $3ab2c7783ae57f3c$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $3ab2c7783ae57f3c$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $3ab2c7783ae57f3c$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $3ab2c7783ae57f3c$export$9665a07d9187b414; });

var $gkaEr = parcelRequire("gkaEr");

var $1PZpd = parcelRequire("1PZpd");
var $3ab2c7783ae57f3c$export$4b84fd0e2c617bd = "#FFEBE6";
var $3ab2c7783ae57f3c$export$b34b069eff244586 = "#FFBDAD";
var $3ab2c7783ae57f3c$export$be802dd0d8b57f35 = "#FF8F73";
var $3ab2c7783ae57f3c$export$4a7404f376229999 = "#FF5630";
var $3ab2c7783ae57f3c$export$2010d0fb4295b346 = "#DE350B";
var $3ab2c7783ae57f3c$export$2837b5a1a71d5c02 = "#BF2600";
var $3ab2c7783ae57f3c$export$8d9596b529bbb9cf = "#FFFAE6";
var $3ab2c7783ae57f3c$export$41060a744ab0b7ae = "#FFF0B3";
var $3ab2c7783ae57f3c$export$5aae31392d72caaa = "#FFC400";
var $3ab2c7783ae57f3c$export$fc857b6f8771648a = "#F8E6A0";
var $3ab2c7783ae57f3c$export$59619663aa6500fb = "#FF991F";
var $3ab2c7783ae57f3c$export$874739ea9e379ab6 = "#FF8B00";
var $3ab2c7783ae57f3c$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $3ab2c7783ae57f3c$export$69a3bf21b9686c2b = "#ABF5D1";
var $3ab2c7783ae57f3c$export$747d86715d4175de = "#57D9A3";
var $3ab2c7783ae57f3c$export$940e1f69e873f202 = "#36B37E";
var $3ab2c7783ae57f3c$export$a49394138f7b8e85 = "#00875A";
var $3ab2c7783ae57f3c$export$6fa04827ac68a4fb = "#006644";
var $3ab2c7783ae57f3c$export$226de0355ed012f8 = "#DEEBFF";
var $3ab2c7783ae57f3c$export$8c13c2ee36917869 = "#B3D4FF";
var $3ab2c7783ae57f3c$export$ecfc1dff386a3e7a = "#4C9AFF";
var $3ab2c7783ae57f3c$export$b3de0ae08da2ce64 = "#0052CC";
var $3ab2c7783ae57f3c$export$a6ee3d71bc067634 = "#0747A6";
var $3ab2c7783ae57f3c$export$f72948ef771f6f15 = "#D3F1A7";
var $3ab2c7783ae57f3c$export$29a4f05edc054374 = "#FFFFFF";
var $3ab2c7783ae57f3c$export$9fdfb749e33cdf97 = "#F4F5F7";
var $3ab2c7783ae57f3c$export$3e51e8f1440314ba = "#EBECF0";
var $3ab2c7783ae57f3c$export$1ce2d1575d444ceb = "#DFE1E6";
var $3ab2c7783ae57f3c$export$8754fc7e6d8b3000 = "#C1C7D0";
var $3ab2c7783ae57f3c$export$c2e91cbeada39b8b = "#B3BAC5";
var $3ab2c7783ae57f3c$export$eaa8c8a70ac22806 = "#97A0AF";
var $3ab2c7783ae57f3c$export$7c87d337fb91a97d = "#8993A4";
var $3ab2c7783ae57f3c$export$f563ee71e9ee74cd = "#6B778C";
var $3ab2c7783ae57f3c$export$e2ef2124cf4024b1 = "#5E6C84";
var $3ab2c7783ae57f3c$export$1ae1cebe22dcedb4 = "#DCDFE4";
var $3ab2c7783ae57f3c$export$13609db0e6812ab8 = "#091E4224";
var $3ab2c7783ae57f3c$export$c39c0fe0f26207ae = "#42526E";
var $3ab2c7783ae57f3c$export$7090862dc3038a9f = "#758195";
var $3ab2c7783ae57f3c$export$7d61b15e0da132af = "#172B4D";
var $3ab2c7783ae57f3c$export$f78789c8b01753cd = "#172B4D";
var $3ab2c7783ae57f3c$export$a19f0c33186f7767 = "#FDD0EC";
var $3ab2c7783ae57f3c$export$51716a84e62e022c = "#FEDEC8";
var $3ab2c7783ae57f3c$export$363e4475840015bb = "#EAE6FF";
var $3ab2c7783ae57f3c$export$4b0a4417ed59760f = "#C0B6F2";
var $3ab2c7783ae57f3c$export$6011520a64d9a187 = "#998DD9";
var $3ab2c7783ae57f3c$export$a7175d4e9206bc80 = "#DFD8FD";
var $3ab2c7783ae57f3c$export$b48405b95304b5a1 = "#6554C0";
var $3ab2c7783ae57f3c$export$c71e4279dd54a18d = "#5243AA";
var $3ab2c7783ae57f3c$export$147899de772240ec = "#403294";
var $3ab2c7783ae57f3c$export$2cf711fe14c66f06 = "#E6FCFF";
var $3ab2c7783ae57f3c$export$7a8f4d33f6f9772c = "#B3F5FF";
var $3ab2c7783ae57f3c$export$776c9c497ef08533 = "#79E2F2";
var $3ab2c7783ae57f3c$export$69cb3ca10c1e330e = "#C6EDFB";
var $3ab2c7783ae57f3c$export$9dc1ef0f3f48059b = "#00B8D9";
var $3ab2c7783ae57f3c$export$6036577f95c3877e = "#008DA6";
function $3ab2c7783ae57f3c$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($3ab2c7783ae57f3c$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split("").map(function(c) {
            return c === "#" ? "#" : "".concat(c).concat(c);
        }).join("");
    } else if ($3ab2c7783ae57f3c$export$e698776ec826343(color)) return $3ab2c7783ae57f3c$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === "default") return null;
        else if ($1PZpd.default && $1PZpd.default[color]) color = $1PZpd.default[color];
        else if ($1PZpd && $1PZpd[color]) color = $1PZpd[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $3ab2c7783ae57f3c$export$5a544e13ad4e1fa5(color) {
    if (!$3ab2c7783ae57f3c$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split("");
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join("")));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $3ab2c7783ae57f3c$export$9665a07d9187b414(rawColor, alpha) {
    var color = $3ab2c7783ae57f3c$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(","), ")");
}
function $3ab2c7783ae57f3c$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $gkaEr.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return "#" + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $3ab2c7783ae57f3c$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $3ab2c7783ae57f3c$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("gkaEr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0311243cd3f351e0$export$2e2bcd8739ae039; });

var $aW2va = parcelRequire("aW2va");

var $8wqtS = parcelRequire("8wqtS");

var $8DGYW = parcelRequire("8DGYW");

var $eSDxu = parcelRequire("eSDxu");
function $0311243cd3f351e0$export$2e2bcd8739ae039(r, e) {
    return (0, $aW2va.default)(r) || (0, $8wqtS.default)(r, e) || (0, $8DGYW.default)(r, e) || (0, $eSDxu.default)();
}

});
parcelRegister("aW2va", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7f6142ed32c3e71c$export$2e2bcd8739ae039; });
function $7f6142ed32c3e71c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("8wqtS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6345da731660b2b8$export$2e2bcd8739ae039; });
function $6345da731660b2b8$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("8DGYW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64a34e9038b7e4c6$export$2e2bcd8739ae039; });

var $a2saW = parcelRequire("a2saW");
function $64a34e9038b7e4c6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $a2saW.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $a2saW.default)(r, a) : void 0;
    }
}

});
parcelRegister("a2saW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74eff256fe59b6fb$export$2e2bcd8739ae039; });
function $74eff256fe59b6fb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("eSDxu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad54c77635259e91$export$2e2bcd8739ae039; });
function $ad54c77635259e91$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("8stLs", function(module, exports) {

$parcel$export(module.exports, "mention", function () { return $628806d5eecac71e$export$db83999c14438df4; });
$parcel$export(module.exports, "toJSON", function () { return $628806d5eecac71e$export$54fd2c36b5cc6731; });

var $2VHRc = parcelRequire("2VHRc");

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
function $628806d5eecac71e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $628806d5eecac71e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $628806d5eecac71e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $628806d5eecac71e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $628806d5eecac71e$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $628806d5eecac71e$export$db83999c14438df4 = (0, $gtPcq.mention)({
    parseDOM: [
        {
            tag: "span[data-mention-id]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-mention-id") || $628806d5eecac71e$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $628806d5eecac71e$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute("data-access-level") || $628806d5eecac71e$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $7fOn1.uuid).generate()
                };
                var userType = dom.getAttribute("data-user-type");
                if ($628806d5eecac71e$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            "data-mention-id": id,
            "data-access-level": accessLevel,
            contenteditable: "false"
        };
        if (localId) attrs["data-local-id"] = localId;
        if (userType) attrs["data-user-type"] = userType;
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $628806d5eecac71e$var$isOptional = function isOptional(key) {
    return [
        "userType",
        "localId"
    ].indexOf(key) > -1;
};
var $628806d5eecac71e$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($628806d5eecac71e$var$isOptional(key) && !node.attrs[key]) return obj;
            return $628806d5eecac71e$var$_objectSpread($628806d5eecac71e$var$_objectSpread({}, obj), {}, (0, $2VHRc.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("bqzKK", function(module, exports) {

$parcel$export(module.exports, "table", function () { return $851ddb35ba96c044$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableToJSON", function () { return $851ddb35ba96c044$export$1f92a2f429e06fa8; });
$parcel$export(module.exports, "tableRow", function () { return $851ddb35ba96c044$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $851ddb35ba96c044$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "toJSONTableCell", function () { return $851ddb35ba96c044$export$2ac34c099660f1a8; });
$parcel$export(module.exports, "tableHeader", function () { return $851ddb35ba96c044$export$48884d2a5190dc73; });
$parcel$export(module.exports, "toJSONTableHeader", function () { return $851ddb35ba96c044$export$2af48797a1010bb1; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $851ddb35ba96c044$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $851ddb35ba96c044$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $851ddb35ba96c044$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $851ddb35ba96c044$export$2a5a518232fa1a97; });

var $gkaEr = parcelRequire("gkaEr");

var $2VHRc = parcelRequire("2VHRc");

var $aYDRF = parcelRequire("aYDRF");

var $52rTH = parcelRequire("52rTH");

var $7fOn1 = parcelRequire("7fOn1");

var $23OHV = parcelRequire("23OHV");

var $gtPcq = parcelRequire("gtPcq");
function $851ddb35ba96c044$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $851ddb35ba96c044$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $851ddb35ba96c044$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $851ddb35ba96c044$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $851ddb35ba96c044$export$9cfceb893b24742a = "pm-table";
var $851ddb35ba96c044$export$69cb4c3f80383763 = "".concat($851ddb35ba96c044$export$9cfceb893b24742a, "-cell-content-wrap");
var $851ddb35ba96c044$export$7b07d37d879c957f = "".concat($851ddb35ba96c044$export$9cfceb893b24742a, "-header-content-wrap");
var $851ddb35ba96c044$export$8dd42a84cd52da07 = "".concat($851ddb35ba96c044$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $851ddb35ba96c044$export$5e26a5c19f0865d8 = "".concat($851ddb35ba96c044$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $851ddb35ba96c044$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $52rTH.N20).toLocaleLowerCase();
var $851ddb35ba96c044$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute("data-colwidth");
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute("colspan") || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute("data-cell-background");
    var dataCellBackgroundHexCode = dataCellBackground && (0, $52rTH.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes("--ds-background-neutral")) backgroundColor = "";
    else if (backgroundColor && (0, $52rTH.isRgb)(backgroundColor)) {
        var result = (0, $52rTH.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues["background"] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $851ddb35ba96c044$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute("rowspan") || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $851ddb35ba96c044$var$testGlobalTheme;
var $851ddb35ba96c044$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $851ddb35ba96c044$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $851ddb35ba96c044$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($851ddb35ba96c044$var$testGlobalTheme) return {
        colorMode: $851ddb35ba96c044$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $851ddb35ba96c044$var$cssVariablePattern = /^var\(--.*\)$/;
var $851ddb35ba96c044$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs["data-colwidth"] = node.attrs.colwidth.join(",");
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === "tableHeader" && background === $851ddb35ba96c044$export$8cc2833b5b349a1e.get("light gray") || nodeType === "tableCell" && background === $851ddb35ba96c044$export$8cc2833b5b349a1e.get("white") || nodeType === "tableHeader" && background.includes("--ds-background-neutral");
        if (ignored) attrs.style = "";
        else {
            var color = (0, $52rTH.isRgb)(background) && (0, $52rTH.rgbToHex)(background) ? (0, $52rTH.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $aYDRF.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $851ddb35ba96c044$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($851ddb35ba96c044$var$getGlobalTheme().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $23OHV.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs["data-cell-background"] = color;
            if (typeof color === "string") attrs.colorname = $851ddb35ba96c044$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === "tableHeader") attrs.class = $851ddb35ba96c044$export$7b07d37d879c957f;
    else attrs.class = $851ddb35ba96c044$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs["data-local-id"] = node.attrs.localId;
    return attrs;
};
var $851ddb35ba96c044$export$219b7f492ad209f8 = new Map();
var $851ddb35ba96c044$export$95e9c925fbf01d1c = (0, $52rTH.hexToRgba)((0, $52rTH.N800), 0.12) || (0, $52rTH.N0);
var $851ddb35ba96c044$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $52rTH.N0),
        "White"
    ],
    [
        (0, $52rTH.B50),
        "Light blue"
    ],
    [
        (0, $52rTH.T50),
        "Light teal"
    ],
    [
        (0, $52rTH.G50),
        "Light green"
    ],
    [
        (0, $52rTH.Y50),
        "Light yellow"
    ],
    [
        (0, $52rTH.R50),
        "Light red"
    ],
    [
        (0, $52rTH.P50),
        "Light purple"
    ],
    [
        (0, $52rTH.N20),
        "Light gray"
    ],
    [
        (0, $52rTH.B75),
        "Blue"
    ],
    [
        (0, $52rTH.T75),
        "Teal"
    ],
    [
        (0, $52rTH.G75),
        "Green"
    ],
    [
        (0, $52rTH.Y75),
        "Yellow"
    ],
    [
        (0, $52rTH.R75),
        "Red"
    ],
    [
        (0, $52rTH.P75),
        "Purple"
    ],
    [
        (0, $52rTH.N60),
        "Gray"
    ],
    [
        (0, $52rTH.B100),
        "Dark blue"
    ],
    [
        (0, $52rTH.T100),
        "Dark teal"
    ],
    [
        (0, $52rTH.G200),
        "Dark green"
    ],
    [
        (0, $52rTH.Y200),
        "Dark yellow"
    ],
    [
        (0, $52rTH.R100),
        "Dark red"
    ],
    [
        (0, $52rTH.P100),
        "Dark purple"
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $gkaEr.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $851ddb35ba96c044$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $851ddb35ba96c044$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $851ddb35ba96c044$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: "table",
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute("data-number-column") === "true",
                    layout: // copying from editor
                    dom.getAttribute("data-layout") || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute("data-layout")) || "default",
                    __autoSize: dom.getAttribute("data-autosize") === "true",
                    localId: dom.getAttribute("data-table-local-id") || (0, $7fOn1.uuid).generate(),
                    width: Number(dom.getAttribute("data-table-width")) || null,
                    displayMode: dom.getAttribute("data-table-display-mode") || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-number-column": node.attrs.isNumberColumnEnabled,
            "data-layout": node.attrs.layout,
            "data-autosize": node.attrs.__autoSize,
            "data-table-local-id": node.attrs.localId,
            "data-table-width": node.attrs.width,
            "data-table-display-mode": node.attrs.displayMode
        };
        return [
            "table",
            attrs,
            [
                "tbody",
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $851ddb35ba96c044$var$createTableSpec = function createTableSpec() {
    return (0, $gtPcq.table)($851ddb35ba96c044$var$tableNodeSpecOptions);
};
var $851ddb35ba96c044$export$9852986a3ec5f6a0 = $851ddb35ba96c044$var$createTableSpec();
var $851ddb35ba96c044$export$90e634fbace1f0c4 = $851ddb35ba96c044$var$createTableSpec();
var $851ddb35ba96c044$export$3862de5c8c9098cf = $851ddb35ba96c044$var$createTableSpec();
var $851ddb35ba96c044$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith("__") && (key !== "localId" || !!value);
};
var $851ddb35ba96c044$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $851ddb35ba96c044$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $851ddb35ba96c044$var$_objectSpread($851ddb35ba96c044$var$_objectSpread({}, obj), {}, (0, $2VHRc.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $851ddb35ba96c044$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: "tr"
        }
    ],
    toDOM: function toDOM() {
        return [
            "tr",
            0
        ];
    }
};
var $851ddb35ba96c044$export$ce666bf02318c957 = (0, $gtPcq.tableRow)($851ddb35ba96c044$var$tableRowNodeSpecOptions);
var $851ddb35ba96c044$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $851ddb35ba96c044$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: ".ak-renderer-table-number-column",
            ignore: true
        },
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return $851ddb35ba96c044$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            $851ddb35ba96c044$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $851ddb35ba96c044$export$e1e720e5f4603e6a = (0, $gtPcq.tableCell)($851ddb35ba96c044$var$tableCellNodeSpecOptions);
var $851ddb35ba96c044$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($851ddb35ba96c044$var$cellAttrs[key] && $851ddb35ba96c044$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $851ddb35ba96c044$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return $851ddb35ba96c044$export$43977bde391e007(dom, {
                    background: $851ddb35ba96c044$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            $851ddb35ba96c044$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $851ddb35ba96c044$export$48884d2a5190dc73 = (0, $gtPcq.tableHeader)($851ddb35ba96c044$var$tableHeaderNodeSpecOptions);
var $851ddb35ba96c044$export$2af48797a1010bb1 = $851ddb35ba96c044$export$2ac34c099660f1a8;
var $851ddb35ba96c044$export$ce086a560a1d05f5 = (0, $gtPcq.tableWithNestedTable)($851ddb35ba96c044$var$tableNodeSpecOptions);
var $851ddb35ba96c044$export$7d657479499397 = (0, $gtPcq.tableRowWithNestedTable)($851ddb35ba96c044$var$tableRowNodeSpecOptions);
var $851ddb35ba96c044$export$abf39ca178940ff3 = (0, $gtPcq.tableCellWithNestedTable)($851ddb35ba96c044$var$tableCellNodeSpecOptions);
var $851ddb35ba96c044$export$2a5a518232fa1a97 = (0, $gtPcq.tableHeaderWithNestedTable)($851ddb35ba96c044$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $851ddb35ba96c044$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "tr",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            "tr",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $851ddb35ba96c044$export$c8f0853ac97552c9 = (0, $gtPcq.tableRow)($851ddb35ba96c044$var$tableRowNodeSpecOptionsWithLocalId);
var $851ddb35ba96c044$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return $851ddb35ba96c044$export$43977bde391e007(dom, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            $851ddb35ba96c044$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $851ddb35ba96c044$export$db76cfd28a574029 = (0, $gtPcq.tableCell)($851ddb35ba96c044$var$tableCellNodeSpecOptionsWithLocalId);
var $851ddb35ba96c044$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return $851ddb35ba96c044$export$43977bde391e007(dom, {
                    background: $851ddb35ba96c044$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            $851ddb35ba96c044$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $851ddb35ba96c044$export$b82d2b1d8824143d = (0, $gtPcq.tableHeader)($851ddb35ba96c044$var$tableHeaderNodeSpecOptionsWithLocalId);
var $851ddb35ba96c044$export$27926e30c8a74147 = (0, $gtPcq.tableRowWithNestedTable)($851ddb35ba96c044$var$tableRowNodeSpecOptionsWithLocalId);
var $851ddb35ba96c044$export$e9fd700fafee293a = (0, $gtPcq.tableCellWithNestedTable)($851ddb35ba96c044$var$tableCellNodeSpecOptionsWithLocalId);
var $851ddb35ba96c044$export$7928c3aeb4cd2213 = (0, $gtPcq.tableHeaderWithNestedTable)($851ddb35ba96c044$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("aYDRF", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $7fde6e43f23f5f5d$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $7fde6e43f23f5f5d$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $7fde6e43f23f5f5d$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $7fde6e43f23f5f5d$export$a270511a0e7fd61a; });

var $6TSjL = parcelRequire("6TSjL");
function $7fde6e43f23f5f5d$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $7fde6e43f23f5f5d$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $7fde6e43f23f5f5d$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ "#091E4224": "var(--ds-border, #091E4224)",
    /** gray */ "#758195": "var(--ds-border-bold, #758195)",
    /** gray - bold */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $7fde6e43f23f5f5d$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $7fde6e43f23f5f5d$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $7fde6e43f23f5f5d$export$57fa5089caad992 = {
    /** blue - light */ "#B3D4FF": "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    /** blue - medium */ "#4C9AFF": "var(--ds-icon-accent-blue, #4C9AFF)",
    /** blue - strong */ "#0747A6": "var(--ds-text-accent-blue, #0747A6)",
    /** teal - light */ "#B3F5FF": "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    /** teal - medium */ "#00B8D9": "var(--ds-icon-accent-teal, #00B8D9)",
    /** teal - strong */ "#008DA6": "var(--ds-text-accent-teal, #008DA6)",
    /** green - light */ "#ABF5D1": "var(--ds-background-accent-green-subtler, #ABF5D1)",
    /** green - medium */ "#36B37E": "var(--ds-icon-accent-green, #36B37E)",
    /** green - strong */ "#006644": "var(--ds-text-accent-green, #006644)",
    /** yellowOrange - light */ "#FFF0B3": "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    /** yellowOrange - medium */ "#FFC400": "var(--ds-background-accent-orange-subtle, #FFC400)",
    /** yellowOrange - strong */ "#FF991F": "var(--ds-icon-accent-orange, #FF991F)",
    /** red - light */ "#FFBDAD": "var(--ds-background-accent-red-subtler, #FFBDAD)",
    /** red - medium */ "#FF5630": "var(--ds-icon-accent-red, #FF5630)",
    /** red - strong */ "#BF2600": "var(--ds-text-accent-red, #BF2600)",
    /** purple - light */ "#EAE6FF": "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    /** purple - medium */ "#6554C0": "var(--ds-icon-accent-purple, #6554C0)",
    /** purple - strong */ "#403294": "var(--ds-text-accent-purple, #403294)",
    /** whiteGray - light */ "#FFFFFF": "var(--ds-text-inverse, #FFFFFF)",
    /** whiteGray - medium */ "#97A0AF": "var(--ds-icon-accent-gray, #97A0AF)",
    /** whiteGray - strong */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $7fde6e43f23f5f5d$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $6TSjL.default).getExperimentValue("platform_editor_add_orange_highlight_color", "cohort", "control") !== "test") $7fde6e43f23f5f5d$export$12a518ff137dd389["#FEDEC8"] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $7fde6e43f23f5f5d$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $7fde6e43f23f5f5d$export$12a518ff137dd389 = {
    /** Gray - light */ "#DCDFE4": "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ "#C6EDFB": "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ "#D3F1A7": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ "#F8E6A0": "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    /** Orange - light */ "#FEDEC8": "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ "#FDD0EC": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ "#DFD8FD": "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $7fde6e43f23f5f5d$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $7fde6e43f23f5f5d$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $7fde6e43f23f5f5d$export$2462741d70e6a62f = {
    /** blue - light */ "#DEEBFF": {
        getValue: function getValue() {
            return "#DEEBFF";
        },
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    /** blue - medium */ "#B3D4FF": {
        getValue: function getValue() {
            return "#B3D4FF";
        },
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    /** blue - strong */ "#4C9AFF": {
        getValue: function getValue() {
            return "#4C9AFF";
        },
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    /** teal - light */ "#E6FCFF": {
        getValue: function getValue() {
            return "#E6FCFF";
        },
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
    },
    /** teal - medium */ "#B3F5FF": {
        getValue: function getValue() {
            return "#B3F5FF";
        },
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
    },
    /** teal - strong */ "#79E2F2": {
        getValue: function getValue() {
            return "#79E2F2";
        },
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
    },
    /** green - light */ "#E3FCEF": {
        getValue: function getValue() {
            return "#E3FCEF";
        },
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
    },
    /** green - medium */ "#ABF5D1": {
        getValue: function getValue() {
            return "#ABF5D1";
        },
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
    },
    /** green - strong */ "#57D9A3": {
        getValue: function getValue() {
            return "#57D9A3";
        },
        token: "var(--ds-background-accent-green-subtle, #57D9A3)"
    },
    /** yellowOrange - light */ "#FFFAE6": {
        getValue: function getValue() {
            return "#FFFAE6";
        },
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
    },
    /** yellowOrange - medium */ "#FFF0B3": {
        getValue: function getValue() {
            return "#FFF0B3";
        },
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
    },
    /** yellowOrange - strong */ "#FFC400": {
        getValue: function getValue() {
            return "#FFC400";
        },
        token: "var(--ds-background-accent-orange-subtle, #FFC400)"
    },
    /** red - light */ "#FFEBE6": {
        getValue: function getValue() {
            return "#FFEBE6";
        },
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
    },
    /** red - medium */ "#FFBDAD": {
        getValue: function getValue() {
            return "#FFBDAD";
        },
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
    },
    /** red - strong */ "#FF8F73": {
        getValue: function getValue() {
            return "#FF8F73";
        },
        token: "var(--ds-background-accent-red-subtle, #FF8F73)"
    },
    /** purple - light */ "#EAE6FF": {
        getValue: function getValue() {
            return "#EAE6FF";
        },
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
    },
    /** purple - medium */ "#C0B6F2": {
        getValue: function getValue() {
            return "#C0B6F2";
        },
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
    },
    /** purple - strong */ "#998DD9": {
        getValue: function getValue() {
            return "#998DD9";
        },
        token: "var(--ds-background-accent-purple-subtle, #998DD9)"
    },
    /** whiteGray - light */ "#FFFFFF": {
        getValue: function getValue() {
            return "#FFFFFF";
        },
        token: "var(--ds-surface, #FFFFFF)"
    },
    /** whiteGray - medium */ "#F4F5F7": {
        getValue: function getValue() {
            return "#F4F5F7";
        },
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
    },
    /** whiteGray - strong */ "#B3BAC5": {
        getValue: function getValue() {
            return "#B3BAC5";
        },
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
    }
};

});
parcelRegister("6TSjL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5062037c41e43103$export$2e2bcd8739ae039; });

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $6THua = parcelRequire("6THua");

var $3ChEx = parcelRequire("3ChEx");

var $6Mjpu = parcelRequire("6Mjpu");



var $5062037c41e43103$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $5062037c41e43103$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $cnuD2.default)(this, FeatureGates);
    }
    return (0, $ecJAY.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$5062037c41e43103$var$_FeatureGates = $5062037c41e43103$var$FeatureGates;
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "client", new (0, $3ChEx.Client)());
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$5062037c41e43103$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $5062037c41e43103$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $5062037c41e43103$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$5062037c41e43103$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $5062037c41e43103$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $5062037c41e43103$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "initializeCalled", $5062037c41e43103$var$_FeatureGates.client.initializeCalled.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "initializeCompleted", $5062037c41e43103$var$_FeatureGates.client.initializeCompleted.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "initialize", $5062037c41e43103$var$_FeatureGates.client.initialize.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "initializeWithProvider", $5062037c41e43103$var$_FeatureGates.client.initializeWithProvider.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "initializeFromValues", $5062037c41e43103$var$_FeatureGates.client.initializeFromValues.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "manuallyLogGateExposure", $5062037c41e43103$var$_FeatureGates.client.manuallyLogGateExposure.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "getExperiment", $5062037c41e43103$var$_FeatureGates.client.getExperiment.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "manuallyLogExperimentExposure", $5062037c41e43103$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "manuallyLogLayerExposure", $5062037c41e43103$var$_FeatureGates.client.manuallyLogLayerExposure.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "shutdownStatsig", $5062037c41e43103$var$_FeatureGates.client.shutdownStatsig.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "overrideGate", $5062037c41e43103$var$_FeatureGates.client.overrideGate.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "clearGateOverride", $5062037c41e43103$var$_FeatureGates.client.clearGateOverride.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "overrideConfig", $5062037c41e43103$var$_FeatureGates.client.overrideConfig.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "clearConfigOverride", $5062037c41e43103$var$_FeatureGates.client.clearConfigOverride.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "setOverrides", $5062037c41e43103$var$_FeatureGates.client.setOverrides.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "getOverrides", $5062037c41e43103$var$_FeatureGates.client.getOverrides.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "clearAllOverrides", $5062037c41e43103$var$_FeatureGates.client.clearAllOverrides.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "isCurrentUser", $5062037c41e43103$var$_FeatureGates.client.isCurrentUser.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "onGateUpdated", $5062037c41e43103$var$_FeatureGates.client.onGateUpdated.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "onExperimentValueUpdated", $5062037c41e43103$var$_FeatureGates.client.onExperimentValueUpdated.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "onAnyUpdated", $5062037c41e43103$var$_FeatureGates.client.onAnyUpdated.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "updateUser", $5062037c41e43103$var$_FeatureGates.client.updateUser.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "updateUserWithProvider", $5062037c41e43103$var$_FeatureGates.client.updateUserWithProvider.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "updateUserWithValues", $5062037c41e43103$var$_FeatureGates.client.updateUserWithValues.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "getPackageVersion", $5062037c41e43103$var$_FeatureGates.client.getPackageVersion.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "getLayer", $5062037c41e43103$var$_FeatureGates.client.getLayer.bind($5062037c41e43103$var$_FeatureGates.client));
(0, $6THua.default)($5062037c41e43103$var$FeatureGates, "getLayerValue", $5062037c41e43103$var$_FeatureGates.client.getLayerValue.bind($5062037c41e43103$var$_FeatureGates.client));
var $5062037c41e43103$var$boundFGJS = $5062037c41e43103$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $5062037c41e43103$var$FeatureGates;
    else {
        var $5062037c41e43103$var$_boundFGJS, $5062037c41e43103$var$_boundFGJS$getPackage;
        $5062037c41e43103$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $5062037c41e43103$var$boundVersion = (($5062037c41e43103$var$_boundFGJS = $5062037c41e43103$var$boundFGJS) === null || $5062037c41e43103$var$_boundFGJS === void 0 || ($5062037c41e43103$var$_boundFGJS$getPackage = $5062037c41e43103$var$_boundFGJS.getPackageVersion) === null || $5062037c41e43103$var$_boundFGJS$getPackage === void 0 ? void 0 : $5062037c41e43103$var$_boundFGJS$getPackage.call($5062037c41e43103$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($5062037c41e43103$var$boundVersion !== (0, $6Mjpu.CLIENT_VERSION)) {
            var $5062037c41e43103$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($5062037c41e43103$var$boundVersion, " when module version ").concat((0, $6Mjpu.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($5062037c41e43103$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $5062037c41e43103$export$2e2bcd8739ae039 = $5062037c41e43103$var$boundFGJS;

});
parcelRegister("3ChEx", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $2a229d30ad1b6b4d$export$1f2bb630327ac4b6; });

var $jR3qz = parcelRequire("jR3qz");

var $6wazT = parcelRequire("6wazT");

var $diwCl = parcelRequire("diwCl");

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $6THua = parcelRequire("6THua");

var $7qFNr = parcelRequire("7qFNr");

var $hRKKo = parcelRequire("hRKKo");

var $2HmGJ = parcelRequire("2HmGJ");

var $3ZihN = parcelRequire("3ZihN");

var $aMzdQ = parcelRequire("aMzdQ");

var $fJyoP = parcelRequire("fJyoP");

var $iyAcz = parcelRequire("iyAcz");

var $ekea1 = parcelRequire("ekea1");

var $hHdS0 = parcelRequire("hHdS0");

var $dsUzg = parcelRequire("dsUzg");

var $8uCTq = parcelRequire("8uCTq");

var $6Mjpu = parcelRequire("6Mjpu");
var $2a229d30ad1b6b4d$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $2a229d30ad1b6b4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a229d30ad1b6b4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a229d30ad1b6b4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a229d30ad1b6b4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2a229d30ad1b6b4d$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $2a229d30ad1b6b4d$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $2a229d30ad1b6b4d$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $hHdS0.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, $cnuD2.default)(this, Client);
        (0, $6THua.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $6THua.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $6THua.default)(this, "initWithDefaults", false);
        (0, $6THua.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $6THua.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $6THua.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $6THua.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $6THua.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $6THua.default)(this, "subscriptions", new (0, $2HmGJ.default)());
        (0, $6THua.default)(this, "dataAdapter", new (0, $ekea1.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $6THua.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $hHdS0.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $ecJAY.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8uCTq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $8uCTq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $8uCTq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $8uCTq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $6Mjpu.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $2a229d30ad1b6b4d$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $6Mjpu.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $dsUzg.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $8uCTq.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $8uCTq.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $8uCTq.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $iyAcz.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $3ZihN.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $3ZihN.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $fJyoP.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $8uCTq.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $8uCTq.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $2a229d30ad1b6b4d$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $iyAcz.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $iyAcz.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $6wazT.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $2a229d30ad1b6b4d$var$_objectSpread($2a229d30ad1b6b4d$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $6wazT.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $8uCTq.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $2a229d30ad1b6b4d$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $2a229d30ad1b6b4d$var$_objectSpread($2a229d30ad1b6b4d$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $2a229d30ad1b6b4d$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $dsUzg.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $jR3qz.default)(newClientOptions, $2a229d30ad1b6b4d$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $8uCTq.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $2a229d30ad1b6b4d$var$_objectSpread($2a229d30ad1b6b4d$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $hRKKo.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $hRKKo.StatsigClient)($2a229d30ad1b6b4d$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $8uCTq.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $6Mjpu.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $aMzdQ.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $aMzdQ.Layer).fromLayer((0, $hRKKo._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("6wazT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bedefc60a8b62a9$export$2e2bcd8739ae039; });

var $YOg6S = parcelRequire("YOg6S");

var $lCEKo = parcelRequire("lCEKo");

var $03lTJ = parcelRequire("03lTJ");

var $kEtcZ = parcelRequire("kEtcZ");
function $4bedefc60a8b62a9$export$2e2bcd8739ae039(r, e) {
    return (0, $YOg6S.default)(r) || (0, $lCEKo.default)(r, e) || (0, $03lTJ.default)(r, e) || (0, $kEtcZ.default)();
}

});
parcelRegister("YOg6S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b6c9711d375b856$export$2e2bcd8739ae039; });
function $0b6c9711d375b856$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("lCEKo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbdcc11ec5875865$export$2e2bcd8739ae039; });
function $fbdcc11ec5875865$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("03lTJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00a14466e96ec673$export$2e2bcd8739ae039; });

var $3J00N = parcelRequire("3J00N");
function $00a14466e96ec673$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $3J00N.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $3J00N.default)(r, a) : void 0;
    }
}

});
parcelRegister("3J00N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b6595710856fc7f$export$2e2bcd8739ae039; });
function $2b6595710856fc7f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("kEtcZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f08e334435ce1d3c$export$2e2bcd8739ae039; });
function $f08e334435ce1d3c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("diwCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ae641f4e111fe13$export$2e2bcd8739ae039; });
function $9ae641f4e111fe13$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $9ae641f4e111fe13$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $9ae641f4e111fe13$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $9ae641f4e111fe13$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("7qFNr", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $568b620017de84f8$var$runtime = (parcelRequire("f9U1O"))();
module.exports = $568b620017de84f8$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $568b620017de84f8$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $568b620017de84f8$var$runtime;
    else Function("r", "regeneratorRuntime = r")($568b620017de84f8$var$runtime);
}

});
parcelRegister("f9U1O", function(module, exports) {

var $hAAp4 = parcelRequire("hAAp4");

var $4L6tU = parcelRequire("4L6tU");

var $5xdHx = parcelRequire("5xdHx");

var $jkrMB = parcelRequire("jkrMB");

var $1xvPT = parcelRequire("1xvPT");

var $a8nNF = parcelRequire("a8nNF");

var $5xmht = parcelRequire("5xmht");
function $b09328511a0d6424$var$_regeneratorRuntime() {
    "use strict";
    var r = $4L6tU(), e = r.m($b09328511a0d6424$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $5xmht(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $b09328511a0d6424$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $hAAp4(r, e);
            },
            AsyncIterator: $1xvPT,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $jkrMB : $5xdHx)(a(r), e, t, o, u);
            },
            keys: $a8nNF,
            values: $5xmht
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $b09328511a0d6424$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hAAp4", function(module, exports) {
function $cce209662ce3b5b6$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $cce209662ce3b5b6$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4L6tU", function(module, exports) {

var $9Ujw7 = parcelRequire("9Ujw7");
function $3770944749426695$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $9Ujw7(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($9Ujw7(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $9Ujw7(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $9Ujw7(u, "constructor", GeneratorFunctionPrototype), $9Ujw7(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $9Ujw7(GeneratorFunctionPrototype, o, "GeneratorFunction"), $9Ujw7(u), $9Ujw7(u, o, "Generator"), $9Ujw7(u, n, function() {
        return this;
    }), $9Ujw7(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $3770944749426695$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $3770944749426695$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9Ujw7", function(module, exports) {
function $73687bb0bb34e936$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $73687bb0bb34e936$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $73687bb0bb34e936$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $73687bb0bb34e936$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $73687bb0bb34e936$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("5xdHx", function(module, exports) {

var $jkrMB = parcelRequire("jkrMB");
function $407aa99d6e652dea$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $jkrMB(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $407aa99d6e652dea$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("jkrMB", function(module, exports) {

var $4L6tU = parcelRequire("4L6tU");

var $1xvPT = parcelRequire("1xvPT");
function $e1256fb5cdd50024$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $1xvPT($4L6tU().w(r, e, t, o), n || Promise);
}
module.exports = $e1256fb5cdd50024$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("1xvPT", function(module, exports) {

var $hAAp4 = parcelRequire("hAAp4");

var $9Ujw7 = parcelRequire("9Ujw7");
function $11f1917fdec7e91a$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $hAAp4 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($9Ujw7($11f1917fdec7e91a$var$AsyncIterator.prototype), $9Ujw7($11f1917fdec7e91a$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $9Ujw7(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $11f1917fdec7e91a$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("a8nNF", function(module, exports) {
function $760d1cebbe70fce2$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $760d1cebbe70fce2$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5xmht", function(module, exports) {

var $dzA3D = parcelRequire("dzA3D");
var $40815154d73902db$var$_typeof = $dzA3D.default;
function $40815154d73902db$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($40815154d73902db$var$_typeof(e) + " is not iterable");
}
module.exports = $40815154d73902db$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dzA3D", function(module, exports) {
function $9e1a838f905908e4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9e1a838f905908e4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9e1a838f905908e4$var$_typeof(o);
}
module.exports = $9e1a838f905908e4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("2HmGJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f713254722e5119$export$2e2bcd8739ae039; });

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $6THua = parcelRequire("6THua");

var $aWTIZ = parcelRequire("aWTIZ");
function $1f713254722e5119$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1f713254722e5119$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1f713254722e5119$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1f713254722e5119$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1f713254722e5119$export$a66cbd9b2289cd78 = "@all-features";
var $1f713254722e5119$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $cnuD2.default)(this, Subscriptions);
        (0, $6THua.default)(this, "eventToValue", new Map());
        this.emitter = new (0, $aWTIZ.EventEmitter2)();
    }
    return (0, $ecJAY.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $1f713254722e5119$var$_objectSpread($1f713254722e5119$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $1f713254722e5119$var$_objectSpread($1f713254722e5119$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $1f713254722e5119$var$_objectSpread($1f713254722e5119$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $1f713254722e5119$var$_objectSpread($1f713254722e5119$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($1f713254722e5119$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($1f713254722e5119$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($1f713254722e5119$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $1f713254722e5119$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("3ZihN", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $2e7540d546c2944d$export$6dc24881a3d96325; });

var $bo26J = parcelRequire("bo26J");

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $8uCTq = parcelRequire("8uCTq");
var $2e7540d546c2944d$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $cnuD2.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $ecJAY.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, $bo26J.default)(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, $bo26J.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $8uCTq.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("8uCTq", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $62ef4b611e7a41b2$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $62ef4b611e7a41b2$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $62ef4b611e7a41b2$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $62ef4b611e7a41b2$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $62ef4b611e7a41b2$export$18ad168d3dbac899; });

var $jR3qz = parcelRequire("jR3qz");

var $6wazT = parcelRequire("6wazT");

var $6THua = parcelRequire("6THua");

var $hRKKo = parcelRequire("hRKKo");

var $9pt99 = parcelRequire("9pt99");

var $fJyoP = parcelRequire("fJyoP");

var $dsUzg = parcelRequire("dsUzg");
var $62ef4b611e7a41b2$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $62ef4b611e7a41b2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62ef4b611e7a41b2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62ef4b611e7a41b2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62ef4b611e7a41b2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $62ef4b611e7a41b2$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $62ef4b611e7a41b2$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $9pt99.isFedRamp)() ? (0, $dsUzg.PerimeterType).FEDRAMP_MODERATE : (0, $dsUzg.PerimeterType).COMMERCIAL
    }, options);
};
var $62ef4b611e7a41b2$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $6wazT.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $6wazT.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $6wazT.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $6wazT.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $62ef4b611e7a41b2$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $62ef4b611e7a41b2$var$_objectSpread({
            stableID: (0, $hRKKo.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $62ef4b611e7a41b2$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $jR3qz.default)(options, $62ef4b611e7a41b2$var$_excluded);
    return $62ef4b611e7a41b2$var$_objectSpread($62ef4b611e7a41b2$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $62ef4b611e7a41b2$var$evaluationReasonMappings = Object.entries((0, $fJyoP.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $6wazT.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $62ef4b611e7a41b2$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $62ef4b611e7a41b2$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $6wazT.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $fJyoP.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("9pt99", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $6d9d0ec31856521a$export$64d6499adf9b2e51; });

var $dpGXE = parcelRequire("dpGXE");
function $6d9d0ec31856521a$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $dpGXE.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("dpGXE", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $9c3eef5d9ced3b4c$export$ce553301d55c2fd8; });
var $9c3eef5d9ced3b4c$export$ce553301d55c2fd8 = "fedramp-moderate";
var $9c3eef5d9ced3b4c$export$f005e2e9f707cb5f = "commercial";
var $9c3eef5d9ced3b4c$export$bd6b5a7802d76127 = "fedramp-fedex";
var $9c3eef5d9ced3b4c$export$a739cd5aac835909 = "stg";
var $9c3eef5d9ced3b4c$export$42dd0cdd351a4a9 = "prod";
var $9c3eef5d9ced3b4c$export$404582bc18fe4d9e = "dev";

});


parcelRegister("fJyoP", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $b745be03b9ddc109$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $b745be03b9ddc109$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("dsUzg", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $9cd9c50ded5737cc$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $9cd9c50ded5737cc$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9cd9c50ded5737cc$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $9cd9c50ded5737cc$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $9cd9c50ded5737cc$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("aMzdQ", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $7d99b580619fd0cc$export$936d0764594b6eb3; });

var $bo26J = parcelRequire("bo26J");

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $8uCTq = parcelRequire("8uCTq");
var $7d99b580619fd0cc$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $cnuD2.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $ecJAY.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $bo26J.default)(val) === (0, $bo26J.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $8uCTq.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("iyAcz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8277be1044458c4$export$2e2bcd8739ae039; });

var $6THua = parcelRequire("6THua");

var $diwCl = parcelRequire("diwCl");

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $7qFNr = parcelRequire("7qFNr");

var $dsUzg = parcelRequire("dsUzg");

var $6Mjpu = parcelRequire("6Mjpu");

var $8hskj = parcelRequire("8hskj");
function $d8277be1044458c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8277be1044458c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8277be1044458c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8277be1044458c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d8277be1044458c4$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $d8277be1044458c4$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $d8277be1044458c4$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $d8277be1044458c4$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $d8277be1044458c4$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $d8277be1044458c4$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $d8277be1044458c4$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $d8277be1044458c4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $cnuD2.default)(this, Fetcher);
    }
    return (0, $ecJAY.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $8hskj.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $8hskj.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $d8277be1044458c4$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $dsUzg.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $dsUzg.FeatureGateEnvironment).Production:
                        return $d8277be1044458c4$export$18c93900db9358a4;
                    case (0, $dsUzg.FeatureGateEnvironment).Staging:
                        return $d8277be1044458c4$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $dsUzg.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $dsUzg.FeatureGateEnvironment).Development:
                        return $d8277be1044458c4$export$f058dbf75c3bc647;
                    case (0, $dsUzg.FeatureGateEnvironment).Staging:
                        return $d8277be1044458c4$export$942ba04389b0d5a2;
                    default:
                        return $d8277be1044458c4$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $d8277be1044458c4$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $d8277be1044458c4$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $6Mjpu.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("6Mjpu", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $4ef648346312f2bf$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $4ef648346312f2bf$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("8hskj", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $6075e253b2aba036$export$286baf652d0b1206; });

var $ecJAY = parcelRequire("ecJAY");

var $cnuD2 = parcelRequire("cnuD2");

var $iiAZM = parcelRequire("iiAZM");

var $hxW36 = parcelRequire("hxW36");

var $a4x0H = parcelRequire("a4x0H");

var $hqdGY = parcelRequire("hqdGY");
function $6075e253b2aba036$var$_callSuper(t, o, e) {
    return o = (0, $hxW36.default)(o), (0, $iiAZM.default)(t, $6075e253b2aba036$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hxW36.default)(t).constructor) : o.apply(t, e));
}
function $6075e253b2aba036$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6075e253b2aba036$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $6075e253b2aba036$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $cnuD2.default)(this, ResponseError);
        return $6075e253b2aba036$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $a4x0H.default)(ResponseError, _Error);
    return (0, $ecJAY.default)(ResponseError);
}(/*#__PURE__*/ (0, $hqdGY.default)(Error));

});
parcelRegister("iiAZM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5269af9ea1bb0e9$export$2e2bcd8739ae039; });

var $bo26J = parcelRequire("bo26J");

var $6WU2m = parcelRequire("6WU2m");
function $d5269af9ea1bb0e9$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $bo26J.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $6WU2m.default)(t);
}

});
parcelRegister("6WU2m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $50f3a0abeb161f49$export$2e2bcd8739ae039; });
function $50f3a0abeb161f49$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hxW36", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cc628c0d384c1577$export$2e2bcd8739ae039; });
function $cc628c0d384c1577$export$2e2bcd8739ae039(t) {
    return $cc628c0d384c1577$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cc628c0d384c1577$export$2e2bcd8739ae039(t);
}

});

parcelRegister("a4x0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7553e243cb9261c7$export$2e2bcd8739ae039; });

var $4L3NI = parcelRequire("4L3NI");
function $7553e243cb9261c7$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $4L3NI.default)(t, e);
}

});
parcelRegister("4L3NI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $376e7ff5cd0bafd4$export$2e2bcd8739ae039; });
function $376e7ff5cd0bafd4$export$2e2bcd8739ae039(t, e) {
    return $376e7ff5cd0bafd4$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $376e7ff5cd0bafd4$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hqdGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $caef7c5d79908422$export$2e2bcd8739ae039; });

var $hxW36 = parcelRequire("hxW36");

var $4L3NI = parcelRequire("4L3NI");

var $e7ixm = parcelRequire("e7ixm");

var $3rNin = parcelRequire("3rNin");
function $caef7c5d79908422$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $caef7c5d79908422$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $e7ixm.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $3rNin.default)(t, arguments, (0, $hxW36.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $4L3NI.default)(Wrapper, t);
    }, $caef7c5d79908422$export$2e2bcd8739ae039(t);
}

});
parcelRegister("e7ixm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4701933a91a9f7a$export$2e2bcd8739ae039; });
function $a4701933a91a9f7a$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("3rNin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $282a21c671a32522$export$2e2bcd8739ae039; });

var $iqGlV = parcelRequire("iqGlV");

var $4L3NI = parcelRequire("4L3NI");
function $282a21c671a32522$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $iqGlV.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $4L3NI.default)(p, r.prototype), p;
}

});
parcelRegister("iqGlV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6ab8209c7e40f30$export$2e2bcd8739ae039; });
function $d6ab8209c7e40f30$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d6ab8209c7e40f30$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("ekea1", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $a6ddeaf6f9bf125b$export$55fffef3474104af; });

var $diwCl = parcelRequire("diwCl");

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $iiAZM = parcelRequire("iiAZM");

var $hxW36 = parcelRequire("hxW36");

var $7Po56 = parcelRequire("7Po56");

var $a4x0H = parcelRequire("a4x0H");

var $6THua = parcelRequire("6THua");

var $7qFNr = parcelRequire("7qFNr");

var $hRKKo = parcelRequire("hRKKo");
function $a6ddeaf6f9bf125b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6ddeaf6f9bf125b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6ddeaf6f9bf125b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6ddeaf6f9bf125b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a6ddeaf6f9bf125b$var$_callSuper(t, o, e) {
    return o = (0, $hxW36.default)(o), (0, $iiAZM.default)(t, $a6ddeaf6f9bf125b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hxW36.default)(t).constructor) : o.apply(t, e));
}
function $a6ddeaf6f9bf125b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a6ddeaf6f9bf125b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a6ddeaf6f9bf125b$var$_superPropGet(t, o, e, r) {
    var p = (0, $7Po56.default)((0, $hxW36.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a6ddeaf6f9bf125b$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $cnuD2.default)(this, NoFetchDataAdapter);
        _this = $a6ddeaf6f9bf125b$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, $6THua.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $a4x0H.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $ecJAY.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $hRKKo.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $a6ddeaf6f9bf125b$var$_objectSpread($a6ddeaf6f9bf125b$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $hRKKo._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $a6ddeaf6f9bf125b$var$_objectSpread($a6ddeaf6f9bf125b$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $hRKKo._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $diwCl.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7qFNr))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $hRKKo._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $hRKKo.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $a6ddeaf6f9bf125b$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $a6ddeaf6f9bf125b$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $hRKKo.DataAdapterCore));

});
parcelRegister("7Po56", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b2ff9e3efff4c44$export$2e2bcd8739ae039; });

var $2ZQCH = parcelRequire("2ZQCH");
function $5b2ff9e3efff4c44$export$2e2bcd8739ae039() {
    return $5b2ff9e3efff4c44$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $2ZQCH.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $5b2ff9e3efff4c44$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("2ZQCH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22ea192ba44e9723$export$2e2bcd8739ae039; });

var $hxW36 = parcelRequire("hxW36");
function $22ea192ba44e9723$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $hxW36.default)(t)););
    return t;
}

});



parcelRegister("hHdS0", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $ce213620b3e81363$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $ce213620b3e81363$export$bcb28fbac1def494; });

var $6THua = parcelRequire("6THua");

var $6wazT = parcelRequire("6wazT");

var $cnuD2 = parcelRequire("cnuD2");

var $ecJAY = parcelRequire("ecJAY");

var $j59CT = parcelRequire("j59CT");
function $ce213620b3e81363$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce213620b3e81363$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce213620b3e81363$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce213620b3e81363$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ce213620b3e81363$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $ce213620b3e81363$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $ce213620b3e81363$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $ce213620b3e81363$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $ce213620b3e81363$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $ce213620b3e81363$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $ce213620b3e81363$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $ce213620b3e81363$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $ce213620b3e81363$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $ce213620b3e81363$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $ce213620b3e81363$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $ce213620b3e81363$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $cnuD2.default)(this, PersistentOverrideAdapter);
        this._overrides = $ce213620b3e81363$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $ecJAY.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $ce213620b3e81363$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $ce213620b3e81363$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $ce213620b3e81363$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $6wazT.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $6wazT.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $6wazT.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($ce213620b3e81363$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($ce213620b3e81363$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $ce213620b3e81363$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $j59CT._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, $ce213620b3e81363$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $6wazT.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $6wazT.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($ce213620b3e81363$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, current.details), {}, {
                        reason: $ce213620b3e81363$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($ce213620b3e81363$var$djb2MapKey((0, $j59CT._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $ce213620b3e81363$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($ce213620b3e81363$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $j59CT._makeTypedGet)(current.name, overridden),
                    details: $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, current.details), {}, {
                        reason: $ce213620b3e81363$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($ce213620b3e81363$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $j59CT._makeTypedGet)(current.name, overridden),
                    details: $ce213620b3e81363$var$_objectSpread($ce213620b3e81363$var$_objectSpread({}, current.details), {}, {
                        reason: $ce213620b3e81363$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("23OHV", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $18033206f262e2a6$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $18033206f262e2a6$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $18033206f262e2a6$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $18033206f262e2a6$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $18033206f262e2a6$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $18033206f262e2a6$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $18033206f262e2a6$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $18033206f262e2a6$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $18033206f262e2a6$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $18033206f262e2a6$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $18033206f262e2a6$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $18033206f262e2a6$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $18033206f262e2a6$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $18033206f262e2a6$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $18033206f262e2a6$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $18033206f262e2a6$var$rgbToLch = function rgbToLch(rgb) {
    return $18033206f262e2a6$var$labToLch($18033206f262e2a6$var$xyzToLab($18033206f262e2a6$var$rgbToXyz(rgb)));
};
var $18033206f262e2a6$var$lchToRgb = function lchToRgb(lch) {
    return $18033206f262e2a6$var$xyzToRgb($18033206f262e2a6$var$labToXyz($18033206f262e2a6$var$lchToLab(lch)));
};
var $18033206f262e2a6$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $18033206f262e2a6$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $18033206f262e2a6$var$rgbToLch(rgb);
    lch.l = $18033206f262e2a6$var$clamp(newPercent, 0, 100);
    return $18033206f262e2a6$var$rgbToHex($18033206f262e2a6$var$lchToRgb(lch));
};
var $18033206f262e2a6$var$getLightness = function getLightness(color) {
    var rgb = $18033206f262e2a6$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $18033206f262e2a6$var$rgbToLch(rgb);
    return lch.l;
};
var $18033206f262e2a6$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $18033206f262e2a6$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $18033206f262e2a6$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("6tVVd", function(module, exports) {

$parcel$export(module.exports, "getSchemaBasedOnStage", function () { return $4b8261942634b95d$export$fd147e7d448dea03; });
$parcel$export(module.exports, "defaultSchema", function () { return $4b8261942634b95d$export$1db618b7b2275ea1; });

var $fV0Sg = parcelRequire("fV0Sg");

var $8G05O = parcelRequire("8G05O");
var $5ZyM5 = parcelRequire("5ZyM5");
var $gucG8 = parcelRequire("gucG8");
var $h4zHV = parcelRequire("h4zHV");
var $lV21z = parcelRequire("lV21z");
var $bqzKK = parcelRequire("bqzKK");

var $gwOQO = parcelRequire("gwOQO");
var $4b8261942634b95d$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            "doc",
            "paragraph",
            "text",
            "bulletList",
            "orderedList",
            "listItem",
            "heading",
            "blockquote",
            "codeBlock",
            "panel",
            "rule",
            "image",
            "caption",
            "mention",
            "media",
            "mediaGroup",
            "mediaSingle",
            "mediaInline",
            "confluenceUnsupportedBlock",
            "confluenceUnsupportedInline",
            "confluenceJiraIssue",
            "expand",
            "nestedExpand",
            "extension",
            "inlineExtension",
            "bodiedExtension",
            "hardBreak",
            "emoji",
            "table",
            "tableCell",
            "tableHeader",
            "tableRow",
            "decisionList",
            "decisionItem",
            "taskList",
            "taskItem",
            "blockTaskItem",
            "unknownBlock",
            "date",
            "status",
            "placeholder",
            "layoutSection",
            "layoutColumn",
            "inlineCard",
            "blockCard",
            "embedCard",
            "unsupportedBlock",
            "unsupportedInline"
        ],
        marks: [
            "link",
            "em",
            "strong",
            "strike",
            "subsup",
            "underline",
            "code",
            "textColor",
            "backgroundColor",
            "confluenceInlineComment",
            "breakout",
            "alignment",
            "indentation",
            "annotation",
            "dataConsumer",
            "border",
            "unsupportedMark",
            "unsupportedNodeAttribute",
            "typeAheadQuery",
            // https://product-fabric.atlassian.net/browse/ED-10214,
            "fragment"
        ]
    };
    return defaultSchemaConfig;
};
var $4b8261942634b95d$export$e4e3ac1fa64862db = $4b8261942634b95d$var$getDefaultSchemaConfig();
var $4b8261942634b95d$export$fd147e7d448dea03 = (0, $fV0Sg.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "final";
    var defaultSchemaConfig = $4b8261942634b95d$var$getDefaultSchemaConfig();
    if (stage === "stage0") defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $gucG8.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $5ZyM5.multiBodiedExtension),
        extensionFrame: (0, $5ZyM5.extensionFrame),
        expand: (0, $8G05O.expandWithNestedExpand),
        listItem: (0, $h4zHV.listItemWithDecisionStage0),
        table: (0, $bqzKK.tableWithNestedTable),
        tableRow: (0, $bqzKK.tableRowWithNestedTable),
        tableCell: (0, $bqzKK.tableCellWithNestedTable),
        tableHeader: (0, $bqzKK.tableHeaderWithNestedTable),
        syncBlock: (0, $lV21z.syncBlock)
    };
    return (0, $gwOQO.createSchema)(defaultSchemaConfig);
});
var $4b8261942634b95d$export$1db618b7b2275ea1 = $4b8261942634b95d$export$fd147e7d448dea03();

});
parcelRegister("5ZyM5", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", function () { return $45cd9fc7e890401f$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $45cd9fc7e890401f$export$c3c04d555a8b9013; });

var $j03XP = parcelRequire("j03XP");

var $gtPcq = parcelRequire("gtPcq");
var $45cd9fc7e890401f$export$4fdcae991fd743e7 = (0, $gtPcq.extensionFrameStage0)({
    parseDOM: [
        {
            context: "extensionFrame//",
            tag: "div[data-extension-frame]",
            skip: true
        },
        {
            tag: "div[data-extension-frame]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-extension-frame": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $45cd9fc7e890401f$export$c3c04d555a8b9013 = (0, $gtPcq.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: "multiBodiedExtension//",
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $j03XP.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "multi-bodied-extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});
parcelRegister("j03XP", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", function () { return $dd51178f1e9cad59$export$1765e2758fc47004; });
var $dd51178f1e9cad59$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        "default",
        "wide",
        "full-width"
    ].includes(name);
};
var $dd51178f1e9cad59$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute("data-extension-type");
    var extensionKey = dom.getAttribute("data-extension-key");
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute("data-text") || undefined,
        parameters: JSON.parse(dom.getAttribute("data-parameters") || "{}"),
        localId: dom.getAttribute("data-local-id") || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute("data-layout");
        attrs.layout = $dd51178f1e9cad59$export$d5f21755dc782a4a(rawLayout) ? rawLayout : "default";
    }
    return attrs;
};

});


parcelRegister("gucG8", function(module, exports) {

$parcel$export(module.exports, "layoutSection", function () { return $c0094868db8d81db$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $c0094868db8d81db$export$4f9d8f623ff17117; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $c0094868db8d81db$export$b3b6a70a7fa4a5be = (0, $gtPcq.layoutSection)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $c0094868db8d81db$export$cdae19acb0a520fd = (0, $gtPcq.layoutSectionFull)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $c0094868db8d81db$export$4f9d8f623ff17117 = (0, $gtPcq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute("data-column-rule-style");
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            "data-layout-section": "true",
            "data-column-rule-style": columnRuleStyle || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $c0094868db8d81db$export$d9d3c69a64270b13 = (0, $gtPcq.layoutSection)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs() {
                var localId = (0, $7fOn1.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-layout-section": "true",
            "data-local-id": localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $c0094868db8d81db$export$64facded20dfd85c = (0, $gtPcq.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute("data-column-rule-style");
                var localId = (0, $7fOn1.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            "data-layout-section": "true",
            "data-column-rule-style": columnRuleStyle || undefined,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("h4zHV", function(module, exports) {

$parcel$export(module.exports, "listItem", function () { return $c6de822644799b20$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $c6de822644799b20$export$b2cd54d5ce935ddb; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
var $c6de822644799b20$export$76c7e83ecc9cdf05 = (0, $gtPcq.listItem)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});
var $c6de822644799b20$export$483d52f09158e61c = (0, $gtPcq.listItem)({
    parseDOM: [
        {
            tag: "li",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            "li",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $c6de822644799b20$export$b2cd54d5ce935ddb = (0, $gtPcq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});
var $c6de822644799b20$export$394466eb252d967a = (0, $gtPcq.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: "li",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            "li",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("lV21z", function(module, exports) {

$parcel$export(module.exports, "syncBlock", function () { return $ff507dd1e31eee1b$export$faab0ca9701d7048; });

var $gtPcq = parcelRequire("gtPcq");
var $ff507dd1e31eee1b$export$faab0ca9701d7048 = (0, $gtPcq.syncBlockStage0)({
    parseDOM: [
        {
            tag: "div[data-sync-block]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute("data-local-id") || "",
                    resourceId: dom.getAttribute("data-resource-id") || ""
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = "div";
        var attrs = {
            "data-sync-block": "",
            "data-local-id": localId,
            "data-resource-id": resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("gwOQO", function(module, exports) {

$parcel$export(module.exports, "createSchema", function () { return $c08714688ceb4f94$export$5f4ce795563f4211; });

var $6Z794 = parcelRequire("6Z794");

var $lqDwt = parcelRequire("lqDwt");

var $4TfEa = parcelRequire("4TfEa");

var $esA54 = parcelRequire("esA54");
var $dR250 = parcelRequire("dR250");
var $kwj7j = parcelRequire("kwj7j");
var $jMlcd = parcelRequire("jMlcd");
var $dWcku = parcelRequire("dWcku");
var $gArxa = parcelRequire("gArxa");
var $fzcos = parcelRequire("fzcos");
var $ki8RA = parcelRequire("ki8RA");
var $lkXN0 = parcelRequire("lkXN0");
var $boWpd = parcelRequire("boWpd");
var $l8Enp = parcelRequire("l8Enp");
var $1RQCT = parcelRequire("1RQCT");
var $lgm9Y = parcelRequire("lgm9Y");
var $aXHcE = parcelRequire("aXHcE");
var $7cIFM = parcelRequire("7cIFM");
var $803ek = parcelRequire("803ek");
var $j3QbZ = parcelRequire("j3QbZ");
var $4RiRA = parcelRequire("4RiRA");
var $5an7V = parcelRequire("5an7V");
var $dRnD7 = parcelRequire("dRnD7");

var $5NuaV = parcelRequire("5NuaV");
var $8MBWr = parcelRequire("8MBWr");
var $bfXJM = parcelRequire("bfXJM");
var $hnesC = parcelRequire("hnesC");
var $9blJR = parcelRequire("9blJR");
var $hCSPY = parcelRequire("hCSPY");
var $9ZIAY = parcelRequire("9ZIAY");
var $WJKE3 = parcelRequire("WJKE3");
var $brv21 = parcelRequire("brv21");
var $ldwFL = parcelRequire("ldwFL");
var $ajcOO = parcelRequire("ajcOO");
var $h01Ec = parcelRequire("h01Ec");
var $cImFj = parcelRequire("cImFj");
var $8kfDk = parcelRequire("8kfDk");
var $8knNh = parcelRequire("8knNh");
var $8G05O = parcelRequire("8G05O");
var $4FCN7 = parcelRequire("4FCN7");
var $aMswM = parcelRequire("aMswM");
var $1sNoH = parcelRequire("1sNoH");
var $5ZyM5 = parcelRequire("5ZyM5");
var $h7IZm = parcelRequire("h7IZm");
var $a5tjA = parcelRequire("a5tjA");
var $amAmU = parcelRequire("amAmU");
var $eBrzV = parcelRequire("eBrzV");
var $k1uRN = parcelRequire("k1uRN");
var $7qgam = parcelRequire("7qgam");
var $gucG8 = parcelRequire("gucG8");
var $h4zHV = parcelRequire("h4zHV");
var $dA2jn = parcelRequire("dA2jn");
var $4RA3Z = parcelRequire("4RA3Z");
var $GOuH7 = parcelRequire("GOuH7");
var $gVZPw = parcelRequire("gVZPw");
var $8stLs = parcelRequire("8stLs");
var $dMOvb = parcelRequire("dMOvb");
var $c1vLe = parcelRequire("c1vLe");
var $9x4sf = parcelRequire("9x4sf");
var $k5nLu = parcelRequire("k5nLu");
var $cEUfF = parcelRequire("cEUfF");
var $7drBE = parcelRequire("7drBE");
var $lV21z = parcelRequire("lV21z");
var $bqzKK = parcelRequire("bqzKK");
var $3Exd5 = parcelRequire("3Exd5");
var $gRYNd = parcelRequire("gRYNd");
var $lNxQx = parcelRequire("lNxQx");
var $lc2i3 = parcelRequire("lc2i3");
var $6nnv5 = parcelRequire("6nnv5");
function $c08714688ceb4f94$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $c08714688ceb4f94$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $c08714688ceb4f94$var$markGroupDeclarations = [
    $c08714688ceb4f94$var$groupDeclaration((0, $lqDwt.COLOR)),
    $c08714688ceb4f94$var$groupDeclaration((0, $lqDwt.FONT_STYLE)),
    $c08714688ceb4f94$var$groupDeclaration((0, $lqDwt.SEARCH_QUERY)),
    $c08714688ceb4f94$var$groupDeclaration((0, $lqDwt.LINK))
];
var $c08714688ceb4f94$var$markGroupDeclarationsNames = $c08714688ceb4f94$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $c08714688ceb4f94$var$nodesInOrder = [
    {
        name: "doc",
        spec: (0, $cImFj.doc)
    },
    {
        name: "paragraph",
        spec: (0, $9x4sf.paragraph)
    },
    {
        name: "text",
        spec: (0, $gRYNd.text)
    },
    {
        name: "bulletList",
        spec: (0, $hnesC.bulletList)
    },
    {
        name: "orderedList",
        spec: (0, $c1vLe.orderedListWithOrder)
    },
    {
        name: "listItem",
        spec: (0, $h4zHV.listItem)
    },
    {
        name: "heading",
        spec: (0, $a5tjA.heading)
    },
    {
        name: "blockquote",
        spec: (0, $4FCN7.extendedBlockquote)
    },
    {
        name: "codeBlock",
        spec: (0, $hCSPY.codeBlock)
    },
    {
        name: "panel",
        spec: (0, $aMswM.extendedPanel)(true)
    },
    {
        name: "rule",
        spec: (0, $cEUfF.rule)
    },
    {
        name: "image",
        spec: (0, $amAmU.image)
    },
    {
        name: "mention",
        spec: (0, $8stLs.mention)
    },
    {
        name: "caption",
        spec: (0, $9blJR.caption)
    },
    {
        name: "media",
        spec: (0, $dA2jn.media)
    },
    {
        name: "mediaGroup",
        spec: (0, $4RA3Z.mediaGroup)
    },
    {
        name: "mediaSingle",
        spec: (0, $gVZPw.mediaSingleFull)
    },
    {
        name: "mediaInline",
        spec: (0, $GOuH7.mediaInline)
    },
    {
        name: "placeholder",
        spec: (0, $k5nLu.placeholder)
    },
    {
        name: "layoutSection",
        spec: (0, $gucG8.layoutSection)
    },
    {
        name: "layoutColumn",
        spec: (0, $7qgam.layoutColumn)
    },
    {
        name: "hardBreak",
        spec: (0, $h7IZm.hardBreak)
    },
    {
        name: "emoji",
        spec: (0, $8knNh.emoji)
    },
    {
        name: "table",
        spec: (0, $bqzKK.table)
    },
    {
        name: "tableCell",
        spec: (0, $bqzKK.tableCell)
    },
    {
        name: "tableRow",
        spec: (0, $bqzKK.tableRow)
    },
    {
        name: "tableHeader",
        spec: (0, $bqzKK.tableHeader)
    },
    {
        name: "confluenceJiraIssue",
        spec: (0, $9ZIAY.confluenceJiraIssue)
    },
    {
        name: "confluenceUnsupportedInline",
        spec: (0, $brv21.confluenceUnsupportedInline)
    },
    {
        name: "confluenceUnsupportedBlock",
        spec: (0, $WJKE3.confluenceUnsupportedBlock)
    },
    {
        name: "decisionList",
        spec: (0, $h01Ec.decisionList)
    },
    {
        name: "decisionItem",
        spec: (0, $ajcOO.decisionItem)
    },
    {
        name: "taskList",
        spec: (0, $3Exd5.taskList)
    },
    {
        name: "taskItem",
        spec: (0, $8MBWr.taskItem)
    },
    {
        name: "blockTaskItem",
        spec: (0, $8MBWr.blockTaskItem)
    },
    {
        name: "date",
        spec: (0, $ldwFL.date)
    },
    {
        name: "status",
        spec: (0, $7drBE.status)
    },
    {
        name: "expand",
        spec: (0, $8G05O.expandWithNestedExpand)
    },
    {
        name: "nestedExpand",
        spec: (0, $dMOvb.nestedExpand)
    },
    {
        name: "extension",
        spec: (0, $1sNoH.extension)
    },
    {
        name: "inlineExtension",
        spec: (0, $k1uRN.inlineExtension)
    },
    {
        name: "bodiedExtension",
        spec: (0, $bfXJM.bodiedExtension)
    },
    {
        name: "multiBodiedExtension",
        spec: (0, $5ZyM5.multiBodiedExtension)
    },
    {
        name: "extensionFrame",
        spec: (0, $5ZyM5.extensionFrame)
    },
    {
        name: "inlineCard",
        spec: (0, $eBrzV.inlineCard)
    },
    {
        name: "blockCard",
        spec: (0, $5NuaV.blockCard)
    },
    {
        name: "embedCard",
        spec: (0, $8kfDk.embedCard)
    },
    {
        name: "syncBlock",
        spec: (0, $lV21z.syncBlock)
    },
    {
        name: "unknownBlock",
        spec: (0, $lNxQx.default)
    },
    {
        name: "unsupportedBlock",
        spec: (0, $lc2i3.unsupportedBlock)
    },
    {
        name: "unsupportedInline",
        spec: (0, $6nnv5.unsupportedInline)
    }
];
var $c08714688ceb4f94$var$marksInOrder = [
    {
        name: "link",
        spec: (0, $1RQCT.link)
    },
    {
        name: "em",
        spec: (0, $lkXN0.em)
    },
    {
        name: "strong",
        spec: (0, $aXHcE.strong)
    },
    {
        name: "textColor",
        spec: (0, $803ek.textColor)
    },
    {
        name: "backgroundColor",
        spec: (0, $kwj7j.backgroundColor)
    },
    {
        name: "strike",
        spec: (0, $lgm9Y.strike)
    },
    {
        name: "subsup",
        spec: (0, $7cIFM.subsup)
    },
    {
        name: "underline",
        spec: (0, $4RiRA.underline)
    },
    {
        name: "code",
        spec: (0, $gArxa.code)
    },
    {
        name: "typeAheadQuery",
        spec: (0, $j3QbZ.typeAheadQuery)
    },
    {
        name: "alignment",
        spec: (0, $esA54.alignment)
    },
    {
        name: "annotation",
        spec: (0, $dR250.annotation)
    },
    {
        name: "confluenceInlineComment",
        spec: (0, $fzcos.confluenceInlineComment)
    }
].concat($c08714688ceb4f94$var$markGroupDeclarations, [
    {
        name: "breakout",
        spec: (0, $dWcku.breakout)
    },
    {
        name: "dataConsumer",
        spec: (0, $ki8RA.dataConsumer)
    },
    {
        name: "fragment",
        spec: (0, $boWpd.fragment)
    },
    {
        name: "indentation",
        spec: (0, $l8Enp.indentation)
    },
    {
        name: "border",
        spec: (0, $jMlcd.border)
    },
    {
        name: "unsupportedMark",
        spec: (0, $5an7V.unsupportedMark)
    },
    {
        name: "unsupportedNodeAttribute",
        spec: (0, $dRnD7.unsupportedNodeAttribute)
    }
]);
function $c08714688ceb4f94$export$2d0c32a809131488() {
    var nodes = $c08714688ceb4f94$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $c08714688ceb4f94$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $c08714688ceb4f94$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($c08714688ceb4f94$var$markGroupDeclarationsNames);
    var nodes = $c08714688ceb4f94$var$addItems($c08714688ceb4f94$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $c08714688ceb4f94$var$addItems($c08714688ceb4f94$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $4TfEa.sanitizeNodes)(nodes, marks);
    return new (0, $6Z794.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $c08714688ceb4f94$export$c77b6d30da5276a1 = true;

});
parcelRegister("lqDwt", function(module, exports) {

$parcel$export(module.exports, "FONT_STYLE", function () { return $f99aaf15b002c17e$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $f99aaf15b002c17e$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $f99aaf15b002c17e$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $f99aaf15b002c17e$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $f99aaf15b002c17e$export$4498a6080fed604c = "fontStyle";
var $f99aaf15b002c17e$export$f8e8a5f34f6ea725 = "searchQuery";
var $f99aaf15b002c17e$export$b395009ca7f092c7 = "link";
var $f99aaf15b002c17e$export$9b982809044276a6 = "color";
var $f99aaf15b002c17e$export$470d0905851e47a1 = "alignment";
var $f99aaf15b002c17e$export$bacb7f4b06a06b22 = "indentation";

});

parcelRegister("4TfEa", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", function () { return $38f86fa1beac6d9b$export$daf54fed04c8fb77; });

var $2VHRc = parcelRequire("2VHRc");
function $38f86fa1beac6d9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $38f86fa1beac6d9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $38f86fa1beac6d9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $38f86fa1beac6d9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $38f86fa1beac6d9b$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $38f86fa1beac6d9b$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== "_") nodeSpec.marks = nodeSpec.marks.split(" ").filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(" ");
        if (nodeSpec.content) nodeSpec.content = $38f86fa1beac6d9b$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $38f86fa1beac6d9b$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, " ");
    var contentKeys = content.split(" ");
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$38f86fa1beac6d9b$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $38f86fa1beac6d9b$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $38f86fa1beac6d9b$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || "";
    if (!content || !content.match(/\w/)) return "";
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, "g"), "").replace("  ", " ").trim();
}
function $38f86fa1beac6d9b$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("esA54", function(module, exports) {

$parcel$export(module.exports, "alignment", function () { return $a86fab153f68b7eb$export$8e53000a4ec837; });

var $h2c1T = parcelRequire("h2c1T");
var $a86fab153f68b7eb$export$be9cf49015769bbd = {
    end: "right",
    right: "end",
    center: "center"
};
var $a86fab153f68b7eb$export$8e53000a4ec837 = (0, $h2c1T.alignment)({
    parseDOM: [
        {
            tag: "div.fabric-editor-block-mark",
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute("data-align");
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                "data-align": mark.attrs.align
            },
            0
        ];
    }
});

});

parcelRegister("dR250", function(module, exports) {

$parcel$export(module.exports, "annotation", function () { return $a161d69b4dbcef52$export$8512c9afa7b24c3b; });

var $2VHRc = parcelRequire("2VHRc");

var $h2c1T = parcelRequire("h2c1T");
function $a161d69b4dbcef52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a161d69b4dbcef52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a161d69b4dbcef52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a161d69b4dbcef52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a161d69b4dbcef52$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $a161d69b4dbcef52$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $a161d69b4dbcef52$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        "data-mark-type": "annotation",
        "data-mark-annotation-type": annotationType,
        "data-id": id
    };
    if (state) return $a161d69b4dbcef52$var$_objectSpread($a161d69b4dbcef52$var$_objectSpread({}, data), {}, {
        "data-mark-annotation-state": state
    });
    return data;
}
var $a161d69b4dbcef52$export$8512c9afa7b24c3b = (0, $h2c1T.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: "annotation",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-id"),
                    annotationType: dom.getAttribute("data-mark-annotation-type")
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            "span",
            $a161d69b4dbcef52$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                "class": "fabric-editor-annotation"
            }, $a161d69b4dbcef52$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("kwj7j", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", function () { return $ef05a00bdd6bdfbf$export$8c5a050822fd698c; });

var $2VHRc = parcelRequire("2VHRc");

var $gkaEr = parcelRequire("gkaEr");

var $h2c1T = parcelRequire("h2c1T");

var $aYDRF = parcelRequire("aYDRF");

var $52rTH = parcelRequire("52rTH");

var $803ek = parcelRequire("803ek");

var $23OHV = parcelRequire("23OHV");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
var $ef05a00bdd6bdfbf$var$colorArrayPalette = [
    [
        (0, $52rTH.Neutral300),
        "Gray"
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $52rTH.T200),
        "Teal"
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $52rTH.L200),
        "Lime"
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $52rTH.O200),
        "Orange"
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $52rTH.M200),
        "Magenta"
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $52rTH.P200),
        "Purple"
    ] // token: color.background.accent.purple.subtler
];
var $ef05a00bdd6bdfbf$var$colorArrayPaletteNext = [
    [
        (0, $52rTH.Neutral300),
        "Gray"
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $52rTH.P200),
        "Purple"
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $52rTH.M200),
        "Magenta"
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $52rTH.O200),
        "Orange"
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $52rTH.Yellow200),
        "Yellow"
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $52rTH.L200),
        "Lime"
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $52rTH.T200),
        "Teal"
    ] // token: color.background.accent.teal.subtler
];
var $ef05a00bdd6bdfbf$export$14ec3f21a268e497 = new Map();
$ef05a00bdd6bdfbf$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $gkaEr.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $ef05a00bdd6bdfbf$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $ef05a00bdd6bdfbf$export$7ab6fa38cecaeee2 = new Map();
$ef05a00bdd6bdfbf$var$colorArrayPaletteNext.forEach(function(_ref3) {
    var _ref4 = (0, $gkaEr.default)(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $ef05a00bdd6bdfbf$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label);
});
var $ef05a00bdd6bdfbf$export$8c5a050822fd698c = (0, $h2c1T.backgroundColor)({
    parseDOM: [
        {
            style: "background-color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $52rTH.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $ef05a00bdd6bdfbf$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: ".fabric-background-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $ef05a00bdd6bdfbf$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $aYDRF.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $803ek.getGlobalTheme)().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $23OHV.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, $2VHRc.default)({
                class: "fabric-background-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-background-custom-color", mark.attrs.color)
        ];
    }
});

});
parcelRegister("803ek", function(module, exports) {

$parcel$export(module.exports, "getGlobalTheme", function () { return $5d30d43cda445d16$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $5d30d43cda445d16$export$32f78bffcd82ff28; });

var $2VHRc = parcelRequire("2VHRc");

var $gkaEr = parcelRequire("gkaEr");

var $h2c1T = parcelRequire("h2c1T");

var $aYDRF = parcelRequire("aYDRF");

var $52rTH = parcelRequire("52rTH");

var $23OHV = parcelRequire("23OHV");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $5d30d43cda445d16$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $52rTH.B500),
        "Dark blue"
    ],
    // Chore coat
    [
        (0, $52rTH.T500),
        "Dark teal"
    ],
    // Shabby chic
    [
        (0, $52rTH.G500),
        "Dark green"
    ],
    // Keen green
    [
        (0, $52rTH.Y400),
        "Orange"
    ],
    // Cheezy blasters
    [
        (0, $52rTH.R500),
        "Dark red"
    ],
    // Dragon's blood
    [
        (0, $52rTH.P500),
        "Dark purple"
    ],
    // Prince
    // row 2
    [
        (0, $52rTH.N80),
        "Light gray"
    ],
    // Spooky ghost
    [
        (0, $52rTH.B100),
        "Blue"
    ],
    // Arvo breeze
    [
        (0, $52rTH.T300),
        "Teal"
    ],
    // Tamarama
    [
        (0, $52rTH.G300),
        "Green"
    ],
    // Fine pine
    [
        (0, $52rTH.Y200),
        "Yellow"
    ],
    // Pub mix
    [
        (0, $52rTH.R300),
        "Red"
    ],
    // Poppy surprise
    [
        (0, $52rTH.P300),
        "Purple"
    ],
    // Da' juice
    // row 3
    [
        (0, $52rTH.N0),
        "White"
    ],
    [
        (0, $52rTH.B75),
        "Light blue"
    ],
    // Schwag
    [
        (0, $52rTH.T75),
        "Light teal"
    ],
    // Arctic chill
    [
        (0, $52rTH.G75),
        "Light green"
    ],
    // Mintie
    [
        (0, $52rTH.Y75),
        "Light yellow"
    ],
    // Dandelion whisper
    [
        (0, $52rTH.R75),
        "Light red"
    ],
    // Bondi sunburn
    [
        (0, $52rTH.P50),
        "Light purple"
    ] // Lavender secret
];
var $5d30d43cda445d16$export$569885e57444f84a = new Map();
var $5d30d43cda445d16$export$81e5ed9e84fe2e28 = $5d30d43cda445d16$export$569885e57444f84a;
$5d30d43cda445d16$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $gkaEr.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $5d30d43cda445d16$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $5d30d43cda445d16$var$testGlobalTheme;
var $5d30d43cda445d16$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $5d30d43cda445d16$var$testGlobalTheme = theme;
};
var $5d30d43cda445d16$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($5d30d43cda445d16$var$testGlobalTheme) return {
        colorMode: $5d30d43cda445d16$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $5d30d43cda445d16$export$32f78bffcd82ff28 = (0, $h2c1T.textColor)({
    parseDOM: [
        {
            style: "color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $52rTH.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $5d30d43cda445d16$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: ".fabric-text-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $5d30d43cda445d16$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $aYDRF.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($5d30d43cda445d16$export$813ecdf77207a053().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $23OHV.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, $2VHRc.default)({
                class: "fabric-text-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-text-custom-color", mark.attrs.color)
        ];
    }
});

});


parcelRegister("jMlcd", function(module, exports) {

$parcel$export(module.exports, "border", function () { return $e662f117b583d09b$export$1edee58a52776cd9; });

var $gkaEr = parcelRequire("gkaEr");

var $h2c1T = parcelRequire("h2c1T");

var $aYDRF = parcelRequire("aYDRF");

var $52rTH = parcelRequire("52rTH");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $e662f117b583d09b$var$borderColorArrayPalette = [
    [
        (0, $52rTH.N300A),
        "Subtle gray"
    ],
    [
        (0, $52rTH.N600),
        "Gray"
    ],
    [
        (0, $52rTH.N1000),
        "Bold gray"
    ]
];
var $e662f117b583d09b$export$e4e044c989c86ca7 = new Map();
$e662f117b583d09b$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $gkaEr.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $e662f117b583d09b$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $e662f117b583d09b$export$1edee58a52776cd9 = (0, $h2c1T.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute("data-color")) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : "").toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute("data-size")) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : "0");
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $e662f117b583d09b$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? "span" : "div";
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $aYDRF.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                "data-mark-type": "border",
                "data-color": mark.attrs.color,
                "data-size": mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("dWcku", function(module, exports) {

$parcel$export(module.exports, "breakout", function () { return $a25a41895e9a47b4$export$89015c65f1c75e3f; });

var $h2c1T = parcelRequire("h2c1T");
var $a25a41895e9a47b4$var$allowedTypes = [
    "wide",
    "full-width"
];
var $a25a41895e9a47b4$export$89015c65f1c75e3f = (0, $h2c1T.breakout)({
    parseDOM: [
        {
            tag: "div.fabric-editor-breakout-mark",
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute("data-mode");
                var width = dom.getAttribute("data-width");
                return {
                    mode: $a25a41895e9a47b4$var$allowedTypes.indexOf(mode || "") === -1 ? "wide" : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            "div",
            {
                class: "fabric-editor-breakout-mark",
                "data-mode": mark.attrs.mode,
                "data-width": (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("gArxa", function(module, exports) {

$parcel$export(module.exports, "code", function () { return $c1355dd220c29f4a$export$6565f9f03506010b; });

var $h2c1T = parcelRequire("h2c1T");
var $c1355dd220c29f4a$export$6565f9f03506010b = (0, $h2c1T.code)({
    parseDOM: [
        {
            tag: "span.code",
            preserveWhitespace: true
        },
        {
            tag: "code",
            preserveWhitespace: true
        },
        {
            tag: "tt",
            preserveWhitespace: true
        },
        {
            tag: "span",
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre") return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "span",
            {
                class: "code",
                spellcheck: "false"
            }
        ];
    }
});

});

parcelRegister("fzcos", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", function () { return $b553bd00756d7d5d$export$f3b72f8fc4684ecd; });

var $h2c1T = parcelRequire("h2c1T");
var $b553bd00756d7d5d$export$f3b72f8fc4684ecd = (0, $h2c1T.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("lkXN0", function(module, exports) {

$parcel$export(module.exports, "em", function () { return $f889d82532e3cf6c$export$c63c6f932822f543; });

var $h2c1T = parcelRequire("h2c1T");
/**
 * @name em_mark
 */ var $f889d82532e3cf6c$var$emDOM = [
    "em"
];
var $f889d82532e3cf6c$export$c63c6f932822f543 = (0, $h2c1T.em)({
    parseDOM: [
        {
            tag: "i"
        },
        {
            tag: "em"
        },
        {
            style: "font-style=italic"
        }
    ],
    toDOM: function toDOM() {
        return $f889d82532e3cf6c$var$emDOM;
    }
});

});

parcelRegister("l8Enp", function(module, exports) {

$parcel$export(module.exports, "indentation", function () { return $f639aa4b2c1f6954$export$480c699bd4ec0d86; });

var $h2c1T = parcelRequire("h2c1T");
var $f639aa4b2c1f6954$export$480c699bd4ec0d86 = (0, $h2c1T.indentation)({
    parseDOM: [
        {
            tag: "div.fabric-editor-indentation-mark",
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute("data-level") || "0");
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-indentation-mark",
                "data-level": mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("lgm9Y", function(module, exports) {

$parcel$export(module.exports, "strike", function () { return $f7ac481782a7d915$export$4899a95d70ec5056; });

var $h2c1T = parcelRequire("h2c1T");
var $f7ac481782a7d915$export$4899a95d70ec5056 = (0, $h2c1T.strike)({
    parseDOM: [
        {
            tag: "strike"
        },
        {
            tag: "s"
        },
        {
            tag: "del"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "line-through" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "s"
        ];
    }
});

});

parcelRegister("aXHcE", function(module, exports) {

$parcel$export(module.exports, "strong", function () { return $7fb0ed4fbf2a7e6d$export$59ae2c325a998f89; });

var $h2c1T = parcelRequire("h2c1T");
/**
 * @name strong_mark
 */ var $7fb0ed4fbf2a7e6d$var$strongDOM = [
    "strong"
];
var $7fb0ed4fbf2a7e6d$export$59ae2c325a998f89 = (0, $h2c1T.strong)({
    parseDOM: [
        {
            tag: "strong"
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: "b",
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== "normal" && null;
            }
        },
        {
            tag: "span",
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === "string" && (fontWeight === "bold" || fontWeight === "bolder" || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $7fb0ed4fbf2a7e6d$var$strongDOM;
    }
});

});

parcelRegister("7cIFM", function(module, exports) {

$parcel$export(module.exports, "subsup", function () { return $53ec4e81f6948807$export$b3401ee80eb31041; });

var $h2c1T = parcelRequire("h2c1T");
/**
 * @name subsup_mark
 */ function $53ec4e81f6948807$var$getAttrFromVerticalAlign(node) {
    if (node === "sub") return {
        type: "sub"
    };
    if (node === "super") return {
        type: "sup"
    };
    return false;
}
var $53ec4e81f6948807$export$b3401ee80eb31041 = (0, $h2c1T.subsup)({
    parseDOM: [
        {
            tag: "sub",
            attrs: {
                type: "sub"
            }
        },
        {
            tag: "sup",
            attrs: {
                type: "sup"
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: "vertical-align=super",
            getAttrs: function getAttrs(node) {
                return $53ec4e81f6948807$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: "vertical-align=sub",
            getAttrs: function getAttrs(node) {
                return $53ec4e81f6948807$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("j3QbZ", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", function () { return $de06c8702d87529c$export$20af3dabbb5538df; });

var $h2c1T = parcelRequire("h2c1T");

var $52rTH = parcelRequire("52rTH");
var $de06c8702d87529c$export$20af3dabbb5538df = (0, $h2c1T.typeAheadQuery)({
    parseDOM: [
        {
            tag: "span[data-type-ahead-query]"
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-type-ahead-query": "true",
                "data-trigger": node.attrs.trigger,
                style: "color: ".concat((0, $52rTH.B400))
            }
        ];
    }
});

});

parcelRegister("4RiRA", function(module, exports) {

$parcel$export(module.exports, "underline", function () { return $389abe88a6870a9f$export$425327af25286e5e; });

var $h2c1T = parcelRequire("h2c1T");
var $389abe88a6870a9f$export$425327af25286e5e = (0, $h2c1T.underline)({
    parseDOM: [
        {
            tag: "u"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "underline" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "u"
        ];
    }
});

});

parcelRegister("5an7V", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", function () { return $3c2fd3705c72785c$export$30d78d5eb6719bb8; });

var $h2c1T = parcelRequire("h2c1T");
var $3c2fd3705c72785c$export$30d78d5eb6719bb8 = (0, $h2c1T.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            "span"
        ];
    }
});

});

parcelRegister("dRnD7", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $a1728e0033b6e427$export$a316dc07ff5182a2; });

var $h2c1T = parcelRequire("h2c1T");
var $a1728e0033b6e427$export$a316dc07ff5182a2 = (0, $h2c1T.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            "span"
        ];
    }
});

});

parcelRegister("5NuaV", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $4388ef8b72788a4b$export$c4c2f833baaebdb8; });

var $2VHRc = parcelRequire("2VHRc");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $4388ef8b72788a4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4388ef8b72788a4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4388ef8b72788a4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4388ef8b72788a4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $4388ef8b72788a4b$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute("data-card-data");
    var datasource = anchor.getAttribute("data-datasource");
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute("data-layout") || undefined : undefined,
        width: Number(dom.getAttribute("data-width")) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $4388ef8b72788a4b$export$c4c2f833baaebdb8 = (0, $gtPcq.blockCard)({
    parseDOM: [
        {
            tag: "a[data-block-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4388ef8b72788a4b$var$_objectSpread({
                    url: anchor.getAttribute("href") || undefined
                }, $4388ef8b72788a4b$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: "div[data-block-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4388ef8b72788a4b$var$_objectSpread({
                    url: anchor.getAttribute("data-card-url") || undefined
                }, $4388ef8b72788a4b$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            "data-block-card": "",
            href: url || "",
            "data-card-data": data ? JSON.stringify(data) : "",
            "data-datasource": datasource ? JSON.stringify(datasource) : "",
            "data-layout": layout,
            "data-width": "".concat(width)
        };
        return [
            "a",
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || " "
        ];
    }
});
var $4388ef8b72788a4b$export$9894f24949f094e5 = (0, $gtPcq.blockCard)({
    parseDOM: [
        {
            tag: "a[data-block-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4388ef8b72788a4b$var$_objectSpread($4388ef8b72788a4b$var$_objectSpread({
                    url: anchor.getAttribute("href") || undefined
                }, $4388ef8b72788a4b$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        },
        {
            tag: "div[data-block-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4388ef8b72788a4b$var$_objectSpread($4388ef8b72788a4b$var$_objectSpread({
                    url: anchor.getAttribute("data-card-url") || undefined
                }, $4388ef8b72788a4b$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            "data-block-card": "",
            href: url || "",
            "data-card-data": data ? JSON.stringify(data) : "",
            "data-datasource": datasource ? JSON.stringify(datasource) : "",
            "data-layout": layout,
            "data-width": "".concat(width),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            "a",
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || " "
        ];
    }
});

});

parcelRegister("8MBWr", function(module, exports) {

$parcel$export(module.exports, "taskItem", function () { return $66503cdb2c66d7b9$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "blockTaskItem", function () { return $66503cdb2c66d7b9$export$16018c61064a18df; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
var $66503cdb2c66d7b9$export$6d8b0ef52e2e6390 = (0, $gtPcq.taskItem)({
    parseDOM: [
        {
            tag: "div[data-task-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $7fOn1.uuid).generate(),
                    state: dom.getAttribute("data-task-state") || "TODO"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-task-local-id": localId || "local-task",
            "data-task-state": state || "TODO"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $66503cdb2c66d7b9$export$16018c61064a18df = (0, $gtPcq.blockTaskItem)({
    parseDOM: [
        {
            tag: "div[data-task-is-block]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $7fOn1.uuid).generate(),
                    state: dom.getAttribute("data-task-state") || "TODO"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            "data-task-local-id": localId || "local-task",
            "data-task-state": state || "TODO",
            "data-task-is-block": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("bfXJM", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", function () { return $831f6f0a4e17595b$export$27903d543b563e39; });

var $j03XP = parcelRequire("j03XP");

var $gtPcq = parcelRequire("gtPcq");
var $831f6f0a4e17595b$export$27903d543b563e39 = (0, $gtPcq.bodiedExtension)({
    parseDOM: [
        {
            context: "bodiedExtension//",
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $j03XP.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "bodied-extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("hnesC", function(module, exports) {

$parcel$export(module.exports, "bulletList", function () { return $ca5fcd3f12d43596$export$a140c94e5ea26bee; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
var $ca5fcd3f12d43596$export$5f25a39efab3b58b = ".ak-ul";
var $ca5fcd3f12d43596$export$a140c94e5ea26bee = (0, $gtPcq.bulletList)({
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $ca5fcd3f12d43596$export$5f25a39efab3b58b.substr(1)
        };
        return [
            "ul",
            attrs,
            0
        ];
    }
});
var $ca5fcd3f12d43596$export$dfd406053b2bab40 = (0, $gtPcq.bulletList)({
    parseDOM: [
        {
            tag: "ul",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $ca5fcd3f12d43596$export$5f25a39efab3b58b.substr(1),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "ul",
            attrs,
            0
        ];
    }
});

});

parcelRegister("9blJR", function(module, exports) {

$parcel$export(module.exports, "caption", function () { return $6af601008913b678$export$8e3c2dfdc4f0453d; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $6af601008913b678$export$8e3c2dfdc4f0453d = (0, $gtPcq.caption)({
    parseDOM: [
        {
            tag: "figcaption[data-caption]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-caption": "true"
        };
        return [
            "figcaption",
            attrs,
            0
        ];
    }
});
var $6af601008913b678$export$b5d01ee303c467aa = (0, $gtPcq.caption)({
    parseDOM: [
        {
            tag: "figcaption[data-caption]",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-caption": "true",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "figcaption",
            attrs,
            0
        ];
    }
});

});

parcelRegister("9ZIAY", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", function () { return $746c6742f49af9a0$export$daf889beb5092f95; });

var $gtPcq = parcelRequire("gtPcq");
var $746c6742f49af9a0$var$name = "confluenceJiraIssue";
var $746c6742f49af9a0$export$daf889beb5092f95 = (0, $gtPcq.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: 'span[data-node-type="'.concat($746c6742f49af9a0$var$name, '"]'),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $746c6742f49af9a0$var$name,
            "data-macro-id": node.attrs.macroId,
            "data-schema-version": node.attrs.schemaVersion,
            "data-server": node.attrs.server,
            "data-server-id": node.attrs.serverId,
            "data-jira-issue": node.attrs.issueKey
        };
        return [
            "span",
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("WJKE3", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $0b08e828384d4efd$export$e6e4878f43c27cab; });

var $gtPcq = parcelRequire("gtPcq");
var $0b08e828384d4efd$var$name = "confluenceUnsupportedBlock";
var $0b08e828384d4efd$export$e6e4878f43c27cab = (0, $gtPcq.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            "data-node-type": $0b08e828384d4efd$var$name,
            "data-confluence-unsupported": "block",
            "data-confluence-unsupported-block-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($0b08e828384d4efd$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-block-cxhtml")
                };
            }
        }
    ]
});

});

parcelRegister("brv21", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $854a498ddc870b59$export$3e6d667072febc87; });

var $gtPcq = parcelRequire("gtPcq");
var $854a498ddc870b59$var$name = "confluenceUnsupportedInline";
var $854a498ddc870b59$export$3e6d667072febc87 = (0, $gtPcq.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $854a498ddc870b59$var$name,
            "data-confluence-unsupported": "inline",
            "data-confluence-unsupported-inline-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($854a498ddc870b59$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-inline-cxhtml")
                };
            }
        }
    ]
});

});

parcelRegister("ldwFL", function(module, exports) {

$parcel$export(module.exports, "date", function () { return $f72427f23b779138$export$324d90190a8b822a; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $f72427f23b779138$export$324d90190a8b822a = (0, $gtPcq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute("data-timestamp")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "date",
            "data-timestamp": node.attrs.timestamp
        };
        return [
            "span",
            attrs
        ];
    }
});
var $f72427f23b779138$export$a6a035390e3921b2 = (0, $gtPcq.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute("data-timestamp"),
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-node-type": "date",
            "data-timestamp": node.attrs.timestamp,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "span",
            attrs
        ];
    }
});

});

parcelRegister("ajcOO", function(module, exports) {

$parcel$export(module.exports, "decisionItem", function () { return $78159f3f13a3b12e$export$6959e16eeff859b4; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
var $78159f3f13a3b12e$export$6959e16eeff859b4 = (0, $gtPcq.decisionItem)({
    parseDOM: [
        {
            tag: "li[data-decision-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $7fOn1.uuid).generate(),
                    state: dom.getAttribute("data-decision-state")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-decision-local-id": localId || "local-decision",
            "data-decision-state": state
        };
        return [
            "li",
            attrs,
            0
        ];
    }
});

});

parcelRegister("h01Ec", function(module, exports) {

$parcel$export(module.exports, "decisionList", function () { return $c603b6e77efe888d$export$62d45a65fb43d95e; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
/**
 * @name decisionList_node
 */ var $c603b6e77efe888d$var$name = "decisionList";
var $c603b6e77efe888d$export$a5393ce68c2ff601 = '[data-node-type="'.concat($c603b6e77efe888d$var$name, '"]');
var $c603b6e77efe888d$export$62d45a65fb43d95e = (0, $gtPcq.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($c603b6e77efe888d$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $c603b6e77efe888d$var$name,
            "data-decision-list-local-id": localId || "local-decision-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("cImFj", function(module, exports) {

$parcel$export(module.exports, "doc", function () { return $941b2cf50f719d95$export$2a111da947c407d2; });

var $gtPcq = parcelRequire("gtPcq");
var $941b2cf50f719d95$export$2a111da947c407d2 = (0, $gtPcq.doc)({});

});

parcelRegister("8kfDk", function(module, exports) {

$parcel$export(module.exports, "embedCard", function () { return $60fc5170e7a108d5$export$be4283d9a1cb1ff6; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $60fc5170e7a108d5$export$be4283d9a1cb1ff6 = (0, $gtPcq.embedCard)({
    parseDOM: [
        {
            tag: "div[data-embed-card]",
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute("data-card-url"),
                    layout: dom.getAttribute("data-layout") || "center",
                    width: Number(dom.getAttribute("data-width")) || null,
                    originalWidth: Number(dom.getAttribute("data-card-original-width")) || null,
                    originalHeight: Number(dom.getAttribute("data-card-original-height")) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            "data-embed-card": "",
            "data-card-url": url,
            "data-layout": layout,
            "data-width": width,
            "data-original-width": originalWidth,
            "data-original-height": originalHeight
        };
        return [
            "div",
            attrs
        ];
    }
});
var $60fc5170e7a108d5$export$36734475a7f6fd3e = (0, $gtPcq.embedCard)({
    parseDOM: [
        {
            tag: "div[data-embed-card]",
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute("data-card-url"),
                    layout: dom.getAttribute("data-layout") || "center",
                    width: Number(dom.getAttribute("data-width")) || null,
                    originalWidth: Number(dom.getAttribute("data-card-original-width")) || null,
                    originalHeight: Number(dom.getAttribute("data-card-original-height")) || null,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            "data-embed-card": "",
            "data-card-url": url,
            "data-layout": layout,
            "data-width": width,
            "data-original-width": originalWidth,
            "data-original-height": originalHeight,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            "div",
            attrs
        ];
    }
});

});

parcelRegister("8knNh", function(module, exports) {

$parcel$export(module.exports, "emoji", function () { return $6102a5f075943d61$export$a19185d1233fc4b2; });

var $2VHRc = parcelRequire("2VHRc");

var $7pnjq = parcelRequire("7pnjq");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $6102a5f075943d61$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6102a5f075943d61$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6102a5f075943d61$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6102a5f075943d61$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6102a5f075943d61$export$a19185d1233fc4b2 = (0, $gtPcq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: "div.ak-editor-panel__icon span",
            ignore: true
        },
        {
            tag: "span[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: "img[data-emoticon-name]",
            getAttrs: function getAttrs(dom) {
                return (0, $7pnjq.acNameToEmoji)(dom.getAttribute("data-emoticon-name"));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: "img[data-hipchat-emoticon]",
            getAttrs: function getAttrs(dom) {
                return (0, $7pnjq.acShortcutToEmoji)(dom.getAttribute("data-hipchat-emoticon"));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: "img.emoji[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            "data-emoji-short-name": shortName,
            "data-emoji-id": id,
            "data-emoji-text": text,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $6102a5f075943d61$export$ebb3b3c7a0ac9936 = (0, $gtPcq.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: "div.ak-editor-panel__icon span",
            ignore: true
        },
        {
            tag: "span[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: "img[data-emoticon-name]",
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $7pnjq.acNameToEmoji)(dom.getAttribute("data-emoticon-name"));
                return $6102a5f075943d61$var$_objectSpread($6102a5f075943d61$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: "img[data-hipchat-emoticon]",
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $7pnjq.acShortcutToEmoji)(dom.getAttribute("data-hipchat-emoticon"));
                return $6102a5f075943d61$var$_objectSpread($6102a5f075943d61$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $7fOn1.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: "img.emoji[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $6102a5f075943d61$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            "data-emoji-short-name": shortName,
            "data-emoji-id": id,
            "data-emoji-text": text,
            contenteditable: "false",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});
parcelRegister("7pnjq", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", function () { return $564cf3874d4fd34e$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $564cf3874d4fd34e$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $564cf3874d4fd34e$var$DEFAULT_EMOJI_ID = "2b50";
// Default ac:name for emoticons as a fallback is `blue-star`
var $564cf3874d4fd34e$var$DEFAULT_EMOJI_ACNAME = "blue-star";
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $564cf3874d4fd34e$var$HC_EMOTICON_PREFIX = "atlassian-";
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $564cf3874d4fd34e$var$acNameToEmojiMap = {
    smile: [
        "1f642",
        ":slight_smile:",
        "\uD83D\uDE42"
    ],
    sad: [
        "1f641",
        ":slight_frown:",
        "\uD83D\uDE41"
    ],
    cheeky: [
        "1f61b",
        ":stuck_out_tongue:",
        "\uD83D\uDE1B"
    ],
    laugh: [
        "1f600",
        ":grinning:",
        "\uD83D\uDE00"
    ],
    wink: [
        "1f609",
        ":wink:",
        "\uD83D\uDE09"
    ],
    information: [
        "2139",
        ":information_source:",
        "\u2139"
    ],
    tick: [
        "2705",
        ":white_check_mark:",
        "\u2705"
    ],
    cross: [
        "274c",
        ":x:",
        "\u274C"
    ],
    warning: [
        "26a0",
        ":warning:",
        "\u26A0"
    ],
    plus: [
        "2795",
        ":heavy_plus_sign:",
        "\u2795"
    ],
    minus: [
        "2796",
        ":heavy_minus_sign:",
        "\u2796"
    ],
    question: [
        "2753",
        ":question:",
        "?"
    ],
    "thumbs-up": [
        "1f44d",
        ":thumbsup:",
        "\uD83D\uDC4D"
    ],
    "thumbs-down": [
        "1f44e",
        ":thumbsdown:",
        "\uD83D\uDC4E"
    ],
    "light-on": [
        "1f4a1",
        ":bulb:",
        "\uD83D\uDCA1"
    ],
    "yellow-star": [
        "2b50",
        ":star:",
        "\uD83D\uDC9B"
    ],
    "light-off": [
        "1f6ab",
        ":no_entry_sign:",
        "\uD83D\uDEAB"
    ],
    "red-star": [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "green-star": [
        "1f49a",
        ":green_heart:",
        "\uD83D\uDC9A"
    ],
    "blue-star": [
        "1f499",
        ":blue_heart:",
        "\uD83D\uDC99"
    ],
    heart: [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "broken-heart": [
        "1f494",
        ":broken_heart:",
        "\uD83D\uDC94"
    ]
};
function $564cf3874d4fd34e$export$f61e93bda2a8b420(acName) {
    var emojiData = $564cf3874d4fd34e$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $564cf3874d4fd34e$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ""
    };
}
function $564cf3874d4fd34e$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $564cf3874d4fd34e$var$acNameToEmojiMap[acName] ? $564cf3874d4fd34e$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($564cf3874d4fd34e$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $564cf3874d4fd34e$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($564cf3874d4fd34e$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ""
    };
}
function $564cf3874d4fd34e$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ":" ? 1 : 0, shortName[shortName.length - 1] === ":" ? -1 : shortName.length);
}
function $564cf3874d4fd34e$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($564cf3874d4fd34e$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $564cf3874d4fd34e$var$getAcNameFromShortName(shortName);
        if (possibleName in $564cf3874d4fd34e$var$acNameToEmojiMap) return possibleName;
    }
    return $564cf3874d4fd34e$export$bc94e44ec0e7bd82(id) || $564cf3874d4fd34e$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("4FCN7", function(module, exports) {

$parcel$export(module.exports, "extendedBlockquote", function () { return $366914e492177005$export$70a64939da3e8455; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
/**
 * @name blockquote_node
 */ var $366914e492177005$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: "blockquote"
        }
    ],
    toDOM: function toDOM() {
        return [
            "blockquote",
            0
        ];
    }
};
var $366914e492177005$export$67dc04e652a298ca = (0, $gtPcq.blockquoteLegacy)($366914e492177005$var$nodeSpecOptions);
var $366914e492177005$export$70a64939da3e8455 = (0, $gtPcq.blockquote)($366914e492177005$var$nodeSpecOptions);
var $366914e492177005$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "blockquote",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            "blockquote",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $366914e492177005$export$950ebf43f3364a0f = (0, $gtPcq.blockquote)($366914e492177005$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("aMswM", function(module, exports) {

$parcel$export(module.exports, "extendedPanel", function () { return $7d948410e8dcb14e$export$ce20b13564211141; });

var $2VHRc = parcelRequire("2VHRc");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $7d948410e8dcb14e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d948410e8dcb14e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d948410e8dcb14e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d948410e8dcb14e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7d948410e8dcb14e$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $7d948410e8dcb14e$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        "data-panel-type": nodeAttrs.panelType,
        "data-panel-icon": nodeAttrs.panelIcon,
        "data-panel-icon-id": nodeAttrs.panelIconId,
        "data-panel-icon-text": nodeAttrs.panelIconText,
        "data-panel-color": nodeAttrs.panelColor,
        "data-local-id": (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $7d948410e8dcb14e$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute("data-panel-type")
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $7fOn1.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $7d948410e8dcb14e$var$_objectSpread($7d948410e8dcb14e$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute("data-panel-icon"),
        panelIconId: dom.getAttribute("data-panel-icon-id"),
        panelIconText: dom.getAttribute("data-panel-icon-text"),
        panelColor: dom.getAttribute("data-panel-color")
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $7d948410e8dcb14e$export$969277cf61e5a7aa.CUSTOM ? $7d948410e8dcb14e$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $7d948410e8dcb14e$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: "div[data-panel-type]",
                getAttrs: function getAttrs(dom) {
                    return $7d948410e8dcb14e$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $7d948410e8dcb14e$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                "data-panel-content": "true"
            };
            return [
                "div",
                attrs,
                [
                    "div",
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $7d948410e8dcb14e$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $gtPcq.panel)($7d948410e8dcb14e$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $7d948410e8dcb14e$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $gtPcq.panel)($7d948410e8dcb14e$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("1sNoH", function(module, exports) {

$parcel$export(module.exports, "extension", function () { return $110eb948796e7a32$export$1b45514b112dd749; });

var $j03XP = parcelRequire("j03XP");

var $gtPcq = parcelRequire("gtPcq");
var $110eb948796e7a32$export$1b45514b112dd749 = (0, $gtPcq.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $j03XP.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs
        ];
    }
});

});

parcelRegister("h7IZm", function(module, exports) {

$parcel$export(module.exports, "hardBreak", function () { return $033794986899a38c$export$371da9dd35aba193; });

var $gtPcq = parcelRequire("gtPcq");
var $033794986899a38c$export$371da9dd35aba193 = (0, $gtPcq.hardBreak)({
    parseDOM: [
        {
            tag: "br"
        }
    ],
    toDOM: function toDOM() {
        return [
            "br"
        ];
    }
});

});

parcelRegister("a5tjA", function(module, exports) {

$parcel$export(module.exports, "heading", function () { return $75811c517347089c$export$46e4a324ac90507f; });

var $gtPcq = parcelRequire("gtPcq");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $75811c517347089c$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute("data-local-id") || ((_heading$attrs = $75811c517347089c$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $75811c517347089c$export$46e4a324ac90507f = (0, $gtPcq.heading)({
    parseDOM: [
        {
            tag: "h1",
            getAttrs: $75811c517347089c$var$getAttrs(1)
        },
        {
            tag: "h2",
            getAttrs: $75811c517347089c$var$getAttrs(2)
        },
        {
            tag: "h3",
            getAttrs: $75811c517347089c$var$getAttrs(3)
        },
        {
            tag: "h4",
            getAttrs: $75811c517347089c$var$getAttrs(4)
        },
        {
            tag: "h5",
            getAttrs: $75811c517347089c$var$getAttrs(5)
        },
        {
            tag: "h6",
            getAttrs: $75811c517347089c$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = "h" + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("amAmU", function(module, exports) {

$parcel$export(module.exports, "image", function () { return $78b82b756a95de28$export$5c452ff88e35e47d; });

var $gtPcq = parcelRequire("gtPcq");
var $78b82b756a95de28$export$5c452ff88e35e47d = (0, $gtPcq.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: "img[src]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute("src"),
                    alt: dom.getAttribute("alt"),
                    title: dom.getAttribute("title")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "img",
            node.attrs
        ];
    }
});

});

parcelRegister("eBrzV", function(module, exports) {

$parcel$export(module.exports, "inlineCard", function () { return $aa19e9e8cafd8265$export$cbf8224b64e0d942; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $aa19e9e8cafd8265$export$cbf8224b64e0d942 = (0, $gtPcq.inlineCard)({
    parseDOM: [
        {
            tag: "a[data-inline-card], span[data-inline-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute("href") || anchor.getAttribute("data-card-url") || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: "div[data-inline-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                return {
                    url: anchor.getAttribute("data-card-url"),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-inline-card": "",
            href: node.attrs.url || "",
            "data-card-data": node.attrs.data ? JSON.stringify(node.attrs.data) : ""
        };
        if (node.attrs.url) return [
            "a",
            attrs,
            node.attrs.url
        ];
        else return [
            "a",
            attrs
        ];
    }
});
var $aa19e9e8cafd8265$export$7ed775fc743eadd1 = (0, $gtPcq.inlineCard)({
    parseDOM: [
        {
            tag: "a[data-inline-card], span[data-inline-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute("href") || anchor.getAttribute("data-card-url") || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: "div[data-inline-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                return {
                    url: anchor.getAttribute("data-card-url"),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-inline-card": "",
            href: node.attrs.url || "",
            "data-card-data": node.attrs.data ? JSON.stringify(node.attrs.data) : "",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            "a",
            attrs,
            node.attrs.url
        ];
        else return [
            "a",
            attrs
        ];
    }
});

});

parcelRegister("k1uRN", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", function () { return $e93bd823d23ffa4f$export$16b353b2649bd8d9; });

var $j03XP = parcelRequire("j03XP");

var $gtPcq = parcelRequire("gtPcq");
var $e93bd823d23ffa4f$export$16b353b2649bd8d9 = (0, $gtPcq.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: "span[data-extension-type]",
            getAttrs: function getAttrs(domNode) {
                return (0, $j03XP.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-local-id:": node.attrs.localId,
            contenteditable: "false"
        };
        return [
            "span",
            attrs
        ];
    }
});

});

parcelRegister("7qgam", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", function () { return $567780604aabb5e9$export$ab76e7c03cd6f650; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $567780604aabb5e9$export$ab76e7c03cd6f650 = (0, $gtPcq.layoutColumn)({
    parseDOM: [
        {
            context: "layoutColumn//",
            tag: "div[data-layout-column]",
            skip: true
        },
        {
            tag: "div[data-layout-column]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute("data-column-width")) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-layout-column": "true"
        };
        var width = node.attrs.width;
        if (width) {
            attrs["style"] = "flex-basis: ".concat(width, "%");
            attrs["data-column-width"] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            "data-layout-content": "true"
        };
        return [
            "div",
            attrs,
            [
                "div",
                contentAttrs,
                0
            ]
        ];
    }
});
var $567780604aabb5e9$export$b2e27d292505bac2 = (0, $gtPcq.layoutColumn)({
    parseDOM: [
        {
            context: "layoutColumn//",
            tag: "div[data-layout-column]",
            skip: true
        },
        {
            tag: "div[data-layout-column]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute("data-column-width")) || undefined,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-layout-column": "true",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        var width = node.attrs.width;
        if (width) {
            attrs["style"] = "flex-basis: ".concat(width, "%");
            attrs["data-column-width"] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            "data-layout-content": "true"
        };
        return [
            "div",
            attrs,
            [
                "div",
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("4RA3Z", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", function () { return $38a81612c8d820e0$export$2855e964765eac9; });

var $gtPcq = parcelRequire("gtPcq");
var $38a81612c8d820e0$export$2855e964765eac9 = (0, $gtPcq.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": "mediaGroup"
            },
            0
        ];
    }
});

});

parcelRegister("GOuH7", function(module, exports) {

$parcel$export(module.exports, "mediaInline", function () { return $080b176de9ff6aaf$export$38bab695e3f720f1; });

var $2VHRc = parcelRequire("2VHRc");

var $dA2jn = parcelRequire("dA2jn");

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
function $080b176de9ff6aaf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $080b176de9ff6aaf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $080b176de9ff6aaf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $080b176de9ff6aaf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $080b176de9ff6aaf$export$38bab695e3f720f1 = (0, $dA2jn.createMediaSpec)((0, $gtPcq.mediaInline)({}).attrs, true);
var $080b176de9ff6aaf$export$aea8e9c496505c61 = (0, $dA2jn.createMediaSpec)($080b176de9ff6aaf$var$_objectSpread($080b176de9ff6aaf$var$_objectSpread({}, (0, $gtPcq.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $7fOn1.uuid).generate()
    }
}), true, true);

});

parcelRegister("dMOvb", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", function () { return $a096eeb1b398057b$export$63cadbf5f4296627; });

var $9ZNlu = parcelRequire("9ZNlu");

var $2VHRc = parcelRequire("2VHRc");

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
function $a096eeb1b398057b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a096eeb1b398057b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a096eeb1b398057b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $2VHRc.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a096eeb1b398057b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $a096eeb1b398057b$var$getExpandAttrs(domNode, generateLocalId) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true,
        localId: generateLocalId ? (0, $7fOn1.uuid).generate() : undefined
    };
}
var $a096eeb1b398057b$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: "nestedExpand//",
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $a096eeb1b398057b$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $a096eeb1b398057b$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-node-type": "nestedExpand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $a096eeb1b398057b$export$63cadbf5f4296627 = (0, $gtPcq.nestedExpand)($a096eeb1b398057b$var$nestedExpandFactoryOptions);
var $a096eeb1b398057b$export$b854197485aa1fa0 = (0, $gtPcq.nestedExpand)($a096eeb1b398057b$var$_objectSpread($a096eeb1b398057b$var$_objectSpread({}, $a096eeb1b398057b$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, $9ZNlu.default)($a096eeb1b398057b$var$nestedExpandFactoryOptions.parseDOM), [
        {
            context: "nestedExpand//",
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $a096eeb1b398057b$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $a096eeb1b398057b$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});
parcelRegister("9ZNlu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $747016942ec6bcb8$export$2e2bcd8739ae039; });

var $j5THO = parcelRequire("j5THO");

var $3k40E = parcelRequire("3k40E");

var $8DGYW = parcelRequire("8DGYW");

var $56mci = parcelRequire("56mci");
function $747016942ec6bcb8$export$2e2bcd8739ae039(r) {
    return (0, $j5THO.default)(r) || (0, $3k40E.default)(r) || (0, $8DGYW.default)(r) || (0, $56mci.default)();
}

});
parcelRegister("j5THO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de69b1ef8196c176$export$2e2bcd8739ae039; });

var $a2saW = parcelRequire("a2saW");
function $de69b1ef8196c176$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $a2saW.default)(r);
}

});

parcelRegister("3k40E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26b6598a95871834$export$2e2bcd8739ae039; });
function $26b6598a95871834$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("56mci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b6ebb3a025f246d$export$2e2bcd8739ae039; });
function $3b6ebb3a025f246d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("c1vLe", function(module, exports) {

$parcel$export(module.exports, "orderedListWithOrder", function () { return $8c0e371578f34638$export$b9ab759e8298198f; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
var $8c0e371578f34638$export$4e7125c7ff595be5 = ".ak-ol";
var $8c0e371578f34638$export$a5dc81035676e7a = (0, $gtPcq.orderedList)({
    parseDOM: [
        {
            tag: "ol"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $8c0e371578f34638$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
var $8c0e371578f34638$export$8157adc5747ec436 = (0, $gtPcq.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $8c0e371578f34638$export$4e7125c7ff595be5.substr(1),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $8c0e371578f34638$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $8c0e371578f34638$export$b9ab759e8298198f = (0, $gtPcq.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute("start");
                if (startDOMAttr) {
                    var start = $8c0e371578f34638$var$resolveStart(startDOMAttr);
                    if (typeof start === "number") return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $8c0e371578f34638$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === "number" ? String(start) : undefined,
            class: $8c0e371578f34638$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
var $8c0e371578f34638$export$2ea3505d41d7525d = (0, $gtPcq.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute("start");
                var localId = (0, $7fOn1.uuid).generate();
                if (startDOMAttr) {
                    var start = $8c0e371578f34638$var$resolveStart(startDOMAttr);
                    if (typeof start === "number") return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $8c0e371578f34638$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === "number" ? String(start) : undefined,
            class: $8c0e371578f34638$export$4e7125c7ff595be5.substr(1),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("9x4sf", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $6f0aa6b3b3ee5310$export$9c206ddddb32a9b; });

var $gtPcq = parcelRequire("gtPcq");
var $6f0aa6b3b3ee5310$export$9c206ddddb32a9b = (0, $gtPcq.paragraph)({
    parseDOM: [
        {
            tag: "p",
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute("data-local-id") || ((_paragraph$attrs = $6f0aa6b3b3ee5310$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = "p";
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("k5nLu", function(module, exports) {

$parcel$export(module.exports, "placeholder", function () { return $e9f6b57ea3982d2f$export$c7187bbd1a7a9244; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
var $e9f6b57ea3982d2f$export$c7187bbd1a7a9244 = (0, $gtPcq.placeholder)({
    parseDOM: [
        {
            tag: "span[data-placeholder]",
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute("data-placeholder") || $e9f6b57ea3982d2f$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            "data-placeholder": text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: "true"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $e9f6b57ea3982d2f$export$6205248609a8f7a0 = (0, $gtPcq.placeholder)({
    parseDOM: [
        {
            tag: "span[data-placeholder]",
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute("data-placeholder") || $e9f6b57ea3982d2f$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            "data-placeholder": text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: "true",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});

parcelRegister("cEUfF", function(module, exports) {

$parcel$export(module.exports, "rule", function () { return $9374dadd6e63d5c7$export$fbeb3a3956e8a3c7; });

var $gtPcq = parcelRequire("gtPcq");

var $7fOn1 = parcelRequire("7fOn1");
/**
 * @name rule_node
 */ var $9374dadd6e63d5c7$var$hrDOM = [
    "hr"
];
var $9374dadd6e63d5c7$export$fbeb3a3956e8a3c7 = (0, $gtPcq.rule)({
    parseDOM: [
        {
            tag: "hr"
        }
    ],
    toDOM: function toDOM() {
        return $9374dadd6e63d5c7$var$hrDOM;
    }
});
var $9374dadd6e63d5c7$export$bf3ef6fb6ad90e7 = (0, $gtPcq.rule)({
    parseDOM: [
        {
            tag: "hr",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            "hr",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("7drBE", function(module, exports) {

$parcel$export(module.exports, "status", function () { return $540f295833cf1eed$export$471f7ae5c4103ae1; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
var $540f295833cf1eed$export$471f7ae5c4103ae1 = (0, $gtPcq.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, "").trim(),
                    color: dom.getAttribute("data-color"),
                    localId: (0, $7fOn1.uuid).generate(),
                    style: dom.getAttribute("data-style")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            "data-node-type": "status",
            "data-color": color,
            "data-local-id": localId,
            "data-style": style,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});

parcelRegister("3Exd5", function(module, exports) {

$parcel$export(module.exports, "taskList", function () { return $2a8ede5c7996ef88$export$375b6afcc5f4d291; });

var $7fOn1 = parcelRequire("7fOn1");

var $gtPcq = parcelRequire("gtPcq");
/**
 * @name taskList_node
 */ var $2a8ede5c7996ef88$var$name = "actionList";
var $2a8ede5c7996ef88$export$c0ec71adb7a18fb2 = '[data-node-type="'.concat($2a8ede5c7996ef88$var$name, '"]');
var $2a8ede5c7996ef88$export$375b6afcc5f4d291 = (0, $gtPcq.taskList)({
    parseDOM: [
        {
            tag: "div".concat($2a8ede5c7996ef88$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $7fOn1.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $2a8ede5c7996ef88$var$name,
            "data-task-list-local-id": localId || "local-task-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("gRYNd", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $c480c0c4ec8d4fae$export$6f093cfa640b7166; });

var $gtPcq = parcelRequire("gtPcq");
var $c480c0c4ec8d4fae$export$6f093cfa640b7166 = (0, $gtPcq.text)({
    toDebugString: function() {
        return "text_node";
    }
});

});

parcelRegister("lNxQx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fde86dc5e993d316$export$2e2bcd8739ae039; });
var $fde86dc5e993d316$var$name = "unknownBlock";
var $fde86dc5e993d316$export$2e2bcd8739ae039 = {
    group: "block",
    content: "inline+",
    marks: "_",
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": $fde86dc5e993d316$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($fde86dc5e993d316$var$name, '"]')
        }
    ]
};

});

parcelRegister("lc2i3", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", function () { return $f6dc7ec272b1bc60$export$44b79b0979d0f0f7; });

var $gtPcq = parcelRequire("gtPcq");
var $f6dc7ec272b1bc60$export$44b79b0979d0f0f7 = (0, $gtPcq.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedBlock",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    }
});

});

parcelRegister("6nnv5", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", function () { return $4a471ebcd4f0a7bc$export$310ebe0d80122e9b; });

var $gtPcq = parcelRequire("gtPcq");
var $4a471ebcd4f0a7bc$export$310ebe0d80122e9b = (0, $gtPcq.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedInline",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "span",
            attrs,
            "Unsupported content"
        ];
    }
});

});



parcelRegister("buJff", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", function () { return $85e597c6863e0fa5$export$28e4e3c024cce988; });
var $85e597c6863e0fa5$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $85e597c6863e0fa5$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $85e597c6863e0fa5$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case "link":
        case "em":
        case "strong":
        case "strike":
        case "subsup":
        case "underline":
        case "code":
        case "textColor":
        case "backgroundColor":
        case "confluenceInlineComment":
        case "breakout":
        case "alignment":
        case "indentation":
        case "border":
            return $85e597c6863e0fa5$var$defaultAllowOverrideBehaviour;
        default:
            return $85e597c6863e0fa5$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("3muWh", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", function () { return $272b6d03eeefaa54$export$48b382180baf8e88; });

var $6THua = parcelRequire("6THua");

var $gNPkQ = parcelRequire("gNPkQ");

var $c2tSt = parcelRequire("c2tSt");

var $cpaLi = parcelRequire("cpaLi");
function $272b6d03eeefaa54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $272b6d03eeefaa54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $272b6d03eeefaa54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $272b6d03eeefaa54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $272b6d03eeefaa54$var$hasNestedTable = function hasNestedTable(tableCellNode) {
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some(function(node) {
        return (node === null || node === void 0 ? void 0 : node.type) === "table";
    });
};
function $272b6d03eeefaa54$export$48b382180baf8e88(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$keepNestedTa = options.keepNestedTables, keepNestedTables = _options$keepNestedTa === void 0 ? false : _options$keepNestedTa;
    var sanitizedJSON = (0, $c2tSt.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $272b6d03eeefaa54$var$_objectSpread($272b6d03eeefaa54$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== "typeAheadQuery";
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $cpaLi.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: function tableCell(node) {
            if ($272b6d03eeefaa54$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $gNPkQ.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: function tableHeader(node) {
            if ($272b6d03eeefaa54$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $gNPkQ.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $cpaLi.removeNonAnnotationMarks),
        mention: (0, $cpaLi.removeNonAnnotationMarks),
        date: (0, $cpaLi.removeNonAnnotationMarks),
        hardBreak: (0, $cpaLi.removeMarks),
        inlineCard: (0, $cpaLi.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("gNPkQ", function(module, exports) {

$parcel$export(module.exports, "transformNestedTablesIncomingDocument", function () { return $c3b90b090bae2de0$export$18544d0b5f43e4a1; });
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", function () { return $c3b90b090bae2de0$export$8a334a7d9fe120ec; });

var $6THua = parcelRequire("6THua");

var $c2tSt = parcelRequire("c2tSt");

var $jLapR = parcelRequire("jLapR");

var $7oEnv = parcelRequire("7oEnv");
function $c3b90b090bae2de0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c3b90b090bae2de0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c3b90b090bae2de0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c3b90b090bae2de0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c3b90b090bae2de0$var$NESTED_TABLE_EXTENSION_TYPE = "com.atlassian.confluence.migration", $c3b90b090bae2de0$var$NESTED_TABLE_EXTENSION_KEY = "nested-table";
var $c3b90b090bae2de0$export$f45e7335ec874bfe = function isNestedTableExtension(extensionNode) {
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $c3b90b090bae2de0$var$NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $c3b90b090bae2de0$var$NESTED_TABLE_EXTENSION_KEY;
};
var $c3b90b090bae2de0$var$transformNestedTableExtension = function transformNestedTableExtension(nestedTableExtension) {
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        var adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $7oEnv.NodeNestingTransformError)("Failed to parse nested table content");
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $c3b90b090bae2de0$var$isInsideBodiedExtension(parent) {
    var _parent$parent;
    if (parent.node === undefined) return false;
    if (parent.node.type === "bodiedExtension") return true;
    if (parent !== null && parent !== void 0 && (_parent$parent = parent.parent) !== null && _parent$parent !== void 0 && _parent$parent.node) return $c3b90b090bae2de0$var$isInsideBodiedExtension(parent.parent);
    return false;
}
var $c3b90b090bae2de0$export$18544d0b5f43e4a1 = function transformNestedTablesIncomingDocument(adf) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isTransformed = false;
    var transformedAdf = (0, $c2tSt.traverse)(adf, {
        extension: function extension(node, parent) {
            if ($c3b90b090bae2de0$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === "renderer" && $c3b90b090bae2de0$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $c3b90b090bae2de0$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
var $c3b90b090bae2de0$export$8a334a7d9fe120ec = function transformNestedTableNodeOutgoingDocument(tableCellNode) {
    try {
        var _tableCellNode$conten;
        return $c3b90b090bae2de0$var$_objectSpread($c3b90b090bae2de0$var$_objectSpread({}, tableCellNode), {}, {
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map(function(childNode) {
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === "table") return (0, $jLapR.extension)({
                    extensionType: $c3b90b090bae2de0$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $c3b90b090bae2de0$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: "doc",
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        });
    } catch (e) {
        throw new (0, $7oEnv.NodeNestingTransformError)("Failed to encode nested table node");
    }
};

});
parcelRegister("c2tSt", function(module, exports) {

$parcel$export(module.exports, "traverse", function () { return $8c3cd903b78c1bbb$export$df3f009e3d155b20; });

var $6THua = parcelRequire("6THua");
function $8c3cd903b78c1bbb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c3cd903b78c1bbb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c3cd903b78c1bbb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c3cd903b78c1bbb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8c3cd903b78c1bbb$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $8c3cd903b78c1bbb$export$df3f009e3d155b20(adf, visitors) {
    if (!$8c3cd903b78c1bbb$export$735cfea22ce30f58(visitors)) throw new Error('Visitors are not valid: "'.concat(Object.keys(visitors).join(", "), '"'));
    return $8c3cd903b78c1bbb$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $8c3cd903b78c1bbb$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors["any"];
    var newNode = $8c3cd903b78c1bbb$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($8c3cd903b78c1bbb$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $8c3cd903b78c1bbb$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("jLapR", function(module, exports) {

$parcel$export(module.exports, "extension", function () { return $e62a7c894358565e$export$1b45514b112dd749; });
var $e62a7c894358565e$export$1b45514b112dd749 = function extension(attrs) {
    return {
        type: "extension",
        attrs: attrs
    };
};

});

parcelRegister("7oEnv", function(module, exports) {

$parcel$export(module.exports, "NodeNestingTransformError", function () { return $562a188c36aef42c$export$3d8e8d2182f13924; });

var $ecJAY = parcelRequire("ecJAY");

var $cnuD2 = parcelRequire("cnuD2");

var $iiAZM = parcelRequire("iiAZM");

var $hxW36 = parcelRequire("hxW36");

var $a4x0H = parcelRequire("a4x0H");

var $hqdGY = parcelRequire("hqdGY");
function $562a188c36aef42c$var$_callSuper(t, o, e) {
    return o = (0, $hxW36.default)(o), (0, $iiAZM.default)(t, $562a188c36aef42c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hxW36.default)(t).constructor) : o.apply(t, e));
}
function $562a188c36aef42c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($562a188c36aef42c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $562a188c36aef42c$export$3d8e8d2182f13924 = /*#__PURE__*/ function(_Error) {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ function NodeNestingTransformError(message) {
        var _this;
        (0, $cnuD2.default)(this, NodeNestingTransformError);
        _this = $562a188c36aef42c$var$_callSuper(this, NodeNestingTransformError, [
            message
        ]);
        _this.name = "NodeNestingTransformError";
        return _this;
    }
    (0, $a4x0H.default)(NodeNestingTransformError, _Error);
    return (0, $ecJAY.default)(NodeNestingTransformError);
}(/*#__PURE__*/ (0, $hqdGY.default)(Error));

});


parcelRegister("cpaLi", function(module, exports) {

$parcel$export(module.exports, "removeMarks", function () { return $90802af02bb677fa$export$9bf001d8ef76e497; });
$parcel$export(module.exports, "removeNonAnnotationMarks", function () { return $90802af02bb677fa$export$8cae9126fc577085; });

var $6THua = parcelRequire("6THua");
function $90802af02bb677fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $90802af02bb677fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $90802af02bb677fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $6THua.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $90802af02bb677fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $90802af02bb677fa$export$9bf001d8ef76e497(node) {
    var newNode = $90802af02bb677fa$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}
function $90802af02bb677fa$export$8cae9126fc577085(node) {
    var newNode = $90802af02bb677fa$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === "annotation";
    });
    return newNode;
}

});




parcelRegister("bXM4W", function(module, exports) {

$parcel$export(module.exports, "AiMateMarkdownTransformer", function () { return $8b5a7fcf9b8443a9$export$614853bf2169db97; });

var $1xlxq = parcelRequire("1xlxq");

var $aOXmm = parcelRequire("aOXmm");

var $ikYff = parcelRequire("ikYff");

var $hHqa4 = parcelRequire("hHqa4");

var $7o3Z4 = parcelRequire("7o3Z4");

var $1yLHG = parcelRequire("1yLHG");

var $dRiR4 = parcelRequire("dRiR4");

var $cOqps = parcelRequire("cOqps");

var $6WBoi = parcelRequire("6WBoi");

var $dcNr3 = parcelRequire("dcNr3");

var $jxLBU = parcelRequire("jxLBU");

var $hiLjw = parcelRequire("hiLjw");

var $jy0KW = parcelRequire("jy0KW");

var $i9MpO = parcelRequire("i9MpO");

var $6IBtV = parcelRequire("6IBtV");

var $hCpnc = parcelRequire("hCpnc");

var $hyzpf = parcelRequire("hyzpf");

var $k3Mis = parcelRequire("k3Mis");

var $lE051 = parcelRequire("lE051");
function $8b5a7fcf9b8443a9$var$_callSuper(t, o, e) {
    return o = (0, $hHqa4.default)(o), (0, $ikYff.default)(t, $8b5a7fcf9b8443a9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hHqa4.default)(t).constructor) : o.apply(t, e));
}
function $8b5a7fcf9b8443a9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8b5a7fcf9b8443a9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $8b5a7fcf9b8443a9$export$614853bf2169db97 = /*#__PURE__*/ function(_MarkdownTransformer) {
    function AiMateMarkdownTransformer(schema, pluginConfig, streaming) {
        var _this;
        (0, $1xlxq.default)(this, AiMateMarkdownTransformer);
        _this = $8b5a7fcf9b8443a9$var$_callSuper(this, AiMateMarkdownTransformer);
        var md = (0, (/*@__PURE__*/$parcel$interopDefault($1yLHG)))("zero", {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            "entity",
            // Process escaped chars and hardbreaks
            "escape",
            "newline"
        ]);
        (0, $lE051.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $i9MpO.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $hiLjw.default));
        if ((0, $jxLBU.fg)("rovo_enable_data_sculptor")) md.use((0, $jy0KW.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $hyzpf.createSmartLinksPlugin)(pluginConfig.smartLinks));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $hCpnc.default));
        // Table support
        if (schema.nodes.table) md.use((0, $dRiR4.markdownItTable));
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $6IBtV.default));
        var filter = (0, $lE051.filterSchemaMapping)(schema, (0, $k3Mis.mdToPmSchema));
        _this.parser = new (0, $6WBoi.MarkdownParser)(schema, md, filter);
        return _this;
    }
    (0, $7o3Z4.default)(AiMateMarkdownTransformer, _MarkdownTransformer);
    return (0, $aOXmm.default)(AiMateMarkdownTransformer, [
        {
            key: "parse",
            value: function parse(content) {
                var node = this.parser.parse(content);
                if (!node) return new (0, $dcNr3.Node)();
                return node;
            }
        }
    ]);
}((0, $cOqps.MarkdownTransformer));

});
parcelRegister("1xlxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11e9948e895ca5c2$export$2e2bcd8739ae039; });
function $11e9948e895ca5c2$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aOXmm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e0c9e7f5b476269$export$2e2bcd8739ae039; });

var $9rQBU = parcelRequire("9rQBU");
function $7e0c9e7f5b476269$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9rQBU.default)(o.key), o);
    }
}
function $7e0c9e7f5b476269$export$2e2bcd8739ae039(e, r, t) {
    return r && $7e0c9e7f5b476269$var$_defineProperties(e.prototype, r), t && $7e0c9e7f5b476269$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("9rQBU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0f71ffac67ff18$export$2e2bcd8739ae039; });

var $cXFtm = parcelRequire("cXFtm");

var $fASqd = parcelRequire("fASqd");
function $6e0f71ffac67ff18$export$2e2bcd8739ae039(t) {
    var i = (0, $fASqd.default)(t, "string");
    return "symbol" == (0, $cXFtm.default)(i) ? i : i + "";
}

});
parcelRegister("cXFtm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96fb2a532b76b1a0$export$2e2bcd8739ae039; });
function $96fb2a532b76b1a0$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $96fb2a532b76b1a0$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $96fb2a532b76b1a0$export$2e2bcd8739ae039(o);
}

});

parcelRegister("fASqd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5a46ed890eebbaf$export$2e2bcd8739ae039; });

var $cXFtm = parcelRequire("cXFtm");
function $b5a46ed890eebbaf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $cXFtm.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $cXFtm.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ikYff", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d598d3a287cc8855$export$2e2bcd8739ae039; });

var $cXFtm = parcelRequire("cXFtm");

var $ie6Ix = parcelRequire("ie6Ix");
function $d598d3a287cc8855$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $cXFtm.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $ie6Ix.default)(t);
}

});
parcelRegister("ie6Ix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d44ebeb5361c9cab$export$2e2bcd8739ae039; });
function $d44ebeb5361c9cab$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hHqa4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ce2abef4e67af294$export$2e2bcd8739ae039; });
function $ce2abef4e67af294$export$2e2bcd8739ae039(t) {
    return $ce2abef4e67af294$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $ce2abef4e67af294$export$2e2bcd8739ae039(t);
}

});

parcelRegister("7o3Z4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $560ddd6ded0798a0$export$2e2bcd8739ae039; });

var $hntIm = parcelRequire("hntIm");
function $560ddd6ded0798a0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $hntIm.default)(t, e);
}

});
parcelRegister("hntIm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6ba253696f5fba$export$2e2bcd8739ae039; });
function $ca6ba253696f5fba$export$2e2bcd8739ae039(t, e) {
    return $ca6ba253696f5fba$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $ca6ba253696f5fba$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("1yLHG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7REiV"));

});
parcelRegister("7REiV", function(module, exports) {
// Main parser class
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");

var $dFtML = parcelRequire("dFtML");

var $iMmNk = parcelRequire("iMmNk");

var $aTisr = parcelRequire("aTisr");

var $28fdg = parcelRequire("28fdg");

var $kSn8M = parcelRequire("kSn8M");

var $btK9F = parcelRequire("btK9F");

var $daLid = parcelRequire("daLid");

var $4oriI = parcelRequire("4oriI");



var $5b9cbf338d02597f$var$config = {
    default: (parcelRequire("hovff")),
    zero: (parcelRequire("hp7z1")),
    commonmark: (parcelRequire("91F03"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $5b9cbf338d02597f$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $5b9cbf338d02597f$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $5b9cbf338d02597f$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $5b9cbf338d02597f$var$BAD_PROTO_RE.test(str) ? $5b9cbf338d02597f$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $5b9cbf338d02597f$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $5b9cbf338d02597f$var$normalizeLink(url) {
    var parsed = $daLid.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5b9cbf338d02597f$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $4oriI.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $daLid.encode($daLid.format(parsed));
}
function $5b9cbf338d02597f$var$normalizeLinkText(url) {
    var parsed = $daLid.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $5b9cbf338d02597f$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $4oriI.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $daLid.decode($daLid.format(parsed), $daLid.decode.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $5b9cbf338d02597f$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $5b9cbf338d02597f$var$MarkdownIt)) return new $5b9cbf338d02597f$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$kx3Xx.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $kSn8M();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $28fdg();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $aTisr();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $iMmNk();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $btK9F();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $5b9cbf338d02597f$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $5b9cbf338d02597f$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $5b9cbf338d02597f$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $kx3Xx;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $kx3Xx.assign({}, $dFtML);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.set = function(options) {
    $kx3Xx.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($kx3Xx.isString(presets)) {
        presetName = presets;
        presets = $5b9cbf338d02597f$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $5b9cbf338d02597f$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $5b9cbf338d02597f$var$MarkdownIt;

});
parcelRegister("kx3Xx", function(module, exports) {

$parcel$export(module.exports, "lib", function () { return $ef29f5f5a5951bb2$export$16c08b91f883959a; }, function (v) { return $ef29f5f5a5951bb2$export$16c08b91f883959a = v; });
$parcel$export(module.exports, "assign", function () { return $ef29f5f5a5951bb2$export$e6e34fd1f2686227; }, function (v) { return $ef29f5f5a5951bb2$export$e6e34fd1f2686227 = v; });
$parcel$export(module.exports, "isString", function () { return $ef29f5f5a5951bb2$export$844ec244b1367d54; }, function (v) { return $ef29f5f5a5951bb2$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "has", function () { return $ef29f5f5a5951bb2$export$a4f4bb6b1453fff5; }, function (v) { return $ef29f5f5a5951bb2$export$a4f4bb6b1453fff5 = v; });
$parcel$export(module.exports, "unescapeMd", function () { return $ef29f5f5a5951bb2$export$5ccde1ea0c14bb03; }, function (v) { return $ef29f5f5a5951bb2$export$5ccde1ea0c14bb03 = v; });
$parcel$export(module.exports, "unescapeAll", function () { return $ef29f5f5a5951bb2$export$db8a17c6655f7e2c; }, function (v) { return $ef29f5f5a5951bb2$export$db8a17c6655f7e2c = v; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $ef29f5f5a5951bb2$export$644a8f5b13b2a36d; }, function (v) { return $ef29f5f5a5951bb2$export$644a8f5b13b2a36d = v; });
$parcel$export(module.exports, "fromCodePoint", function () { return $ef29f5f5a5951bb2$export$73bfc63873071f74; }, function (v) { return $ef29f5f5a5951bb2$export$73bfc63873071f74 = v; });
$parcel$export(module.exports, "escapeHtml", function () { return $ef29f5f5a5951bb2$export$4cf11838cdc2a8a8; }, function (v) { return $ef29f5f5a5951bb2$export$4cf11838cdc2a8a8 = v; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $ef29f5f5a5951bb2$export$f78478f71955b6bc; }, function (v) { return $ef29f5f5a5951bb2$export$f78478f71955b6bc = v; });
$parcel$export(module.exports, "isSpace", function () { return $ef29f5f5a5951bb2$export$1d5ccafae59b4926; }, function (v) { return $ef29f5f5a5951bb2$export$1d5ccafae59b4926 = v; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $ef29f5f5a5951bb2$export$3c52dd84024ae72c; }, function (v) { return $ef29f5f5a5951bb2$export$3c52dd84024ae72c = v; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $ef29f5f5a5951bb2$export$829a0d33ae4e744; }, function (v) { return $ef29f5f5a5951bb2$export$829a0d33ae4e744 = v; });
$parcel$export(module.exports, "isPunctChar", function () { return $ef29f5f5a5951bb2$export$4888a643af800fc1; }, function (v) { return $ef29f5f5a5951bb2$export$4888a643af800fc1 = v; });
$parcel$export(module.exports, "escapeRE", function () { return $ef29f5f5a5951bb2$export$bc616c8f7dc20d5d; }, function (v) { return $ef29f5f5a5951bb2$export$bc616c8f7dc20d5d = v; });
$parcel$export(module.exports, "normalizeReference", function () { return $ef29f5f5a5951bb2$export$20ef46802c8744b; }, function (v) { return $ef29f5f5a5951bb2$export$20ef46802c8744b = v; });
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $ef29f5f5a5951bb2$export$16c08b91f883959a;
var $ef29f5f5a5951bb2$export$e6e34fd1f2686227;
var $ef29f5f5a5951bb2$export$844ec244b1367d54;
var $ef29f5f5a5951bb2$export$a4f4bb6b1453fff5;
var $ef29f5f5a5951bb2$export$5ccde1ea0c14bb03;
var $ef29f5f5a5951bb2$export$db8a17c6655f7e2c;
var $ef29f5f5a5951bb2$export$644a8f5b13b2a36d;
var $ef29f5f5a5951bb2$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $ef29f5f5a5951bb2$export$4cf11838cdc2a8a8;
var $ef29f5f5a5951bb2$export$f78478f71955b6bc;
var $ef29f5f5a5951bb2$export$1d5ccafae59b4926;
var $ef29f5f5a5951bb2$export$3c52dd84024ae72c;
var $ef29f5f5a5951bb2$export$829a0d33ae4e744;
var $ef29f5f5a5951bb2$export$4888a643af800fc1;
var $ef29f5f5a5951bb2$export$bc616c8f7dc20d5d;
var $ef29f5f5a5951bb2$export$20ef46802c8744b;
"use strict";
function $ef29f5f5a5951bb2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $ef29f5f5a5951bb2$var$isString(obj) {
    return $ef29f5f5a5951bb2$var$_class(obj) === "[object String]";
}
var $ef29f5f5a5951bb2$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $ef29f5f5a5951bb2$var$has(object, key) {
    return $ef29f5f5a5951bb2$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $ef29f5f5a5951bb2$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $ef29f5f5a5951bb2$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $ef29f5f5a5951bb2$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $ef29f5f5a5951bb2$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $ef29f5f5a5951bb2$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $ef29f5f5a5951bb2$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $ef29f5f5a5951bb2$var$UNESCAPE_ALL_RE = new RegExp($ef29f5f5a5951bb2$var$UNESCAPE_MD_RE.source + "|" + $ef29f5f5a5951bb2$var$ENTITY_RE.source, "gi");
var $ef29f5f5a5951bb2$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $k7nXf = parcelRequire("k7nXf");
function $ef29f5f5a5951bb2$var$replaceEntityPattern(match, name) {
    var code;
    if ($ef29f5f5a5951bb2$var$has($k7nXf, name)) return $k7nXf[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $ef29f5f5a5951bb2$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($ef29f5f5a5951bb2$var$isValidEntityCode(code)) return $ef29f5f5a5951bb2$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $ef29f5f5a5951bb2$var$unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($ef29f5f5a5951bb2$var$UNESCAPE_MD_RE, "$1");
}
function $ef29f5f5a5951bb2$var$unescapeAll(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($ef29f5f5a5951bb2$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $ef29f5f5a5951bb2$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $ef29f5f5a5951bb2$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $ef29f5f5a5951bb2$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $ef29f5f5a5951bb2$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $ef29f5f5a5951bb2$var$replaceUnsafeChar(ch) {
    return $ef29f5f5a5951bb2$var$HTML_REPLACEMENTS[ch];
}
function $ef29f5f5a5951bb2$var$escapeHtml(str) {
    if ($ef29f5f5a5951bb2$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($ef29f5f5a5951bb2$var$HTML_ESCAPE_REPLACE_RE, $ef29f5f5a5951bb2$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $ef29f5f5a5951bb2$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $ef29f5f5a5951bb2$var$escapeRE(str) {
    return str.replace($ef29f5f5a5951bb2$var$REGEXP_ESCAPE_RE, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
function $ef29f5f5a5951bb2$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $ef29f5f5a5951bb2$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $5Ulqw = parcelRequire("5Ulqw");
// Currently without astral characters support.
function $ef29f5f5a5951bb2$var$isPunctChar(ch) {
    return $5Ulqw.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $ef29f5f5a5951bb2$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $ef29f5f5a5951bb2$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$ef29f5f5a5951bb2$export$16c08b91f883959a = {};

$ef29f5f5a5951bb2$export$16c08b91f883959a.mdurl = (parcelRequire("daLid"));

$ef29f5f5a5951bb2$export$16c08b91f883959a.ucmicro = (parcelRequire("lXba5"));
$ef29f5f5a5951bb2$export$e6e34fd1f2686227 = $ef29f5f5a5951bb2$var$assign;
$ef29f5f5a5951bb2$export$844ec244b1367d54 = $ef29f5f5a5951bb2$var$isString;
$ef29f5f5a5951bb2$export$a4f4bb6b1453fff5 = $ef29f5f5a5951bb2$var$has;
$ef29f5f5a5951bb2$export$5ccde1ea0c14bb03 = $ef29f5f5a5951bb2$var$unescapeMd;
$ef29f5f5a5951bb2$export$db8a17c6655f7e2c = $ef29f5f5a5951bb2$var$unescapeAll;
$ef29f5f5a5951bb2$export$644a8f5b13b2a36d = $ef29f5f5a5951bb2$var$isValidEntityCode;
$ef29f5f5a5951bb2$export$73bfc63873071f74 = $ef29f5f5a5951bb2$var$fromCodePoint;
$ef29f5f5a5951bb2$export$4cf11838cdc2a8a8 = $ef29f5f5a5951bb2$var$escapeHtml;
$ef29f5f5a5951bb2$export$f78478f71955b6bc = $ef29f5f5a5951bb2$var$arrayReplaceAt;
$ef29f5f5a5951bb2$export$1d5ccafae59b4926 = $ef29f5f5a5951bb2$var$isSpace;
$ef29f5f5a5951bb2$export$3c52dd84024ae72c = $ef29f5f5a5951bb2$var$isWhiteSpace;
$ef29f5f5a5951bb2$export$829a0d33ae4e744 = $ef29f5f5a5951bb2$var$isMdAsciiPunct;
$ef29f5f5a5951bb2$export$4888a643af800fc1 = $ef29f5f5a5951bb2$var$isPunctChar;
$ef29f5f5a5951bb2$export$bc616c8f7dc20d5d = $ef29f5f5a5951bb2$var$escapeRE;
$ef29f5f5a5951bb2$export$20ef46802c8744b = $ef29f5f5a5951bb2$var$normalizeReference;

});
parcelRegister("k7nXf", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
"use strict";

/*eslint quotes:0*/ module.exports = (parcelRequire("aofX1"));

});
parcelRegister("aofX1", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("daLid", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $9970e4e047c4c263$export$c564cdbbe6da493; }, function (v) { return $9970e4e047c4c263$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $9970e4e047c4c263$export$2f872c0f2117be69; }, function (v) { return $9970e4e047c4c263$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "format", function () { return $9970e4e047c4c263$export$d9468344d3651243; }, function (v) { return $9970e4e047c4c263$export$d9468344d3651243 = v; });
$parcel$export(module.exports, "parse", function () { return $9970e4e047c4c263$export$98e6a39c04603d36; }, function (v) { return $9970e4e047c4c263$export$98e6a39c04603d36 = v; });
var $9970e4e047c4c263$export$c564cdbbe6da493;
var $9970e4e047c4c263$export$2f872c0f2117be69;
var $9970e4e047c4c263$export$d9468344d3651243;
var $9970e4e047c4c263$export$98e6a39c04603d36;
"use strict";

$9970e4e047c4c263$export$c564cdbbe6da493 = (parcelRequire("cZFlA"));

$9970e4e047c4c263$export$2f872c0f2117be69 = (parcelRequire("4nffN"));

$9970e4e047c4c263$export$d9468344d3651243 = (parcelRequire("5i6SK"));

$9970e4e047c4c263$export$98e6a39c04603d36 = (parcelRequire("8ZjSD"));

});
parcelRegister("cZFlA", function(module, exports) {
"use strict";
var $975b413bea425ef2$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $975b413bea425ef2$var$getEncodeCache(exclude) {
    var i, ch, cache = $975b413bea425ef2$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $975b413bea425ef2$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $975b413bea425ef2$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = "";
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $975b413bea425ef2$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    cache = $975b413bea425ef2$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$975b413bea425ef2$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$975b413bea425ef2$var$encode.componentChars = "-_.!~*'()";
module.exports = $975b413bea425ef2$var$encode;

});

parcelRegister("4nffN", function(module, exports) {
"use strict";
/* eslint-disable no-bitwise */ var $32f524810b94a9e2$var$decodeCache = {};
function $32f524810b94a9e2$var$getDecodeCache(exclude) {
    var i, ch, cache = $32f524810b94a9e2$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $32f524810b94a9e2$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $32f524810b94a9e2$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== "string") exclude = $32f524810b94a9e2$var$decode.defaultChars;
    cache = $32f524810b94a9e2$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = "";
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
$32f524810b94a9e2$var$decode.defaultChars = ";/?:@&=+$,#";
$32f524810b94a9e2$var$decode.componentChars = "";
module.exports = $32f524810b94a9e2$var$decode;

});

parcelRegister("5i6SK", function(module, exports) {
"use strict";
module.exports = function format(url) {
    var result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
};

});

parcelRegister("8ZjSD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $68b3710569a9d608$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $68b3710569a9d608$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $68b3710569a9d608$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$68b3710569a9d608$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$68b3710569a9d608$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
$68b3710569a9d608$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($68b3710569a9d608$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$68b3710569a9d608$var$autoEscape = [
    "'"
].concat($68b3710569a9d608$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$68b3710569a9d608$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($68b3710569a9d608$var$autoEscape), $68b3710569a9d608$var$hostEndingChars = [
    "/",
    "?",
    "#"
], $68b3710569a9d608$var$hostnameMaxLen = 255, $68b3710569a9d608$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $68b3710569a9d608$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$68b3710569a9d608$var$hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
$68b3710569a9d608$var$slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
/* eslint-enable no-script-url */ function $68b3710569a9d608$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $68b3710569a9d608$var$Url) return url;
    var u = new $68b3710569a9d608$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$68b3710569a9d608$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = $68b3710569a9d608$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $68b3710569a9d608$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $68b3710569a9d608$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$68b3710569a9d608$var$hostlessProtocol[proto] && (slashes || proto && !$68b3710569a9d608$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $68b3710569a9d608$var$hostEndingChars.length; i++){
            hec = rest.indexOf($68b3710569a9d608$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $68b3710569a9d608$var$nonHostChars.length; i++){
            hec = rest.indexOf($68b3710569a9d608$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($68b3710569a9d608$var$hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($68b3710569a9d608$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($68b3710569a9d608$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $68b3710569a9d608$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($68b3710569a9d608$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$68b3710569a9d608$var$Url.prototype.parseHost = function(host) {
    var port = $68b3710569a9d608$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $68b3710569a9d608$var$urlParse;

});


parcelRegister("lXba5", function(module, exports) {

$parcel$export(module.exports, "Any", function () { return $ffb7c42a54468adc$export$b24b633b1364b94b; }, function (v) { return $ffb7c42a54468adc$export$b24b633b1364b94b = v; });
$parcel$export(module.exports, "Cc", function () { return $ffb7c42a54468adc$export$15dafbac7aec8a57; }, function (v) { return $ffb7c42a54468adc$export$15dafbac7aec8a57 = v; });
$parcel$export(module.exports, "Cf", function () { return $ffb7c42a54468adc$export$239cff0cce87eb56; }, function (v) { return $ffb7c42a54468adc$export$239cff0cce87eb56 = v; });
$parcel$export(module.exports, "P", function () { return $ffb7c42a54468adc$export$56c0d5a1e737357d; }, function (v) { return $ffb7c42a54468adc$export$56c0d5a1e737357d = v; });
$parcel$export(module.exports, "Z", function () { return $ffb7c42a54468adc$export$dc98b0b04f4c7758; }, function (v) { return $ffb7c42a54468adc$export$dc98b0b04f4c7758 = v; });
var $ffb7c42a54468adc$export$b24b633b1364b94b;
var $ffb7c42a54468adc$export$15dafbac7aec8a57;
var $ffb7c42a54468adc$export$239cff0cce87eb56;
var $ffb7c42a54468adc$export$56c0d5a1e737357d;
var $ffb7c42a54468adc$export$dc98b0b04f4c7758;
"use strict";

$ffb7c42a54468adc$export$b24b633b1364b94b = (parcelRequire("9ABC1"));

$ffb7c42a54468adc$export$15dafbac7aec8a57 = (parcelRequire("hpbR5"));

$ffb7c42a54468adc$export$239cff0cce87eb56 = (parcelRequire("848dF"));

$ffb7c42a54468adc$export$56c0d5a1e737357d = (parcelRequire("5Ulqw"));

$ffb7c42a54468adc$export$dc98b0b04f4c7758 = (parcelRequire("ay1D7"));

});
parcelRegister("848dF", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("dFtML", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", function () { return $9f36357cf47c5a05$export$2a2c8612930e58d0; }, function (v) { return $9f36357cf47c5a05$export$2a2c8612930e58d0 = v; });
$parcel$export(module.exports, "parseLinkDestination", function () { return $9f36357cf47c5a05$export$22bd24080f95f2b3; }, function (v) { return $9f36357cf47c5a05$export$22bd24080f95f2b3 = v; });
$parcel$export(module.exports, "parseLinkTitle", function () { return $9f36357cf47c5a05$export$89650c5477a69db9; }, function (v) { return $9f36357cf47c5a05$export$89650c5477a69db9 = v; });
// Just a shortcut for bulk export
var $9f36357cf47c5a05$export$2a2c8612930e58d0;
var $9f36357cf47c5a05$export$22bd24080f95f2b3;
var $9f36357cf47c5a05$export$89650c5477a69db9;
"use strict";

$9f36357cf47c5a05$export$2a2c8612930e58d0 = (parcelRequire("eQh6b"));

$9f36357cf47c5a05$export$22bd24080f95f2b3 = (parcelRequire("6lzFB"));

$9f36357cf47c5a05$export$89650c5477a69db9 = (parcelRequire("64QaH"));

});
parcelRegister("eQh6b", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
"use strict";
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("6lzFB", function(module, exports) {
// Parse link destination
//
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $49f05f91ddb7c8c4$require$unescapeAll = $kx3Xx.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $49f05f91ddb7c8c4$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $49f05f91ddb7c8c4$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("64QaH", function(module, exports) {
// Parse link title
//
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $46cb95fb5052f834$require$unescapeAll = $kx3Xx.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ""
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $46cb95fb5052f834$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("iMmNk", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ "use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $dabe643e483f5a7f$require$assign = $kx3Xx.assign;

var $kx3Xx = parcelRequire("kx3Xx");
var $dabe643e483f5a7f$require$unescapeAll = $kx3Xx.unescapeAll;

var $kx3Xx = parcelRequire("kx3Xx");
var $dabe643e483f5a7f$require$escapeHtml = $kx3Xx.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $dabe643e483f5a7f$var$default_rules = {};
$dabe643e483f5a7f$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + $dabe643e483f5a7f$require$escapeHtml(token.content) + "</code>";
};
$dabe643e483f5a7f$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + $dabe643e483f5a7f$require$escapeHtml(tokens[idx].content) + "</code></pre>\n";
};
$dabe643e483f5a7f$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $dabe643e483f5a7f$require$unescapeAll(token.info).trim() : "", langName = "", langAttrs = "", highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $dabe643e483f5a7f$require$escapeHtml(token.content);
    else highlighted = $dabe643e483f5a7f$require$escapeHtml(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex("class");
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return "<pre><code" + slf.renderAttrs(tmpToken) + ">" + highlighted + "</code></pre>\n";
    }
    return "<pre><code" + slf.renderAttrs(token) + ">" + highlighted + "</code></pre>\n";
};
$dabe643e483f5a7f$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$dabe643e483f5a7f$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$dabe643e483f5a7f$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$dabe643e483f5a7f$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $dabe643e483f5a7f$require$escapeHtml(tokens[idx].content);
};
$dabe643e483f5a7f$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$dabe643e483f5a7f$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $dabe643e483f5a7f$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $dabe643e483f5a7f$require$assign({}, $dabe643e483f5a7f$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $dabe643e483f5a7f$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + $dabe643e483f5a7f$require$escapeHtml(token.attrs[i][0]) + '="' + $dabe643e483f5a7f$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $dabe643e483f5a7f$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = "", needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $dabe643e483f5a7f$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = "", rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $dabe643e483f5a7f$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = "";
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === "text") result += tokens[i].content;
        else if (tokens[i].type === "image") result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === "softbreak") result += "\n";
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $dabe643e483f5a7f$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = "", rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $dabe643e483f5a7f$var$Renderer;

});

parcelRegister("aTisr", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ "use strict";

var $cFdRN = parcelRequire("cFdRN");







var $7edd5bc3f78d6ef8$var$_rules = [
    [
        "normalize",
        (parcelRequire("4wz93"))
    ],
    [
        "block",
        (parcelRequire("4sUbU"))
    ],
    [
        "inline",
        (parcelRequire("jin3n"))
    ],
    [
        "linkify",
        (parcelRequire("eMNPc"))
    ],
    [
        "replacements",
        (parcelRequire("apO3E"))
    ],
    [
        "smartquotes",
        (parcelRequire("bP2ZO"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (parcelRequire("i28FN"))
    ]
];
/**
 * new Core()
 **/ function $7edd5bc3f78d6ef8$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $cFdRN();
    for(var i = 0; i < $7edd5bc3f78d6ef8$var$_rules.length; i++)this.ruler.push($7edd5bc3f78d6ef8$var$_rules[i][0], $7edd5bc3f78d6ef8$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $7edd5bc3f78d6ef8$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules("");
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$7edd5bc3f78d6ef8$var$Core.prototype.State = (parcelRequire("6IVY4"));
module.exports = $7edd5bc3f78d6ef8$var$Core;

});
parcelRegister("cFdRN", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ "use strict";
/**
 * new Ruler()
 **/ function $938411fbaa6a2103$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$938411fbaa6a2103$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$938411fbaa6a2103$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $938411fbaa6a2103$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $938411fbaa6a2103$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $938411fbaa6a2103$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $938411fbaa6a2103$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $938411fbaa6a2103$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $938411fbaa6a2103$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $938411fbaa6a2103$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $938411fbaa6a2103$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $938411fbaa6a2103$var$Ruler;

});

parcelRegister("4wz93", function(module, exports) {
// Normalize input string
"use strict";
// https://spec.commonmark.org/0.29/#line-ending
var $34b569a5059fcfd7$var$NEWLINES_RE = /\r\n?|\n/g;
var $34b569a5059fcfd7$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($34b569a5059fcfd7$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($34b569a5059fcfd7$var$NULL_RE, "\uFFFD");
    state.src = str;
};

});

parcelRegister("4sUbU", function(module, exports) {
"use strict";
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("jin3n", function(module, exports) {
"use strict";
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("eMNPc", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $ac3c3286eba92432$require$arrayReplaceAt = $kx3Xx.arrayReplaceAt;
function $ac3c3286eba92432$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $ac3c3286eba92432$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($ac3c3286eba92432$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($ac3c3286eba92432$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token("link_open", "a", 1);
                    token.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    token = new state.Token("text", "", 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token("link_close", "a", -1);
                    token.level = --level;
                    token.markup = "linkify";
                    token.info = "auto";
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $ac3c3286eba92432$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("apO3E", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
"use strict";
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $795311a3f83e6760$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $795311a3f83e6760$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $795311a3f83e6760$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $795311a3f83e6760$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $795311a3f83e6760$var$replaceFn(match, name) {
    return $795311a3f83e6760$var$SCOPED_ABBR[name.toLowerCase()];
}
function $795311a3f83e6760$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($795311a3f83e6760$var$SCOPED_ABBR_RE, $795311a3f83e6760$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $795311a3f83e6760$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($795311a3f83e6760$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($795311a3f83e6760$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $795311a3f83e6760$var$replace_scoped(state.tokens[blkIdx].children);
        if ($795311a3f83e6760$var$RARE_RE.test(state.tokens[blkIdx].content)) $795311a3f83e6760$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("bP2ZO", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $89b6c80c3dacb494$require$isWhiteSpace = $kx3Xx.isWhiteSpace;

var $kx3Xx = parcelRequire("kx3Xx");
var $89b6c80c3dacb494$require$isPunctChar = $kx3Xx.isPunctChar;

var $kx3Xx = parcelRequire("kx3Xx");
var $89b6c80c3dacb494$require$isMdAsciiPunct = $kx3Xx.isMdAsciiPunct;
var $89b6c80c3dacb494$var$QUOTE_TEST_RE = /['"]/;
var $89b6c80c3dacb494$var$QUOTE_RE = /['"]/g;
var $89b6c80c3dacb494$var$APOSTROPHE = "\u2019"; /* ’ */ 
function $89b6c80c3dacb494$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $89b6c80c3dacb494$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $89b6c80c3dacb494$var$QUOTE_RE.lastIndex = pos;
            t = $89b6c80c3dacb494$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $89b6c80c3dacb494$require$isMdAsciiPunct(lastChar) || $89b6c80c3dacb494$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $89b6c80c3dacb494$require$isMdAsciiPunct(nextChar) || $89b6c80c3dacb494$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $89b6c80c3dacb494$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $89b6c80c3dacb494$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $89b6c80c3dacb494$var$replaceAt(token.content, t.index, $89b6c80c3dacb494$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $89b6c80c3dacb494$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $89b6c80c3dacb494$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $89b6c80c3dacb494$var$replaceAt(token.content, t.index, $89b6c80c3dacb494$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$89b6c80c3dacb494$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $89b6c80c3dacb494$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("i28FN", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
"use strict";
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("6IVY4", function(module, exports) {
// Core state object
//
"use strict";

var $8446C = parcelRequire("8446C");
function $4e53d15f895c20d9$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$4e53d15f895c20d9$var$StateCore.prototype.Token = $8446C;
module.exports = $4e53d15f895c20d9$var$StateCore;

});
parcelRegister("8446C", function(module, exports) {
// Token class
"use strict";
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $5df1e1c09d562010$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $5df1e1c09d562010$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $5df1e1c09d562010$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $5df1e1c09d562010$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $5df1e1c09d562010$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $5df1e1c09d562010$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
module.exports = $5df1e1c09d562010$var$Token;

});



parcelRegister("28fdg", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ "use strict";

var $cFdRN = parcelRequire("cFdRN");











var $18d82118ed3dfd6c$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (parcelRequire("9b9vg")),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (parcelRequire("aZCgJ"))
    ],
    [
        "fence",
        (parcelRequire("kkIhS")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (parcelRequire("aF8Dr")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (parcelRequire("fXy6B")),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (parcelRequire("2DsO8")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (parcelRequire("jDjwi"))
    ],
    [
        "html_block",
        (parcelRequire("9RJRy")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (parcelRequire("6By5U")),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (parcelRequire("fUIAG"))
    ],
    [
        "paragraph",
        (parcelRequire("ATfin"))
    ]
];
/**
 * new ParserBlock()
 **/ function $18d82118ed3dfd6c$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $cFdRN();
    for(var i = 0; i < $18d82118ed3dfd6c$var$_rules.length; i++)this.ruler.push($18d82118ed3dfd6c$var$_rules[i][0], $18d82118ed3dfd6c$var$_rules[i][1], {
        alt: ($18d82118ed3dfd6c$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$18d82118ed3dfd6c$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(""), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error("none of the block rules matched");
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $18d82118ed3dfd6c$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$18d82118ed3dfd6c$var$ParserBlock.prototype.State = (parcelRequire("bxYBh"));
module.exports = $18d82118ed3dfd6c$var$ParserBlock;

});
parcelRegister("9b9vg", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $6aec834a86d7c924$require$isSpace = $kx3Xx.isSpace;
function $6aec834a86d7c924$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $6aec834a86d7c924$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = "";
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$6aec834a86d7c924$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $6aec834a86d7c924$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$6aec834a86d7c924$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $6aec834a86d7c924$var$getLine(state, startLine + 1);
    columns = lineText.split("|");
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $6aec834a86d7c924$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $6aec834a86d7c924$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    token = state.push("table_open", "table", 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push("thead_open", "thead", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push("tr_open", "tr", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push("th_open", "th", 1);
        if (aligns[i]) token.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        token = state.push("inline", "", 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push("th_close", "th", -1);
    }
    token = state.push("tr_close", "tr", -1);
    token = state.push("thead_close", "thead", -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $6aec834a86d7c924$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $6aec834a86d7c924$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push("tbody_open", "tbody", 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push("tr_open", "tr", 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push("td_open", "td", 1);
            if (aligns[i]) token.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            token = state.push("inline", "", 0);
            token.content = columns[i] ? columns[i].trim() : "";
            token.children = [];
            token = state.push("td_close", "td", -1);
        }
        token = state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        token = state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("aZCgJ", function(module, exports) {
// Code block (4 spaces padded)
"use strict";
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("kkIhS", function(module, exports) {
// fences (``` lang, ~~~ lang)
"use strict";
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("aF8Dr", function(module, exports) {
// Block quotes
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $7c346e7f55ca83e5$require$isSpace = $kx3Xx.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules("blockquote");
    oldParentType = state.parentType;
    state.parentType = "blockquote";
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($7c346e7f55ca83e5$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push("blockquote_open", "blockquote", 1);
    token.markup = ">";
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push("blockquote_close", "blockquote", -1);
    token.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("fXy6B", function(module, exports) {
// Horizontal rule
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $b9e6d253cce79109$require$isSpace = $kx3Xx.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$b9e6d253cce79109$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("2DsO8", function(module, exports) {
// Lists
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $1eb591e67b81c6e2$require$isSpace = $kx3Xx.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $1eb591e67b81c6e2$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$1eb591e67b81c6e2$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $1eb591e67b81c6e2$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$1eb591e67b81c6e2$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $1eb591e67b81c6e2$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $1eb591e67b81c6e2$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $1eb591e67b81c6e2$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules("list");
    oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $1eb591e67b81c6e2$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $1eb591e67b81c6e2$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $1eb591e67b81c6e2$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("jDjwi", function(module, exports) {
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $e4b0cd13503a029a$require$normalizeReference = $kx3Xx.normalizeReference;

var $kx3Xx = parcelRequire("kx3Xx");
var $e4b0cd13503a029a$require$isSpace = $kx3Xx.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules("reference");
    oldParentType = state.parentType;
    state.parentType = "reference";
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($e4b0cd13503a029a$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($e4b0cd13503a029a$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = "";
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$e4b0cd13503a029a$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$e4b0cd13503a029a$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $e4b0cd13503a029a$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("9RJRy", function(module, exports) {
// HTML block
"use strict";

var $98Zlm = parcelRequire("98Zlm");

var $7Gix5 = parcelRequire("7Gix5");
var $72eca3af79058e90$require$HTML_OPEN_CLOSE_TAG_RE = $7Gix5.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $72eca3af79058e90$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + $98Zlm.join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp($72eca3af79058e90$require$HTML_OPEN_CLOSE_TAG_RE.source + "\\s*$"),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $72eca3af79058e90$var$HTML_SEQUENCES.length; i++){
        if ($72eca3af79058e90$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $72eca3af79058e90$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $72eca3af79058e90$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$72eca3af79058e90$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($72eca3af79058e90$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("98Zlm", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
"use strict";
module.exports = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "section",
    "source",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRegister("7Gix5", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", function () { return $597ad4dd15b9fc69$export$6db61d2c3a16e419; }, function (v) { return $597ad4dd15b9fc69$export$6db61d2c3a16e419 = v; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $597ad4dd15b9fc69$export$cd48660d06f74639; }, function (v) { return $597ad4dd15b9fc69$export$cd48660d06f74639 = v; });
// Regexps to match html elements
var $597ad4dd15b9fc69$export$6db61d2c3a16e419;
var $597ad4dd15b9fc69$export$cd48660d06f74639;
"use strict";
var $597ad4dd15b9fc69$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
var $597ad4dd15b9fc69$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
var $597ad4dd15b9fc69$var$single_quoted = "'[^']*'";
var $597ad4dd15b9fc69$var$double_quoted = '"[^"]*"';
var $597ad4dd15b9fc69$var$attr_value = "(?:" + $597ad4dd15b9fc69$var$unquoted + "|" + $597ad4dd15b9fc69$var$single_quoted + "|" + $597ad4dd15b9fc69$var$double_quoted + ")";
var $597ad4dd15b9fc69$var$attribute = "(?:\\s+" + $597ad4dd15b9fc69$var$attr_name + "(?:\\s*=\\s*" + $597ad4dd15b9fc69$var$attr_value + ")?)";
var $597ad4dd15b9fc69$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $597ad4dd15b9fc69$var$attribute + "*\\s*\\/?>";
var $597ad4dd15b9fc69$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
var $597ad4dd15b9fc69$var$comment = "<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->";
var $597ad4dd15b9fc69$var$processing = "<[?][\\s\\S]*?[?]>";
var $597ad4dd15b9fc69$var$declaration = "<![A-Z]+\\s+[^>]*>";
var $597ad4dd15b9fc69$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
var $597ad4dd15b9fc69$var$HTML_TAG_RE = new RegExp("^(?:" + $597ad4dd15b9fc69$var$open_tag + "|" + $597ad4dd15b9fc69$var$close_tag + "|" + $597ad4dd15b9fc69$var$comment + "|" + $597ad4dd15b9fc69$var$processing + "|" + $597ad4dd15b9fc69$var$declaration + "|" + $597ad4dd15b9fc69$var$cdata + ")");
var $597ad4dd15b9fc69$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + $597ad4dd15b9fc69$var$open_tag + "|" + $597ad4dd15b9fc69$var$close_tag + ")");
$597ad4dd15b9fc69$export$6db61d2c3a16e419 = $597ad4dd15b9fc69$var$HTML_TAG_RE;
$597ad4dd15b9fc69$export$cd48660d06f74639 = $597ad4dd15b9fc69$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("6By5U", function(module, exports) {
// heading (#, ##, ...)
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $4cf0a531c29e0b98$require$isSpace = $kx3Xx.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$4cf0a531c29e0b98$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $4cf0a531c29e0b98$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = "########".slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = "########".slice(0, level);
    return true;
};

});

parcelRegister("fUIAG", function(module, exports) {
// lheading (---, ===)
"use strict";
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = "paragraph"; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push("heading_open", "h" + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push("heading_close", "h" + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("ATfin", function(module, exports) {
// Paragraph
"use strict";
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules("paragraph");
    oldParentType = state.parentType;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push("paragraph_open", "p", 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push("inline", "", 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("bxYBh", function(module, exports) {
// Parser state class
"use strict";

var $8446C = parcelRequire("8446C");

var $kx3Xx = parcelRequire("kx3Xx");
var $8681c8b63a248258$require$isSpace = $kx3Xx.isSpace;
function $8681c8b63a248258$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // renderer
    this.result = "";
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($8681c8b63a248258$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$8681c8b63a248258$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $8446C(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$8681c8b63a248258$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$8681c8b63a248258$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$8681c8b63a248258$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$8681c8b63a248258$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$8681c8b63a248258$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$8681c8b63a248258$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$8681c8b63a248258$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$8681c8b63a248258$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$8681c8b63a248258$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return "";
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($8681c8b63a248258$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$8681c8b63a248258$var$StateBlock.prototype.Token = $8446C;
module.exports = $8681c8b63a248258$var$StateBlock;

});


parcelRegister("kSn8M", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ "use strict";

var $cFdRN = parcelRequire("cFdRN");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $f32acd0c6d81126d$var$_rules = [
    [
        "text",
        (parcelRequire("8yCRr"))
    ],
    [
        "linkify",
        (parcelRequire("W0KxA"))
    ],
    [
        "newline",
        (parcelRequire("a7kgJ"))
    ],
    [
        "escape",
        (parcelRequire("kWoPE"))
    ],
    [
        "backticks",
        (parcelRequire("2o3FO"))
    ],
    [
        "strikethrough",
        (parcelRequire("dMTSc")).tokenize
    ],
    [
        "emphasis",
        (parcelRequire("3i0TY")).tokenize
    ],
    [
        "link",
        (parcelRequire("kNq3S"))
    ],
    [
        "image",
        (parcelRequire("bXRby"))
    ],
    [
        "autolink",
        (parcelRequire("01mp7"))
    ],
    [
        "html_inline",
        (parcelRequire("cClU0"))
    ],
    [
        "entity",
        (parcelRequire("dTvYD"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $f32acd0c6d81126d$var$_rules2 = [
    [
        "balance_pairs",
        (parcelRequire("jkSAO"))
    ],
    [
        "strikethrough",
        (parcelRequire("dMTSc")).postProcess
    ],
    [
        "emphasis",
        (parcelRequire("3i0TY")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (parcelRequire("eY8i5"))
    ]
];
/**
 * new ParserInline()
 **/ function $f32acd0c6d81126d$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $cFdRN();
    for(i = 0; i < $f32acd0c6d81126d$var$_rules.length; i++)this.ruler.push($f32acd0c6d81126d$var$_rules[i][0], $f32acd0c6d81126d$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $cFdRN();
    for(i = 0; i < $f32acd0c6d81126d$var$_rules2.length; i++)this.ruler2.push($f32acd0c6d81126d$var$_rules2[i][0], $f32acd0c6d81126d$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$f32acd0c6d81126d$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(""), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$f32acd0c6d81126d$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(""), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $f32acd0c6d81126d$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules("");
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$f32acd0c6d81126d$var$ParserInline.prototype.State = (parcelRequire("k8JMI"));
module.exports = $f32acd0c6d81126d$var$ParserInline;

});
parcelRegister("8yCRr", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
"use strict";
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $63afa4b48ea4051a$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$63afa4b48ea4051a$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("W0KxA", function(module, exports) {
// Process links like https://example.org/
"use strict";
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $0ae5ffc2c205b30c$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($0ae5ffc2c205b30c$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push("link_open", "a", 1);
        token.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token.markup = "linkify";
        token.info = "auto";
        token = state.push("text", "", 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push("link_close", "a", -1);
        token.markup = "linkify";
        token.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("a7kgJ", function(module, exports) {
// Proceess '\n'
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $75da47c7dfa91261$require$isSpace = $kx3Xx.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $75da47c7dfa91261$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("kWoPE", function(module, exports) {
// Process escaped chars and hardbreaks
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $f3ec7c8ac3608081$require$isSpace = $kx3Xx.isSpace;
var $f3ec7c8ac3608081$var$ESCAPED = [];
for(var $f3ec7c8ac3608081$var$i = 0; $f3ec7c8ac3608081$var$i < 256; $f3ec7c8ac3608081$var$i++)$f3ec7c8ac3608081$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $f3ec7c8ac3608081$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$f3ec7c8ac3608081$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = "\\" + escapedStr;
    if (!silent) {
        token = state.push("text_special", "", 0);
        if (ch1 < 256 && $f3ec7c8ac3608081$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("2o3FO", function(module, exports) {
// Parse backticks
"use strict";
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("dMTSc", function(module, exports) {

$parcel$export(module.exports, "tokenize", function () { return $a09b194c88ef9bb6$export$660b2ee2d4fb4eff; }, function (v) { return $a09b194c88ef9bb6$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "postProcess", function () { return $a09b194c88ef9bb6$export$7b804a0e0ce836d9; }, function (v) { return $a09b194c88ef9bb6$export$7b804a0e0ce836d9 = v; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $a09b194c88ef9bb6$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $a09b194c88ef9bb6$export$7b804a0e0ce836d9;
"use strict";
$a09b194c88ef9bb6$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $a09b194c88ef9bb6$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$a09b194c88ef9bb6$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $a09b194c88ef9bb6$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $a09b194c88ef9bb6$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("3i0TY", function(module, exports) {

$parcel$export(module.exports, "tokenize", function () { return $2653c0a2509b6e4c$export$660b2ee2d4fb4eff; }, function (v) { return $2653c0a2509b6e4c$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "postProcess", function () { return $2653c0a2509b6e4c$export$7b804a0e0ce836d9; }, function (v) { return $2653c0a2509b6e4c$export$7b804a0e0ce836d9 = v; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $2653c0a2509b6e4c$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $2653c0a2509b6e4c$export$7b804a0e0ce836d9;
"use strict";
$2653c0a2509b6e4c$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $2653c0a2509b6e4c$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? "strong_open" : "em_open";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = isStrong ? "strong_close" : "em_close";
        token.tag = isStrong ? "strong" : "em";
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
$2653c0a2509b6e4c$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $2653c0a2509b6e4c$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $2653c0a2509b6e4c$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("kNq3S", function(module, exports) {
// Process [link](<to> "stuff")
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $f23c998294255cd2$require$normalizeReference = $kx3Xx.normalizeReference;

var $kx3Xx = parcelRequire("kx3Xx");
var $f23c998294255cd2$require$isSpace = $kx3Xx.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = "", title = "", oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$f23c998294255cd2$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$f23c998294255cd2$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$f23c998294255cd2$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$f23c998294255cd2$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push("link_open", "a", 1);
        token.attrs = attrs = [
            [
                "href",
                href
            ]
        ];
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("bXRby", function(module, exports) {
// Process ![image](<src> "title")
"use strict";

var $kx3Xx = parcelRequire("kx3Xx");
var $8b5e75e6ca0a326e$require$normalizeReference = $kx3Xx.normalizeReference;

var $kx3Xx = parcelRequire("kx3Xx");
var $8b5e75e6ca0a326e$require$isSpace = $kx3Xx.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = "", oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$8b5e75e6ca0a326e$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$8b5e75e6ca0a326e$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$8b5e75e6ca0a326e$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$8b5e75e6ca0a326e$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push("image", "img", 0);
        token.attrs = attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("01mp7", function(module, exports) {
// Process autolinks '<protocol:...>'
"use strict";
/*eslint max-len:0*/ var $0041791fff9f6608$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $0041791fff9f6608$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($0041791fff9f6608$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($0041791fff9f6608$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push("link_open", "a", 1);
            token.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token.markup = "autolink";
            token.info = "auto";
            token = state.push("text", "", 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push("link_close", "a", -1);
            token.markup = "autolink";
            token.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("cClU0", function(module, exports) {
// Process html tags
"use strict";

var $7Gix5 = parcelRequire("7Gix5");
var $92fa05fd2840adbf$require$HTML_TAG_RE = $7Gix5.HTML_TAG_RE;
function $92fa05fd2840adbf$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $92fa05fd2840adbf$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $92fa05fd2840adbf$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$92fa05fd2840adbf$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($92fa05fd2840adbf$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push("html_inline", "", 0);
        token.content = match[0];
        if ($92fa05fd2840adbf$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($92fa05fd2840adbf$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("dTvYD", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
"use strict";

var $k7nXf = parcelRequire("k7nXf");

var $kx3Xx = parcelRequire("kx3Xx");
var $a1d9375e6a17579d$require$has = $kx3Xx.has;

var $kx3Xx = parcelRequire("kx3Xx");
var $a1d9375e6a17579d$require$isValidEntityCode = $kx3Xx.isValidEntityCode;

var $kx3Xx = parcelRequire("kx3Xx");
var $a1d9375e6a17579d$require$fromCodePoint = $kx3Xx.fromCodePoint;
var $a1d9375e6a17579d$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $a1d9375e6a17579d$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($a1d9375e6a17579d$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push("text_special", "", 0);
                token.content = $a1d9375e6a17579d$require$isValidEntityCode(code) ? $a1d9375e6a17579d$require$fromCodePoint(code) : $a1d9375e6a17579d$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($a1d9375e6a17579d$var$NAMED_RE);
        if (match) {
            if ($a1d9375e6a17579d$require$has($k7nXf, match[1])) {
                if (!silent) {
                    token = state.push("text_special", "", 0);
                    token.content = $k7nXf[match[1]];
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("jkSAO", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
"use strict";
function $e13a3b8c89e795a4$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $e13a3b8c89e795a4$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $e13a3b8c89e795a4$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("eY8i5", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
"use strict";
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("k8JMI", function(module, exports) {
// Inline parser state
"use strict";

var $8446C = parcelRequire("8446C");

var $kx3Xx = parcelRequire("kx3Xx");
var $ea9811e96037ef55$require$isWhiteSpace = $kx3Xx.isWhiteSpace;

var $kx3Xx = parcelRequire("kx3Xx");
var $ea9811e96037ef55$require$isPunctChar = $kx3Xx.isPunctChar;

var $kx3Xx = parcelRequire("kx3Xx");
var $ea9811e96037ef55$require$isMdAsciiPunct = $kx3Xx.isMdAsciiPunct;
function $ea9811e96037ef55$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$ea9811e96037ef55$var$StateInline.prototype.pushPending = function() {
    var token = new $8446C("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$ea9811e96037ef55$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $8446C(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$ea9811e96037ef55$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $ea9811e96037ef55$require$isMdAsciiPunct(lastChar) || $ea9811e96037ef55$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $ea9811e96037ef55$require$isMdAsciiPunct(nextChar) || $ea9811e96037ef55$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $ea9811e96037ef55$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $ea9811e96037ef55$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$ea9811e96037ef55$var$StateInline.prototype.Token = $8446C;
module.exports = $ea9811e96037ef55$var$StateInline;

});


parcelRegister("btK9F", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $85b6348a8cb74b74$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $85b6348a8cb74b74$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $85b6348a8cb74b74$var$isString(obj) {
    return $85b6348a8cb74b74$var$_class(obj) === "[object String]";
}
function $85b6348a8cb74b74$var$isObject(obj) {
    return $85b6348a8cb74b74$var$_class(obj) === "[object Object]";
}
function $85b6348a8cb74b74$var$isRegExp(obj) {
    return $85b6348a8cb74b74$var$_class(obj) === "[object RegExp]";
}
function $85b6348a8cb74b74$var$isFunction(obj) {
    return $85b6348a8cb74b74$var$_class(obj) === "[object Function]";
}
function $85b6348a8cb74b74$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $85b6348a8cb74b74$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $85b6348a8cb74b74$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $85b6348a8cb74b74$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $85b6348a8cb74b74$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $85b6348a8cb74b74$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $85b6348a8cb74b74$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $85b6348a8cb74b74$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $85b6348a8cb74b74$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $85b6348a8cb74b74$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $85b6348a8cb74b74$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ivGOt"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($85b6348a8cb74b74$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($85b6348a8cb74b74$var$isObject(val)) {
            if ($85b6348a8cb74b74$var$isRegExp(val.validate)) compiled.validate = $85b6348a8cb74b74$var$createValidator(val.validate);
            else if ($85b6348a8cb74b74$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($85b6348a8cb74b74$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $85b6348a8cb74b74$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($85b6348a8cb74b74$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $85b6348a8cb74b74$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($85b6348a8cb74b74$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $85b6348a8cb74b74$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $85b6348a8cb74b74$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $85b6348a8cb74b74$var$createMatch(self, shift) {
    var match = new $85b6348a8cb74b74$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $85b6348a8cb74b74$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $85b6348a8cb74b74$var$LinkifyIt)) return new $85b6348a8cb74b74$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($85b6348a8cb74b74$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $85b6348a8cb74b74$var$assign({}, $85b6348a8cb74b74$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $85b6348a8cb74b74$var$assign({}, $85b6348a8cb74b74$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $85b6348a8cb74b74$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $85b6348a8cb74b74$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $85b6348a8cb74b74$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $85b6348a8cb74b74$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($85b6348a8cb74b74$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($85b6348a8cb74b74$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $85b6348a8cb74b74$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $85b6348a8cb74b74$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $85b6348a8cb74b74$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $85b6348a8cb74b74$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $85b6348a8cb74b74$var$LinkifyIt;

});
parcelRegister("ivGOt", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("9ABC1")).source;
    re.src_Cc = (parcelRequire("hpbR5")).source;
    re.src_Z = (parcelRequire("ay1D7")).source;
    re.src_P = (parcelRequire("5Ulqw")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // allow `I'm_king` if no pair found
    "\\.{2,}[a-zA-Z0-9%/&]|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + ",(?!" + re.src_ZCc + "|$)|" + // allow `,,,` in paths
    ";(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + // allow `!!!` in paths, but not at the end
    "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});


parcelRegister("4oriI", function(module, exports) {

$parcel$export(module.exports, "toUnicode", function () { return $332e94b1fe1f4a4f$export$110c810e8727e62b; });
$parcel$export(module.exports, "toASCII", function () { return $332e94b1fe1f4a4f$export$69111c4ea6e0c4a0; });
"use strict";
/** Highest positive signed 32-bit float value */ const $332e94b1fe1f4a4f$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $332e94b1fe1f4a4f$var$base = 36;
const $332e94b1fe1f4a4f$var$tMin = 1;
const $332e94b1fe1f4a4f$var$tMax = 26;
const $332e94b1fe1f4a4f$var$skew = 38;
const $332e94b1fe1f4a4f$var$damp = 700;
const $332e94b1fe1f4a4f$var$initialBias = 72;
const $332e94b1fe1f4a4f$var$initialN = 128; // 0x80
const $332e94b1fe1f4a4f$var$delimiter = "-"; // '\x2D'
/** Regular expressions */ const $332e94b1fe1f4a4f$var$regexPunycode = /^xn--/;
const $332e94b1fe1f4a4f$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $332e94b1fe1f4a4f$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $332e94b1fe1f4a4f$var$errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const $332e94b1fe1f4a4f$var$baseMinusTMin = $332e94b1fe1f4a4f$var$base - $332e94b1fe1f4a4f$var$tMin;
const $332e94b1fe1f4a4f$var$floor = Math.floor;
const $332e94b1fe1f4a4f$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $332e94b1fe1f4a4f$var$error(type) {
    throw new RangeError($332e94b1fe1f4a4f$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $332e94b1fe1f4a4f$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $332e94b1fe1f4a4f$var$mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($332e94b1fe1f4a4f$var$regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = $332e94b1fe1f4a4f$var$map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $332e94b1fe1f4a4f$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $332e94b1fe1f4a4f$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $332e94b1fe1f4a4f$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $332e94b1fe1f4a4f$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $332e94b1fe1f4a4f$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $332e94b1fe1f4a4f$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $332e94b1fe1f4a4f$var$floor(delta / $332e94b1fe1f4a4f$var$damp) : delta >> 1;
    delta += $332e94b1fe1f4a4f$var$floor(delta / numPoints);
    for(; delta > $332e94b1fe1f4a4f$var$baseMinusTMin * $332e94b1fe1f4a4f$var$tMax >> 1; k += $332e94b1fe1f4a4f$var$base)delta = $332e94b1fe1f4a4f$var$floor(delta / $332e94b1fe1f4a4f$var$baseMinusTMin);
    return $332e94b1fe1f4a4f$var$floor(k + ($332e94b1fe1f4a4f$var$baseMinusTMin + 1) * delta / (delta + $332e94b1fe1f4a4f$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $332e94b1fe1f4a4f$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $332e94b1fe1f4a4f$var$initialN;
    let bias = $332e94b1fe1f4a4f$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($332e94b1fe1f4a4f$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $332e94b1fe1f4a4f$var$error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $332e94b1fe1f4a4f$var$base;; k += $332e94b1fe1f4a4f$var$base){
            if (index >= inputLength) $332e94b1fe1f4a4f$var$error("invalid-input");
            const digit = $332e94b1fe1f4a4f$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $332e94b1fe1f4a4f$var$base) $332e94b1fe1f4a4f$var$error("invalid-input");
            if (digit > $332e94b1fe1f4a4f$var$floor(($332e94b1fe1f4a4f$var$maxInt - i) / w)) $332e94b1fe1f4a4f$var$error("overflow");
            i += digit * w;
            const t = k <= bias ? $332e94b1fe1f4a4f$var$tMin : k >= bias + $332e94b1fe1f4a4f$var$tMax ? $332e94b1fe1f4a4f$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $332e94b1fe1f4a4f$var$base - t;
            if (w > $332e94b1fe1f4a4f$var$floor($332e94b1fe1f4a4f$var$maxInt / baseMinusT)) $332e94b1fe1f4a4f$var$error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $332e94b1fe1f4a4f$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($332e94b1fe1f4a4f$var$floor(i / out) > $332e94b1fe1f4a4f$var$maxInt - n) $332e94b1fe1f4a4f$var$error("overflow");
        n += $332e94b1fe1f4a4f$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $332e94b1fe1f4a4f$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $332e94b1fe1f4a4f$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $332e94b1fe1f4a4f$var$initialN;
    let delta = 0;
    let bias = $332e94b1fe1f4a4f$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($332e94b1fe1f4a4f$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($332e94b1fe1f4a4f$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $332e94b1fe1f4a4f$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $332e94b1fe1f4a4f$var$floor(($332e94b1fe1f4a4f$var$maxInt - delta) / handledCPCountPlusOne)) $332e94b1fe1f4a4f$var$error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $332e94b1fe1f4a4f$var$maxInt) $332e94b1fe1f4a4f$var$error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $332e94b1fe1f4a4f$var$base;; k += $332e94b1fe1f4a4f$var$base){
                    const t = k <= bias ? $332e94b1fe1f4a4f$var$tMin : k >= bias + $332e94b1fe1f4a4f$var$tMax ? $332e94b1fe1f4a4f$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $332e94b1fe1f4a4f$var$base - t;
                    output.push($332e94b1fe1f4a4f$var$stringFromCharCode($332e94b1fe1f4a4f$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $332e94b1fe1f4a4f$var$floor(qMinusT / baseMinusT);
                }
                output.push($332e94b1fe1f4a4f$var$stringFromCharCode($332e94b1fe1f4a4f$var$digitToBasic(q, 0)));
                bias = $332e94b1fe1f4a4f$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $332e94b1fe1f4a4f$export$110c810e8727e62b = function(input) {
    return $332e94b1fe1f4a4f$var$mapDomain(input, function(string) {
        return $332e94b1fe1f4a4f$var$regexPunycode.test(string) ? $332e94b1fe1f4a4f$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $332e94b1fe1f4a4f$export$69111c4ea6e0c4a0 = function(input) {
    return $332e94b1fe1f4a4f$var$mapDomain(input, function(string) {
        return $332e94b1fe1f4a4f$var$regexNonASCII.test(string) ? "xn--" + $332e94b1fe1f4a4f$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $332e94b1fe1f4a4f$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": $332e94b1fe1f4a4f$export$c1700176c90f250f,
        "encode": $332e94b1fe1f4a4f$export$f999239d9b149395
    },
    "decode": $332e94b1fe1f4a4f$export$2f872c0f2117be69,
    "encode": $332e94b1fe1f4a4f$export$c564cdbbe6da493,
    "toASCII": $332e94b1fe1f4a4f$export$69111c4ea6e0c4a0,
    "toUnicode": $332e94b1fe1f4a4f$export$110c810e8727e62b
};
var $332e94b1fe1f4a4f$export$2e2bcd8739ae039 = $332e94b1fe1f4a4f$var$punycode;

});

parcelRegister("hovff", function(module, exports) {
// markdown-it default options
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("hp7z1", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
"use strict";
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};

});

parcelRegister("91F03", function(module, exports) {
// Commonmark default options
"use strict";
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: "language-",
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};

});



parcelRegister("dRiR4", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", function () { return $a16ed9c8e341eecc$export$26a6b72a65821214; });

var $hfLKy = parcelRequire("hfLKy");
var $a16ed9c8e341eecc$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before("paragraph", "table", (0, (/*@__PURE__*/$parcel$interopDefault($hfLKy))), {
        alt: [
            "paragraph",
            "reference"
        ]
    });
};

});
parcelRegister("hfLKy", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $c8f8e07f6004237b$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $c8f8e07f6004237b$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $c8f8e07f6004237b$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$c8f8e07f6004237b$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c8f8e07f6004237b$var$getLine(state, startLine + 1);
    columns = lineText.split("|");
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $c8f8e07f6004237b$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c8f8e07f6004237b$var$escapedSplit(lineText.replace(/^\||\|$/g, ""));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push("table_open", "table", 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push("tr_open", "tr", 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push("th_open", "th", 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        token = state.push("paragraph_open", "p", 1);
        token = state.push("inline", "", 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push("paragraph_close", "p", -1);
        token = state.push("th_close", "th", -1);
    }
    token = state.push("tr_close", "tr", -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $c8f8e07f6004237b$var$getLine(state, nextLine).trim();
        if (lineText.indexOf("|") === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c8f8e07f6004237b$var$escapedSplit(lineText.replace(/^\||\|$/g, ""));
        token = state.push("tr_open", "tr", 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push("td_open", "td", 1);
            if (aligns[_i]) token.attrs = [
                [
                    "style",
                    "text-align:" + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === " " || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || "").length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push("td_close", "td", -1);
        }
        token = state.push("tr_close", "tr", -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push("table_close", "table", -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("cOqps", function(module, exports) {

$parcel$export(module.exports, "MarkdownTransformer", function () { return $953ea3eecd30349f$export$267fd7ead7cc4561; });

var $1xlxq = parcelRequire("1xlxq");

var $aOXmm = parcelRequire("aOXmm");

var $g7d1I = parcelRequire("g7d1I");

var $1yLHG = parcelRequire("1yLHG");

var $dRiR4 = parcelRequire("dRiR4");

var $6WBoi = parcelRequire("6WBoi");

var $4ScXa = parcelRequire("4ScXa");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $953ea3eecd30349f$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce(function(newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
var $953ea3eecd30349f$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: "blockquote",
        paragraph: "paragraph",
        rule: "hr",
        // lheading (---, ===)
        heading: [
            "heading",
            "lheading"
        ],
        codeBlock: [
            "code",
            "fence"
        ],
        listItem: "list",
        image: "image"
    },
    marks: {
        em: "emphasis",
        strong: "text",
        link: [
            "link",
            "autolink",
            "reference",
            "linkify"
        ],
        strike: "strikethrough",
        code: "backticks"
    }
};
var $953ea3eecd30349f$var$mdToPmMapping = {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            };
        }
    },
    hr: {
        node: "rule"
    },
    heading: {
        block: "heading",
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                level: +tok.tag.slice(1)
            };
        }
    },
    softbreak: {
        node: "hardBreak"
    },
    hardbreak: {
        node: "hardBreak"
    },
    code_block: {
        block: "codeBlock"
    },
    list_item: {
        block: "listItem"
    },
    bullet_list: {
        block: "bulletList"
    },
    ordered_list: {
        block: "orderedList",
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                order: typeof tok.attrGet("start") === "number" ? tok.attrGet("start") : 1
            };
        }
    },
    code_inline: {
        mark: "code"
    },
    fence: {
        block: "codeBlock",
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                language: tok.info && tok.info.trim() || null
            };
        }
    },
    media_single: {
        block: "mediaSingle",
        attrs: function attrs() {
            return {};
        }
    },
    media: {
        node: "media",
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet("url"),
                alt: tok.attrGet("alt"),
                type: "external"
            };
        }
    },
    emoji: {
        node: "emoji",
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                shortName: ":".concat(tok.markup, ":"),
                text: tok.content
            };
        }
    },
    table: {
        block: "table"
    },
    tr: {
        block: "tableRow"
    },
    th: {
        block: "tableHeader"
    },
    td: {
        block: "tableCell"
    },
    s: {
        mark: "strike"
    },
    task_list: {
        block: "taskList"
    },
    task_item: {
        block: "taskItem",
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                state: tok.meta
            };
        }
    }
};
var $953ea3eecd30349f$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($1yLHG)))("zero", {
    html: false
});
$953ea3eecd30349f$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    "entity",
    // Process escaped chars and hardbreaks
    "escape"
]);
var $953ea3eecd30349f$export$267fd7ead7cc4561 = /*#__PURE__*/ function() {
    function MarkdownTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $g7d1I.defaultSchema);
        var tokenizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $953ea3eecd30349f$var$md;
        (0, $1xlxq.default)(this, MarkdownTransformer);
        // Enable markdown plugins based on schema
        [
            "nodes",
            "marks"
        ].forEach(function(key) {
            for(var idx in $953ea3eecd30349f$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($953ea3eecd30349f$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $dRiR4.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $4ScXa.markdownItMedia));
        this.markdownParser = new (0, $6WBoi.MarkdownParser)(schema, tokenizer, $953ea3eecd30349f$var$filterMdToPmSchemaMapping(schema, $953ea3eecd30349f$var$mdToPmMapping));
    }
    return (0, $aOXmm.default)(MarkdownTransformer, [
        {
            key: "encode",
            value: function encode(_node) {
                throw new Error("This is not implemented yet");
            }
        },
        {
            key: "parse",
            value: function parse(content) {
                return this.markdownParser.parse(content);
            }
        }
    ]);
}();

});
parcelRegister("g7d1I", function(module, exports) {

$parcel$export(module.exports, "defaultSchema", function () { return $bbb7679cb0b5c28e$export$1db618b7b2275ea1; });

var $fV0Sg = parcelRequire("fV0Sg");

var $fDngI = parcelRequire("fDngI");
var $eBbW7 = parcelRequire("eBbW7");
var $cjtvg = parcelRequire("cjtvg");
var $gM9eJ = parcelRequire("gM9eJ");
var $eZY8K = parcelRequire("eZY8K");
var $8gSlb = parcelRequire("8gSlb");

var $jVI5d = parcelRequire("jVI5d");
var $bbb7679cb0b5c28e$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            "doc",
            "paragraph",
            "text",
            "bulletList",
            "orderedList",
            "listItem",
            "heading",
            "blockquote",
            "codeBlock",
            "panel",
            "rule",
            "image",
            "caption",
            "mention",
            "media",
            "mediaGroup",
            "mediaSingle",
            "mediaInline",
            "confluenceUnsupportedBlock",
            "confluenceUnsupportedInline",
            "confluenceJiraIssue",
            "expand",
            "nestedExpand",
            "extension",
            "inlineExtension",
            "bodiedExtension",
            "hardBreak",
            "emoji",
            "table",
            "tableCell",
            "tableHeader",
            "tableRow",
            "decisionList",
            "decisionItem",
            "taskList",
            "taskItem",
            "blockTaskItem",
            "unknownBlock",
            "date",
            "status",
            "placeholder",
            "layoutSection",
            "layoutColumn",
            "inlineCard",
            "blockCard",
            "embedCard",
            "unsupportedBlock",
            "unsupportedInline"
        ],
        marks: [
            "link",
            "em",
            "strong",
            "strike",
            "subsup",
            "underline",
            "code",
            "textColor",
            "backgroundColor",
            "confluenceInlineComment",
            "breakout",
            "alignment",
            "indentation",
            "annotation",
            "dataConsumer",
            "border",
            "unsupportedMark",
            "unsupportedNodeAttribute",
            "typeAheadQuery",
            // https://product-fabric.atlassian.net/browse/ED-10214,
            "fragment"
        ]
    };
    return defaultSchemaConfig;
};
var $bbb7679cb0b5c28e$export$e4e3ac1fa64862db = $bbb7679cb0b5c28e$var$getDefaultSchemaConfig();
var $bbb7679cb0b5c28e$export$fd147e7d448dea03 = (0, $fV0Sg.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "final";
    var defaultSchemaConfig = $bbb7679cb0b5c28e$var$getDefaultSchemaConfig();
    if (stage === "stage0") defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $cjtvg.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $eBbW7.multiBodiedExtension),
        extensionFrame: (0, $eBbW7.extensionFrame),
        expand: (0, $fDngI.expandWithNestedExpand),
        listItem: (0, $gM9eJ.listItemWithDecisionStage0),
        table: (0, $8gSlb.tableWithNestedTable),
        tableRow: (0, $8gSlb.tableRowWithNestedTable),
        tableCell: (0, $8gSlb.tableCellWithNestedTable),
        tableHeader: (0, $8gSlb.tableHeaderWithNestedTable),
        syncBlock: (0, $eZY8K.syncBlock)
    };
    return (0, $jVI5d.createSchema)(defaultSchemaConfig);
});
var $bbb7679cb0b5c28e$export$1db618b7b2275ea1 = $bbb7679cb0b5c28e$export$fd147e7d448dea03();

});
parcelRegister("fDngI", function(module, exports) {

$parcel$export(module.exports, "expandWithNestedExpand", function () { return $b61c8c3390a03ec9$export$7b80cba28d10b2c1; });

var $417VF = parcelRequire("417VF");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $b61c8c3390a03ec9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b61c8c3390a03ec9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b61c8c3390a03ec9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b61c8c3390a03ec9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $b61c8c3390a03ec9$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true
    };
}
var $b61c8c3390a03ec9$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: "table//",
            tag: 'div[data-node-type="expand"]',
            getAttrs: $b61c8c3390a03ec9$var$getExpandAttrs
        },
        {
            context: "expand//",
            tag: '[data-node-type="expand"]',
            getAttrs: $b61c8c3390a03ec9$var$getExpandAttrs
        },
        {
            context: "nestedExpand//",
            tag: '[data-node-type="expand"]',
            getAttrs: $b61c8c3390a03ec9$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $b61c8c3390a03ec9$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "expand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $b61c8c3390a03ec9$export$7b80cba28d10b2c1 = (0, $ceuZl.expand)($b61c8c3390a03ec9$var$nodeSpecOptions);
var $b61c8c3390a03ec9$export$2ae5e7565ff9ffa6 = (0, $ceuZl.expand)({
    parseDOM: [
        {
            context: "table//",
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $b61c8c3390a03ec9$var$getExpandAttrs(dom);
                return $b61c8c3390a03ec9$var$_objectSpread($b61c8c3390a03ec9$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        },
        {
            context: "expand//",
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $b61c8c3390a03ec9$var$getExpandAttrs(dom);
                return $b61c8c3390a03ec9$var$_objectSpread($b61c8c3390a03ec9$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        },
        {
            context: "nestedExpand//",
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $b61c8c3390a03ec9$var$getExpandAttrs(dom);
                return $b61c8c3390a03ec9$var$_objectSpread($b61c8c3390a03ec9$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $b61c8c3390a03ec9$var$getExpandAttrs(dom);
                return $b61c8c3390a03ec9$var$_objectSpread($b61c8c3390a03ec9$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-node-type": "expand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $b61c8c3390a03ec9$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith("__");
        }).reduce(function(obj, key) {
            return $b61c8c3390a03ec9$var$_objectSpread($b61c8c3390a03ec9$var$_objectSpread({}, obj), {}, (0, $417VF.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("417VF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ecd67f43ae7612b$export$2e2bcd8739ae039; });

var $h8kiZ = parcelRequire("h8kiZ");
function $2ecd67f43ae7612b$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $h8kiZ.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("h8kiZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c792ef36e9cbfbaa$export$2e2bcd8739ae039; });

var $4zrxo = parcelRequire("4zrxo");

var $4W5no = parcelRequire("4W5no");
function $c792ef36e9cbfbaa$export$2e2bcd8739ae039(t) {
    var i = (0, $4W5no.default)(t, "string");
    return "symbol" == (0, $4zrxo.default)(i) ? i : i + "";
}

});
parcelRegister("4zrxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $353fcab9c64e060c$export$2e2bcd8739ae039; });
function $353fcab9c64e060c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $353fcab9c64e060c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $353fcab9c64e060c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4W5no", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3980bfcef351cd61$export$2e2bcd8739ae039; });

var $4zrxo = parcelRequire("4zrxo");
function $3980bfcef351cd61$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $4zrxo.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $4zrxo.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("ceuZl", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $8e7ed47ee155bcd4$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $8e7ed47ee155bcd4$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $8e7ed47ee155bcd4$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockTaskItem", function () { return $8e7ed47ee155bcd4$export$16018c61064a18df; });
$parcel$export(module.exports, "bodiedExtension", function () { return $8e7ed47ee155bcd4$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $8e7ed47ee155bcd4$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $8e7ed47ee155bcd4$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $8e7ed47ee155bcd4$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $8e7ed47ee155bcd4$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $8e7ed47ee155bcd4$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $8e7ed47ee155bcd4$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $8e7ed47ee155bcd4$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $8e7ed47ee155bcd4$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $8e7ed47ee155bcd4$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $8e7ed47ee155bcd4$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $8e7ed47ee155bcd4$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $8e7ed47ee155bcd4$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $8e7ed47ee155bcd4$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "extension", function () { return $8e7ed47ee155bcd4$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $8e7ed47ee155bcd4$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $8e7ed47ee155bcd4$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $8e7ed47ee155bcd4$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $8e7ed47ee155bcd4$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $8e7ed47ee155bcd4$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $8e7ed47ee155bcd4$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $8e7ed47ee155bcd4$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $8e7ed47ee155bcd4$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $8e7ed47ee155bcd4$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $8e7ed47ee155bcd4$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $8e7ed47ee155bcd4$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $8e7ed47ee155bcd4$export$df876f0305235056; });
$parcel$export(module.exports, "media", function () { return $8e7ed47ee155bcd4$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $8e7ed47ee155bcd4$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $8e7ed47ee155bcd4$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $8e7ed47ee155bcd4$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $8e7ed47ee155bcd4$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $8e7ed47ee155bcd4$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $8e7ed47ee155bcd4$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $8e7ed47ee155bcd4$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $8e7ed47ee155bcd4$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $8e7ed47ee155bcd4$export$63cadbf5f4296627; });
$parcel$export(module.exports, "orderedList", function () { return $8e7ed47ee155bcd4$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $8e7ed47ee155bcd4$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "paragraph", function () { return $8e7ed47ee155bcd4$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $8e7ed47ee155bcd4$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $8e7ed47ee155bcd4$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $8e7ed47ee155bcd4$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "syncBlockStage0", function () { return $8e7ed47ee155bcd4$export$3782866d5d058412; });
$parcel$export(module.exports, "table", function () { return $8e7ed47ee155bcd4$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $8e7ed47ee155bcd4$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $8e7ed47ee155bcd4$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $8e7ed47ee155bcd4$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $8e7ed47ee155bcd4$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $8e7ed47ee155bcd4$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $8e7ed47ee155bcd4$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $8e7ed47ee155bcd4$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $8e7ed47ee155bcd4$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $8e7ed47ee155bcd4$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $8e7ed47ee155bcd4$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $8e7ed47ee155bcd4$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $8e7ed47ee155bcd4$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $25HJn = parcelRequire("25HJn");
var $8e7ed47ee155bcd4$export$c4c2f833baaebdb8 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $8e7ed47ee155bcd4$export$67dc04e652a298ca = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $8e7ed47ee155bcd4$export$199922e5af8e9a6 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $8e7ed47ee155bcd4$export$16018c61064a18df = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | extension) (paragraph | extension)*",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "TODO"
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$27903d543b563e39 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$e7320d153c538837 = (0, $25HJn.createPMNodeSpecFactory)({
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$a140c94e5ea26bee = (0, $25HJn.createPMNodeSpecFactory)({
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$8e3c2dfdc4f0453d = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*",
    marks: "_",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $8e7ed47ee155bcd4$export$7bb0d5c671655cc4 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $8e7ed47ee155bcd4$export$e4f1c66d84049f8b = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(text | unsupportedInline)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $8e7ed47ee155bcd4$export$daf889beb5092f95 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ""
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $8e7ed47ee155bcd4$export$e6e4878f43c27cab = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $8e7ed47ee155bcd4$export$3e6d667072febc87 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $8e7ed47ee155bcd4$export$324d90190a8b822a = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        timestamp: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$47988d68fe575725 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        timestamp: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$6959e16eeff859b4 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "DECIDED"
        }
    },
    defining: true
});
var $8e7ed47ee155bcd4$export$62d45a65fb43d95e = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(decisionItem | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: ""
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$2a111da947c407d2 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout"
});
var $8e7ed47ee155bcd4$export$be4283d9a1cb1ff6 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        url: {
            default: ""
        },
        layout: {
            default: "center"
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$a19185d1233fc4b2 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$f5574b5d45fc2112 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        shortName: {
            default: ""
        },
        id: {
            default: ""
        },
        text: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$9f77e0932fb78f72 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    group: "block",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$7e3788972005cc72 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+",
    marks: "unsupportedMark unsupportedNodeAttribute fragment dataConsumer",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$1b45514b112dd749 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$a8baf338431a691 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$b555be60c7703afb = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$371da9dd35aba193 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: "\n"
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $8e7ed47ee155bcd4$export$46e4a324ac90507f = (0, $25HJn.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border",
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$1b0c1557b234fa00 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$85461f751c457cc2 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$2b380a0f7e250af1 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$5c452ff88e35e47d = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        src: {
            default: ""
        },
        alt: {
            default: ""
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $8e7ed47ee155bcd4$export$cbf8224b64e0d942 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $8e7ed47ee155bcd4$export$2f4e72b9459914ad = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $8e7ed47ee155bcd4$export$16b353b2649bd8d9 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$b3b1e36c2105006d = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$ab76e7c03cd6f650 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(block | unsupportedBlock)+",
    marks: "unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment",
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $8e7ed47ee155bcd4$export$b3b6a70a7fa4a5be = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $8e7ed47ee155bcd4$export$cdae19acb0a520fd = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){2,3}",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $8e7ed47ee155bcd4$export$206007566ca0aca5 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $8e7ed47ee155bcd4$export$76c7e83ecc9cdf05 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*",
    marks: "dataConsumer fragment unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$df876f0305235056 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$987d49ffe1b0900f = (0, $25HJn.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: "file"
        },
        localId: {
            default: null
        },
        id: {
            default: ""
        },
        alt: {
            default: ""
        },
        collection: {
            default: ""
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$2855e964765eac9 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(media | unsupportedBlock)+",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {},
    selectable: false
});
var $8e7ed47ee155bcd4$export$38bab695e3f720f1 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        type: {
            default: "file"
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ""
        },
        alt: {
            default: ""
        },
        collection: {
            default: ""
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$969fe3781ca15058 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        layout: {
            default: "center"
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: "media|unsupportedBlock+|media unsupportedBlock+",
    marks: "annotation border link unsupportedMark unsupportedNodeAttribute"
});
var $8e7ed47ee155bcd4$export$8d067f22dc2d1254 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: false,
    attrs: {
        layout: {
            default: "center"
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$7e767666f2ce108a = (0, $25HJn.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: "center"
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$4bd9a38995f6bf50 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "media|unsupportedBlock+|media unsupportedBlock+",
    marks: "link annotation border unsupportedMark unsupportedNodeAttribute",
    group: "block",
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: "center"
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$db83999c14438df4 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        localId: {
            default: null
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$46f790bd65f760d0 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        id: {
            default: ""
        },
        localId: {
            default: null
        },
        text: {
            default: ""
        },
        accessLevel: {
            default: ""
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$750e45819f66d9d0 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "extensionFrame+",
    marks: "unsupportedNodeAttribute unsupportedMark",
    group: "blockRootOnly",
    attrs: {
        extensionKey: {
            default: ""
        },
        extensionType: {
            default: ""
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: "default"
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $8e7ed47ee155bcd4$export$63cadbf5f4296627 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$f03786aa6312d1e4 = (0, $25HJn.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ""
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $8e7ed47ee155bcd4$export$a5dc81035676e7a = (0, $25HJn.createPMNodeSpecFactory)({
    content: "listItem+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$21f42ab9b6679f44 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+",
    marks: "unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    group: "block",
    attrs: {
        panelType: {
            default: "info"
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$9c206ddddb32a9b = (0, $25HJn.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border",
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$4f98472e6dc14293 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$ea332b61641b0588 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$a1f41dc4901771f8 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$c7187bbd1a7a9244 = (0, $25HJn.createPMNodeSpecFactory)({
    marks: "",
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $8e7ed47ee155bcd4$export$fbeb3a3956e8a3c7 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    attrs: {
        localId: {
            default: null
        }
    }
});
var $8e7ed47ee155bcd4$export$471f7ae5c4103ae1 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: ""
        },
        style: {
            default: ""
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$b6ce52be8d7a261 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        text: {
            default: ""
        },
        color: {
            default: ""
        },
        localId: {
            default: ""
        },
        style: {
            default: ""
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$3782866d5d058412 = (0, $25HJn.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ""
        },
        localId: {
            default: ""
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$9852986a3ec5f6a0 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "tableRow+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: "table"
});
var $8e7ed47ee155bcd4$export$ce086a560a1d05f5 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "tableRow+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: "default"
        },
        localId: {
            default: ""
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: "table"
});
var $8e7ed47ee155bcd4$export$e1e720e5f4603e6a = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "cell"
});
var $8e7ed47ee155bcd4$export$abf39ca178940ff3 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "cell"
});
var $8e7ed47ee155bcd4$export$48884d2a5190dc73 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "header_cell"
});
var $8e7ed47ee155bcd4$export$2a5a518232fa1a97 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+",
    marks: "alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment",
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: "header_cell"
});
var $8e7ed47ee155bcd4$export$ce666bf02318c957 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: "row"
});
var $8e7ed47ee155bcd4$export$7d657479499397 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(tableCell | tableHeader)+",
    marks: "unsupportedMark unsupportedNodeAttribute",
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: "row"
});
var $8e7ed47ee155bcd4$export$6d8b0ef52e2e6390 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "inline*",
    marks: "_",
    attrs: {
        localId: {
            default: ""
        },
        state: {
            default: "TODO"
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$375b6afcc5f4d291 = (0, $25HJn.createPMNodeSpecFactory)({
    content: "(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*",
    marks: "unsupportedMark unsupportedNodeAttribute",
    group: "block",
    attrs: {
        localId: {
            default: ""
        }
    },
    selectable: false,
    defining: true
});
var $8e7ed47ee155bcd4$export$6f093cfa640b7166 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline"
});
var $8e7ed47ee155bcd4$export$5ea06bc686c59dc2 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline"
});
var $8e7ed47ee155bcd4$export$93256a4c17b33a82 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline"
});
var $8e7ed47ee155bcd4$export$a12828d0f14a2762 = (0, $25HJn.createPMNodeSpecFactory)({});
var $8e7ed47ee155bcd4$export$44b79b0979d0f0f7 = (0, $25HJn.createPMNodeSpecFactory)({
    group: "block",
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $8e7ed47ee155bcd4$export$310ebe0d80122e9b = (0, $25HJn.createPMNodeSpecFactory)({
    group: "inline",
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("25HJn", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $185df8748170f5e9$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $185df8748170f5e9$export$cf5823ed4e9f4c6f; });

var $417VF = parcelRequire("417VF");
function $185df8748170f5e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $185df8748170f5e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $185df8748170f5e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $185df8748170f5e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $185df8748170f5e9$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $185df8748170f5e9$var$_objectSpread($185df8748170f5e9$var$_objectSpread($185df8748170f5e9$var$_objectSpread($185df8748170f5e9$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $185df8748170f5e9$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $185df8748170f5e9$var$_objectSpread($185df8748170f5e9$var$_objectSpread($185df8748170f5e9$var$_objectSpread($185df8748170f5e9$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});


parcelRegister("bI8Ay", function(module, exports) {

$parcel$export(module.exports, "uuid", function () { return $886a774372544381$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $886a774372544381$export$1c3aefb711c3a4cc = function generateUuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $886a774372544381$var$staticValue = false;
var $886a774372544381$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $886a774372544381$var$staticValue = value;
    },
    generate: function generate() {
        return $886a774372544381$var$staticValue || $886a774372544381$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("eBbW7", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", function () { return $aa0dc7b229d798e1$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $aa0dc7b229d798e1$export$c3c04d555a8b9013; });

var $2HBwi = parcelRequire("2HBwi");

var $ceuZl = parcelRequire("ceuZl");
var $aa0dc7b229d798e1$export$4fdcae991fd743e7 = (0, $ceuZl.extensionFrameStage0)({
    parseDOM: [
        {
            context: "extensionFrame//",
            tag: "div[data-extension-frame]",
            skip: true
        },
        {
            tag: "div[data-extension-frame]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-extension-frame": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $aa0dc7b229d798e1$export$c3c04d555a8b9013 = (0, $ceuZl.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: "multiBodiedExtension//",
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2HBwi.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "multi-bodied-extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});
parcelRegister("2HBwi", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", function () { return $1f7cb3936da4ef5a$export$1765e2758fc47004; });
var $1f7cb3936da4ef5a$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        "default",
        "wide",
        "full-width"
    ].includes(name);
};
var $1f7cb3936da4ef5a$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute("data-extension-type");
    var extensionKey = dom.getAttribute("data-extension-key");
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute("data-text") || undefined,
        parameters: JSON.parse(dom.getAttribute("data-parameters") || "{}"),
        localId: dom.getAttribute("data-local-id") || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute("data-layout");
        attrs.layout = $1f7cb3936da4ef5a$export$d5f21755dc782a4a(rawLayout) ? rawLayout : "default";
    }
    return attrs;
};

});


parcelRegister("cjtvg", function(module, exports) {

$parcel$export(module.exports, "layoutSection", function () { return $8f6e2521180a2f27$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $8f6e2521180a2f27$export$4f9d8f623ff17117; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $8f6e2521180a2f27$export$b3b6a70a7fa4a5be = (0, $ceuZl.layoutSection)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $8f6e2521180a2f27$export$cdae19acb0a520fd = (0, $ceuZl.layoutSectionFull)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-layout-section": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $8f6e2521180a2f27$export$4f9d8f623ff17117 = (0, $ceuZl.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute("data-column-rule-style");
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            "data-layout-section": "true",
            "data-column-rule-style": columnRuleStyle || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $8f6e2521180a2f27$export$d9d3c69a64270b13 = (0, $ceuZl.layoutSection)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs() {
                var localId = (0, $bI8Ay.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-layout-section": "true",
            "data-local-id": localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $8f6e2521180a2f27$export$64facded20dfd85c = (0, $ceuZl.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: "layoutSection//|layoutColumn//",
            tag: "div[data-layout-section]",
            skip: true
        },
        {
            tag: "div[data-layout-section]",
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute("data-column-rule-style");
                var localId = (0, $bI8Ay.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            "data-layout-section": "true",
            "data-column-rule-style": columnRuleStyle || undefined,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("gM9eJ", function(module, exports) {

$parcel$export(module.exports, "listItem", function () { return $c3684b3dcf318d65$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $c3684b3dcf318d65$export$b2cd54d5ce935ddb; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
var $c3684b3dcf318d65$export$76c7e83ecc9cdf05 = (0, $ceuZl.listItem)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});
var $c3684b3dcf318d65$export$483d52f09158e61c = (0, $ceuZl.listItem)({
    parseDOM: [
        {
            tag: "li",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            "li",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $c3684b3dcf318d65$export$b2cd54d5ce935ddb = (0, $ceuZl.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM: function toDOM() {
        return [
            "li",
            0
        ];
    }
});
var $c3684b3dcf318d65$export$394466eb252d967a = (0, $ceuZl.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: "li",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            "li",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("eZY8K", function(module, exports) {

$parcel$export(module.exports, "syncBlock", function () { return $aeb569be640e9eeb$export$faab0ca9701d7048; });

var $ceuZl = parcelRequire("ceuZl");
var $aeb569be640e9eeb$export$faab0ca9701d7048 = (0, $ceuZl.syncBlockStage0)({
    parseDOM: [
        {
            tag: "div[data-sync-block]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute("data-local-id") || "",
                    resourceId: dom.getAttribute("data-resource-id") || ""
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = "div";
        var attrs = {
            "data-sync-block": "",
            "data-local-id": localId,
            "data-resource-id": resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("8gSlb", function(module, exports) {

$parcel$export(module.exports, "table", function () { return $6059f841fce889ee$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableRow", function () { return $6059f841fce889ee$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $6059f841fce889ee$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableHeader", function () { return $6059f841fce889ee$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $6059f841fce889ee$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $6059f841fce889ee$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $6059f841fce889ee$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $6059f841fce889ee$export$2a5a518232fa1a97; });

var $7hPAH = parcelRequire("7hPAH");

var $417VF = parcelRequire("417VF");

var $b4q3Q = parcelRequire("b4q3Q");

var $2zOsm = parcelRequire("2zOsm");

var $bI8Ay = parcelRequire("bI8Ay");

var $dMATI = parcelRequire("dMATI");

var $ceuZl = parcelRequire("ceuZl");
function $6059f841fce889ee$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6059f841fce889ee$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6059f841fce889ee$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6059f841fce889ee$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6059f841fce889ee$export$9cfceb893b24742a = "pm-table";
var $6059f841fce889ee$export$69cb4c3f80383763 = "".concat($6059f841fce889ee$export$9cfceb893b24742a, "-cell-content-wrap");
var $6059f841fce889ee$export$7b07d37d879c957f = "".concat($6059f841fce889ee$export$9cfceb893b24742a, "-header-content-wrap");
var $6059f841fce889ee$export$8dd42a84cd52da07 = "".concat($6059f841fce889ee$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $6059f841fce889ee$export$5e26a5c19f0865d8 = "".concat($6059f841fce889ee$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $6059f841fce889ee$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $2zOsm.N20).toLocaleLowerCase();
var $6059f841fce889ee$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute("data-colwidth");
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(",").map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute("colspan") || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute("data-cell-background");
    var dataCellBackgroundHexCode = dataCellBackground && (0, $2zOsm.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes("--ds-background-neutral")) backgroundColor = "";
    else if (backgroundColor && (0, $2zOsm.isRgb)(backgroundColor)) {
        var result = (0, $2zOsm.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues["background"] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $6059f841fce889ee$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute("rowspan") || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $6059f841fce889ee$var$testGlobalTheme;
var $6059f841fce889ee$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $6059f841fce889ee$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $6059f841fce889ee$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($6059f841fce889ee$var$testGlobalTheme) return {
        colorMode: $6059f841fce889ee$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $6059f841fce889ee$var$cssVariablePattern = /^var\(--.*\)$/;
var $6059f841fce889ee$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs["data-colwidth"] = node.attrs.colwidth.join(",");
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === "tableHeader" && background === $6059f841fce889ee$export$8cc2833b5b349a1e.get("light gray") || nodeType === "tableCell" && background === $6059f841fce889ee$export$8cc2833b5b349a1e.get("white") || nodeType === "tableHeader" && background.includes("--ds-background-neutral");
        if (ignored) attrs.style = "";
        else {
            var color = (0, $2zOsm.isRgb)(background) && (0, $2zOsm.rgbToHex)(background) ? (0, $2zOsm.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $b4q3Q.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $6059f841fce889ee$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($6059f841fce889ee$var$getGlobalTheme().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $dMATI.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs["data-cell-background"] = color;
            if (typeof color === "string") attrs.colorname = $6059f841fce889ee$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === "tableHeader") attrs.class = $6059f841fce889ee$export$7b07d37d879c957f;
    else attrs.class = $6059f841fce889ee$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs["data-local-id"] = node.attrs.localId;
    return attrs;
};
var $6059f841fce889ee$export$219b7f492ad209f8 = new Map();
var $6059f841fce889ee$export$95e9c925fbf01d1c = (0, $2zOsm.hexToRgba)((0, $2zOsm.N800), 0.12) || (0, $2zOsm.N0);
var $6059f841fce889ee$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $2zOsm.N0),
        "White"
    ],
    [
        (0, $2zOsm.B50),
        "Light blue"
    ],
    [
        (0, $2zOsm.T50),
        "Light teal"
    ],
    [
        (0, $2zOsm.G50),
        "Light green"
    ],
    [
        (0, $2zOsm.Y50),
        "Light yellow"
    ],
    [
        (0, $2zOsm.R50),
        "Light red"
    ],
    [
        (0, $2zOsm.P50),
        "Light purple"
    ],
    [
        (0, $2zOsm.N20),
        "Light gray"
    ],
    [
        (0, $2zOsm.B75),
        "Blue"
    ],
    [
        (0, $2zOsm.T75),
        "Teal"
    ],
    [
        (0, $2zOsm.G75),
        "Green"
    ],
    [
        (0, $2zOsm.Y75),
        "Yellow"
    ],
    [
        (0, $2zOsm.R75),
        "Red"
    ],
    [
        (0, $2zOsm.P75),
        "Purple"
    ],
    [
        (0, $2zOsm.N60),
        "Gray"
    ],
    [
        (0, $2zOsm.B100),
        "Dark blue"
    ],
    [
        (0, $2zOsm.T100),
        "Dark teal"
    ],
    [
        (0, $2zOsm.G200),
        "Dark green"
    ],
    [
        (0, $2zOsm.Y200),
        "Dark yellow"
    ],
    [
        (0, $2zOsm.R100),
        "Dark red"
    ],
    [
        (0, $2zOsm.P100),
        "Dark purple"
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $7hPAH.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $6059f841fce889ee$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $6059f841fce889ee$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $6059f841fce889ee$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: "table",
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute("data-number-column") === "true",
                    layout: // copying from editor
                    dom.getAttribute("data-layout") || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute("data-layout")) || "default",
                    __autoSize: dom.getAttribute("data-autosize") === "true",
                    localId: dom.getAttribute("data-table-local-id") || (0, $bI8Ay.uuid).generate(),
                    width: Number(dom.getAttribute("data-table-width")) || null,
                    displayMode: dom.getAttribute("data-table-display-mode") || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-number-column": node.attrs.isNumberColumnEnabled,
            "data-layout": node.attrs.layout,
            "data-autosize": node.attrs.__autoSize,
            "data-table-local-id": node.attrs.localId,
            "data-table-width": node.attrs.width,
            "data-table-display-mode": node.attrs.displayMode
        };
        return [
            "table",
            attrs,
            [
                "tbody",
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $6059f841fce889ee$var$createTableSpec = function createTableSpec() {
    return (0, $ceuZl.table)($6059f841fce889ee$var$tableNodeSpecOptions);
};
var $6059f841fce889ee$export$9852986a3ec5f6a0 = $6059f841fce889ee$var$createTableSpec();
var $6059f841fce889ee$export$90e634fbace1f0c4 = $6059f841fce889ee$var$createTableSpec();
var $6059f841fce889ee$export$3862de5c8c9098cf = $6059f841fce889ee$var$createTableSpec();
var $6059f841fce889ee$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith("__") && (key !== "localId" || !!value);
};
var $6059f841fce889ee$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $6059f841fce889ee$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $6059f841fce889ee$var$_objectSpread($6059f841fce889ee$var$_objectSpread({}, obj), {}, (0, $417VF.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $6059f841fce889ee$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: "tr"
        }
    ],
    toDOM: function toDOM() {
        return [
            "tr",
            0
        ];
    }
};
var $6059f841fce889ee$export$ce666bf02318c957 = (0, $ceuZl.tableRow)($6059f841fce889ee$var$tableRowNodeSpecOptions);
var $6059f841fce889ee$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $6059f841fce889ee$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: ".ak-renderer-table-number-column",
            ignore: true
        },
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return $6059f841fce889ee$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            $6059f841fce889ee$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $6059f841fce889ee$export$e1e720e5f4603e6a = (0, $ceuZl.tableCell)($6059f841fce889ee$var$tableCellNodeSpecOptions);
var $6059f841fce889ee$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($6059f841fce889ee$var$cellAttrs[key] && $6059f841fce889ee$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $6059f841fce889ee$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return $6059f841fce889ee$export$43977bde391e007(dom, {
                    background: $6059f841fce889ee$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            $6059f841fce889ee$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $6059f841fce889ee$export$48884d2a5190dc73 = (0, $ceuZl.tableHeader)($6059f841fce889ee$var$tableHeaderNodeSpecOptions);
var $6059f841fce889ee$export$2af48797a1010bb1 = $6059f841fce889ee$export$2ac34c099660f1a8;
var $6059f841fce889ee$export$ce086a560a1d05f5 = (0, $ceuZl.tableWithNestedTable)($6059f841fce889ee$var$tableNodeSpecOptions);
var $6059f841fce889ee$export$7d657479499397 = (0, $ceuZl.tableRowWithNestedTable)($6059f841fce889ee$var$tableRowNodeSpecOptions);
var $6059f841fce889ee$export$abf39ca178940ff3 = (0, $ceuZl.tableCellWithNestedTable)($6059f841fce889ee$var$tableCellNodeSpecOptions);
var $6059f841fce889ee$export$2a5a518232fa1a97 = (0, $ceuZl.tableHeaderWithNestedTable)($6059f841fce889ee$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $6059f841fce889ee$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "tr",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            "tr",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $6059f841fce889ee$export$c8f0853ac97552c9 = (0, $ceuZl.tableRow)($6059f841fce889ee$var$tableRowNodeSpecOptionsWithLocalId);
var $6059f841fce889ee$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "td",
            getAttrs: function getAttrs(dom) {
                return $6059f841fce889ee$export$43977bde391e007(dom, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "td",
            $6059f841fce889ee$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $6059f841fce889ee$export$db76cfd28a574029 = (0, $ceuZl.tableCell)($6059f841fce889ee$var$tableCellNodeSpecOptionsWithLocalId);
var $6059f841fce889ee$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "th",
            getAttrs: function getAttrs(dom) {
                return $6059f841fce889ee$export$43977bde391e007(dom, {
                    background: $6059f841fce889ee$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "th",
            $6059f841fce889ee$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $6059f841fce889ee$export$b82d2b1d8824143d = (0, $ceuZl.tableHeader)($6059f841fce889ee$var$tableHeaderNodeSpecOptionsWithLocalId);
var $6059f841fce889ee$export$27926e30c8a74147 = (0, $ceuZl.tableRowWithNestedTable)($6059f841fce889ee$var$tableRowNodeSpecOptionsWithLocalId);
var $6059f841fce889ee$export$e9fd700fafee293a = (0, $ceuZl.tableCellWithNestedTable)($6059f841fce889ee$var$tableCellNodeSpecOptionsWithLocalId);
var $6059f841fce889ee$export$7928c3aeb4cd2213 = (0, $ceuZl.tableHeaderWithNestedTable)($6059f841fce889ee$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("7hPAH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $54e223d09d3563a6$export$2e2bcd8739ae039; });

var $fcWJA = parcelRequire("fcWJA");

var $5QxFb = parcelRequire("5QxFb");

var $jr0Cx = parcelRequire("jr0Cx");

var $kynti = parcelRequire("kynti");
function $54e223d09d3563a6$export$2e2bcd8739ae039(r, e) {
    return (0, $fcWJA.default)(r) || (0, $5QxFb.default)(r, e) || (0, $jr0Cx.default)(r, e) || (0, $kynti.default)();
}

});
parcelRegister("fcWJA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b125896c2fb0ccf5$export$2e2bcd8739ae039; });
function $b125896c2fb0ccf5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5QxFb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $441bebeb8a2bcd90$export$2e2bcd8739ae039; });
function $441bebeb8a2bcd90$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("jr0Cx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e261052646a7a0f5$export$2e2bcd8739ae039; });

var $4VT0m = parcelRequire("4VT0m");
function $e261052646a7a0f5$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $4VT0m.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $4VT0m.default)(r, a) : void 0;
    }
}

});
parcelRegister("4VT0m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3977271d305d3487$export$2e2bcd8739ae039; });
function $3977271d305d3487$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("kynti", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef69309969fadc7d$export$2e2bcd8739ae039; });
function $ef69309969fadc7d$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("b4q3Q", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $80f448a0ebd83054$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $80f448a0ebd83054$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $80f448a0ebd83054$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $80f448a0ebd83054$export$a270511a0e7fd61a; });

var $4LHd8 = parcelRequire("4LHd8");
function $80f448a0ebd83054$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $80f448a0ebd83054$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $80f448a0ebd83054$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ "#091E4224": "var(--ds-border, #091E4224)",
    /** gray */ "#758195": "var(--ds-border-bold, #758195)",
    /** gray - bold */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $80f448a0ebd83054$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $80f448a0ebd83054$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $80f448a0ebd83054$export$57fa5089caad992 = {
    /** blue - light */ "#B3D4FF": "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    /** blue - medium */ "#4C9AFF": "var(--ds-icon-accent-blue, #4C9AFF)",
    /** blue - strong */ "#0747A6": "var(--ds-text-accent-blue, #0747A6)",
    /** teal - light */ "#B3F5FF": "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    /** teal - medium */ "#00B8D9": "var(--ds-icon-accent-teal, #00B8D9)",
    /** teal - strong */ "#008DA6": "var(--ds-text-accent-teal, #008DA6)",
    /** green - light */ "#ABF5D1": "var(--ds-background-accent-green-subtler, #ABF5D1)",
    /** green - medium */ "#36B37E": "var(--ds-icon-accent-green, #36B37E)",
    /** green - strong */ "#006644": "var(--ds-text-accent-green, #006644)",
    /** yellowOrange - light */ "#FFF0B3": "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    /** yellowOrange - medium */ "#FFC400": "var(--ds-background-accent-orange-subtle, #FFC400)",
    /** yellowOrange - strong */ "#FF991F": "var(--ds-icon-accent-orange, #FF991F)",
    /** red - light */ "#FFBDAD": "var(--ds-background-accent-red-subtler, #FFBDAD)",
    /** red - medium */ "#FF5630": "var(--ds-icon-accent-red, #FF5630)",
    /** red - strong */ "#BF2600": "var(--ds-text-accent-red, #BF2600)",
    /** purple - light */ "#EAE6FF": "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    /** purple - medium */ "#6554C0": "var(--ds-icon-accent-purple, #6554C0)",
    /** purple - strong */ "#403294": "var(--ds-text-accent-purple, #403294)",
    /** whiteGray - light */ "#FFFFFF": "var(--ds-text-inverse, #FFFFFF)",
    /** whiteGray - medium */ "#97A0AF": "var(--ds-icon-accent-gray, #97A0AF)",
    /** whiteGray - strong */ "#172B4D": "var(--ds-text, #172B4D)"
};
function $80f448a0ebd83054$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $4LHd8.default).getExperimentValue("platform_editor_add_orange_highlight_color", "cohort", "control") !== "test") $80f448a0ebd83054$export$12a518ff137dd389["#FEDEC8"] = "var(--ds-background-accent-yellow-subtler, #F8E6A0)";
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $80f448a0ebd83054$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $80f448a0ebd83054$export$12a518ff137dd389 = {
    /** Gray - light */ "#DCDFE4": "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ "#C6EDFB": "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ "#D3F1A7": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Yellow - light */ "#F8E6A0": "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    /** Orange - light */ "#FEDEC8": "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ "#FDD0EC": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ "#DFD8FD": "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $80f448a0ebd83054$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $80f448a0ebd83054$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $80f448a0ebd83054$export$2462741d70e6a62f = {
    /** blue - light */ "#DEEBFF": {
        getValue: function getValue() {
            return "#DEEBFF";
        },
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    /** blue - medium */ "#B3D4FF": {
        getValue: function getValue() {
            return "#B3D4FF";
        },
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    /** blue - strong */ "#4C9AFF": {
        getValue: function getValue() {
            return "#4C9AFF";
        },
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    /** teal - light */ "#E6FCFF": {
        getValue: function getValue() {
            return "#E6FCFF";
        },
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)"
    },
    /** teal - medium */ "#B3F5FF": {
        getValue: function getValue() {
            return "#B3F5FF";
        },
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)"
    },
    /** teal - strong */ "#79E2F2": {
        getValue: function getValue() {
            return "#79E2F2";
        },
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)"
    },
    /** green - light */ "#E3FCEF": {
        getValue: function getValue() {
            return "#E3FCEF";
        },
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)"
    },
    /** green - medium */ "#ABF5D1": {
        getValue: function getValue() {
            return "#ABF5D1";
        },
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)"
    },
    /** green - strong */ "#57D9A3": {
        getValue: function getValue() {
            return "#57D9A3";
        },
        token: "var(--ds-background-accent-green-subtle, #57D9A3)"
    },
    /** yellowOrange - light */ "#FFFAE6": {
        getValue: function getValue() {
            return "#FFFAE6";
        },
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)"
    },
    /** yellowOrange - medium */ "#FFF0B3": {
        getValue: function getValue() {
            return "#FFF0B3";
        },
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)"
    },
    /** yellowOrange - strong */ "#FFC400": {
        getValue: function getValue() {
            return "#FFC400";
        },
        token: "var(--ds-background-accent-orange-subtle, #FFC400)"
    },
    /** red - light */ "#FFEBE6": {
        getValue: function getValue() {
            return "#FFEBE6";
        },
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)"
    },
    /** red - medium */ "#FFBDAD": {
        getValue: function getValue() {
            return "#FFBDAD";
        },
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)"
    },
    /** red - strong */ "#FF8F73": {
        getValue: function getValue() {
            return "#FF8F73";
        },
        token: "var(--ds-background-accent-red-subtle, #FF8F73)"
    },
    /** purple - light */ "#EAE6FF": {
        getValue: function getValue() {
            return "#EAE6FF";
        },
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)"
    },
    /** purple - medium */ "#C0B6F2": {
        getValue: function getValue() {
            return "#C0B6F2";
        },
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)"
    },
    /** purple - strong */ "#998DD9": {
        getValue: function getValue() {
            return "#998DD9";
        },
        token: "var(--ds-background-accent-purple-subtle, #998DD9)"
    },
    /** whiteGray - light */ "#FFFFFF": {
        getValue: function getValue() {
            return "#FFFFFF";
        },
        token: "var(--ds-surface, #FFFFFF)"
    },
    /** whiteGray - medium */ "#F4F5F7": {
        getValue: function getValue() {
            return "#F4F5F7";
        },
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)"
    },
    /** whiteGray - strong */ "#B3BAC5": {
        getValue: function getValue() {
            return "#B3BAC5";
        },
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)"
    }
};

});

parcelRegister("2zOsm", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $1e05fd4443145055$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $1e05fd4443145055$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $1e05fd4443145055$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $1e05fd4443145055$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $1e05fd4443145055$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $1e05fd4443145055$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $1e05fd4443145055$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $1e05fd4443145055$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Yellow200", function () { return $1e05fd4443145055$export$fc857b6f8771648a; });
$parcel$export(module.exports, "Y400", function () { return $1e05fd4443145055$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $1e05fd4443145055$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $1e05fd4443145055$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $1e05fd4443145055$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $1e05fd4443145055$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $1e05fd4443145055$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $1e05fd4443145055$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $1e05fd4443145055$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $1e05fd4443145055$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $1e05fd4443145055$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $1e05fd4443145055$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $1e05fd4443145055$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $1e05fd4443145055$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $1e05fd4443145055$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $1e05fd4443145055$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $1e05fd4443145055$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $1e05fd4443145055$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $1e05fd4443145055$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $1e05fd4443145055$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $1e05fd4443145055$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $1e05fd4443145055$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $1e05fd4443145055$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $1e05fd4443145055$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $1e05fd4443145055$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $1e05fd4443145055$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $1e05fd4443145055$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $1e05fd4443145055$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $1e05fd4443145055$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $1e05fd4443145055$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $1e05fd4443145055$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $1e05fd4443145055$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $1e05fd4443145055$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $1e05fd4443145055$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $1e05fd4443145055$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $1e05fd4443145055$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $1e05fd4443145055$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $1e05fd4443145055$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $1e05fd4443145055$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $1e05fd4443145055$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $1e05fd4443145055$export$9665a07d9187b414; });

var $7hPAH = parcelRequire("7hPAH");

var $1PZpd = parcelRequire("1PZpd");
var $1e05fd4443145055$export$4b84fd0e2c617bd = "#FFEBE6";
var $1e05fd4443145055$export$b34b069eff244586 = "#FFBDAD";
var $1e05fd4443145055$export$be802dd0d8b57f35 = "#FF8F73";
var $1e05fd4443145055$export$4a7404f376229999 = "#FF5630";
var $1e05fd4443145055$export$2010d0fb4295b346 = "#DE350B";
var $1e05fd4443145055$export$2837b5a1a71d5c02 = "#BF2600";
var $1e05fd4443145055$export$8d9596b529bbb9cf = "#FFFAE6";
var $1e05fd4443145055$export$41060a744ab0b7ae = "#FFF0B3";
var $1e05fd4443145055$export$5aae31392d72caaa = "#FFC400";
var $1e05fd4443145055$export$fc857b6f8771648a = "#F8E6A0";
var $1e05fd4443145055$export$59619663aa6500fb = "#FF991F";
var $1e05fd4443145055$export$874739ea9e379ab6 = "#FF8B00";
var $1e05fd4443145055$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $1e05fd4443145055$export$69a3bf21b9686c2b = "#ABF5D1";
var $1e05fd4443145055$export$747d86715d4175de = "#57D9A3";
var $1e05fd4443145055$export$940e1f69e873f202 = "#36B37E";
var $1e05fd4443145055$export$a49394138f7b8e85 = "#00875A";
var $1e05fd4443145055$export$6fa04827ac68a4fb = "#006644";
var $1e05fd4443145055$export$226de0355ed012f8 = "#DEEBFF";
var $1e05fd4443145055$export$8c13c2ee36917869 = "#B3D4FF";
var $1e05fd4443145055$export$ecfc1dff386a3e7a = "#4C9AFF";
var $1e05fd4443145055$export$b3de0ae08da2ce64 = "#0052CC";
var $1e05fd4443145055$export$a6ee3d71bc067634 = "#0747A6";
var $1e05fd4443145055$export$f72948ef771f6f15 = "#D3F1A7";
var $1e05fd4443145055$export$29a4f05edc054374 = "#FFFFFF";
var $1e05fd4443145055$export$9fdfb749e33cdf97 = "#F4F5F7";
var $1e05fd4443145055$export$3e51e8f1440314ba = "#EBECF0";
var $1e05fd4443145055$export$1ce2d1575d444ceb = "#DFE1E6";
var $1e05fd4443145055$export$8754fc7e6d8b3000 = "#C1C7D0";
var $1e05fd4443145055$export$c2e91cbeada39b8b = "#B3BAC5";
var $1e05fd4443145055$export$eaa8c8a70ac22806 = "#97A0AF";
var $1e05fd4443145055$export$7c87d337fb91a97d = "#8993A4";
var $1e05fd4443145055$export$f563ee71e9ee74cd = "#6B778C";
var $1e05fd4443145055$export$e2ef2124cf4024b1 = "#5E6C84";
var $1e05fd4443145055$export$1ae1cebe22dcedb4 = "#DCDFE4";
var $1e05fd4443145055$export$13609db0e6812ab8 = "#091E4224";
var $1e05fd4443145055$export$c39c0fe0f26207ae = "#42526E";
var $1e05fd4443145055$export$7090862dc3038a9f = "#758195";
var $1e05fd4443145055$export$7d61b15e0da132af = "#172B4D";
var $1e05fd4443145055$export$f78789c8b01753cd = "#172B4D";
var $1e05fd4443145055$export$a19f0c33186f7767 = "#FDD0EC";
var $1e05fd4443145055$export$51716a84e62e022c = "#FEDEC8";
var $1e05fd4443145055$export$363e4475840015bb = "#EAE6FF";
var $1e05fd4443145055$export$4b0a4417ed59760f = "#C0B6F2";
var $1e05fd4443145055$export$6011520a64d9a187 = "#998DD9";
var $1e05fd4443145055$export$a7175d4e9206bc80 = "#DFD8FD";
var $1e05fd4443145055$export$b48405b95304b5a1 = "#6554C0";
var $1e05fd4443145055$export$c71e4279dd54a18d = "#5243AA";
var $1e05fd4443145055$export$147899de772240ec = "#403294";
var $1e05fd4443145055$export$2cf711fe14c66f06 = "#E6FCFF";
var $1e05fd4443145055$export$7a8f4d33f6f9772c = "#B3F5FF";
var $1e05fd4443145055$export$776c9c497ef08533 = "#79E2F2";
var $1e05fd4443145055$export$69cb3ca10c1e330e = "#C6EDFB";
var $1e05fd4443145055$export$9dc1ef0f3f48059b = "#00B8D9";
var $1e05fd4443145055$export$6036577f95c3877e = "#008DA6";
function $1e05fd4443145055$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($1e05fd4443145055$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split("").map(function(c) {
            return c === "#" ? "#" : "".concat(c).concat(c);
        }).join("");
    } else if ($1e05fd4443145055$export$e698776ec826343(color)) return $1e05fd4443145055$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === "default") return null;
        else if ($1PZpd.default && $1PZpd.default[color]) color = $1PZpd.default[color];
        else if ($1PZpd && $1PZpd[color]) color = $1PZpd[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $1e05fd4443145055$export$5a544e13ad4e1fa5(color) {
    if (!$1e05fd4443145055$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split("");
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join("")));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $1e05fd4443145055$export$9665a07d9187b414(rawColor, alpha) {
    var color = $1e05fd4443145055$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(","), ")");
}
function $1e05fd4443145055$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $7hPAH.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return "#" + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $1e05fd4443145055$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $1e05fd4443145055$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});

parcelRegister("dMATI", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $a08c6123af5ec6f4$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $a08c6123af5ec6f4$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $a08c6123af5ec6f4$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $a08c6123af5ec6f4$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $a08c6123af5ec6f4$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $a08c6123af5ec6f4$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $a08c6123af5ec6f4$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $a08c6123af5ec6f4$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $a08c6123af5ec6f4$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $a08c6123af5ec6f4$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $a08c6123af5ec6f4$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $a08c6123af5ec6f4$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $a08c6123af5ec6f4$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $a08c6123af5ec6f4$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $a08c6123af5ec6f4$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $a08c6123af5ec6f4$var$rgbToLch = function rgbToLch(rgb) {
    return $a08c6123af5ec6f4$var$labToLch($a08c6123af5ec6f4$var$xyzToLab($a08c6123af5ec6f4$var$rgbToXyz(rgb)));
};
var $a08c6123af5ec6f4$var$lchToRgb = function lchToRgb(lch) {
    return $a08c6123af5ec6f4$var$xyzToRgb($a08c6123af5ec6f4$var$labToXyz($a08c6123af5ec6f4$var$lchToLab(lch)));
};
var $a08c6123af5ec6f4$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $a08c6123af5ec6f4$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $a08c6123af5ec6f4$var$rgbToLch(rgb);
    lch.l = $a08c6123af5ec6f4$var$clamp(newPercent, 0, 100);
    return $a08c6123af5ec6f4$var$rgbToHex($a08c6123af5ec6f4$var$lchToRgb(lch));
};
var $a08c6123af5ec6f4$var$getLightness = function getLightness(color) {
    var rgb = $a08c6123af5ec6f4$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $a08c6123af5ec6f4$var$rgbToLch(rgb);
    return lch.l;
};
var $a08c6123af5ec6f4$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $a08c6123af5ec6f4$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $a08c6123af5ec6f4$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("jVI5d", function(module, exports) {

$parcel$export(module.exports, "createSchema", function () { return $e82589282ac29ac4$export$5f4ce795563f4211; });

var $2succ = parcelRequire("2succ");

var $cE2or = parcelRequire("cE2or");

var $50wYd = parcelRequire("50wYd");

var $aUr33 = parcelRequire("aUr33");
var $7GRkj = parcelRequire("7GRkj");
var $1Zx1F = parcelRequire("1Zx1F");
var $2lYmO = parcelRequire("2lYmO");
var $9QETs = parcelRequire("9QETs");
var $OA5QS = parcelRequire("OA5QS");
var $ibB8x = parcelRequire("ibB8x");
var $5IKJ6 = parcelRequire("5IKJ6");
var $d1unO = parcelRequire("d1unO");
var $bd7Dn = parcelRequire("bd7Dn");
var $cqSTp = parcelRequire("cqSTp");
var $8025L = parcelRequire("8025L");
var $kYri4 = parcelRequire("kYri4");
var $1upJy = parcelRequire("1upJy");
var $9UALV = parcelRequire("9UALV");
var $gpALN = parcelRequire("gpALN");
var $2caEI = parcelRequire("2caEI");
var $j5tG8 = parcelRequire("j5tG8");
var $hmtgI = parcelRequire("hmtgI");
var $4TvWL = parcelRequire("4TvWL");

var $FFE94 = parcelRequire("FFE94");
var $klliO = parcelRequire("klliO");
var $gMOX4 = parcelRequire("gMOX4");
var $iiKEH = parcelRequire("iiKEH");
var $iTzjv = parcelRequire("iTzjv");
var $2qvtN = parcelRequire("2qvtN");
var $3J7dg = parcelRequire("3J7dg");
var $e5HHV = parcelRequire("e5HHV");
var $dVWVz = parcelRequire("dVWVz");
var $6gCnQ = parcelRequire("6gCnQ");
var $38GhG = parcelRequire("38GhG");
var $lLKxs = parcelRequire("lLKxs");
var $jVUUr = parcelRequire("jVUUr");
var $1i4nh = parcelRequire("1i4nh");
var $eDvyI = parcelRequire("eDvyI");
var $fDngI = parcelRequire("fDngI");
var $bHU7n = parcelRequire("bHU7n");
var $lI9dQ = parcelRequire("lI9dQ");
var $3SOm6 = parcelRequire("3SOm6");
var $eBbW7 = parcelRequire("eBbW7");
var $g6wtR = parcelRequire("g6wtR");
var $hGcqq = parcelRequire("hGcqq");
var $hQZNB = parcelRequire("hQZNB");
var $5p6cx = parcelRequire("5p6cx");
var $3vnPp = parcelRequire("3vnPp");
var $3Bcqm = parcelRequire("3Bcqm");
var $cjtvg = parcelRequire("cjtvg");
var $gM9eJ = parcelRequire("gM9eJ");
var $uEvQZ = parcelRequire("uEvQZ");
var $kfA1Y = parcelRequire("kfA1Y");
var $4wAmH = parcelRequire("4wAmH");
var $lRp6Z = parcelRequire("lRp6Z");
var $kq0F2 = parcelRequire("kq0F2");
var $jhapy = parcelRequire("jhapy");
var $9MmD5 = parcelRequire("9MmD5");
var $7GBWG = parcelRequire("7GBWG");
var $chRYW = parcelRequire("chRYW");
var $hsZqR = parcelRequire("hsZqR");
var $aAisl = parcelRequire("aAisl");
var $eZY8K = parcelRequire("eZY8K");
var $8gSlb = parcelRequire("8gSlb");
var $dFjEs = parcelRequire("dFjEs");
var $1eeTW = parcelRequire("1eeTW");
var $cuLGP = parcelRequire("cuLGP");
var $8cnnR = parcelRequire("8cnnR");
var $cKx2u = parcelRequire("cKx2u");
function $e82589282ac29ac4$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $e82589282ac29ac4$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $e82589282ac29ac4$var$markGroupDeclarations = [
    $e82589282ac29ac4$var$groupDeclaration((0, $cE2or.COLOR)),
    $e82589282ac29ac4$var$groupDeclaration((0, $cE2or.FONT_STYLE)),
    $e82589282ac29ac4$var$groupDeclaration((0, $cE2or.SEARCH_QUERY)),
    $e82589282ac29ac4$var$groupDeclaration((0, $cE2or.LINK))
];
var $e82589282ac29ac4$var$markGroupDeclarationsNames = $e82589282ac29ac4$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $e82589282ac29ac4$var$nodesInOrder = [
    {
        name: "doc",
        spec: (0, $jVUUr.doc)
    },
    {
        name: "paragraph",
        spec: (0, $7GBWG.paragraph)
    },
    {
        name: "text",
        spec: (0, $1eeTW.text)
    },
    {
        name: "bulletList",
        spec: (0, $iiKEH.bulletList)
    },
    {
        name: "orderedList",
        spec: (0, $9MmD5.orderedListWithOrder)
    },
    {
        name: "listItem",
        spec: (0, $gM9eJ.listItem)
    },
    {
        name: "heading",
        spec: (0, $hGcqq.heading)
    },
    {
        name: "blockquote",
        spec: (0, $bHU7n.extendedBlockquote)
    },
    {
        name: "codeBlock",
        spec: (0, $2qvtN.codeBlock)
    },
    {
        name: "panel",
        spec: (0, $lI9dQ.extendedPanel)(true)
    },
    {
        name: "rule",
        spec: (0, $hsZqR.rule)
    },
    {
        name: "image",
        spec: (0, $hQZNB.image)
    },
    {
        name: "mention",
        spec: (0, $kq0F2.mention)
    },
    {
        name: "caption",
        spec: (0, $iTzjv.caption)
    },
    {
        name: "media",
        spec: (0, $uEvQZ.media)
    },
    {
        name: "mediaGroup",
        spec: (0, $kfA1Y.mediaGroup)
    },
    {
        name: "mediaSingle",
        spec: (0, $lRp6Z.mediaSingleFull)
    },
    {
        name: "mediaInline",
        spec: (0, $4wAmH.mediaInline)
    },
    {
        name: "placeholder",
        spec: (0, $chRYW.placeholder)
    },
    {
        name: "layoutSection",
        spec: (0, $cjtvg.layoutSection)
    },
    {
        name: "layoutColumn",
        spec: (0, $3Bcqm.layoutColumn)
    },
    {
        name: "hardBreak",
        spec: (0, $g6wtR.hardBreak)
    },
    {
        name: "emoji",
        spec: (0, $eDvyI.emoji)
    },
    {
        name: "table",
        spec: (0, $8gSlb.table)
    },
    {
        name: "tableCell",
        spec: (0, $8gSlb.tableCell)
    },
    {
        name: "tableRow",
        spec: (0, $8gSlb.tableRow)
    },
    {
        name: "tableHeader",
        spec: (0, $8gSlb.tableHeader)
    },
    {
        name: "confluenceJiraIssue",
        spec: (0, $3J7dg.confluenceJiraIssue)
    },
    {
        name: "confluenceUnsupportedInline",
        spec: (0, $dVWVz.confluenceUnsupportedInline)
    },
    {
        name: "confluenceUnsupportedBlock",
        spec: (0, $e5HHV.confluenceUnsupportedBlock)
    },
    {
        name: "decisionList",
        spec: (0, $lLKxs.decisionList)
    },
    {
        name: "decisionItem",
        spec: (0, $38GhG.decisionItem)
    },
    {
        name: "taskList",
        spec: (0, $dFjEs.taskList)
    },
    {
        name: "taskItem",
        spec: (0, $klliO.taskItem)
    },
    {
        name: "blockTaskItem",
        spec: (0, $klliO.blockTaskItem)
    },
    {
        name: "date",
        spec: (0, $6gCnQ.date)
    },
    {
        name: "status",
        spec: (0, $aAisl.status)
    },
    {
        name: "expand",
        spec: (0, $fDngI.expandWithNestedExpand)
    },
    {
        name: "nestedExpand",
        spec: (0, $jhapy.nestedExpand)
    },
    {
        name: "extension",
        spec: (0, $3SOm6.extension)
    },
    {
        name: "inlineExtension",
        spec: (0, $3vnPp.inlineExtension)
    },
    {
        name: "bodiedExtension",
        spec: (0, $gMOX4.bodiedExtension)
    },
    {
        name: "multiBodiedExtension",
        spec: (0, $eBbW7.multiBodiedExtension)
    },
    {
        name: "extensionFrame",
        spec: (0, $eBbW7.extensionFrame)
    },
    {
        name: "inlineCard",
        spec: (0, $5p6cx.inlineCard)
    },
    {
        name: "blockCard",
        spec: (0, $FFE94.blockCard)
    },
    {
        name: "embedCard",
        spec: (0, $1i4nh.embedCard)
    },
    {
        name: "syncBlock",
        spec: (0, $eZY8K.syncBlock)
    },
    {
        name: "unknownBlock",
        spec: (0, $cuLGP.default)
    },
    {
        name: "unsupportedBlock",
        spec: (0, $8cnnR.unsupportedBlock)
    },
    {
        name: "unsupportedInline",
        spec: (0, $cKx2u.unsupportedInline)
    }
];
var $e82589282ac29ac4$var$marksInOrder = [
    {
        name: "link",
        spec: (0, $8025L.link)
    },
    {
        name: "em",
        spec: (0, $d1unO.em)
    },
    {
        name: "strong",
        spec: (0, $1upJy.strong)
    },
    {
        name: "textColor",
        spec: (0, $gpALN.textColor)
    },
    {
        name: "backgroundColor",
        spec: (0, $1Zx1F.backgroundColor)
    },
    {
        name: "strike",
        spec: (0, $kYri4.strike)
    },
    {
        name: "subsup",
        spec: (0, $9UALV.subsup)
    },
    {
        name: "underline",
        spec: (0, $j5tG8.underline)
    },
    {
        name: "code",
        spec: (0, $OA5QS.code)
    },
    {
        name: "typeAheadQuery",
        spec: (0, $2caEI.typeAheadQuery)
    },
    {
        name: "alignment",
        spec: (0, $aUr33.alignment)
    },
    {
        name: "annotation",
        spec: (0, $7GRkj.annotation)
    },
    {
        name: "confluenceInlineComment",
        spec: (0, $ibB8x.confluenceInlineComment)
    }
].concat($e82589282ac29ac4$var$markGroupDeclarations, [
    {
        name: "breakout",
        spec: (0, $9QETs.breakout)
    },
    {
        name: "dataConsumer",
        spec: (0, $5IKJ6.dataConsumer)
    },
    {
        name: "fragment",
        spec: (0, $bd7Dn.fragment)
    },
    {
        name: "indentation",
        spec: (0, $cqSTp.indentation)
    },
    {
        name: "border",
        spec: (0, $2lYmO.border)
    },
    {
        name: "unsupportedMark",
        spec: (0, $hmtgI.unsupportedMark)
    },
    {
        name: "unsupportedNodeAttribute",
        spec: (0, $4TvWL.unsupportedNodeAttribute)
    }
]);
function $e82589282ac29ac4$export$2d0c32a809131488() {
    var nodes = $e82589282ac29ac4$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $e82589282ac29ac4$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $e82589282ac29ac4$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($e82589282ac29ac4$var$markGroupDeclarationsNames);
    var nodes = $e82589282ac29ac4$var$addItems($e82589282ac29ac4$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $e82589282ac29ac4$var$addItems($e82589282ac29ac4$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $50wYd.sanitizeNodes)(nodes, marks);
    return new (0, $2succ.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $e82589282ac29ac4$export$c77b6d30da5276a1 = true;

});
parcelRegister("2succ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1ca59e8ae70c9cf8$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $1ca59e8ae70c9cf8$export$19342e026b58ebb7; });

var $73qKE = parcelRequire("73qKE");
function $1ca59e8ae70c9cf8$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1ca59e8ae70c9cf8$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $1ca59e8ae70c9cf8$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $1ca59e8ae70c9cf8$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $1ca59e8ae70c9cf8$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $1ca59e8ae70c9cf8$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $1ca59e8ae70c9cf8$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $1ca59e8ae70c9cf8$var$retIndex(0, pos);
        if (pos == this.size) return $1ca59e8ae70c9cf8$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $1ca59e8ae70c9cf8$var$retIndex(i + 1, end);
                return $1ca59e8ae70c9cf8$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty;
        if (nodes instanceof $1ca59e8ae70c9cf8$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty = new $1ca59e8ae70c9cf8$export$ffb0004e005737fa([], 0);
const $1ca59e8ae70c9cf8$var$found = {
    index: 0,
    offset: 0
};
function $1ca59e8ae70c9cf8$var$retIndex(index, offset) {
    $1ca59e8ae70c9cf8$var$found.index = index;
    $1ca59e8ae70c9cf8$var$found.offset = offset;
    return $1ca59e8ae70c9cf8$var$found;
}
function $1ca59e8ae70c9cf8$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$1ca59e8ae70c9cf8$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$1ca59e8ae70c9cf8$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $1ca59e8ae70c9cf8$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
        if (marks instanceof $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $1ca59e8ae70c9cf8$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $1ca59e8ae70c9cf8$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e($1ca59e8ae70c9cf8$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e($1ca59e8ae70c9cf8$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e.empty = new $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e($1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty, 0, 0);
function $1ca59e8ae70c9cf8$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($1ca59e8ae70c9cf8$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $1ca59e8ae70c9cf8$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $1ca59e8ae70c9cf8$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $1ca59e8ae70c9cf8$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $1ca59e8ae70c9cf8$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $1ca59e8ae70c9cf8$export$6de0e778727af3f2("Inconsistent open depths");
    return $1ca59e8ae70c9cf8$var$replaceOuter($from, $to, slice, 0);
}
function $1ca59e8ae70c9cf8$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $1ca59e8ae70c9cf8$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $1ca59e8ae70c9cf8$var$close(node, $1ca59e8ae70c9cf8$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $1ca59e8ae70c9cf8$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $1ca59e8ae70c9cf8$var$prepareSliceForReplace(slice, $from);
        return $1ca59e8ae70c9cf8$var$close(node, $1ca59e8ae70c9cf8$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $1ca59e8ae70c9cf8$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $1ca59e8ae70c9cf8$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $1ca59e8ae70c9cf8$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $1ca59e8ae70c9cf8$var$checkJoin(node, $after.node(depth));
    return node;
}
function $1ca59e8ae70c9cf8$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $1ca59e8ae70c9cf8$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $1ca59e8ae70c9cf8$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$1ca59e8ae70c9cf8$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $1ca59e8ae70c9cf8$var$addNode($end.nodeBefore, target);
}
function $1ca59e8ae70c9cf8$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $1ca59e8ae70c9cf8$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $1ca59e8ae70c9cf8$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $1ca59e8ae70c9cf8$var$joinable($end, $to, depth + 1);
    let content = [];
    $1ca59e8ae70c9cf8$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $1ca59e8ae70c9cf8$var$checkJoin(openStart, openEnd);
        $1ca59e8ae70c9cf8$var$addNode($1ca59e8ae70c9cf8$var$close(openStart, $1ca59e8ae70c9cf8$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $1ca59e8ae70c9cf8$var$addNode($1ca59e8ae70c9cf8$var$close(openStart, $1ca59e8ae70c9cf8$var$replaceTwoWay($from, $start, depth + 1)), content);
        $1ca59e8ae70c9cf8$var$addRange($start, $end, depth, content);
        if (openEnd) $1ca59e8ae70c9cf8$var$addNode($1ca59e8ae70c9cf8$var$close(openEnd, $1ca59e8ae70c9cf8$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $1ca59e8ae70c9cf8$var$addRange($to, null, depth, content);
    return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(content);
}
function $1ca59e8ae70c9cf8$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $1ca59e8ae70c9cf8$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $1ca59e8ae70c9cf8$var$joinable($from, $to, depth + 1);
        $1ca59e8ae70c9cf8$var$addNode($1ca59e8ae70c9cf8$var$close(type, $1ca59e8ae70c9cf8$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $1ca59e8ae70c9cf8$var$addRange($to, null, depth, content);
    return new $1ca59e8ae70c9cf8$export$ffb0004e005737fa(content);
}
function $1ca59e8ae70c9cf8$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $1ca59e8ae70c9cf8$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $1ca59e8ae70c9cf8$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $1ca59e8ae70c9cf8$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $1ca59e8ae70c9cf8$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $1ca59e8ae70c9cf8$var$resolveCache.set(doc, cache = new $1ca59e8ae70c9cf8$var$ResolveCache);
        let result = cache.elts[cache.i] = $1ca59e8ae70c9cf8$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $1ca59e8ae70c9cf8$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $1ca59e8ae70c9cf8$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $1ca59e8ae70c9cf8$var$resolveCacheSize = 12, $1ca59e8ae70c9cf8$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $1ca59e8ae70c9cf8$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $1ca59e8ae70c9cf8$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $1ca59e8ae70c9cf8$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $1ca59e8ae70c9cf8$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $1ca59e8ae70c9cf8$var$emptyAttrs) && $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $1ca59e8ae70c9cf8$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $1ca59e8ae70c9cf8$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $1ca59e8ae70c9cf8$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $1ca59e8ae70c9cf8$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $1ca59e8ae70c9cf8$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $1ca59e8ae70c9cf8$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $1ca59e8ae70c9cf8$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty;
    }
}
$1ca59e8ae70c9cf8$export$85c928794f8d04d4.prototype.text = undefined;
class $1ca59e8ae70c9cf8$var$TextNode extends $1ca59e8ae70c9cf8$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $1ca59e8ae70c9cf8$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $1ca59e8ae70c9cf8$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $1ca59e8ae70c9cf8$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $1ca59e8ae70c9cf8$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $1ca59e8ae70c9cf8$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $1ca59e8ae70c9cf8$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $1ca59e8ae70c9cf8$export$364ed450558d7ec4.empty;
        let expr = $1ca59e8ae70c9cf8$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $1ca59e8ae70c9cf8$var$dfa($1ca59e8ae70c9cf8$var$nfa(expr));
        $1ca59e8ae70c9cf8$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $1ca59e8ae70c9cf8$export$364ed450558d7ec4.empty = new $1ca59e8ae70c9cf8$export$364ed450558d7ec4(true);
class $1ca59e8ae70c9cf8$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $1ca59e8ae70c9cf8$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($1ca59e8ae70c9cf8$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $1ca59e8ae70c9cf8$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($1ca59e8ae70c9cf8$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $1ca59e8ae70c9cf8$var$parseExprSubscript(stream) {
    let expr = $1ca59e8ae70c9cf8$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $1ca59e8ae70c9cf8$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $1ca59e8ae70c9cf8$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $1ca59e8ae70c9cf8$var$parseExprRange(stream, expr) {
    let min = $1ca59e8ae70c9cf8$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $1ca59e8ae70c9cf8$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $1ca59e8ae70c9cf8$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $1ca59e8ae70c9cf8$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $1ca59e8ae70c9cf8$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $1ca59e8ae70c9cf8$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $1ca59e8ae70c9cf8$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $1ca59e8ae70c9cf8$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $1ca59e8ae70c9cf8$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($1ca59e8ae70c9cf8$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $1ca59e8ae70c9cf8$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($1ca59e8ae70c9cf8$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $1ca59e8ae70c9cf8$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $1ca59e8ae70c9cf8$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($1ca59e8ae70c9cf8$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $1ca59e8ae70c9cf8$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $1ca59e8ae70c9cf8$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $1ca59e8ae70c9cf8$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $1ca59e8ae70c9cf8$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $1ca59e8ae70c9cf8$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $1ca59e8ae70c9cf8$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $1ca59e8ae70c9cf8$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $1ca59e8ae70c9cf8$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $1ca59e8ae70c9cf8$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $1ca59e8ae70c9cf8$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(content), $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $1ca59e8ae70c9cf8$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $1ca59e8ae70c9cf8$export$85c928794f8d04d4(this, attrs, content.append(after), $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1ca59e8ae70c9cf8$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $1ca59e8ae70c9cf8$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $1ca59e8ae70c9cf8$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $1ca59e8ae70c9cf8$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $1ca59e8ae70c9cf8$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $1ca59e8ae70c9cf8$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $1ca59e8ae70c9cf8$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $1ca59e8ae70c9cf8$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044(this, $1ca59e8ae70c9cf8$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $1ca59e8ae70c9cf8$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $1ca59e8ae70c9cf8$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $1ca59e8ae70c9cf8$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $1ca59e8ae70c9cf8$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $1ca59e8ae70c9cf8$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $1ca59e8ae70c9cf8$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $1ca59e8ae70c9cf8$var$TextNode(type, type.defaultAttrs, text, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $1ca59e8ae70c9cf8$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $73qKE.default).from(spec.nodes), instanceSpec.marks = (0, $73qKE.default).from(spec.marks || {}), this.nodes = $1ca59e8ae70c9cf8$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $1ca59e8ae70c9cf8$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $1ca59e8ae70c9cf8$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $1ca59e8ae70c9cf8$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $1ca59e8ae70c9cf8$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $1ca59e8ae70c9cf8$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $1ca59e8ae70c9cf8$var$isTagRule(rule) {
    return rule.tag != null;
}
function $1ca59e8ae70c9cf8$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $1ca59e8ae70c9cf8$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $1ca59e8ae70c9cf8$var$ParseContext(this, options, false);
        context.addAll(dom, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $1ca59e8ae70c9cf8$var$ParseContext(this, options, true);
        context.addAll(dom, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $1ca59e8ae70c9cf8$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($1ca59e8ae70c9cf8$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1ca59e8ae70c9cf8$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $1ca59e8ae70c9cf8$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $1ca59e8ae70c9cf8$export$1059c6e7d2ce5669(schema, $1ca59e8ae70c9cf8$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($1ca59e8ae70c9cf8$var$isTagRule(rule)) this.tags.push(rule);
            else if ($1ca59e8ae70c9cf8$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $1ca59e8ae70c9cf8$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $1ca59e8ae70c9cf8$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $1ca59e8ae70c9cf8$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS = 1, $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS_FULL = 2, $1ca59e8ae70c9cf8$var$OPT_OPEN_LEFT = 4;
function $1ca59e8ae70c9cf8$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS | $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS_FULL : base & ~$1ca59e8ae70c9cf8$var$OPT_OPEN_LEFT;
}
class $1ca59e8ae70c9cf8$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $1ca59e8ae70c9cf8$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($1ca59e8ae70c9cf8$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$1ca59e8ae70c9cf8$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $1ca59e8ae70c9cf8$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $1ca59e8ae70c9cf8$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($1ca59e8ae70c9cf8$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $1ca59e8ae70c9cf8$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $1ca59e8ae70c9cf8$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($1ca59e8ae70c9cf8$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $1ca59e8ae70c9cf8$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $1ca59e8ae70c9cf8$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $1ca59e8ae70c9cf8$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $1ca59e8ae70c9cf8$var$OPT_OPEN_LEFT;
        let applyMarks = $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $1ca59e8ae70c9cf8$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $1ca59e8ae70c9cf8$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $1ca59e8ae70c9cf8$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $1ca59e8ae70c9cf8$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $1ca59e8ae70c9cf8$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $1ca59e8ae70c9cf8$var$NodeContext(topNode.type, topNode.attrs, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $1ca59e8ae70c9cf8$var$NodeContext(null, null, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $1ca59e8ae70c9cf8$var$NodeContext(parser.schema.topNodeType, null, $1ca59e8ae70c9cf8$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $1ca59e8ae70c9cf8$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $1ca59e8ae70c9cf8$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $1ca59e8ae70c9cf8$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $1ca59e8ae70c9cf8$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $1ca59e8ae70c9cf8$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $1ca59e8ae70c9cf8$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $1ca59e8ae70c9cf8$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $1ca59e8ae70c9cf8$var$renderSpec($1ca59e8ae70c9cf8$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $1ca59e8ae70c9cf8$var$renderSpec($1ca59e8ae70c9cf8$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $1ca59e8ae70c9cf8$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $1ca59e8ae70c9cf8$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $1ca59e8ae70c9cf8$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $1ca59e8ae70c9cf8$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $1ca59e8ae70c9cf8$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $1ca59e8ae70c9cf8$var$doc(options) {
    return options.document || window.document;
}
const $1ca59e8ae70c9cf8$var$suspiciousAttributeCache = new WeakMap();
function $1ca59e8ae70c9cf8$var$suspiciousAttributes(attrs) {
    let value = $1ca59e8ae70c9cf8$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $1ca59e8ae70c9cf8$var$suspiciousAttributeCache.set(attrs, value = $1ca59e8ae70c9cf8$var$suspiciousAttributesInner(attrs));
    return value;
}
function $1ca59e8ae70c9cf8$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $1ca59e8ae70c9cf8$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $1ca59e8ae70c9cf8$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $1ca59e8ae70c9cf8$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("cE2or", function(module, exports) {

$parcel$export(module.exports, "FONT_STYLE", function () { return $934b13af51eb165d$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $934b13af51eb165d$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $934b13af51eb165d$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $934b13af51eb165d$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $934b13af51eb165d$export$4498a6080fed604c = "fontStyle";
var $934b13af51eb165d$export$f8e8a5f34f6ea725 = "searchQuery";
var $934b13af51eb165d$export$b395009ca7f092c7 = "link";
var $934b13af51eb165d$export$9b982809044276a6 = "color";
var $934b13af51eb165d$export$470d0905851e47a1 = "alignment";
var $934b13af51eb165d$export$bacb7f4b06a06b22 = "indentation";

});

parcelRegister("50wYd", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", function () { return $3a56870b9752794b$export$daf54fed04c8fb77; });

var $417VF = parcelRequire("417VF");
function $3a56870b9752794b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a56870b9752794b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a56870b9752794b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a56870b9752794b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a56870b9752794b$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $3a56870b9752794b$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== "_") nodeSpec.marks = nodeSpec.marks.split(" ").filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(" ");
        if (nodeSpec.content) nodeSpec.content = $3a56870b9752794b$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $3a56870b9752794b$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, " ");
    var contentKeys = content.split(" ");
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$3a56870b9752794b$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $3a56870b9752794b$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $3a56870b9752794b$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || "";
    if (!content || !content.match(/\w/)) return "";
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, "g"), "").replace("  ", " ").trim();
}
function $3a56870b9752794b$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("aUr33", function(module, exports) {

$parcel$export(module.exports, "alignment", function () { return $7f141d8ef83396eb$export$8e53000a4ec837; });

var $ctaip = parcelRequire("ctaip");
var $7f141d8ef83396eb$export$be9cf49015769bbd = {
    end: "right",
    right: "end",
    center: "center"
};
var $7f141d8ef83396eb$export$8e53000a4ec837 = (0, $ctaip.alignment)({
    parseDOM: [
        {
            tag: "div.fabric-editor-block-mark",
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute("data-align");
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                "data-align": mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("ctaip", function(module, exports) {

$parcel$export(module.exports, "alignment", function () { return $91402e05e16a313e$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $91402e05e16a313e$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $91402e05e16a313e$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $91402e05e16a313e$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $91402e05e16a313e$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $91402e05e16a313e$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $91402e05e16a313e$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $91402e05e16a313e$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $91402e05e16a313e$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $91402e05e16a313e$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $91402e05e16a313e$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $91402e05e16a313e$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $91402e05e16a313e$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $91402e05e16a313e$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $91402e05e16a313e$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $91402e05e16a313e$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $91402e05e16a313e$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $91402e05e16a313e$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $91402e05e16a313e$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $91402e05e16a313e$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $25HJn = parcelRequire("25HJn");
var $91402e05e16a313e$export$8e53000a4ec837 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: "alignment indentation",
    group: "alignment"
});
var $91402e05e16a313e$export$8512c9afa7b24c3b = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ""
        },
        annotationType: {
            default: "inlineComment"
        }
    },
    inclusive: true,
    excludes: "",
    group: "annotation"
});
var $91402e05e16a313e$export$8c5a050822fd698c = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: "color",
    group: "color"
});
var $91402e05e16a313e$export$1edee58a52776cd9 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $91402e05e16a313e$export$89015c65f1c75e3f = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: "wide"
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $91402e05e16a313e$export$6565f9f03506010b = (0, $25HJn.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: "fontStyle link searchQuery color"
});
var $91402e05e16a313e$export$f3b72f8fc4684ecd = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ""
        }
    },
    inclusive: false,
    excludes: ""
});
var $91402e05e16a313e$export$3024f02c495408d6 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $91402e05e16a313e$export$c63c6f932822f543 = (0, $25HJn.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $91402e05e16a313e$export$f00aeb236b6f05af = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ""
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ""
});
var $91402e05e16a313e$export$480c699bd4ec0d86 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: "indentation alignment",
    group: "indentation"
});
var $91402e05e16a313e$export$9c30223ca0a664fb = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: "link",
    group: "link"
});
var $91402e05e16a313e$export$4899a95d70ec5056 = (0, $25HJn.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $91402e05e16a313e$export$59ae2c325a998f89 = (0, $25HJn.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $91402e05e16a313e$export$b3401ee80eb31041 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: "sub"
        }
    },
    inclusive: true,
    group: "fontStyle"
});
var $91402e05e16a313e$export$32f78bffcd82ff28 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: "color"
});
var $91402e05e16a313e$export$20af3dabbb5538df = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ""
        }
    },
    inclusive: true,
    group: "searchQuery"
});
var $91402e05e16a313e$export$425327af25286e5e = (0, $25HJn.createPMMarkSpecFactory)({
    inclusive: true,
    group: "fontStyle"
});
var $91402e05e16a313e$export$30d78d5eb6719bb8 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ""
});
var $91402e05e16a313e$export$a316dc07ff5182a2 = (0, $25HJn.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("7GRkj", function(module, exports) {

$parcel$export(module.exports, "annotation", function () { return $5995d23508ed5262$export$8512c9afa7b24c3b; });

var $417VF = parcelRequire("417VF");

var $ctaip = parcelRequire("ctaip");
function $5995d23508ed5262$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5995d23508ed5262$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5995d23508ed5262$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5995d23508ed5262$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5995d23508ed5262$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $5995d23508ed5262$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $5995d23508ed5262$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        "data-mark-type": "annotation",
        "data-mark-annotation-type": annotationType,
        "data-id": id
    };
    if (state) return $5995d23508ed5262$var$_objectSpread($5995d23508ed5262$var$_objectSpread({}, data), {}, {
        "data-mark-annotation-state": state
    });
    return data;
}
var $5995d23508ed5262$export$8512c9afa7b24c3b = (0, $ctaip.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: "annotation",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-id"),
                    annotationType: dom.getAttribute("data-mark-annotation-type")
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            "span",
            $5995d23508ed5262$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                "class": "fabric-editor-annotation"
            }, $5995d23508ed5262$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("1Zx1F", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", function () { return $17351b3563e4ef70$export$8c5a050822fd698c; });

var $417VF = parcelRequire("417VF");

var $7hPAH = parcelRequire("7hPAH");

var $ctaip = parcelRequire("ctaip");

var $b4q3Q = parcelRequire("b4q3Q");

var $2zOsm = parcelRequire("2zOsm");

var $gpALN = parcelRequire("gpALN");

var $dMATI = parcelRequire("dMATI");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
var $17351b3563e4ef70$var$colorArrayPalette = [
    [
        (0, $2zOsm.Neutral300),
        "Gray"
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $2zOsm.T200),
        "Teal"
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $2zOsm.L200),
        "Lime"
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $2zOsm.O200),
        "Orange"
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $2zOsm.M200),
        "Magenta"
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $2zOsm.P200),
        "Purple"
    ] // token: color.background.accent.purple.subtler
];
var $17351b3563e4ef70$var$colorArrayPaletteNext = [
    [
        (0, $2zOsm.Neutral300),
        "Gray"
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $2zOsm.P200),
        "Purple"
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $2zOsm.M200),
        "Magenta"
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $2zOsm.O200),
        "Orange"
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $2zOsm.Yellow200),
        "Yellow"
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $2zOsm.L200),
        "Lime"
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $2zOsm.T200),
        "Teal"
    ] // token: color.background.accent.teal.subtler
];
var $17351b3563e4ef70$export$14ec3f21a268e497 = new Map();
$17351b3563e4ef70$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $7hPAH.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $17351b3563e4ef70$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $17351b3563e4ef70$export$7ab6fa38cecaeee2 = new Map();
$17351b3563e4ef70$var$colorArrayPaletteNext.forEach(function(_ref3) {
    var _ref4 = (0, $7hPAH.default)(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $17351b3563e4ef70$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label);
});
var $17351b3563e4ef70$export$8c5a050822fd698c = (0, $ctaip.backgroundColor)({
    parseDOM: [
        {
            style: "background-color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $2zOsm.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $17351b3563e4ef70$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: ".fabric-background-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $17351b3563e4ef70$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $b4q3Q.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $gpALN.getGlobalTheme)().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $dMATI.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, $417VF.default)({
                class: "fabric-background-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-background-custom-color", mark.attrs.color)
        ];
    }
});

});
parcelRegister("gpALN", function(module, exports) {

$parcel$export(module.exports, "getGlobalTheme", function () { return $bf2b80e09c2d18e5$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $bf2b80e09c2d18e5$export$32f78bffcd82ff28; });

var $417VF = parcelRequire("417VF");

var $7hPAH = parcelRequire("7hPAH");

var $ctaip = parcelRequire("ctaip");

var $b4q3Q = parcelRequire("b4q3Q");

var $2zOsm = parcelRequire("2zOsm");

var $dMATI = parcelRequire("dMATI");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $bf2b80e09c2d18e5$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $2zOsm.B500),
        "Dark blue"
    ],
    // Chore coat
    [
        (0, $2zOsm.T500),
        "Dark teal"
    ],
    // Shabby chic
    [
        (0, $2zOsm.G500),
        "Dark green"
    ],
    // Keen green
    [
        (0, $2zOsm.Y400),
        "Orange"
    ],
    // Cheezy blasters
    [
        (0, $2zOsm.R500),
        "Dark red"
    ],
    // Dragon's blood
    [
        (0, $2zOsm.P500),
        "Dark purple"
    ],
    // Prince
    // row 2
    [
        (0, $2zOsm.N80),
        "Light gray"
    ],
    // Spooky ghost
    [
        (0, $2zOsm.B100),
        "Blue"
    ],
    // Arvo breeze
    [
        (0, $2zOsm.T300),
        "Teal"
    ],
    // Tamarama
    [
        (0, $2zOsm.G300),
        "Green"
    ],
    // Fine pine
    [
        (0, $2zOsm.Y200),
        "Yellow"
    ],
    // Pub mix
    [
        (0, $2zOsm.R300),
        "Red"
    ],
    // Poppy surprise
    [
        (0, $2zOsm.P300),
        "Purple"
    ],
    // Da' juice
    // row 3
    [
        (0, $2zOsm.N0),
        "White"
    ],
    [
        (0, $2zOsm.B75),
        "Light blue"
    ],
    // Schwag
    [
        (0, $2zOsm.T75),
        "Light teal"
    ],
    // Arctic chill
    [
        (0, $2zOsm.G75),
        "Light green"
    ],
    // Mintie
    [
        (0, $2zOsm.Y75),
        "Light yellow"
    ],
    // Dandelion whisper
    [
        (0, $2zOsm.R75),
        "Light red"
    ],
    // Bondi sunburn
    [
        (0, $2zOsm.P50),
        "Light purple"
    ] // Lavender secret
];
var $bf2b80e09c2d18e5$export$569885e57444f84a = new Map();
var $bf2b80e09c2d18e5$export$81e5ed9e84fe2e28 = $bf2b80e09c2d18e5$export$569885e57444f84a;
$bf2b80e09c2d18e5$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $7hPAH.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $bf2b80e09c2d18e5$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $bf2b80e09c2d18e5$var$testGlobalTheme;
var $bf2b80e09c2d18e5$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $bf2b80e09c2d18e5$var$testGlobalTheme = theme;
};
var $bf2b80e09c2d18e5$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($bf2b80e09c2d18e5$var$testGlobalTheme) return {
        colorMode: $bf2b80e09c2d18e5$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute("data-color-mode") || "";
    return {
        colorMode: colorMode
    };
};
var $bf2b80e09c2d18e5$export$32f78bffcd82ff28 = (0, $ctaip.textColor)({
    parseDOM: [
        {
            style: "color",
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $2zOsm.rgbToHex)(value);
                else if (value[0] === "#") hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $bf2b80e09c2d18e5$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: ".fabric-text-color-mark",
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $bf2b80e09c2d18e5$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $b4q3Q.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($bf2b80e09c2d18e5$export$813ecdf77207a053().colorMode === "dark") // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $dMATI.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            "span",
            (0, $417VF.default)({
                class: "fabric-text-color-mark",
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, "data-text-custom-color", mark.attrs.color)
        ];
    }
});

});


parcelRegister("2lYmO", function(module, exports) {

$parcel$export(module.exports, "border", function () { return $1b6c5e925d176d9b$export$1edee58a52776cd9; });

var $7hPAH = parcelRequire("7hPAH");

var $ctaip = parcelRequire("ctaip");

var $b4q3Q = parcelRequire("b4q3Q");

var $2zOsm = parcelRequire("2zOsm");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $1b6c5e925d176d9b$var$borderColorArrayPalette = [
    [
        (0, $2zOsm.N300A),
        "Subtle gray"
    ],
    [
        (0, $2zOsm.N600),
        "Gray"
    ],
    [
        (0, $2zOsm.N1000),
        "Bold gray"
    ]
];
var $1b6c5e925d176d9b$export$e4e044c989c86ca7 = new Map();
$1b6c5e925d176d9b$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $7hPAH.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $1b6c5e925d176d9b$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $1b6c5e925d176d9b$export$1edee58a52776cd9 = (0, $ctaip.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute("data-color")) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : "").toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute("data-size")) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : "0");
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $1b6c5e925d176d9b$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? "span" : "div";
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $b4q3Q.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                "data-mark-type": "border",
                "data-color": mark.attrs.color,
                "data-size": mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("9QETs", function(module, exports) {

$parcel$export(module.exports, "breakout", function () { return $72b8b0f43be29516$export$89015c65f1c75e3f; });

var $ctaip = parcelRequire("ctaip");
var $72b8b0f43be29516$var$allowedTypes = [
    "wide",
    "full-width"
];
var $72b8b0f43be29516$export$89015c65f1c75e3f = (0, $ctaip.breakout)({
    parseDOM: [
        {
            tag: "div.fabric-editor-breakout-mark",
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute("data-mode");
                var width = dom.getAttribute("data-width");
                return {
                    mode: $72b8b0f43be29516$var$allowedTypes.indexOf(mode || "") === -1 ? "wide" : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            "div",
            {
                class: "fabric-editor-breakout-mark",
                "data-mode": mark.attrs.mode,
                "data-width": (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("OA5QS", function(module, exports) {

$parcel$export(module.exports, "code", function () { return $0980ab05542556ea$export$6565f9f03506010b; });

var $ctaip = parcelRequire("ctaip");
var $0980ab05542556ea$export$6565f9f03506010b = (0, $ctaip.code)({
    parseDOM: [
        {
            tag: "span.code",
            preserveWhitespace: true
        },
        {
            tag: "code",
            preserveWhitespace: true
        },
        {
            tag: "tt",
            preserveWhitespace: true
        },
        {
            tag: "span",
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre") return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "span",
            {
                class: "code",
                spellcheck: "false"
            }
        ];
    }
});

});

parcelRegister("ibB8x", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", function () { return $d3d60fa54a1d7be7$export$f3b72f8fc4684ecd; });

var $ctaip = parcelRequire("ctaip");
var $d3d60fa54a1d7be7$export$f3b72f8fc4684ecd = (0, $ctaip.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-mark-type": "confluenceInlineComment",
                "data-reference": node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("5IKJ6", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", function () { return $42a54eb4621a9f66$export$3024f02c495408d6; });

var $417VF = parcelRequire("417VF");

var $ctaip = parcelRequire("ctaip");

var $hkhkR = parcelRequire("hkhkR");
function $42a54eb4621a9f66$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42a54eb4621a9f66$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42a54eb4621a9f66$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42a54eb4621a9f66$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $42a54eb4621a9f66$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $hkhkR.isDOMElement)(maybeValue) && maybeValue.getAttribute("data-sources");
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $42a54eb4621a9f66$export$3024f02c495408d6 = (0, $ctaip.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $42a54eb4621a9f66$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "dataConsumer",
                "data-sources": JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $42a54eb4621a9f66$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === "sources" && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $42a54eb4621a9f66$var$_objectSpread($42a54eb4621a9f66$var$_objectSpread({}, acc), {}, (0, $417VF.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("hkhkR", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", function () { return $c9d1c063ff4d0837$export$c296e2d4365c37a5; });
var $c9d1c063ff4d0837$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("d1unO", function(module, exports) {

$parcel$export(module.exports, "em", function () { return $97b2efc794acb763$export$c63c6f932822f543; });

var $ctaip = parcelRequire("ctaip");
/**
 * @name em_mark
 */ var $97b2efc794acb763$var$emDOM = [
    "em"
];
var $97b2efc794acb763$export$c63c6f932822f543 = (0, $ctaip.em)({
    parseDOM: [
        {
            tag: "i"
        },
        {
            tag: "em"
        },
        {
            style: "font-style=italic"
        }
    ],
    toDOM: function toDOM() {
        return $97b2efc794acb763$var$emDOM;
    }
});

});

parcelRegister("bd7Dn", function(module, exports) {

$parcel$export(module.exports, "fragment", function () { return $8296d4979ce81996$export$f00aeb236b6f05af; });

var $417VF = parcelRequire("417VF");

var $ctaip = parcelRequire("ctaip");

var $hkhkR = parcelRequire("hkhkR");
function $8296d4979ce81996$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8296d4979ce81996$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8296d4979ce81996$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8296d4979ce81996$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $8296d4979ce81996$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $hkhkR.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute("data-name")) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute("data-localId");
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $8296d4979ce81996$export$f00aeb236b6f05af = (0, $ctaip.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $8296d4979ce81996$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? "span" : "div";
        return [
            wrapperStyle,
            {
                "data-mark-type": "fragment",
                "data-name": mark.attrs.name,
                "data-localId": mark.attrs.localId
            }
        ];
    }
});
var $8296d4979ce81996$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $8296d4979ce81996$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("cqSTp", function(module, exports) {

$parcel$export(module.exports, "indentation", function () { return $90d27e4abdb6abf6$export$480c699bd4ec0d86; });

var $ctaip = parcelRequire("ctaip");
var $90d27e4abdb6abf6$export$480c699bd4ec0d86 = (0, $ctaip.indentation)({
    parseDOM: [
        {
            tag: "div.fabric-editor-indentation-mark",
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute("data-level") || "0");
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            "div",
            {
                class: "fabric-editor-block-mark fabric-editor-indentation-mark",
                "data-level": mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("8025L", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $5d2ff238151c186f$export$9c30223ca0a664fb; });

var $417VF = parcelRequire("417VF");

var $ctaip = parcelRequire("ctaip");

var $X7OvV = parcelRequire("X7OvV");
function $5d2ff238151c186f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5d2ff238151c186f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5d2ff238151c186f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5d2ff238151c186f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5d2ff238151c186f$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || "";
        var attrs = {
            __confluenceMetadata: dom.hasAttribute("__confluenceMetadata") ? JSON.parse(dom.getAttribute("__confluenceMetadata") || "") : undefined
        };
        if (!(0, $X7OvV.isSafeUrl)(href)) return false;
        if ((0, $X7OvV.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $X7OvV.normalizeUrl)(href);
        return attrs;
    };
};
var $5d2ff238151c186f$export$9c30223ca0a664fb = (0, $ctaip.link)({
    parseDOM: [
        {
            tag: "[data-block-link]",
            getAttrs: $5d2ff238151c186f$export$b5f67017585d1431("data-block-link"),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute("data-block-link");
                clone.setAttribute("data-skip-paste", "true");
                var wrapper = document.createElement("div");
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: "a[href]",
            getAttrs: $5d2ff238151c186f$export$b5f67017585d1431("href")
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === "__confluenceMetadata") {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === "href") attrs[key] = (0, $X7OvV.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            "a",
            attrs
        ];
        return [
            "a",
            $5d2ff238151c186f$var$_objectSpread($5d2ff238151c186f$var$_objectSpread({}, attrs), {}, (0, $417VF.default)((0, $417VF.default)({}, "data-block-link", "true"), "class", "blockLink")),
            0
        ];
    }
});
var $5d2ff238151c186f$var$OPTIONAL_ATTRS = [
    "title",
    "id",
    "collection",
    "occurrenceKey",
    "__confluenceMetadata"
];
var $5d2ff238151c186f$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($5d2ff238151c186f$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("X7OvV", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", function () { return $0b1b9273059f3082$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "normalizeUrl", function () { return $0b1b9273059f3082$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $0b1b9273059f3082$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $iMJl1 = parcelRequire("iMJl1");
var $0b1b9273059f3082$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $0b1b9273059f3082$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $0b1b9273059f3082$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $0b1b9273059f3082$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($iMJl1)))();
$0b1b9273059f3082$export$8ccbde94d5c7f8e7.add("sourcetree:", "http:");
$0b1b9273059f3082$export$8ccbde94d5c7f8e7.add("jamfselfservice:", "http:");
var $0b1b9273059f3082$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$0b1b9273059f3082$export$8ccbde94d5c7f8e7.add("tel:", $0b1b9273059f3082$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$0b1b9273059f3082$export$8ccbde94d5c7f8e7.add("file:", $0b1b9273059f3082$var$urlWithoutSpacesValidator);
$0b1b9273059f3082$export$8ccbde94d5c7f8e7.add("notes:", "http:");
var $0b1b9273059f3082$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
var $0b1b9273059f3082$var$tlds2Char = "a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
$0b1b9273059f3082$var$tlds.push($0b1b9273059f3082$var$tlds2Char);
$0b1b9273059f3082$export$8ccbde94d5c7f8e7.tlds($0b1b9273059f3082$var$tlds, false);
var $0b1b9273059f3082$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $0b1b9273059f3082$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$0b1b9273059f3082$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($0b1b9273059f3082$export$746d02eae03c72e1) || [
            ""
        ])[0];
        if (link) {
            var index = substr.search($0b1b9273059f3082$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ""
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $0b1b9273059f3082$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $0b1b9273059f3082$export$6f7d7761b97f967(str);
    if (!match.length) match = $0b1b9273059f3082$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $0b1b9273059f3082$export$6535eb414fa2c8b6(url) {
    var match = $0b1b9273059f3082$export$ce9ae45aed3e4ec(url);
    return match && match.url || "";
}
function $0b1b9273059f3082$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith("/") || url === "#top" || url === "#";
}

});
parcelRegister("iMJl1", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $dacfe0e47ae27e82$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $dacfe0e47ae27e82$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $dacfe0e47ae27e82$var$isString(obj) {
    return $dacfe0e47ae27e82$var$_class(obj) === "[object String]";
}
function $dacfe0e47ae27e82$var$isObject(obj) {
    return $dacfe0e47ae27e82$var$_class(obj) === "[object Object]";
}
function $dacfe0e47ae27e82$var$isRegExp(obj) {
    return $dacfe0e47ae27e82$var$_class(obj) === "[object RegExp]";
}
function $dacfe0e47ae27e82$var$isFunction(obj) {
    return $dacfe0e47ae27e82$var$_class(obj) === "[object Function]";
}
function $dacfe0e47ae27e82$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $dacfe0e47ae27e82$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $dacfe0e47ae27e82$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $dacfe0e47ae27e82$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $dacfe0e47ae27e82$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $dacfe0e47ae27e82$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $dacfe0e47ae27e82$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $dacfe0e47ae27e82$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $dacfe0e47ae27e82$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $dacfe0e47ae27e82$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $dacfe0e47ae27e82$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("kLH37"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($dacfe0e47ae27e82$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($dacfe0e47ae27e82$var$isObject(val)) {
            if ($dacfe0e47ae27e82$var$isRegExp(val.validate)) compiled.validate = $dacfe0e47ae27e82$var$createValidator(val.validate);
            else if ($dacfe0e47ae27e82$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($dacfe0e47ae27e82$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $dacfe0e47ae27e82$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($dacfe0e47ae27e82$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $dacfe0e47ae27e82$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($dacfe0e47ae27e82$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $dacfe0e47ae27e82$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $dacfe0e47ae27e82$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $dacfe0e47ae27e82$var$createMatch(self, shift) {
    var match = new $dacfe0e47ae27e82$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $dacfe0e47ae27e82$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $dacfe0e47ae27e82$var$LinkifyIt)) return new $dacfe0e47ae27e82$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($dacfe0e47ae27e82$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $dacfe0e47ae27e82$var$assign({}, $dacfe0e47ae27e82$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $dacfe0e47ae27e82$var$assign({}, $dacfe0e47ae27e82$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $dacfe0e47ae27e82$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $dacfe0e47ae27e82$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $dacfe0e47ae27e82$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $dacfe0e47ae27e82$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($dacfe0e47ae27e82$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($dacfe0e47ae27e82$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $dacfe0e47ae27e82$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $dacfe0e47ae27e82$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $dacfe0e47ae27e82$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $dacfe0e47ae27e82$var$LinkifyIt;

});
parcelRegister("kLH37", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("9ABC1")).source;
    re.src_Cc = (parcelRequire("hpbR5")).source;
    re.src_Z = (parcelRequire("ay1D7")).source;
    re.src_P = (parcelRequire("5Ulqw")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-]).|" + // allow `I'm_king` if no pair found
    "\\.{2,4}[a-zA-Z0-9%/]|" + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + "\\,(?!" + re.src_ZCc + ").|" + // allow `,,,` in paths
    "\\!(?!" + re.src_ZCc + "|[!]).|" + "\\?(?!" + re.src_ZCc + "|[?])." + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});




parcelRegister("kYri4", function(module, exports) {

$parcel$export(module.exports, "strike", function () { return $f44e949148ab15f3$export$4899a95d70ec5056; });

var $ctaip = parcelRequire("ctaip");
var $f44e949148ab15f3$export$4899a95d70ec5056 = (0, $ctaip.strike)({
    parseDOM: [
        {
            tag: "strike"
        },
        {
            tag: "s"
        },
        {
            tag: "del"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "line-through" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "s"
        ];
    }
});

});

parcelRegister("1upJy", function(module, exports) {

$parcel$export(module.exports, "strong", function () { return $115c8dff31190b7c$export$59ae2c325a998f89; });

var $ctaip = parcelRequire("ctaip");
/**
 * @name strong_mark
 */ var $115c8dff31190b7c$var$strongDOM = [
    "strong"
];
var $115c8dff31190b7c$export$59ae2c325a998f89 = (0, $ctaip.strong)({
    parseDOM: [
        {
            tag: "strong"
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: "b",
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== "normal" && null;
            }
        },
        {
            tag: "span",
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === "string" && (fontWeight === "bold" || fontWeight === "bolder" || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $115c8dff31190b7c$var$strongDOM;
    }
});

});

parcelRegister("9UALV", function(module, exports) {

$parcel$export(module.exports, "subsup", function () { return $7375de2a55c023b8$export$b3401ee80eb31041; });

var $ctaip = parcelRequire("ctaip");
/**
 * @name subsup_mark
 */ function $7375de2a55c023b8$var$getAttrFromVerticalAlign(node) {
    if (node === "sub") return {
        type: "sub"
    };
    if (node === "super") return {
        type: "sup"
    };
    return false;
}
var $7375de2a55c023b8$export$b3401ee80eb31041 = (0, $ctaip.subsup)({
    parseDOM: [
        {
            tag: "sub",
            attrs: {
                type: "sub"
            }
        },
        {
            tag: "sup",
            attrs: {
                type: "sup"
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: "vertical-align=super",
            getAttrs: function getAttrs(node) {
                return $7375de2a55c023b8$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: "vertical-align=sub",
            getAttrs: function getAttrs(node) {
                return $7375de2a55c023b8$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("2caEI", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", function () { return $1994f7be6e5729bd$export$20af3dabbb5538df; });

var $ctaip = parcelRequire("ctaip");

var $2zOsm = parcelRequire("2zOsm");
var $1994f7be6e5729bd$export$20af3dabbb5538df = (0, $ctaip.typeAheadQuery)({
    parseDOM: [
        {
            tag: "span[data-type-ahead-query]"
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "span",
            {
                "data-type-ahead-query": "true",
                "data-trigger": node.attrs.trigger,
                style: "color: ".concat((0, $2zOsm.B400))
            }
        ];
    }
});

});

parcelRegister("j5tG8", function(module, exports) {

$parcel$export(module.exports, "underline", function () { return $de55817aa5c592a8$export$425327af25286e5e; });

var $ctaip = parcelRequire("ctaip");
var $de55817aa5c592a8$export$425327af25286e5e = (0, $ctaip.underline)({
    parseDOM: [
        {
            tag: "u"
        },
        {
            style: "text-decoration",
            getAttrs: function getAttrs(value) {
                return value === "underline" && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            "u"
        ];
    }
});

});

parcelRegister("hmtgI", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", function () { return $ca3b31df006b3400$export$30d78d5eb6719bb8; });

var $ctaip = parcelRequire("ctaip");
var $ca3b31df006b3400$export$30d78d5eb6719bb8 = (0, $ctaip.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            "span"
        ];
    }
});

});

parcelRegister("4TvWL", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $390514723c5176de$export$a316dc07ff5182a2; });

var $ctaip = parcelRequire("ctaip");
var $390514723c5176de$export$a316dc07ff5182a2 = (0, $ctaip.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            "span"
        ];
    }
});

});

parcelRegister("FFE94", function(module, exports) {

$parcel$export(module.exports, "blockCard", function () { return $07d422942991125d$export$c4c2f833baaebdb8; });

var $417VF = parcelRequire("417VF");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $07d422942991125d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07d422942991125d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07d422942991125d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07d422942991125d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $07d422942991125d$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute("data-card-data");
    var datasource = anchor.getAttribute("data-datasource");
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute("data-layout") || undefined : undefined,
        width: Number(dom.getAttribute("data-width")) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $07d422942991125d$export$c4c2f833baaebdb8 = (0, $ceuZl.blockCard)({
    parseDOM: [
        {
            tag: "a[data-block-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $07d422942991125d$var$_objectSpread({
                    url: anchor.getAttribute("href") || undefined
                }, $07d422942991125d$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: "div[data-block-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $07d422942991125d$var$_objectSpread({
                    url: anchor.getAttribute("data-card-url") || undefined
                }, $07d422942991125d$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            "data-block-card": "",
            href: url || "",
            "data-card-data": data ? JSON.stringify(data) : "",
            "data-datasource": datasource ? JSON.stringify(datasource) : "",
            "data-layout": layout,
            "data-width": "".concat(width)
        };
        return [
            "a",
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || " "
        ];
    }
});
var $07d422942991125d$export$9894f24949f094e5 = (0, $ceuZl.blockCard)({
    parseDOM: [
        {
            tag: "a[data-block-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $07d422942991125d$var$_objectSpread($07d422942991125d$var$_objectSpread({
                    url: anchor.getAttribute("href") || undefined
                }, $07d422942991125d$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        },
        {
            tag: "div[data-block-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $07d422942991125d$var$_objectSpread($07d422942991125d$var$_objectSpread({
                    url: anchor.getAttribute("data-card-url") || undefined
                }, $07d422942991125d$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            "data-block-card": "",
            href: url || "",
            "data-card-data": data ? JSON.stringify(data) : "",
            "data-datasource": datasource ? JSON.stringify(datasource) : "",
            "data-layout": layout,
            "data-width": "".concat(width),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            "a",
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || " "
        ];
    }
});

});

parcelRegister("klliO", function(module, exports) {

$parcel$export(module.exports, "taskItem", function () { return $ecf64b0e358011dd$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "blockTaskItem", function () { return $ecf64b0e358011dd$export$16018c61064a18df; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
var $ecf64b0e358011dd$export$6d8b0ef52e2e6390 = (0, $ceuZl.taskItem)({
    parseDOM: [
        {
            tag: "div[data-task-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $bI8Ay.uuid).generate(),
                    state: dom.getAttribute("data-task-state") || "TODO"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-task-local-id": localId || "local-task",
            "data-task-state": state || "TODO"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});
var $ecf64b0e358011dd$export$16018c61064a18df = (0, $ceuZl.blockTaskItem)({
    parseDOM: [
        {
            tag: "div[data-task-is-block]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $bI8Ay.uuid).generate(),
                    state: dom.getAttribute("data-task-state") || "TODO"
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            "data-task-local-id": localId || "local-task",
            "data-task-state": state || "TODO",
            "data-task-is-block": "true"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("gMOX4", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", function () { return $c388a6fece00e2a0$export$27903d543b563e39; });

var $2HBwi = parcelRequire("2HBwi");

var $ceuZl = parcelRequire("ceuZl");
var $c388a6fece00e2a0$export$27903d543b563e39 = (0, $ceuZl.bodiedExtension)({
    parseDOM: [
        {
            context: "bodiedExtension//",
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2HBwi.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "bodied-extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("iiKEH", function(module, exports) {

$parcel$export(module.exports, "bulletList", function () { return $d52e19410d16ec4f$export$a140c94e5ea26bee; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
var $d52e19410d16ec4f$export$5f25a39efab3b58b = ".ak-ul";
var $d52e19410d16ec4f$export$a140c94e5ea26bee = (0, $ceuZl.bulletList)({
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $d52e19410d16ec4f$export$5f25a39efab3b58b.substr(1)
        };
        return [
            "ul",
            attrs,
            0
        ];
    }
});
var $d52e19410d16ec4f$export$dfd406053b2bab40 = (0, $ceuZl.bulletList)({
    parseDOM: [
        {
            tag: "ul",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $d52e19410d16ec4f$export$5f25a39efab3b58b.substr(1),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "ul",
            attrs,
            0
        ];
    }
});

});

parcelRegister("iTzjv", function(module, exports) {

$parcel$export(module.exports, "caption", function () { return $dc18c19cff3b33a9$export$8e3c2dfdc4f0453d; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $dc18c19cff3b33a9$export$8e3c2dfdc4f0453d = (0, $ceuZl.caption)({
    parseDOM: [
        {
            tag: "figcaption[data-caption]"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            "data-caption": "true"
        };
        return [
            "figcaption",
            attrs,
            0
        ];
    }
});
var $dc18c19cff3b33a9$export$b5d01ee303c467aa = (0, $ceuZl.caption)({
    parseDOM: [
        {
            tag: "figcaption[data-caption]",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-caption": "true",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "figcaption",
            attrs,
            0
        ];
    }
});

});

parcelRegister("2qvtN", function(module, exports) {

$parcel$export(module.exports, "codeBlock", function () { return $1c466da93e6e86b4$export$7bb0d5c671655cc4; });

var $2succ = parcelRequire("2succ");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $1c466da93e6e86b4$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute("data-language") || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $1c466da93e6e86b4$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains("codehilite")) // code block html from Bitbucket always contains an extra new line
    return $1c466da93e6e86b4$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $1c466da93e6e86b4$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === "CODE") return firstChild.getAttribute("data-language") || undefined;
};
var $1c466da93e6e86b4$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $1c466da93e6e86b4$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains("codehilite")) dom.textContent = dom.textContent.replace(/\n$/, "");
    return dom;
};
function $1c466da93e6e86b4$var$parseCodeFromHtml(node) {
    var code = "";
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === "div" || tagName === "p") // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += "\n";
            }
            if (tagName === "br") code += "\n";
            else code += $1c466da93e6e86b4$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $1c466da93e6e86b4$export$7bb0d5c671655cc4 = (0, $ceuZl.codeBlock)({
    parseDOM: [
        {
            tag: "pre",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $1c466da93e6e86b4$var$getLanguageFromBitbucketStyle(dom.parentElement) || $1c466da93e6e86b4$var$getLanguageFromEditorStyle(dom.parentElement) || $1c466da93e6e86b4$var$getLanguageFromCode(dom) || dom.getAttribute("data-language");
                dom = $1c466da93e6e86b4$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: "div[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre" || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $1c466da93e6e86b4$var$parseCodeFromHtml(domNode);
                return code ? (0, $2succ.Fragment).from(schema.text(code)) : (0, $2succ.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: "table[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: "div.code-block",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll(".react-syntax-highlighter-line-number");
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "pre",
            [
                "code",
                {
                    "data-language": node.attrs.language
                },
                0
            ]
        ];
    }
});
var $1c466da93e6e86b4$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === "uniqueId") return memo;
            if (key === "language" && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $1c466da93e6e86b4$export$3f75de798a0b5356 = (0, $ceuZl.codeBlock)({
    parseDOM: [
        {
            tag: "pre",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $1c466da93e6e86b4$var$getLanguageFromBitbucketStyle(dom.parentElement) || $1c466da93e6e86b4$var$getLanguageFromEditorStyle(dom.parentElement) || $1c466da93e6e86b4$var$getLanguageFromCode(dom) || dom.getAttribute("data-language");
                dom = $1c466da93e6e86b4$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: "div[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === "pre" || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf("monospace") > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $1c466da93e6e86b4$var$parseCodeFromHtml(domNode);
                return code ? (0, $2succ.Fragment).from(schema.text(code)) : (0, $2succ.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: "table[style]",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: "div.code-block",
            preserveWhitespace: "full",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll(".react-syntax-highlighter-line-number");
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "pre",
            attrs,
            [
                "code",
                {
                    "data-language": node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("3J7dg", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", function () { return $2b6b2b6a4fbafcb1$export$daf889beb5092f95; });

var $ceuZl = parcelRequire("ceuZl");
var $2b6b2b6a4fbafcb1$var$name = "confluenceJiraIssue";
var $2b6b2b6a4fbafcb1$export$daf889beb5092f95 = (0, $ceuZl.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: 'span[data-node-type="'.concat($2b6b2b6a4fbafcb1$var$name, '"]'),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $2b6b2b6a4fbafcb1$var$name,
            "data-macro-id": node.attrs.macroId,
            "data-schema-version": node.attrs.schemaVersion,
            "data-server": node.attrs.server,
            "data-server-id": node.attrs.serverId,
            "data-jira-issue": node.attrs.issueKey
        };
        return [
            "span",
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("e5HHV", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $a4236fb28d524ef6$export$e6e4878f43c27cab; });

var $ceuZl = parcelRequire("ceuZl");
var $a4236fb28d524ef6$var$name = "confluenceUnsupportedBlock";
var $a4236fb28d524ef6$export$e6e4878f43c27cab = (0, $ceuZl.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            "data-node-type": $a4236fb28d524ef6$var$name,
            "data-confluence-unsupported": "block",
            "data-confluence-unsupported-block-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($a4236fb28d524ef6$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-block-cxhtml")
                };
            }
        }
    ]
});

});

parcelRegister("dVWVz", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $a24e4f061a2d9e94$export$3e6d667072febc87; });

var $ceuZl = parcelRequire("ceuZl");
var $a24e4f061a2d9e94$var$name = "confluenceUnsupportedInline";
var $a24e4f061a2d9e94$export$3e6d667072febc87 = (0, $ceuZl.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": $a24e4f061a2d9e94$var$name,
            "data-confluence-unsupported": "inline",
            "data-confluence-unsupported-inline-cxhtml": node.attrs["cxhtml"]
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($a24e4f061a2d9e94$var$name, '"]'),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute("data-confluence-unsupported-inline-cxhtml")
                };
            }
        }
    ]
});

});

parcelRegister("6gCnQ", function(module, exports) {

$parcel$export(module.exports, "date", function () { return $490202e22d97e97d$export$324d90190a8b822a; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $490202e22d97e97d$export$324d90190a8b822a = (0, $ceuZl.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute("data-timestamp")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "date",
            "data-timestamp": node.attrs.timestamp
        };
        return [
            "span",
            attrs
        ];
    }
});
var $490202e22d97e97d$export$a6a035390e3921b2 = (0, $ceuZl.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute("data-timestamp"),
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-node-type": "date",
            "data-timestamp": node.attrs.timestamp,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "span",
            attrs
        ];
    }
});

});

parcelRegister("38GhG", function(module, exports) {

$parcel$export(module.exports, "decisionItem", function () { return $2492eb3ae79daeda$export$6959e16eeff859b4; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
var $2492eb3ae79daeda$export$6959e16eeff859b4 = (0, $ceuZl.decisionItem)({
    parseDOM: [
        {
            tag: "li[data-decision-local-id]",
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $bI8Ay.uuid).generate(),
                    state: dom.getAttribute("data-decision-state")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            "data-decision-local-id": localId || "local-decision",
            "data-decision-state": state
        };
        return [
            "li",
            attrs,
            0
        ];
    }
});

});

parcelRegister("lLKxs", function(module, exports) {

$parcel$export(module.exports, "decisionList", function () { return $fd921661c3badc3c$export$62d45a65fb43d95e; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
/**
 * @name decisionList_node
 */ var $fd921661c3badc3c$var$name = "decisionList";
var $fd921661c3badc3c$export$a5393ce68c2ff601 = '[data-node-type="'.concat($fd921661c3badc3c$var$name, '"]');
var $fd921661c3badc3c$export$62d45a65fb43d95e = (0, $ceuZl.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($fd921661c3badc3c$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $fd921661c3badc3c$var$name,
            "data-decision-list-local-id": localId || "local-decision-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("jVUUr", function(module, exports) {

$parcel$export(module.exports, "doc", function () { return $e82f7c2fd78fc001$export$2a111da947c407d2; });

var $ceuZl = parcelRequire("ceuZl");
var $e82f7c2fd78fc001$export$2a111da947c407d2 = (0, $ceuZl.doc)({});

});

parcelRegister("1i4nh", function(module, exports) {

$parcel$export(module.exports, "embedCard", function () { return $0f0add8c88f8f8db$export$be4283d9a1cb1ff6; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $0f0add8c88f8f8db$export$be4283d9a1cb1ff6 = (0, $ceuZl.embedCard)({
    parseDOM: [
        {
            tag: "div[data-embed-card]",
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute("data-card-url"),
                    layout: dom.getAttribute("data-layout") || "center",
                    width: Number(dom.getAttribute("data-width")) || null,
                    originalWidth: Number(dom.getAttribute("data-card-original-width")) || null,
                    originalHeight: Number(dom.getAttribute("data-card-original-height")) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            "data-embed-card": "",
            "data-card-url": url,
            "data-layout": layout,
            "data-width": width,
            "data-original-width": originalWidth,
            "data-original-height": originalHeight
        };
        return [
            "div",
            attrs
        ];
    }
});
var $0f0add8c88f8f8db$export$36734475a7f6fd3e = (0, $ceuZl.embedCard)({
    parseDOM: [
        {
            tag: "div[data-embed-card]",
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute("data-card-url"),
                    layout: dom.getAttribute("data-layout") || "center",
                    width: Number(dom.getAttribute("data-width")) || null,
                    originalWidth: Number(dom.getAttribute("data-card-original-width")) || null,
                    originalHeight: Number(dom.getAttribute("data-card-original-height")) || null,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            "data-embed-card": "",
            "data-card-url": url,
            "data-layout": layout,
            "data-width": width,
            "data-original-width": originalWidth,
            "data-original-height": originalHeight,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            "div",
            attrs
        ];
    }
});

});

parcelRegister("eDvyI", function(module, exports) {

$parcel$export(module.exports, "emoji", function () { return $aa7d302b1c5dde4b$export$a19185d1233fc4b2; });

var $417VF = parcelRequire("417VF");

var $kWcFF = parcelRequire("kWcFF");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $aa7d302b1c5dde4b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aa7d302b1c5dde4b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aa7d302b1c5dde4b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aa7d302b1c5dde4b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aa7d302b1c5dde4b$export$a19185d1233fc4b2 = (0, $ceuZl.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: "div.ak-editor-panel__icon span",
            ignore: true
        },
        {
            tag: "span[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: "img[data-emoticon-name]",
            getAttrs: function getAttrs(dom) {
                return (0, $kWcFF.acNameToEmoji)(dom.getAttribute("data-emoticon-name"));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: "img[data-hipchat-emoticon]",
            getAttrs: function getAttrs(dom) {
                return (0, $kWcFF.acShortcutToEmoji)(dom.getAttribute("data-hipchat-emoticon"));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: "img.emoji[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            "data-emoji-short-name": shortName,
            "data-emoji-id": id,
            "data-emoji-text": text,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $aa7d302b1c5dde4b$export$ebb3b3c7a0ac9936 = (0, $ceuZl.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: "div.ak-editor-panel__icon span",
            ignore: true
        },
        {
            tag: "span[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: "img[data-emoticon-name]",
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $kWcFF.acNameToEmoji)(dom.getAttribute("data-emoticon-name"));
                return $aa7d302b1c5dde4b$var$_objectSpread($aa7d302b1c5dde4b$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: "img[data-hipchat-emoticon]",
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $kWcFF.acShortcutToEmoji)(dom.getAttribute("data-hipchat-emoticon"));
                return $aa7d302b1c5dde4b$var$_objectSpread($aa7d302b1c5dde4b$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $bI8Ay.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: "img.emoji[data-emoji-short-name]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute("data-emoji-short-name") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute("data-emoji-id") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute("data-emoji-text") || $aa7d302b1c5dde4b$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            "data-emoji-short-name": shortName,
            "data-emoji-id": id,
            "data-emoji-text": text,
            contenteditable: "false",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});
parcelRegister("kWcFF", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", function () { return $f3e30da26cb40f1e$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $f3e30da26cb40f1e$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $f3e30da26cb40f1e$var$DEFAULT_EMOJI_ID = "2b50";
// Default ac:name for emoticons as a fallback is `blue-star`
var $f3e30da26cb40f1e$var$DEFAULT_EMOJI_ACNAME = "blue-star";
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $f3e30da26cb40f1e$var$HC_EMOTICON_PREFIX = "atlassian-";
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $f3e30da26cb40f1e$var$acNameToEmojiMap = {
    smile: [
        "1f642",
        ":slight_smile:",
        "\uD83D\uDE42"
    ],
    sad: [
        "1f641",
        ":slight_frown:",
        "\uD83D\uDE41"
    ],
    cheeky: [
        "1f61b",
        ":stuck_out_tongue:",
        "\uD83D\uDE1B"
    ],
    laugh: [
        "1f600",
        ":grinning:",
        "\uD83D\uDE00"
    ],
    wink: [
        "1f609",
        ":wink:",
        "\uD83D\uDE09"
    ],
    information: [
        "2139",
        ":information_source:",
        "\u2139"
    ],
    tick: [
        "2705",
        ":white_check_mark:",
        "\u2705"
    ],
    cross: [
        "274c",
        ":x:",
        "\u274C"
    ],
    warning: [
        "26a0",
        ":warning:",
        "\u26A0"
    ],
    plus: [
        "2795",
        ":heavy_plus_sign:",
        "\u2795"
    ],
    minus: [
        "2796",
        ":heavy_minus_sign:",
        "\u2796"
    ],
    question: [
        "2753",
        ":question:",
        "?"
    ],
    "thumbs-up": [
        "1f44d",
        ":thumbsup:",
        "\uD83D\uDC4D"
    ],
    "thumbs-down": [
        "1f44e",
        ":thumbsdown:",
        "\uD83D\uDC4E"
    ],
    "light-on": [
        "1f4a1",
        ":bulb:",
        "\uD83D\uDCA1"
    ],
    "yellow-star": [
        "2b50",
        ":star:",
        "\uD83D\uDC9B"
    ],
    "light-off": [
        "1f6ab",
        ":no_entry_sign:",
        "\uD83D\uDEAB"
    ],
    "red-star": [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "green-star": [
        "1f49a",
        ":green_heart:",
        "\uD83D\uDC9A"
    ],
    "blue-star": [
        "1f499",
        ":blue_heart:",
        "\uD83D\uDC99"
    ],
    heart: [
        "2764",
        ":heart:",
        "\u2764\uFE0F"
    ],
    "broken-heart": [
        "1f494",
        ":broken_heart:",
        "\uD83D\uDC94"
    ]
};
function $f3e30da26cb40f1e$export$f61e93bda2a8b420(acName) {
    var emojiData = $f3e30da26cb40f1e$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $f3e30da26cb40f1e$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ""
    };
}
function $f3e30da26cb40f1e$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $f3e30da26cb40f1e$var$acNameToEmojiMap[acName] ? $f3e30da26cb40f1e$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($f3e30da26cb40f1e$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $f3e30da26cb40f1e$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($f3e30da26cb40f1e$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ""
    };
}
function $f3e30da26cb40f1e$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ":" ? 1 : 0, shortName[shortName.length - 1] === ":" ? -1 : shortName.length);
}
function $f3e30da26cb40f1e$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($f3e30da26cb40f1e$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $f3e30da26cb40f1e$var$getAcNameFromShortName(shortName);
        if (possibleName in $f3e30da26cb40f1e$var$acNameToEmojiMap) return possibleName;
    }
    return $f3e30da26cb40f1e$export$bc94e44ec0e7bd82(id) || $f3e30da26cb40f1e$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("bHU7n", function(module, exports) {

$parcel$export(module.exports, "extendedBlockquote", function () { return $885f3db6bf3c181c$export$70a64939da3e8455; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
/**
 * @name blockquote_node
 */ var $885f3db6bf3c181c$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: "blockquote"
        }
    ],
    toDOM: function toDOM() {
        return [
            "blockquote",
            0
        ];
    }
};
var $885f3db6bf3c181c$export$67dc04e652a298ca = (0, $ceuZl.blockquoteLegacy)($885f3db6bf3c181c$var$nodeSpecOptions);
var $885f3db6bf3c181c$export$70a64939da3e8455 = (0, $ceuZl.blockquote)($885f3db6bf3c181c$var$nodeSpecOptions);
var $885f3db6bf3c181c$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: "blockquote",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            "blockquote",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $885f3db6bf3c181c$export$950ebf43f3364a0f = (0, $ceuZl.blockquote)($885f3db6bf3c181c$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("lI9dQ", function(module, exports) {

$parcel$export(module.exports, "extendedPanel", function () { return $fce4dc61aa512967$export$ce20b13564211141; });

var $417VF = parcelRequire("417VF");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $fce4dc61aa512967$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fce4dc61aa512967$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fce4dc61aa512967$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fce4dc61aa512967$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fce4dc61aa512967$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $fce4dc61aa512967$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        "data-panel-type": nodeAttrs.panelType,
        "data-panel-icon": nodeAttrs.panelIcon,
        "data-panel-icon-id": nodeAttrs.panelIconId,
        "data-panel-icon-text": nodeAttrs.panelIconText,
        "data-panel-color": nodeAttrs.panelColor,
        "data-local-id": (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $fce4dc61aa512967$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute("data-panel-type")
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $bI8Ay.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $fce4dc61aa512967$var$_objectSpread($fce4dc61aa512967$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute("data-panel-icon"),
        panelIconId: dom.getAttribute("data-panel-icon-id"),
        panelIconText: dom.getAttribute("data-panel-icon-text"),
        panelColor: dom.getAttribute("data-panel-color")
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $fce4dc61aa512967$export$969277cf61e5a7aa.CUSTOM ? $fce4dc61aa512967$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $fce4dc61aa512967$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: "div[data-panel-type]",
                getAttrs: function getAttrs(dom) {
                    return $fce4dc61aa512967$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $fce4dc61aa512967$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                "data-panel-content": "true"
            };
            return [
                "div",
                attrs,
                [
                    "div",
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $fce4dc61aa512967$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $ceuZl.panel)($fce4dc61aa512967$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $fce4dc61aa512967$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $ceuZl.panel)($fce4dc61aa512967$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("3SOm6", function(module, exports) {

$parcel$export(module.exports, "extension", function () { return $2d3d79c65a168210$export$1b45514b112dd749; });

var $2HBwi = parcelRequire("2HBwi");

var $ceuZl = parcelRequire("ceuZl");
var $2d3d79c65a168210$export$1b45514b112dd749 = (0, $ceuZl.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2HBwi.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "extension",
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-layout": node.attrs.layout,
            "data-local-id:": node.attrs.localId
        };
        return [
            "div",
            attrs
        ];
    }
});

});

parcelRegister("g6wtR", function(module, exports) {

$parcel$export(module.exports, "hardBreak", function () { return $bb9666de0d6f2833$export$371da9dd35aba193; });

var $ceuZl = parcelRequire("ceuZl");
var $bb9666de0d6f2833$export$371da9dd35aba193 = (0, $ceuZl.hardBreak)({
    parseDOM: [
        {
            tag: "br"
        }
    ],
    toDOM: function toDOM() {
        return [
            "br"
        ];
    }
});

});

parcelRegister("hGcqq", function(module, exports) {

$parcel$export(module.exports, "heading", function () { return $cdefff4cc81bde5c$export$46e4a324ac90507f; });

var $ceuZl = parcelRequire("ceuZl");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $cdefff4cc81bde5c$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute("data-local-id") || ((_heading$attrs = $cdefff4cc81bde5c$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $cdefff4cc81bde5c$export$46e4a324ac90507f = (0, $ceuZl.heading)({
    parseDOM: [
        {
            tag: "h1",
            getAttrs: $cdefff4cc81bde5c$var$getAttrs(1)
        },
        {
            tag: "h2",
            getAttrs: $cdefff4cc81bde5c$var$getAttrs(2)
        },
        {
            tag: "h3",
            getAttrs: $cdefff4cc81bde5c$var$getAttrs(3)
        },
        {
            tag: "h4",
            getAttrs: $cdefff4cc81bde5c$var$getAttrs(4)
        },
        {
            tag: "h5",
            getAttrs: $cdefff4cc81bde5c$var$getAttrs(5)
        },
        {
            tag: "h6",
            getAttrs: $cdefff4cc81bde5c$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = "h" + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("hQZNB", function(module, exports) {

$parcel$export(module.exports, "image", function () { return $cff73afdef62b5e4$export$5c452ff88e35e47d; });

var $ceuZl = parcelRequire("ceuZl");
var $cff73afdef62b5e4$export$5c452ff88e35e47d = (0, $ceuZl.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: "img[src]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute("src"),
                    alt: dom.getAttribute("alt"),
                    title: dom.getAttribute("title")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            "img",
            node.attrs
        ];
    }
});

});

parcelRegister("5p6cx", function(module, exports) {

$parcel$export(module.exports, "inlineCard", function () { return $3ef419006041e234$export$cbf8224b64e0d942; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $3ef419006041e234$export$cbf8224b64e0d942 = (0, $ceuZl.inlineCard)({
    parseDOM: [
        {
            tag: "a[data-inline-card], span[data-inline-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute("href") || anchor.getAttribute("data-card-url") || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: "div[data-inline-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                return {
                    url: anchor.getAttribute("data-card-url"),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-inline-card": "",
            href: node.attrs.url || "",
            "data-card-data": node.attrs.data ? JSON.stringify(node.attrs.data) : ""
        };
        if (node.attrs.url) return [
            "a",
            attrs,
            node.attrs.url
        ];
        else return [
            "a",
            attrs
        ];
    }
});
var $3ef419006041e234$export$7ed775fc743eadd1 = (0, $ceuZl.inlineCard)({
    parseDOM: [
        {
            tag: "a[data-inline-card], span[data-inline-card]",
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute("href") || anchor.getAttribute("data-card-url") || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: "div[data-inline-card]",
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute("data-card-data");
                return {
                    url: anchor.getAttribute("data-card-url"),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-inline-card": "",
            href: node.attrs.url || "",
            "data-card-data": node.attrs.data ? JSON.stringify(node.attrs.data) : "",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            "a",
            attrs,
            node.attrs.url
        ];
        else return [
            "a",
            attrs
        ];
    }
});

});

parcelRegister("3vnPp", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", function () { return $28d6c01a75ef291d$export$16b353b2649bd8d9; });

var $2HBwi = parcelRequire("2HBwi");

var $ceuZl = parcelRequire("ceuZl");
var $28d6c01a75ef291d$export$16b353b2649bd8d9 = (0, $ceuZl.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: "span[data-extension-type]",
            getAttrs: function getAttrs(domNode) {
                return (0, $2HBwi.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-extension-type": node.attrs.extensionType,
            "data-extension-key": node.attrs.extensionKey,
            "data-text": node.attrs.text,
            "data-parameters": JSON.stringify(node.attrs.parameters),
            "data-local-id:": node.attrs.localId,
            contenteditable: "false"
        };
        return [
            "span",
            attrs
        ];
    }
});

});

parcelRegister("3Bcqm", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", function () { return $29ee76f63a479615$export$ab76e7c03cd6f650; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $29ee76f63a479615$export$ab76e7c03cd6f650 = (0, $ceuZl.layoutColumn)({
    parseDOM: [
        {
            context: "layoutColumn//",
            tag: "div[data-layout-column]",
            skip: true
        },
        {
            tag: "div[data-layout-column]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute("data-column-width")) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-layout-column": "true"
        };
        var width = node.attrs.width;
        if (width) {
            attrs["style"] = "flex-basis: ".concat(width, "%");
            attrs["data-column-width"] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            "data-layout-content": "true"
        };
        return [
            "div",
            attrs,
            [
                "div",
                contentAttrs,
                0
            ]
        ];
    }
});
var $29ee76f63a479615$export$b2e27d292505bac2 = (0, $ceuZl.layoutColumn)({
    parseDOM: [
        {
            context: "layoutColumn//",
            tag: "div[data-layout-column]",
            skip: true
        },
        {
            tag: "div[data-layout-column]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute("data-column-width")) || undefined,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-layout-column": "true",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        var width = node.attrs.width;
        if (width) {
            attrs["style"] = "flex-basis: ".concat(width, "%");
            attrs["data-column-width"] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            "data-layout-content": "true"
        };
        return [
            "div",
            attrs,
            [
                "div",
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("uEvQZ", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", function () { return $05c23a72f034cc29$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "media", function () { return $05c23a72f034cc29$export$987d49ffe1b0900f; });

var $417VF = parcelRequire("417VF");

var $2zOsm = parcelRequire("2zOsm");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $05c23a72f034cc29$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05c23a72f034cc29$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05c23a72f034cc29$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05c23a72f034cc29$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $05c23a72f034cc29$export$bb3fe706be61f640 = (0, $ceuZl.media)({}).attrs;
var $05c23a72f034cc29$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? "span" : "div";
    var nodeName = inline ? "mediaInline" : "media";
    var parseDOM = [
        {
            tag: "".concat(domNodeType, '[data-node-type="').concat(nodeName, '"]'),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $05c23a72f034cc29$export$f84fdfb973c05bd8(k).replace(/^__/, "");
                    var value = dom.getAttribute("data-".concat(key)) || "";
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== "undefined" && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== "undefined" && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $bI8Ay.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            "data-id": node.attrs.id,
            "data-node-type": "".concat(nodeName),
            "data-type": node.attrs.type,
            "data-collection": node.attrs.collection,
            "data-occurrence-key": node.attrs.occurrenceKey,
            "data-width": node.attrs.width,
            "data-height": node.attrs.height,
            "data-url": node.attrs.url,
            "data-alt": node.attrs.alt,
            "data-local-id": node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: "Attachment",
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $2zOsm.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $05c23a72f034cc29$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($05c23a72f034cc29$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $ceuZl.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $ceuZl.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: "img:not(.smart-link-icon)",
                getAttrs: function getAttrs(dom) {
                    var attrs = {
                        type: "external",
                        url: dom.getAttribute("src") || "",
                        alt: dom.getAttribute("alt") || ""
                    };
                    if (generateLocalId) attrs.localId = (0, $bI8Ay.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $05c23a72f034cc29$export$987d49ffe1b0900f = $05c23a72f034cc29$export$35bdbf5bc8caa677($05c23a72f034cc29$export$bb3fe706be61f640, false, false);
var $05c23a72f034cc29$export$8446e47a4c7fd000 = $05c23a72f034cc29$export$35bdbf5bc8caa677($05c23a72f034cc29$var$_objectSpread($05c23a72f034cc29$var$_objectSpread({}, $05c23a72f034cc29$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $bI8Ay.uuid).generate()
    }
}), false, true);
var $05c23a72f034cc29$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $05c23a72f034cc29$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($05c23a72f034cc29$export$987d49ffe1b0900f.attrs) Object.keys($05c23a72f034cc29$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === "_" && key[1] === "_" && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $05c23a72f034cc29$var$optionalAttributes = [
    "occurrenceKey",
    "width",
    "height",
    "url",
    "alt",
    "localId"
];
var $05c23a72f034cc29$var$externalOnlyAttributes = [
    "type",
    "url",
    "width",
    "height",
    "alt",
    "localId"
];
var $05c23a72f034cc29$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === "_" && key[1] === "_");
        }).reduce(function(obj, key) {
            if (node.attrs.type === "external" && $05c23a72f034cc29$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($05c23a72f034cc29$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === "")) return obj;
            if ([
                "width",
                "height"
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("kfA1Y", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", function () { return $ebe1285aefff30d6$export$2855e964765eac9; });

var $ceuZl = parcelRequire("ceuZl");
var $ebe1285aefff30d6$export$2855e964765eac9 = (0, $ceuZl.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": "mediaGroup"
            },
            0
        ];
    }
});

});

parcelRegister("4wAmH", function(module, exports) {

$parcel$export(module.exports, "mediaInline", function () { return $34b65bf5763ba277$export$38bab695e3f720f1; });

var $417VF = parcelRequire("417VF");

var $uEvQZ = parcelRequire("uEvQZ");

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
function $34b65bf5763ba277$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $34b65bf5763ba277$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $34b65bf5763ba277$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $34b65bf5763ba277$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $34b65bf5763ba277$export$38bab695e3f720f1 = (0, $uEvQZ.createMediaSpec)((0, $ceuZl.mediaInline)({}).attrs, true);
var $34b65bf5763ba277$export$aea8e9c496505c61 = (0, $uEvQZ.createMediaSpec)($34b65bf5763ba277$var$_objectSpread($34b65bf5763ba277$var$_objectSpread({}, (0, $ceuZl.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $bI8Ay.uuid).generate()
    }
}), true, true);

});

parcelRegister("lRp6Z", function(module, exports) {

$parcel$export(module.exports, "mediaSingleFull", function () { return $fea206e2dac967d1$export$7e767666f2ce108a; });

var $417VF = parcelRequire("417VF");

var $2rfl8 = parcelRequire("2rfl8");

var $hkhkR = parcelRequire("hkhkR");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $fea206e2dac967d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fea206e2dac967d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fea206e2dac967d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fea206e2dac967d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $fea206e2dac967d1$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: "center"
    }
};
var $fea206e2dac967d1$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $hkhkR.isDOMElement)(dom)) // this should never happen
        return {
            layout: "center"
        };
        var layout = dom.getAttribute("data-layout") || "center";
        var width = Number(dom.getAttribute("data-width")) || null;
        var widthType = dom.getAttribute("data-width-type");
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $bI8Ay.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $2rfl8.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            "data-node-type": "mediaSingle",
            "data-layout": layout,
            "data-width": ""
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs["data-local-id"] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs["data-width"] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $fea206e2dac967d1$var$_objectSpread($fea206e2dac967d1$var$_objectSpread({}, attrs), {}, {
                "data-width-type": widthType || (0, $2rfl8.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $ceuZl.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $ceuZl.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $ceuZl.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $ceuZl.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                "div",
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $fea206e2dac967d1$export$969fe3781ca15058 = $fea206e2dac967d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $fea206e2dac967d1$export$d35e6c006d4abdfb = $fea206e2dac967d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $fea206e2dac967d1$export$9c58e19811ce4cf5 = $fea206e2dac967d1$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $fea206e2dac967d1$export$7e767666f2ce108a = $fea206e2dac967d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $fea206e2dac967d1$export$75376a385837c942 = $fea206e2dac967d1$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $fea206e2dac967d1$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("2rfl8", function(module, exports) {

$parcel$export(module.exports, "WidthType", function () { return $1c6a008f2dba9323$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $1c6a008f2dba9323$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("kq0F2", function(module, exports) {

$parcel$export(module.exports, "mention", function () { return $edd6bf999d5a2008$export$db83999c14438df4; });

var $417VF = parcelRequire("417VF");

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
function $edd6bf999d5a2008$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edd6bf999d5a2008$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edd6bf999d5a2008$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edd6bf999d5a2008$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $edd6bf999d5a2008$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $edd6bf999d5a2008$export$db83999c14438df4 = (0, $ceuZl.mention)({
    parseDOM: [
        {
            tag: "span[data-mention-id]",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute("data-mention-id") || $edd6bf999d5a2008$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $edd6bf999d5a2008$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute("data-access-level") || $edd6bf999d5a2008$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $bI8Ay.uuid).generate()
                };
                var userType = dom.getAttribute("data-user-type");
                if ($edd6bf999d5a2008$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            "data-mention-id": id,
            "data-access-level": accessLevel,
            contenteditable: "false"
        };
        if (localId) attrs["data-local-id"] = localId;
        if (userType) attrs["data-user-type"] = userType;
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $edd6bf999d5a2008$var$isOptional = function isOptional(key) {
    return [
        "userType",
        "localId"
    ].indexOf(key) > -1;
};
var $edd6bf999d5a2008$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($edd6bf999d5a2008$var$isOptional(key) && !node.attrs[key]) return obj;
            return $edd6bf999d5a2008$var$_objectSpread($edd6bf999d5a2008$var$_objectSpread({}, obj), {}, (0, $417VF.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("jhapy", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", function () { return $e087ae4f72f608e5$export$63cadbf5f4296627; });

var $8ZyeF = parcelRequire("8ZyeF");

var $417VF = parcelRequire("417VF");

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
function $e087ae4f72f608e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e087ae4f72f608e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e087ae4f72f608e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $417VF.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e087ae4f72f608e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $e087ae4f72f608e5$var$getExpandAttrs(domNode, generateLocalId) {
    var dom = domNode;
    return {
        title: dom.getAttribute("data-title"),
        __expanded: true,
        localId: generateLocalId ? (0, $bI8Ay.uuid).generate() : undefined
    };
}
var $e087ae4f72f608e5$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: "nestedExpand//",
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e087ae4f72f608e5$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e087ae4f72f608e5$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            "data-node-type": "nestedExpand",
            "data-title": node.attrs.title,
            "data-expanded": node.attrs.__expanded,
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "div",
            attrs,
            0
        ];
    }
};
var $e087ae4f72f608e5$export$63cadbf5f4296627 = (0, $ceuZl.nestedExpand)($e087ae4f72f608e5$var$nestedExpandFactoryOptions);
var $e087ae4f72f608e5$export$b854197485aa1fa0 = (0, $ceuZl.nestedExpand)($e087ae4f72f608e5$var$_objectSpread($e087ae4f72f608e5$var$_objectSpread({}, $e087ae4f72f608e5$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, $8ZyeF.default)($e087ae4f72f608e5$var$nestedExpandFactoryOptions.parseDOM), [
        {
            context: "nestedExpand//",
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e087ae4f72f608e5$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $e087ae4f72f608e5$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});
parcelRegister("8ZyeF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68be93b973440341$export$2e2bcd8739ae039; });

var $aYr9R = parcelRequire("aYr9R");

var $bqMtK = parcelRequire("bqMtK");

var $jr0Cx = parcelRequire("jr0Cx");

var $j4A1A = parcelRequire("j4A1A");
function $68be93b973440341$export$2e2bcd8739ae039(r) {
    return (0, $aYr9R.default)(r) || (0, $bqMtK.default)(r) || (0, $jr0Cx.default)(r) || (0, $j4A1A.default)();
}

});
parcelRegister("aYr9R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fd492fa2937b0b0$export$2e2bcd8739ae039; });

var $4VT0m = parcelRequire("4VT0m");
function $7fd492fa2937b0b0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $4VT0m.default)(r);
}

});

parcelRegister("bqMtK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8527ba4712bbdfd1$export$2e2bcd8739ae039; });
function $8527ba4712bbdfd1$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("j4A1A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de2a55c2d613bd1b$export$2e2bcd8739ae039; });
function $de2a55c2d613bd1b$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("9MmD5", function(module, exports) {

$parcel$export(module.exports, "orderedListWithOrder", function () { return $71ea267b4bffe1a5$export$b9ab759e8298198f; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
var $71ea267b4bffe1a5$export$4e7125c7ff595be5 = ".ak-ol";
var $71ea267b4bffe1a5$export$a5dc81035676e7a = (0, $ceuZl.orderedList)({
    parseDOM: [
        {
            tag: "ol"
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $71ea267b4bffe1a5$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
var $71ea267b4bffe1a5$export$8157adc5747ec436 = (0, $ceuZl.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $71ea267b4bffe1a5$export$4e7125c7ff595be5.substr(1),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $71ea267b4bffe1a5$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $71ea267b4bffe1a5$export$b9ab759e8298198f = (0, $ceuZl.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute("start");
                if (startDOMAttr) {
                    var start = $71ea267b4bffe1a5$var$resolveStart(startDOMAttr);
                    if (typeof start === "number") return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $71ea267b4bffe1a5$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === "number" ? String(start) : undefined,
            class: $71ea267b4bffe1a5$export$4e7125c7ff595be5.substr(1)
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});
var $71ea267b4bffe1a5$export$2ea3505d41d7525d = (0, $ceuZl.orderedList)({
    parseDOM: [
        {
            tag: "ol",
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute("start");
                var localId = (0, $bI8Ay.uuid).generate();
                if (startDOMAttr) {
                    var start = $71ea267b4bffe1a5$var$resolveStart(startDOMAttr);
                    if (typeof start === "number") return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $71ea267b4bffe1a5$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === "number" ? String(start) : undefined,
            class: $71ea267b4bffe1a5$export$4e7125c7ff595be5.substr(1),
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            "ol",
            attrs,
            0
        ];
    }
});

});

parcelRegister("7GBWG", function(module, exports) {

$parcel$export(module.exports, "paragraph", function () { return $5989e3d506dcb82e$export$9c206ddddb32a9b; });

var $ceuZl = parcelRequire("ceuZl");
var $5989e3d506dcb82e$export$9c206ddddb32a9b = (0, $ceuZl.paragraph)({
    parseDOM: [
        {
            tag: "p",
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute("data-local-id") || ((_paragraph$attrs = $5989e3d506dcb82e$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = "p";
        var attrs = localId !== undefined && localId !== null ? [
            {
                "data-local-id": localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("chRYW", function(module, exports) {

$parcel$export(module.exports, "placeholder", function () { return $8f20f23b0066bdce$export$c7187bbd1a7a9244; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
var $8f20f23b0066bdce$export$c7187bbd1a7a9244 = (0, $ceuZl.placeholder)({
    parseDOM: [
        {
            tag: "span[data-placeholder]",
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute("data-placeholder") || $8f20f23b0066bdce$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            "data-placeholder": text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: "true"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});
var $8f20f23b0066bdce$export$6205248609a8f7a0 = (0, $ceuZl.placeholder)({
    parseDOM: [
        {
            tag: "span[data-placeholder]",
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute("data-placeholder") || $8f20f23b0066bdce$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            "data-placeholder": text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: "true",
            "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});

parcelRegister("hsZqR", function(module, exports) {

$parcel$export(module.exports, "rule", function () { return $0348136cdb0c1920$export$fbeb3a3956e8a3c7; });

var $ceuZl = parcelRequire("ceuZl");

var $bI8Ay = parcelRequire("bI8Ay");
/**
 * @name rule_node
 */ var $0348136cdb0c1920$var$hrDOM = [
    "hr"
];
var $0348136cdb0c1920$export$fbeb3a3956e8a3c7 = (0, $ceuZl.rule)({
    parseDOM: [
        {
            tag: "hr"
        }
    ],
    toDOM: function toDOM() {
        return $0348136cdb0c1920$var$hrDOM;
    }
});
var $0348136cdb0c1920$export$bf3ef6fb6ad90e7 = (0, $ceuZl.rule)({
    parseDOM: [
        {
            tag: "hr",
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            "hr",
            {
                "data-local-id": (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("aAisl", function(module, exports) {

$parcel$export(module.exports, "status", function () { return $7b4b95329e7c3ac0$export$471f7ae5c4103ae1; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
var $7b4b95329e7c3ac0$export$471f7ae5c4103ae1 = (0, $ceuZl.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, "").trim(),
                    color: dom.getAttribute("data-color"),
                    localId: (0, $bI8Ay.uuid).generate(),
                    style: dom.getAttribute("data-style")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            "data-node-type": "status",
            "data-color": color,
            "data-local-id": localId,
            "data-style": style,
            contenteditable: "false"
        };
        return [
            "span",
            attrs,
            text
        ];
    }
});

});

parcelRegister("dFjEs", function(module, exports) {

$parcel$export(module.exports, "taskList", function () { return $9f2e5912a1453a44$export$375b6afcc5f4d291; });

var $bI8Ay = parcelRequire("bI8Ay");

var $ceuZl = parcelRequire("ceuZl");
/**
 * @name taskList_node
 */ var $9f2e5912a1453a44$var$name = "actionList";
var $9f2e5912a1453a44$export$c0ec71adb7a18fb2 = '[data-node-type="'.concat($9f2e5912a1453a44$var$name, '"]');
var $9f2e5912a1453a44$export$375b6afcc5f4d291 = (0, $ceuZl.taskList)({
    parseDOM: [
        {
            tag: "div".concat($9f2e5912a1453a44$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $bI8Ay.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            "data-node-type": $9f2e5912a1453a44$var$name,
            "data-task-list-local-id": localId || "local-task-list",
            style: "list-style: none; padding-left: 0"
        };
        return [
            "div",
            attrs,
            0
        ];
    }
});

});

parcelRegister("1eeTW", function(module, exports) {

$parcel$export(module.exports, "text", function () { return $0e52a84f4d0e40bb$export$6f093cfa640b7166; });

var $ceuZl = parcelRequire("ceuZl");
var $0e52a84f4d0e40bb$export$6f093cfa640b7166 = (0, $ceuZl.text)({
    toDebugString: function() {
        return "text_node";
    }
});

});

parcelRegister("cuLGP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $918d4796cfe96139$export$2e2bcd8739ae039; });
var $918d4796cfe96139$var$name = "unknownBlock";
var $918d4796cfe96139$export$2e2bcd8739ae039 = {
    group: "block",
    content: "inline+",
    marks: "_",
    toDOM: function toDOM() {
        return [
            "div",
            {
                "data-node-type": $918d4796cfe96139$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: 'div[data-node-type="'.concat($918d4796cfe96139$var$name, '"]')
        }
    ]
};

});

parcelRegister("8cnnR", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", function () { return $5f8195475a076284$export$44b79b0979d0f0f7; });

var $ceuZl = parcelRequire("ceuZl");
var $5f8195475a076284$export$44b79b0979d0f0f7 = (0, $ceuZl.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedBlock",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "div",
            attrs,
            "Unsupported content"
        ];
    }
});

});

parcelRegister("cKx2u", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", function () { return $948368cfd27aa364$export$310ebe0d80122e9b; });

var $ceuZl = parcelRequire("ceuZl");
var $948368cfd27aa364$export$310ebe0d80122e9b = (0, $ceuZl.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute("data-original-value") || "{}")
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            "data-node-type": "unsupportedInline",
            "data-original-value": JSON.stringify(node.attrs.originalValue)
        };
        return [
            "span",
            attrs,
            "Unsupported content"
        ];
    }
});

});



parcelRegister("6WBoi", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", function () { return $50e529ed563d407a$export$a64f782182dea128; });

var $4JCoo = parcelRequire("4JCoo");
parcelRequire("4HVbV");
var $cFLzQ = parcelRequire("cFLzQ");
/**
Document schema for the data model used by CommonMark.
*/ const $50e529ed563d407a$export$4902baddc787debb = new (0, $4JCoo.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $50e529ed563d407a$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $4JCoo.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $50e529ed563d407a$var$MarkdownParseState {
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $50e529ed563d407a$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $4JCoo.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $4JCoo.Mark).none
            }
        ];
    }
}
function $50e529ed563d407a$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $50e529ed563d407a$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $50e529ed563d407a$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $50e529ed563d407a$var$noOp() {}
function $50e529ed563d407a$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($50e529ed563d407a$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $50e529ed563d407a$var$attrs(spec, tok, tokens, i));
                state.addText($50e529ed563d407a$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $50e529ed563d407a$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $50e529ed563d407a$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($50e529ed563d407a$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($50e529ed563d407a$var$attrs(spec, tok, tokens, i)));
                state.addText($50e529ed563d407a$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($50e529ed563d407a$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($50e529ed563d407a$var$noCloseToken(spec, type)) handlers[type] = $50e529ed563d407a$var$noOp;
            else {
                handlers[type + "_open"] = $50e529ed563d407a$var$noOp;
                handlers[type + "_close"] = $50e529ed563d407a$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $50e529ed563d407a$export$a64f782182dea128 {
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $50e529ed563d407a$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $50e529ed563d407a$var$tokenHandlers(schema, tokens);
    }
}
function $50e529ed563d407a$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $50e529ed563d407a$export$7517583227ad0cb8 = new $50e529ed563d407a$export$a64f782182dea128($50e529ed563d407a$export$4902baddc787debb, (0, $cFLzQ.default)("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $50e529ed563d407a$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $50e529ed563d407a$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $50e529ed563d407a$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $50e529ed563d407a$export$ae9f6f04acb6c60c {
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $50e529ed563d407a$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $50e529ed563d407a$export$f996452ca6e9a0ae = new $50e529ed563d407a$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $50e529ed563d407a$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $50e529ed563d407a$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $50e529ed563d407a$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $50e529ed563d407a$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $50e529ed563d407a$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $50e529ed563d407a$export$61055fa707e69319 {
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $50e529ed563d407a$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, "$1\\$2$3").replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
}

});
parcelRegister("4JCoo", function(module, exports) {

$parcel$export(module.exports, "Mark", function () { return $3729255231571253$export$c9d15bcfc6d42044; });
$parcel$export(module.exports, "Schema", function () { return $3729255231571253$export$19342e026b58ebb7; });

var $73qKE = parcelRequire("73qKE");
function $3729255231571253$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $3729255231571253$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $3729255231571253$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $3729255231571253$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $3729255231571253$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $3729255231571253$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $3729255231571253$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $3729255231571253$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $3729255231571253$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $3729255231571253$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $3729255231571253$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $3729255231571253$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $3729255231571253$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $3729255231571253$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $3729255231571253$var$retIndex(0, pos);
        if (pos == this.size) return $3729255231571253$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $3729255231571253$var$retIndex(i + 1, end);
                return $3729255231571253$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $3729255231571253$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $3729255231571253$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $3729255231571253$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $3729255231571253$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $3729255231571253$export$ffb0004e005737fa.empty;
        if (nodes instanceof $3729255231571253$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $3729255231571253$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $3729255231571253$export$ffb0004e005737fa.empty = new $3729255231571253$export$ffb0004e005737fa([], 0);
const $3729255231571253$var$found = {
    index: 0,
    offset: 0
};
function $3729255231571253$var$retIndex(index, offset) {
    $3729255231571253$var$found.index = index;
    $3729255231571253$var$found.offset = offset;
    return $3729255231571253$var$found;
}
function $3729255231571253$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$3729255231571253$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$3729255231571253$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $3729255231571253$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $3729255231571253$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $3729255231571253$export$c9d15bcfc6d42044.none;
        if (marks instanceof $3729255231571253$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $3729255231571253$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $3729255231571253$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $3729255231571253$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $3729255231571253$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $3729255231571253$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $3729255231571253$export$b3f2e2de3a8baa1e($3729255231571253$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $3729255231571253$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $3729255231571253$export$b3f2e2de3a8baa1e($3729255231571253$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $3729255231571253$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $3729255231571253$export$b3f2e2de3a8baa1e.empty = new $3729255231571253$export$b3f2e2de3a8baa1e($3729255231571253$export$ffb0004e005737fa.empty, 0, 0);
function $3729255231571253$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($3729255231571253$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $3729255231571253$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $3729255231571253$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $3729255231571253$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $3729255231571253$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $3729255231571253$export$6de0e778727af3f2("Inconsistent open depths");
    return $3729255231571253$var$replaceOuter($from, $to, slice, 0);
}
function $3729255231571253$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $3729255231571253$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $3729255231571253$var$close(node, $3729255231571253$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $3729255231571253$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $3729255231571253$var$prepareSliceForReplace(slice, $from);
        return $3729255231571253$var$close(node, $3729255231571253$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $3729255231571253$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $3729255231571253$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $3729255231571253$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $3729255231571253$var$checkJoin(node, $after.node(depth));
    return node;
}
function $3729255231571253$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $3729255231571253$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $3729255231571253$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$3729255231571253$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $3729255231571253$var$addNode($end.nodeBefore, target);
}
function $3729255231571253$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $3729255231571253$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $3729255231571253$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $3729255231571253$var$joinable($end, $to, depth + 1);
    let content = [];
    $3729255231571253$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $3729255231571253$var$checkJoin(openStart, openEnd);
        $3729255231571253$var$addNode($3729255231571253$var$close(openStart, $3729255231571253$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $3729255231571253$var$addNode($3729255231571253$var$close(openStart, $3729255231571253$var$replaceTwoWay($from, $start, depth + 1)), content);
        $3729255231571253$var$addRange($start, $end, depth, content);
        if (openEnd) $3729255231571253$var$addNode($3729255231571253$var$close(openEnd, $3729255231571253$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $3729255231571253$var$addRange($to, null, depth, content);
    return new $3729255231571253$export$ffb0004e005737fa(content);
}
function $3729255231571253$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $3729255231571253$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $3729255231571253$var$joinable($from, $to, depth + 1);
        $3729255231571253$var$addNode($3729255231571253$var$close(type, $3729255231571253$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $3729255231571253$var$addRange($to, null, depth, content);
    return new $3729255231571253$export$ffb0004e005737fa(content);
}
function $3729255231571253$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($3729255231571253$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $3729255231571253$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $3729255231571253$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $3729255231571253$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $3729255231571253$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $3729255231571253$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $3729255231571253$var$resolveCache.set(doc, cache = new $3729255231571253$var$ResolveCache);
        let result = cache.elts[cache.i] = $3729255231571253$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $3729255231571253$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $3729255231571253$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $3729255231571253$var$resolveCacheSize = 12, $3729255231571253$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $3729255231571253$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $3729255231571253$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $3729255231571253$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $3729255231571253$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $3729255231571253$var$emptyAttrs) && $3729255231571253$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $3729255231571253$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $3729255231571253$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $3729255231571253$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $3729255231571253$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $3729255231571253$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $3729255231571253$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $3729255231571253$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $3729255231571253$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $3729255231571253$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $3729255231571253$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $3729255231571253$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$3729255231571253$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $3729255231571253$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $3729255231571253$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $3729255231571253$export$ffb0004e005737fa.empty;
    }
}
$3729255231571253$export$85c928794f8d04d4.prototype.text = undefined;
class $3729255231571253$var$TextNode extends $3729255231571253$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $3729255231571253$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $3729255231571253$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $3729255231571253$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $3729255231571253$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $3729255231571253$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $3729255231571253$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $3729255231571253$export$364ed450558d7ec4.empty;
        let expr = $3729255231571253$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $3729255231571253$var$dfa($3729255231571253$var$nfa(expr));
        $3729255231571253$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $3729255231571253$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $3729255231571253$export$364ed450558d7ec4.empty = new $3729255231571253$export$364ed450558d7ec4(true);
class $3729255231571253$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $3729255231571253$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($3729255231571253$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $3729255231571253$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($3729255231571253$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $3729255231571253$var$parseExprSubscript(stream) {
    let expr = $3729255231571253$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $3729255231571253$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $3729255231571253$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $3729255231571253$var$parseExprRange(stream, expr) {
    let min = $3729255231571253$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $3729255231571253$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $3729255231571253$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $3729255231571253$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $3729255231571253$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $3729255231571253$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $3729255231571253$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $3729255231571253$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $3729255231571253$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($3729255231571253$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $3729255231571253$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($3729255231571253$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $3729255231571253$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $3729255231571253$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($3729255231571253$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $3729255231571253$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $3729255231571253$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $3729255231571253$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $3729255231571253$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $3729255231571253$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $3729255231571253$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $3729255231571253$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $3729255231571253$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $3729255231571253$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $3729255231571253$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $3729255231571253$export$ffb0004e005737fa.from(content), $3729255231571253$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $3729255231571253$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $3729255231571253$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $3729255231571253$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $3729255231571253$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($3729255231571253$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $3729255231571253$export$85c928794f8d04d4(this, attrs, content.append(after), $3729255231571253$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $3729255231571253$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $3729255231571253$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $3729255231571253$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $3729255231571253$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $3729255231571253$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $3729255231571253$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $3729255231571253$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $3729255231571253$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $3729255231571253$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $3729255231571253$export$c9d15bcfc6d42044(this, $3729255231571253$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $3729255231571253$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $3729255231571253$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $3729255231571253$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $3729255231571253$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $3729255231571253$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $3729255231571253$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $3729255231571253$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $3729255231571253$var$TextNode(type, type.defaultAttrs, text, $3729255231571253$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $3729255231571253$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $3729255231571253$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $73qKE.default).from(spec.nodes), instanceSpec.marks = (0, $73qKE.default).from(spec.marks || {}), this.nodes = $3729255231571253$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $3729255231571253$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $3729255231571253$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $3729255231571253$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $3729255231571253$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $3729255231571253$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $3729255231571253$var$isTagRule(rule) {
    return rule.tag != null;
}
function $3729255231571253$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $3729255231571253$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $3729255231571253$var$ParseContext(this, options, false);
        context.addAll(dom, $3729255231571253$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $3729255231571253$var$ParseContext(this, options, true);
        context.addAll(dom, $3729255231571253$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $3729255231571253$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($3729255231571253$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $3729255231571253$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $3729255231571253$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $3729255231571253$export$1059c6e7d2ce5669(schema, $3729255231571253$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($3729255231571253$var$isTagRule(rule)) this.tags.push(rule);
            else if ($3729255231571253$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $3729255231571253$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $3729255231571253$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $3729255231571253$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $3729255231571253$var$OPT_PRESERVE_WS = 1, $3729255231571253$var$OPT_PRESERVE_WS_FULL = 2, $3729255231571253$var$OPT_OPEN_LEFT = 4;
function $3729255231571253$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $3729255231571253$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $3729255231571253$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $3729255231571253$var$OPT_PRESERVE_WS | $3729255231571253$var$OPT_PRESERVE_WS_FULL : base & ~$3729255231571253$var$OPT_OPEN_LEFT;
}
class $3729255231571253$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($3729255231571253$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $3729255231571253$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $3729255231571253$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($3729255231571253$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$3729255231571253$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $3729255231571253$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $3729255231571253$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $3729255231571253$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $3729255231571253$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $3729255231571253$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == "BR" || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($3729255231571253$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $3729255231571253$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $3729255231571253$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($3729255231571253$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $3729255231571253$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $3729255231571253$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $3729255231571253$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $3729255231571253$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $3729255231571253$var$OPT_OPEN_LEFT;
        let applyMarks = $3729255231571253$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $3729255231571253$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $3729255231571253$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $3729255231571253$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $3729255231571253$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $3729255231571253$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $3729255231571253$var$NodeContext(topNode.type, topNode.attrs, $3729255231571253$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $3729255231571253$var$NodeContext(null, null, $3729255231571253$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $3729255231571253$var$NodeContext(parser.schema.topNodeType, null, $3729255231571253$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $3729255231571253$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $3729255231571253$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $3729255231571253$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $3729255231571253$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $3729255231571253$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $3729255231571253$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $3729255231571253$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $3729255231571253$var$renderSpec($3729255231571253$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $3729255231571253$var$renderSpec($3729255231571253$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $3729255231571253$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $3729255231571253$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $3729255231571253$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $3729255231571253$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $3729255231571253$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $3729255231571253$var$doc(options) {
    return options.document || window.document;
}
const $3729255231571253$var$suspiciousAttributeCache = new WeakMap();
function $3729255231571253$var$suspiciousAttributes(attrs) {
    let value = $3729255231571253$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $3729255231571253$var$suspiciousAttributeCache.set(attrs, value = $3729255231571253$var$suspiciousAttributesInner(attrs));
    return value;
}
function $3729255231571253$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $3729255231571253$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $3729255231571253$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $3729255231571253$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("4HVbV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("cFLzQ")).default; });

var $cFLzQ = parcelRequire("cFLzQ");

});
parcelRegister("cFLzQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d8d829740e6eeb0$export$2e2bcd8739ae039; });
// Main parser class

var $jI54p = parcelRequire("jI54p");

var $fAjjj = parcelRequire("fAjjj");

var $7HlX0 = parcelRequire("7HlX0");

var $d2RvS = parcelRequire("d2RvS");

var $4AknX = parcelRequire("4AknX");

var $dbNqD = parcelRequire("dbNqD");

var $xl7OJ = parcelRequire("xl7OJ");
parcelRequire("lg2DG");
var $aBQTj = parcelRequire("aBQTj");
var $cZgRs = parcelRequire("cZgRs");
var $gB3uB = parcelRequire("gB3uB");
var $04rkb = parcelRequire("04rkb");

var $fbObh = parcelRequire("fbObh");

var $1lbw8 = parcelRequire("1lbw8");

var $jlXvj = parcelRequire("jlXvj");

var $9xiZC = parcelRequire("9xiZC");
const $1d8d829740e6eeb0$var$config = {
    default: (0, $1lbw8.default),
    zero: (0, $jlXvj.default),
    commonmark: (0, $9xiZC.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $1d8d829740e6eeb0$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $1d8d829740e6eeb0$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $1d8d829740e6eeb0$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $1d8d829740e6eeb0$var$BAD_PROTO_RE.test(str) ? $1d8d829740e6eeb0$var$GOOD_DATA_RE.test(str) : true;
}
const $1d8d829740e6eeb0$var$RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function $1d8d829740e6eeb0$var$normalizeLink(url) {
    const parsed = $aBQTj.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $1d8d829740e6eeb0$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fbObh.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $cZgRs.default($gB3uB.default(parsed));
}
function $1d8d829740e6eeb0$var$normalizeLinkText(url) {
    const parsed = $aBQTj.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $1d8d829740e6eeb0$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fbObh.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $04rkb.default($gB3uB.default(parsed), $04rkb.default.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $1d8d829740e6eeb0$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $1d8d829740e6eeb0$var$MarkdownIt)) return new $1d8d829740e6eeb0$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$jI54p.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $dbNqD.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $4AknX.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $d2RvS.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $7HlX0.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $xl7OJ.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $1d8d829740e6eeb0$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $1d8d829740e6eeb0$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $1d8d829740e6eeb0$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $jI54p;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $jI54p.assign({}, $fAjjj);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.set = function(options) {
    $jI54p.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($jI54p.isString(presets)) {
        const presetName = presets;
        presets = $1d8d829740e6eeb0$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $1d8d829740e6eeb0$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $1d8d829740e6eeb0$export$2e2bcd8739ae039 = $1d8d829740e6eeb0$var$MarkdownIt;

});
parcelRegister("jI54p", function(module, exports) {

$parcel$export(module.exports, "isString", function () { return $17c1440e03eb49b5$export$844ec244b1367d54; });
$parcel$export(module.exports, "has", function () { return $17c1440e03eb49b5$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "assign", function () { return $17c1440e03eb49b5$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $17c1440e03eb49b5$export$f78478f71955b6bc; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $17c1440e03eb49b5$export$644a8f5b13b2a36d; });
$parcel$export(module.exports, "fromCodePoint", function () { return $17c1440e03eb49b5$export$73bfc63873071f74; });
$parcel$export(module.exports, "unescapeMd", function () { return $17c1440e03eb49b5$export$5ccde1ea0c14bb03; });
$parcel$export(module.exports, "unescapeAll", function () { return $17c1440e03eb49b5$export$db8a17c6655f7e2c; });
$parcel$export(module.exports, "escapeHtml", function () { return $17c1440e03eb49b5$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeRE", function () { return $17c1440e03eb49b5$export$bc616c8f7dc20d5d; });
$parcel$export(module.exports, "isSpace", function () { return $17c1440e03eb49b5$export$1d5ccafae59b4926; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $17c1440e03eb49b5$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isPunctChar", function () { return $17c1440e03eb49b5$export$4888a643af800fc1; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $17c1440e03eb49b5$export$829a0d33ae4e744; });
$parcel$export(module.exports, "normalizeReference", function () { return $17c1440e03eb49b5$export$20ef46802c8744b; });
$parcel$export(module.exports, "lib", function () { return $17c1440e03eb49b5$export$16c08b91f883959a; });
// Utilities
//

var $lg2DG = parcelRequire("lg2DG");
parcelRequire("f3k1c");
var $9aS9E = parcelRequire("9aS9E");
var $2frG6 = parcelRequire("2frG6");
var $f3k1c = parcelRequire("f3k1c");
parcelRequire("86I8v");
var $i9nZH = parcelRequire("i9nZH");
function $17c1440e03eb49b5$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $17c1440e03eb49b5$export$844ec244b1367d54(obj) {
    return $17c1440e03eb49b5$var$_class(obj) === "[object String]";
}
const $17c1440e03eb49b5$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $17c1440e03eb49b5$export$a4f4bb6b1453fff5(object, key) {
    return $17c1440e03eb49b5$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $17c1440e03eb49b5$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $17c1440e03eb49b5$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $17c1440e03eb49b5$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $17c1440e03eb49b5$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $17c1440e03eb49b5$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $17c1440e03eb49b5$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $17c1440e03eb49b5$var$UNESCAPE_ALL_RE = new RegExp($17c1440e03eb49b5$var$UNESCAPE_MD_RE.source + "|" + $17c1440e03eb49b5$var$ENTITY_RE.source, "gi");
const $17c1440e03eb49b5$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $17c1440e03eb49b5$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $17c1440e03eb49b5$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($17c1440e03eb49b5$export$644a8f5b13b2a36d(code)) return $17c1440e03eb49b5$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $i9nZH.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $17c1440e03eb49b5$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace($17c1440e03eb49b5$var$UNESCAPE_MD_RE, "$1");
}
function $17c1440e03eb49b5$export$db8a17c6655f7e2c(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace($17c1440e03eb49b5$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $17c1440e03eb49b5$var$replaceEntityPattern(match, entity);
    });
}
const $17c1440e03eb49b5$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $17c1440e03eb49b5$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $17c1440e03eb49b5$var$HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function $17c1440e03eb49b5$var$replaceUnsafeChar(ch) {
    return $17c1440e03eb49b5$var$HTML_REPLACEMENTS[ch];
}
function $17c1440e03eb49b5$export$4cf11838cdc2a8a8(str) {
    if ($17c1440e03eb49b5$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($17c1440e03eb49b5$var$HTML_ESCAPE_REPLACE_RE, $17c1440e03eb49b5$var$replaceUnsafeChar);
    return str;
}
const $17c1440e03eb49b5$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $17c1440e03eb49b5$export$bc616c8f7dc20d5d(str) {
    return str.replace($17c1440e03eb49b5$var$REGEXP_ESCAPE_RE, "\\$&");
}
function $17c1440e03eb49b5$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $17c1440e03eb49b5$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $17c1440e03eb49b5$export$4888a643af800fc1(ch) {
    return $9aS9E.default.test(ch) || $2frG6.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $17c1440e03eb49b5$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $17c1440e03eb49b5$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $17c1440e03eb49b5$export$16c08b91f883959a = {
    mdurl: $lg2DG,
    ucmicro: $f3k1c
};

});
parcelRegister("lg2DG", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("04rkb")).default; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("cZgRs")).default; });
$parcel$export(module.exports, "format", function () { return (parcelRequire("gB3uB")).default; });
$parcel$export(module.exports, "parse", function () { return (parcelRequire("aBQTj")).default; });

var $04rkb = parcelRequire("04rkb");

var $cZgRs = parcelRequire("cZgRs");

var $gB3uB = parcelRequire("gB3uB");

var $aBQTj = parcelRequire("aBQTj");

});
parcelRegister("04rkb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e38a8fc209801d00$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise */ const $e38a8fc209801d00$var$decodeCache = {};
function $e38a8fc209801d00$var$getDecodeCache(exclude) {
    let cache = $e38a8fc209801d00$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $e38a8fc209801d00$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $e38a8fc209801d00$var$decode(string, exclude) {
    if (typeof exclude !== "string") exclude = $e38a8fc209801d00$var$decode.defaultChars;
    const cache = $e38a8fc209801d00$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = "";
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
$e38a8fc209801d00$var$decode.defaultChars = ";/?:@&=+$,#";
$e38a8fc209801d00$var$decode.componentChars = "";
var $e38a8fc209801d00$export$2e2bcd8739ae039 = $e38a8fc209801d00$var$decode;

});

parcelRegister("cZgRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c06f286568bf9971$export$2e2bcd8739ae039; });
const $c06f286568bf9971$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $c06f286568bf9971$var$getEncodeCache(exclude) {
    let cache = $c06f286568bf9971$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $c06f286568bf9971$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $c06f286568bf9971$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $c06f286568bf9971$var$encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    const cache = $c06f286568bf9971$var$getEncodeCache(exclude);
    let result = "";
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$c06f286568bf9971$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$c06f286568bf9971$var$encode.componentChars = "-_.!~*'()";
var $c06f286568bf9971$export$2e2bcd8739ae039 = $c06f286568bf9971$var$encode;

});

parcelRegister("gB3uB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d69d71cd4a7d650$export$2e2bcd8739ae039; });
function $6d69d71cd4a7d650$export$2e2bcd8739ae039(url) {
    let result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
}

});

parcelRegister("aBQTj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ef2ef887c711d16$export$2e2bcd8739ae039; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $9ef2ef887c711d16$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $9ef2ef887c711d16$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $9ef2ef887c711d16$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $9ef2ef887c711d16$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $9ef2ef887c711d16$var$delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
];
// RFC 2396: characters not allowed for various reasons.
const $9ef2ef887c711d16$var$unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat($9ef2ef887c711d16$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $9ef2ef887c711d16$var$autoEscape = [
    "'"
].concat($9ef2ef887c711d16$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $9ef2ef887c711d16$var$nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat($9ef2ef887c711d16$var$autoEscape);
const $9ef2ef887c711d16$var$hostEndingChars = [
    "/",
    "?",
    "#"
];
const $9ef2ef887c711d16$var$hostnameMaxLen = 255;
const $9ef2ef887c711d16$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $9ef2ef887c711d16$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $9ef2ef887c711d16$var$hostlessProtocol = {
    javascript: true,
    "javascript:": true
};
// protocols that always contain a // bit.
const $9ef2ef887c711d16$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
function $9ef2ef887c711d16$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $9ef2ef887c711d16$var$Url) return url;
    const u = new $9ef2ef887c711d16$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$9ef2ef887c711d16$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        const simplePath = $9ef2ef887c711d16$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $9ef2ef887c711d16$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && $9ef2ef887c711d16$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$9ef2ef887c711d16$var$hostlessProtocol[proto] && (slashes || proto && !$9ef2ef887c711d16$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $9ef2ef887c711d16$var$hostEndingChars.length; i++){
            hec = rest.indexOf($9ef2ef887c711d16$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $9ef2ef887c711d16$var$nonHostChars.length; i++){
            hec = rest.indexOf($9ef2ef887c711d16$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($9ef2ef887c711d16$var$hostnamePartPattern)) {
                    let newpart = "";
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($9ef2ef887c711d16$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($9ef2ef887c711d16$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $9ef2ef887c711d16$var$hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($9ef2ef887c711d16$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
$9ef2ef887c711d16$var$Url.prototype.parseHost = function(host) {
    let port = $9ef2ef887c711d16$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $9ef2ef887c711d16$export$2e2bcd8739ae039 = $9ef2ef887c711d16$var$urlParse;

});


parcelRegister("f3k1c", function(module, exports) {

$parcel$export(module.exports, "Any", function () { return (parcelRequire("6wflq")).default; });
$parcel$export(module.exports, "Cc", function () { return (parcelRequire("3QTAs")).default; });
$parcel$export(module.exports, "Cf", function () { return (parcelRequire("9NYnm")).default; });
$parcel$export(module.exports, "P", function () { return (parcelRequire("9aS9E")).default; });
$parcel$export(module.exports, "S", function () { return (parcelRequire("2frG6")).default; });
$parcel$export(module.exports, "Z", function () { return (parcelRequire("jK7yf")).default; });

var $6wflq = parcelRequire("6wflq");

var $3QTAs = parcelRequire("3QTAs");

var $9NYnm = parcelRequire("9NYnm");

var $9aS9E = parcelRequire("9aS9E");

var $2frG6 = parcelRequire("2frG6");

var $jK7yf = parcelRequire("jK7yf");

});
parcelRegister("6wflq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $932d9325cddfa57e$export$2e2bcd8739ae039; });
var $932d9325cddfa57e$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("3QTAs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4af1a6d2d0821042$export$2e2bcd8739ae039; });
var $4af1a6d2d0821042$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("9NYnm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $788d35e9d402e99f$export$2e2bcd8739ae039; });
var $788d35e9d402e99f$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("9aS9E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4daefa18765538e3$export$2e2bcd8739ae039; });
var $4daefa18765538e3$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("2frG6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38170c03a8a3099c$export$2e2bcd8739ae039; });
var $38170c03a8a3099c$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("jK7yf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b9384e9b938d2c4$export$2e2bcd8739ae039; });
var $8b9384e9b938d2c4$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});


parcelRegister("86I8v", function(module, exports) {

$parcel$export(module.exports, "decodeHTML", function () { return (parcelRequire("i9nZH")).decodeHTML; });

var $i9nZH = parcelRequire("i9nZH");

var $h15HY = parcelRequire("h15HY");

var $aCB8y = parcelRequire("aCB8y");
var $5e711ecc51f024bb$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($5e711ecc51f024bb$export$b8c86583d9718b50 || ($5e711ecc51f024bb$export$b8c86583d9718b50 = {}));
var $5e711ecc51f024bb$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($5e711ecc51f024bb$export$1851b20d614eb756 || ($5e711ecc51f024bb$export$1851b20d614eb756 = {}));
function $5e711ecc51f024bb$export$2f872c0f2117be69(data, options = $5e711ecc51f024bb$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $5e711ecc51f024bb$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $i9nZH.decodeHTML)(data, mode);
    }
    return (0, $i9nZH.decodeXML)(data);
}
function $5e711ecc51f024bb$export$c94669f4c7d36be4(data, options = $5e711ecc51f024bb$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $i9nZH.DecodingMode).Strict;
    return $5e711ecc51f024bb$export$2f872c0f2117be69(data, opts);
}
function $5e711ecc51f024bb$export$c564cdbbe6da493(data, options = $5e711ecc51f024bb$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $5e711ecc51f024bb$export$1851b20d614eb756.UTF8) return (0, $aCB8y.escapeUTF8)(data);
    if (opts.mode === $5e711ecc51f024bb$export$1851b20d614eb756.Attribute) return (0, $aCB8y.escapeAttribute)(data);
    if (opts.mode === $5e711ecc51f024bb$export$1851b20d614eb756.Text) return (0, $aCB8y.escapeText)(data);
    if (opts.level === $5e711ecc51f024bb$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $5e711ecc51f024bb$export$1851b20d614eb756.ASCII) return (0, $h15HY.encodeNonAsciiHTML)(data);
        return (0, $h15HY.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $aCB8y.encodeXML)(data);
}

});
parcelRegister("i9nZH", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", function () { return $d36badff6c022e41$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "decodeHTML", function () { return $d36badff6c022e41$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $d36badff6c022e41$export$88e3b9643a8bd06e; });

var $geEjE = parcelRequire("geEjE");

var $31zoR = parcelRequire("31zoR");

var $iCh3o = parcelRequire("iCh3o");
var $d36badff6c022e41$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($d36badff6c022e41$var$CharCodes || ($d36badff6c022e41$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $d36badff6c022e41$var$TO_LOWER_BIT = 32;
var $d36badff6c022e41$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($d36badff6c022e41$export$6a4325c613e0faec || ($d36badff6c022e41$export$6a4325c613e0faec = {}));
function $d36badff6c022e41$var$isNumber(code) {
    return code >= $d36badff6c022e41$var$CharCodes.ZERO && code <= $d36badff6c022e41$var$CharCodes.NINE;
}
function $d36badff6c022e41$var$isHexadecimalCharacter(code) {
    return code >= $d36badff6c022e41$var$CharCodes.UPPER_A && code <= $d36badff6c022e41$var$CharCodes.UPPER_F || code >= $d36badff6c022e41$var$CharCodes.LOWER_A && code <= $d36badff6c022e41$var$CharCodes.LOWER_F;
}
function $d36badff6c022e41$var$isAsciiAlphaNumeric(code) {
    return code >= $d36badff6c022e41$var$CharCodes.UPPER_A && code <= $d36badff6c022e41$var$CharCodes.UPPER_Z || code >= $d36badff6c022e41$var$CharCodes.LOWER_A && code <= $d36badff6c022e41$var$CharCodes.LOWER_Z || $d36badff6c022e41$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $d36badff6c022e41$var$isEntityInAttributeInvalidEnd(code) {
    return code === $d36badff6c022e41$var$CharCodes.EQUALS || $d36badff6c022e41$var$isAsciiAlphaNumeric(code);
}
var $d36badff6c022e41$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($d36badff6c022e41$var$EntityDecoderState || ($d36badff6c022e41$var$EntityDecoderState = {}));
var $d36badff6c022e41$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($d36badff6c022e41$export$8c8f129ce60f53c || ($d36badff6c022e41$export$8c8f129ce60f53c = {}));
class $d36badff6c022e41$export$15263a93ff7ec8ba {
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $d36badff6c022e41$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $d36badff6c022e41$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $d36badff6c022e41$var$CharCodes.NUM) {
                    this.state = $d36badff6c022e41$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $d36badff6c022e41$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $d36badff6c022e41$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $d36badff6c022e41$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $d36badff6c022e41$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $d36badff6c022e41$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $d36badff6c022e41$var$TO_LOWER_BIT) === $d36badff6c022e41$var$CharCodes.LOWER_X) {
            this.state = $d36badff6c022e41$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $d36badff6c022e41$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($d36badff6c022e41$var$isNumber(char) || $d36badff6c022e41$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($d36badff6c022e41$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $d36badff6c022e41$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $d36badff6c022e41$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $iCh3o.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $d36badff6c022e41$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $d36badff6c022e41$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $d36badff6c022e41$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $d36badff6c022e41$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $d36badff6c022e41$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $d36badff6c022e41$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $d36badff6c022e41$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $d36badff6c022e41$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $d36badff6c022e41$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$d36badff6c022e41$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $d36badff6c022e41$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $d36badff6c022e41$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $d36badff6c022e41$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $d36badff6c022e41$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $d36badff6c022e41$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $d36badff6c022e41$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $d36badff6c022e41$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $d36badff6c022e41$export$8c8f129ce60f53c.Strict;
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $d36badff6c022e41$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $d36badff6c022e41$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $iCh3o.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $d36badff6c022e41$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $d36badff6c022e41$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $d36badff6c022e41$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $d36badff6c022e41$var$htmlDecoder = $d36badff6c022e41$var$getDecoder((0, $geEjE.default));
const $d36badff6c022e41$var$xmlDecoder = $d36badff6c022e41$var$getDecoder((0, $31zoR.default));
function $d36badff6c022e41$export$f045cb747ce77a19(str, mode = $d36badff6c022e41$export$8c8f129ce60f53c.Legacy) {
    return $d36badff6c022e41$var$htmlDecoder(str, mode);
}
function $d36badff6c022e41$export$49f5e8089adb006a(str) {
    return $d36badff6c022e41$var$htmlDecoder(str, $d36badff6c022e41$export$8c8f129ce60f53c.Attribute);
}
function $d36badff6c022e41$export$da52f4371b3f37de(str) {
    return $d36badff6c022e41$var$htmlDecoder(str, $d36badff6c022e41$export$8c8f129ce60f53c.Strict);
}
function $d36badff6c022e41$export$88e3b9643a8bd06e(str) {
    return $d36badff6c022e41$var$xmlDecoder(str, $d36badff6c022e41$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("geEjE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd1d3a08009a3ad7$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $bd1d3a08009a3ad7$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\x00\x00\x00\x00\x00\x00\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\x00\x00\x00\u0342\u0354\x00\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\x00\x00\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\x00\x00\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\x00\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\x00\x00\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\x00\u05BF\x00\x00\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\x00\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\x00\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\x00\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\x00\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\x00\u08C3bleBracket;\u67E6n\u01D4\u08C8\x00\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\x00\u1005bleBracket;\u67E7n\u01D4\u100A\x00\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\x00\x00\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\x00\u132C\u1331\x00\x00\x00\x00\x00\u1338\u133D\u1377\u1385\x00\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\x00\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\x00\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\x00\u15B0\u15B6\u15BF\x00\x00\x00\x00\u15C6\u15DB\u15EB\u165F\u166D\x00\u1695\u169B\u16B2\u16B9\x00\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\x00\x00\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\x00\x00\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\x00\u1833\u01B2\u182F\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\x00\u19E8\u1A11\u1A15\u1A32\x00\u1A37\u1A50\x00\x00\u1AB4\x00\x00\u1AC1\x00\x00\u1B21\u1B2E\u1B4D\u1B52\x00\u1BFD\x00\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\x00\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\x00\x00\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\x00\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\x00\x00\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\x00\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\x00\x00\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\x00\x00\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\x00\x00\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\x00\x00\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\x00\x00\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\x00\u1F9E\x00\u1FA1\u1FA7\x00\x00\u1FC6\u1FCC\x00\u1FD3\x00\u1FE6\u1FEA\u2000\x00\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\x00\x00\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\x00\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\x00\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\x00\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\x00\u2036;\u6154;\u6156\u02B4\u203E\u2041\x00\x00\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\x00\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\x00\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\x00\u22AA\x00\u22B8\u22C5\u22CE\x00\u22D5\u22F3\x00\x00\u22F8\u2322\u2367\u2362\u237F\x00\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\x00\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\x00\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\x00\u24AA\x00\u24B1\x00\x00\x00\x00\x00\u24B5\u24BA\x00\u24C6\u24C8\u24CD\x00\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\x00\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\x00\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\x00\x00\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2D2D\x00\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\x00\x00\u2D8D\u2DAB\x00\u2DC8\u2DCE\x00\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\x00\x00\u2D7C\x00\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\x00\u2E7D\x00\u2E80\u2E9D\x00\u2EA2\u2EB9\x00\x00\u2ECB\u0E9C\x00\u2F13\x00\x00\u2F2B\u2FBC\x00\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\x00\x00\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\x00\u337A\u33A4\x00\x00\u33EC\u33F0\x00\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\x00\u3616\x00\x00\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\x00\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\x00\x00\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\x00\u367E\u36C2\x00\x00\x00\x00\x00\u36DB\u3703\x00\u3709\u376C\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\x00\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\x00\x00\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\x00\x00\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\x00\u3A8B\x00\u3A90\u3A9B\x00\x00\u3A9D\u3AA8\u3AAB\u3AAF\x00\x00\u3AC3\u3ACE\x00\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("31zoR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $233ceccbec7cc626$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $233ceccbec7cc626$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\x00\x00\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("iCh3o", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", function () { return $d8d9011d223f76fa$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $d8d9011d223f76fa$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $d8d9011d223f76fa$var$_a;
const $d8d9011d223f76fa$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $d8d9011d223f76fa$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($d8d9011d223f76fa$var$_a = String.fromCodePoint) !== null && $d8d9011d223f76fa$var$_a !== void 0 ? $d8d9011d223f76fa$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $d8d9011d223f76fa$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $d8d9011d223f76fa$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $d8d9011d223f76fa$export$2e2bcd8739ae039(codePoint) {
    return $d8d9011d223f76fa$export$73bfc63873071f74($d8d9011d223f76fa$export$b978ab756102108a(codePoint));
}

});


parcelRegister("h15HY", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", function () { return $c636f52ec79830fa$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $c636f52ec79830fa$export$e6e86c76506f1190; });

var $h5gtn = parcelRequire("h5gtn");

var $aCB8y = parcelRequire("aCB8y");
const $c636f52ec79830fa$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $c636f52ec79830fa$export$f9d6449b9af28dc1(data) {
    return $c636f52ec79830fa$var$encodeHTMLTrieRe($c636f52ec79830fa$var$htmlReplacer, data);
}
function $c636f52ec79830fa$export$e6e86c76506f1190(data) {
    return $c636f52ec79830fa$var$encodeHTMLTrieRe((0, $aCB8y.xmlReplacer), data);
}
function $c636f52ec79830fa$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $h5gtn.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $aCB8y.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("h5gtn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6ffae79413bc7a6$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $c6ffae79413bc7a6$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$c6ffae79413bc7a6$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $c6ffae79413bc7a6$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $c6ffae79413bc7a6$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $c6ffae79413bc7a6$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $c6ffae79413bc7a6$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("aCB8y", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", function () { return $7bba42a1416cba9a$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $7bba42a1416cba9a$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $7bba42a1416cba9a$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $7bba42a1416cba9a$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $7bba42a1416cba9a$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $7bba42a1416cba9a$export$96e6fc3a139b2555; });
const $7bba42a1416cba9a$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $7bba42a1416cba9a$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $7bba42a1416cba9a$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $7bba42a1416cba9a$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $7bba42a1416cba9a$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $7bba42a1416cba9a$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$7bba42a1416cba9a$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $7bba42a1416cba9a$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $7bba42a1416cba9a$export$4e7f196112fea3c5 = $7bba42a1416cba9a$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $7bba42a1416cba9a$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $7bba42a1416cba9a$export$9e081872deefdcb0 = $7bba42a1416cba9a$var$getEscaper(/[&<>'"]/g, $7bba42a1416cba9a$var$xmlCodeMap);
const $7bba42a1416cba9a$export$30330f3d5eb70e11 = $7bba42a1416cba9a$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $7bba42a1416cba9a$export$96e6fc3a139b2555 = $7bba42a1416cba9a$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});




parcelRegister("fAjjj", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", function () { return (parcelRequire("5JkZh")).default; });
$parcel$export(module.exports, "parseLinkDestination", function () { return (parcelRequire("j78CM")).default; });
$parcel$export(module.exports, "parseLinkTitle", function () { return (parcelRequire("gEl7w")).default; });
// Just a shortcut for bulk export

var $5JkZh = parcelRequire("5JkZh");

var $j78CM = parcelRequire("j78CM");

var $gEl7w = parcelRequire("gEl7w");

});
parcelRegister("5JkZh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b1569c354e2d072$export$2e2bcd8739ae039; });
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $1b1569c354e2d072$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("j78CM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $145d5e534f0845b9$export$2e2bcd8739ae039; });
// Parse link destination
//

var $jI54p = parcelRequire("jI54p");
function $145d5e534f0845b9$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $jI54p.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $jI54p.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("gEl7w", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83dcff318afadbc0$export$2e2bcd8739ae039; });
// Parse link title
//

var $jI54p = parcelRequire("jI54p");
function $83dcff318afadbc0$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: "",
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $jI54p.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $jI54p.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("7HlX0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06dbc00903549363$export$2e2bcd8739ae039; });
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $jI54p = parcelRequire("jI54p");
const $06dbc00903549363$var$default_rules = {};
$06dbc00903549363$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + (0, $jI54p.escapeHtml)(token.content) + "</code>";
};
$06dbc00903549363$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + (0, $jI54p.escapeHtml)(tokens[idx].content) + "</code></pre>\n";
};
$06dbc00903549363$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $jI54p.unescapeAll)(token.info).trim() : "";
    let langName = "";
    let langAttrs = "";
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $jI54p.escapeHtml)(token.content);
    else highlighted = (0, $jI54p.escapeHtml)(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex("class");
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$06dbc00903549363$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$06dbc00903549363$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
$06dbc00903549363$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
$06dbc00903549363$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $jI54p.escapeHtml)(tokens[idx].content);
};
$06dbc00903549363$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$06dbc00903549363$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $06dbc00903549363$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $jI54p.assign)({}, $06dbc00903549363$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $06dbc00903549363$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + (0, $jI54p.escapeHtml)(token.attrs[i][0]) + '="' + (0, $jI54p.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $06dbc00903549363$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = "";
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $06dbc00903549363$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $06dbc00903549363$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = "";
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case "text":
            result += tokens[i].content;
            break;
        case "image":
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case "html_inline":
        case "html_block":
            result += tokens[i].content;
            break;
        case "softbreak":
        case "hardbreak":
            result += "\n";
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $06dbc00903549363$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $06dbc00903549363$export$2e2bcd8739ae039 = $06dbc00903549363$var$Renderer;

});

parcelRegister("d2RvS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0a06ce77a28a3b5$export$2e2bcd8739ae039; });
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $bwo0f = parcelRequire("bwo0f");

var $loU3u = parcelRequire("loU3u");

var $e0Vh5 = parcelRequire("e0Vh5");

var $jtwin = parcelRequire("jtwin");

var $aJUSN = parcelRequire("aJUSN");

var $1DgkB = parcelRequire("1DgkB");

var $49v02 = parcelRequire("49v02");

var $2Slvb = parcelRequire("2Slvb");

var $6Cfi6 = parcelRequire("6Cfi6");
const $c0a06ce77a28a3b5$var$_rules = [
    [
        "normalize",
        (0, $e0Vh5.default)
    ],
    [
        "block",
        (0, $jtwin.default)
    ],
    [
        "inline",
        (0, $aJUSN.default)
    ],
    [
        "linkify",
        (0, $1DgkB.default)
    ],
    [
        "replacements",
        (0, $49v02.default)
    ],
    [
        "smartquotes",
        (0, $2Slvb.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (0, $6Cfi6.default)
    ]
];
/**
 * new Core()
 **/ function $c0a06ce77a28a3b5$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $bwo0f.default)();
    for(let i = 0; i < $c0a06ce77a28a3b5$var$_rules.length; i++)this.ruler.push($c0a06ce77a28a3b5$var$_rules[i][0], $c0a06ce77a28a3b5$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $c0a06ce77a28a3b5$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules("");
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$c0a06ce77a28a3b5$var$Core.prototype.State = (0, $loU3u.default);
var $c0a06ce77a28a3b5$export$2e2bcd8739ae039 = $c0a06ce77a28a3b5$var$Core;

});
parcelRegister("bwo0f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $997ab6ae59545024$export$2e2bcd8739ae039; });
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $997ab6ae59545024$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$997ab6ae59545024$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$997ab6ae59545024$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $997ab6ae59545024$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $997ab6ae59545024$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $997ab6ae59545024$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $997ab6ae59545024$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $997ab6ae59545024$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $997ab6ae59545024$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $997ab6ae59545024$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $997ab6ae59545024$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $997ab6ae59545024$export$2e2bcd8739ae039 = $997ab6ae59545024$var$Ruler;

});

parcelRegister("loU3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8503971349062519$export$2e2bcd8739ae039; });
// Core state object
//

var $c29v9 = parcelRequire("c29v9");
function $8503971349062519$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$8503971349062519$var$StateCore.prototype.Token = (0, $c29v9.default);
var $8503971349062519$export$2e2bcd8739ae039 = $8503971349062519$var$StateCore;

});
parcelRegister("c29v9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25fcd6283be883dc$export$2e2bcd8739ae039; });
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $25fcd6283be883dc$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $25fcd6283be883dc$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $25fcd6283be883dc$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $25fcd6283be883dc$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $25fcd6283be883dc$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $25fcd6283be883dc$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
var $25fcd6283be883dc$export$2e2bcd8739ae039 = $25fcd6283be883dc$var$Token;

});


parcelRegister("e0Vh5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $647857c2f633bbdf$export$2e2bcd8739ae039; });
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $647857c2f633bbdf$var$NEWLINES_RE = /\r\n?|\n/g;
const $647857c2f633bbdf$var$NULL_RE = /\0/g;
function $647857c2f633bbdf$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($647857c2f633bbdf$var$NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace($647857c2f633bbdf$var$NULL_RE, "\uFFFD");
    state.src = str;
}

});

parcelRegister("jtwin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $361b677f0f20eb2d$export$2e2bcd8739ae039; });
function $361b677f0f20eb2d$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("aJUSN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67436c0a0383f463$export$2e2bcd8739ae039; });
function $67436c0a0383f463$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("1DgkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94499097259202e8$export$2e2bcd8739ae039; });
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $jI54p = parcelRequire("jI54p");
function $94499097259202e8$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $94499097259202e8$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $94499097259202e8$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if ($94499097259202e8$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($94499097259202e8$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token("link_open", "a", 1);
                    token_o.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = "linkify";
                    token_o.info = "auto";
                    nodes.push(token_o);
                    const token_t = new state.Token("text", "", 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token("link_close", "a", -1);
                    token_c.level = --level;
                    token_c.markup = "linkify";
                    token_c.info = "auto";
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $jI54p.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("49v02", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d13d0e2445afc9a$export$2e2bcd8739ae039; });
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $3d13d0e2445afc9a$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $3d13d0e2445afc9a$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $3d13d0e2445afc9a$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $3d13d0e2445afc9a$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $3d13d0e2445afc9a$var$replaceFn(match, name) {
    return $3d13d0e2445afc9a$var$SCOPED_ABBR[name.toLowerCase()];
}
function $3d13d0e2445afc9a$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace($3d13d0e2445afc9a$var$SCOPED_ABBR_RE, $3d13d0e2445afc9a$var$replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $3d13d0e2445afc9a$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if ($3d13d0e2445afc9a$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function $3d13d0e2445afc9a$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if ($3d13d0e2445afc9a$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $3d13d0e2445afc9a$var$replace_scoped(state.tokens[blkIdx].children);
        if ($3d13d0e2445afc9a$var$RARE_RE.test(state.tokens[blkIdx].content)) $3d13d0e2445afc9a$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("2Slvb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6fbaf0643bd90b0$export$2e2bcd8739ae039; });
// Convert straight quotation marks to typographic ones
//

var $jI54p = parcelRequire("jI54p");
const $c6fbaf0643bd90b0$var$QUOTE_TEST_RE = /['"]/;
const $c6fbaf0643bd90b0$var$QUOTE_RE = /['"]/g;
const $c6fbaf0643bd90b0$var$APOSTROPHE = "\u2019" /* ’ */ ;
function $c6fbaf0643bd90b0$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $c6fbaf0643bd90b0$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $c6fbaf0643bd90b0$var$QUOTE_RE.lastIndex = pos;
            const t = $c6fbaf0643bd90b0$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $jI54p.isMdAsciiPunct)(lastChar) || (0, $jI54p.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $jI54p.isMdAsciiPunct)(nextChar) || (0, $jI54p.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $jI54p.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $jI54p.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $c6fbaf0643bd90b0$var$replaceAt(token.content, t.index, $c6fbaf0643bd90b0$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $c6fbaf0643bd90b0$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $c6fbaf0643bd90b0$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $c6fbaf0643bd90b0$var$replaceAt(token.content, t.index, $c6fbaf0643bd90b0$var$APOSTROPHE);
        }
    }
}
function $c6fbaf0643bd90b0$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !$c6fbaf0643bd90b0$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $c6fbaf0643bd90b0$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("6Cfi6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a90ab235e2eed9dd$export$2e2bcd8739ae039; });
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $a90ab235e2eed9dd$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("4AknX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80f215b6e5a70f7a$export$2e2bcd8739ae039; });
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $bwo0f = parcelRequire("bwo0f");

var $6LyiY = parcelRequire("6LyiY");

var $k1GX2 = parcelRequire("k1GX2");

var $hSvEk = parcelRequire("hSvEk");

var $fZzJ2 = parcelRequire("fZzJ2");

var $fIQuR = parcelRequire("fIQuR");

var $b1Auv = parcelRequire("b1Auv");

var $1QZTU = parcelRequire("1QZTU");

var $1amXi = parcelRequire("1amXi");

var $1r12A = parcelRequire("1r12A");

var $7P58d = parcelRequire("7P58d");

var $70Ygg = parcelRequire("70Ygg");

var $96sR4 = parcelRequire("96sR4");
const $80f215b6e5a70f7a$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (0, $k1GX2.default),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (0, $hSvEk.default)
    ],
    [
        "fence",
        (0, $fZzJ2.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (0, $fIQuR.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (0, $b1Auv.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (0, $1QZTU.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (0, $1amXi.default)
    ],
    [
        "html_block",
        (0, $1r12A.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (0, $7P58d.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (0, $70Ygg.default)
    ],
    [
        "paragraph",
        (0, $96sR4.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $80f215b6e5a70f7a$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $bwo0f.default)();
    for(let i = 0; i < $80f215b6e5a70f7a$var$_rules.length; i++)this.ruler.push($80f215b6e5a70f7a$var$_rules[i][0], $80f215b6e5a70f7a$var$_rules[i][1], {
        alt: ($80f215b6e5a70f7a$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$80f215b6e5a70f7a$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error("none of the block rules matched");
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $80f215b6e5a70f7a$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$80f215b6e5a70f7a$var$ParserBlock.prototype.State = (0, $6LyiY.default);
var $80f215b6e5a70f7a$export$2e2bcd8739ae039 = $80f215b6e5a70f7a$var$ParserBlock;

});
parcelRegister("6LyiY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ba20578af534b64$export$2e2bcd8739ae039; });
// Parser state class

var $c29v9 = parcelRequire("c29v9");

var $jI54p = parcelRequire("jI54p");
function $4ba20578af534b64$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $jI54p.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$4ba20578af534b64$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $c29v9.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$4ba20578af534b64$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$4ba20578af534b64$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$4ba20578af534b64$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $jI54p.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$4ba20578af534b64$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $jI54p.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$4ba20578af534b64$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$4ba20578af534b64$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$4ba20578af534b64$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return "";
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $jI54p.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
$4ba20578af534b64$var$StateBlock.prototype.Token = (0, $c29v9.default);
var $4ba20578af534b64$export$2e2bcd8739ae039 = $4ba20578af534b64$var$StateBlock;

});

parcelRegister("k1GX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7aaee2baa49b436$export$2e2bcd8739ae039; });
// GFM table, https://github.github.com/gfm/#tables-extension-

var $jI54p = parcelRequire("jI54p");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $f7aaee2baa49b436$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $f7aaee2baa49b436$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $f7aaee2baa49b436$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = "";
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $f7aaee2baa49b436$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $jI54p.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $jI54p.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $jI54p.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $f7aaee2baa49b436$var$getLine(state, startLine + 1);
    let columns = lineText.split("|");
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = $f7aaee2baa49b436$var$getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $f7aaee2baa49b436$var$escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const token_to = state.push("table_open", "table", 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push("thead_open", "thead", 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push("tr_open", "tr", 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push("th_open", "th", 1);
        if (aligns[i]) token_ho.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        const token_il = state.push("inline", "", 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push("th_close", "th", -1);
    }
    state.push("tr_close", "tr", -1);
    state.push("thead_close", "thead", -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $f7aaee2baa49b436$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $f7aaee2baa49b436$var$escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $f7aaee2baa49b436$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push("tbody_open", "tbody", 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push("tr_open", "tr", 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push("td_open", "td", 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            const token_il = state.push("inline", "", 0);
            token_il.content = columns[i] ? columns[i].trim() : "";
            token_il.children = [];
            state.push("td_close", "td", -1);
        }
        state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("hSvEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $124a99557ad5c0be$export$2e2bcd8739ae039; });
// Code block (4 spaces padded)
function $124a99557ad5c0be$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("fZzJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28d4526603682209$export$2e2bcd8739ae039; });
// fences (``` lang, ~~~ lang)
function $28d4526603682209$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("fIQuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87bf765a02e38019$export$2e2bcd8739ae039; });
// Block quotes

var $jI54p = parcelRequire("jI54p");
function $87bf765a02e38019$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const oldParentType = state.parentType;
    state.parentType = "blockquote";
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $jI54p.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push("blockquote_open", "blockquote", 1);
    token_o.markup = ">";
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push("blockquote_close", "blockquote", -1);
    token_c.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("b1Auv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $250647ee09336f4c$export$2e2bcd8739ae039; });
// Horizontal rule

var $jI54p = parcelRequire("jI54p");
function $250647ee09336f4c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $jI54p.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("1QZTU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31123a0b1c1f3b59$export$2e2bcd8739ae039; });
// Lists

var $jI54p = parcelRequire("jI54p");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $31123a0b1c1f3b59$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $jI54p.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $31123a0b1c1f3b59$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $jI54p.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $31123a0b1c1f3b59$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $31123a0b1c1f3b59$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $31123a0b1c1f3b59$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $31123a0b1c1f3b59$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules("list");
    const oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $31123a0b1c1f3b59$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $31123a0b1c1f3b59$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $31123a0b1c1f3b59$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("1amXi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd918e9cce7691e4$export$2e2bcd8739ae039; });

var $jI54p = parcelRequire("jI54p");
function $bd918e9cce7691e4$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules("reference");
            const oldParentType = state.parentType;
            state.parentType = "reference";
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $jI54p.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $jI54p.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = "";
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $jI54p.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $jI54p.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $jI54p.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("1r12A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0feba83eb0771ec8$export$2e2bcd8739ae039; });
// HTML block

var $bYS4T = parcelRequire("bYS4T");

var $hlE45 = parcelRequire("hlE45");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $0feba83eb0771ec8$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + (0, $bYS4T.default).join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp((0, $hlE45.HTML_OPEN_CLOSE_TAG_RE).source + "\\s*$"),
        /^$/,
        false
    ]
];
function $0feba83eb0771ec8$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $0feba83eb0771ec8$var$HTML_SEQUENCES.length; i++){
        if ($0feba83eb0771ec8$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $0feba83eb0771ec8$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $0feba83eb0771ec8$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$0feba83eb0771ec8$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($0feba83eb0771ec8$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("bYS4T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $59adb13f741d830d$export$2e2bcd8739ae039; });
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $59adb13f741d830d$export$2e2bcd8739ae039 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

});

parcelRegister("hlE45", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", function () { return $670e59a2283a6f54$export$6db61d2c3a16e419; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $670e59a2283a6f54$export$cd48660d06f74639; });
// Regexps to match html elements
const $670e59a2283a6f54$var$attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
const $670e59a2283a6f54$var$unquoted = "[^\"'=<>`\\x00-\\x20]+";
const $670e59a2283a6f54$var$single_quoted = "'[^']*'";
const $670e59a2283a6f54$var$double_quoted = '"[^"]*"';
const $670e59a2283a6f54$var$attr_value = "(?:" + $670e59a2283a6f54$var$unquoted + "|" + $670e59a2283a6f54$var$single_quoted + "|" + $670e59a2283a6f54$var$double_quoted + ")";
const $670e59a2283a6f54$var$attribute = "(?:\\s+" + $670e59a2283a6f54$var$attr_name + "(?:\\s*=\\s*" + $670e59a2283a6f54$var$attr_value + ")?)";
const $670e59a2283a6f54$var$open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + $670e59a2283a6f54$var$attribute + "*\\s*\\/?>";
const $670e59a2283a6f54$var$close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
const $670e59a2283a6f54$var$comment = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->";
const $670e59a2283a6f54$var$processing = "<[?][\\s\\S]*?[?]>";
const $670e59a2283a6f54$var$declaration = "<![A-Za-z][^>]*>";
const $670e59a2283a6f54$var$cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
const $670e59a2283a6f54$export$6db61d2c3a16e419 = new RegExp("^(?:" + $670e59a2283a6f54$var$open_tag + "|" + $670e59a2283a6f54$var$close_tag + "|" + $670e59a2283a6f54$var$comment + "|" + $670e59a2283a6f54$var$processing + "|" + $670e59a2283a6f54$var$declaration + "|" + $670e59a2283a6f54$var$cdata + ")");
const $670e59a2283a6f54$export$cd48660d06f74639 = new RegExp("^(?:" + $670e59a2283a6f54$var$open_tag + "|" + $670e59a2283a6f54$var$close_tag + ")");

});


parcelRegister("7P58d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35126bba1d200fe5$export$2e2bcd8739ae039; });
// heading (#, ##, ...)

var $jI54p = parcelRequire("jI54p");
function $35126bba1d200fe5$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $jI54p.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $jI54p.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = "########".slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = "########".slice(0, level);
    return true;
}

});

parcelRegister("70Ygg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c28cd9fc97a8ced$export$2e2bcd8739ae039; });
// lheading (---, ===)
function $6c28cd9fc97a8ced$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = "paragraph" // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("96sR4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4de1288923f8806$export$2e2bcd8739ae039; });
// Paragraph
function $d4de1288923f8806$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push("paragraph_open", "p", 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("dbNqD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db24195157b1e523$export$2e2bcd8739ae039; });
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $bwo0f = parcelRequire("bwo0f");

var $fQiTG = parcelRequire("fQiTG");

var $2f7if = parcelRequire("2f7if");

var $16llW = parcelRequire("16llW");

var $jluIO = parcelRequire("jluIO");

var $enJEG = parcelRequire("enJEG");

var $9gNWc = parcelRequire("9gNWc");

var $kPIst = parcelRequire("kPIst");

var $lUVvq = parcelRequire("lUVvq");

var $7qBJq = parcelRequire("7qBJq");

var $1DdDK = parcelRequire("1DdDK");

var $45X0j = parcelRequire("45X0j");

var $bqcHW = parcelRequire("bqcHW");

var $hV1f7 = parcelRequire("hV1f7");

var $2zvbN = parcelRequire("2zvbN");

var $gI3n6 = parcelRequire("gI3n6");
// Parser rules
const $db24195157b1e523$var$_rules = [
    [
        "text",
        (0, $2f7if.default)
    ],
    [
        "linkify",
        (0, $16llW.default)
    ],
    [
        "newline",
        (0, $jluIO.default)
    ],
    [
        "escape",
        (0, $enJEG.default)
    ],
    [
        "backticks",
        (0, $9gNWc.default)
    ],
    [
        "strikethrough",
        (0, $kPIst.default).tokenize
    ],
    [
        "emphasis",
        (0, $lUVvq.default).tokenize
    ],
    [
        "link",
        (0, $7qBJq.default)
    ],
    [
        "image",
        (0, $1DdDK.default)
    ],
    [
        "autolink",
        (0, $45X0j.default)
    ],
    [
        "html_inline",
        (0, $bqcHW.default)
    ],
    [
        "entity",
        (0, $hV1f7.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $db24195157b1e523$var$_rules2 = [
    [
        "balance_pairs",
        (0, $2zvbN.default)
    ],
    [
        "strikethrough",
        (0, $kPIst.default).postProcess
    ],
    [
        "emphasis",
        (0, $lUVvq.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (0, $gI3n6.default)
    ]
];
/**
 * new ParserInline()
 **/ function $db24195157b1e523$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $bwo0f.default)();
    for(let i = 0; i < $db24195157b1e523$var$_rules.length; i++)this.ruler.push($db24195157b1e523$var$_rules[i][0], $db24195157b1e523$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $bwo0f.default)();
    for(let i = 0; i < $db24195157b1e523$var$_rules2.length; i++)this.ruler2.push($db24195157b1e523$var$_rules2[i][0], $db24195157b1e523$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$db24195157b1e523$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$db24195157b1e523$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $db24195157b1e523$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules("");
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$db24195157b1e523$var$ParserInline.prototype.State = (0, $fQiTG.default);
var $db24195157b1e523$export$2e2bcd8739ae039 = $db24195157b1e523$var$ParserInline;

});
parcelRegister("fQiTG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8de4023f409763f$export$2e2bcd8739ae039; });
// Inline parser state

var $c29v9 = parcelRequire("c29v9");

var $jI54p = parcelRequire("jI54p");
function $a8de4023f409763f$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$a8de4023f409763f$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $c29v9.default)("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$a8de4023f409763f$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $c29v9.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$a8de4023f409763f$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $jI54p.isMdAsciiPunct)(lastChar) || (0, $jI54p.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $jI54p.isMdAsciiPunct)(nextChar) || (0, $jI54p.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $jI54p.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $jI54p.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$a8de4023f409763f$var$StateInline.prototype.Token = (0, $c29v9.default);
var $a8de4023f409763f$export$2e2bcd8739ae039 = $a8de4023f409763f$var$StateInline;

});

parcelRegister("2f7if", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a0c8682a575cf97$export$2e2bcd8739ae039; });
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $6a0c8682a575cf97$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $6a0c8682a575cf97$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$6a0c8682a575cf97$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("16llW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cfd3aa1d2cc273a$export$2e2bcd8739ae039; });
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $0cfd3aa1d2cc273a$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $0cfd3aa1d2cc273a$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($0cfd3aa1d2cc273a$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push("link_open", "a", 1);
        token_o.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token_o.markup = "linkify";
        token_o.info = "auto";
        const token_t = state.push("text", "", 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push("link_close", "a", -1);
        token_c.markup = "linkify";
        token_c.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("jluIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e084498a21d7c80$export$2e2bcd8739ae039; });
// Proceess '\n'

var $jI54p = parcelRequire("jI54p");
function $9e084498a21d7c80$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $jI54p.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("enJEG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $824abee6882f494c$export$2e2bcd8739ae039; });
// Process escaped chars and hardbreaks

var $jI54p = parcelRequire("jI54p");
const $824abee6882f494c$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$824abee6882f494c$var$ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    $824abee6882f494c$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $824abee6882f494c$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $jI54p.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = "\\" + escapedStr;
    if (!silent) {
        const token = state.push("text_special", "", 0);
        if (ch1 < 256 && $824abee6882f494c$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("9gNWc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d105bb776e49db2$export$2e2bcd8739ae039; });
// Parse backticks
function $4d105bb776e49db2$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("kPIst", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5af5805049c61bb6$export$2e2bcd8739ae039; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $5af5805049c61bb6$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $5af5805049c61bb6$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $5af5805049c61bb6$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $5af5805049c61bb6$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $5af5805049c61bb6$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $5af5805049c61bb6$export$2e2bcd8739ae039 = {
    tokenize: $5af5805049c61bb6$var$strikethrough_tokenize,
    postProcess: $5af5805049c61bb6$var$strikethrough_postProcess
};

});

parcelRegister("lUVvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02923c4aac80c0b1$export$2e2bcd8739ae039; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $02923c4aac80c0b1$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $02923c4aac80c0b1$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? "strong_open" : "em_open";
        token_o.tag = isStrong ? "strong" : "em";
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = "";
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? "strong_close" : "em_close";
        token_c.tag = isStrong ? "strong" : "em";
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $02923c4aac80c0b1$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $02923c4aac80c0b1$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $02923c4aac80c0b1$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $02923c4aac80c0b1$export$2e2bcd8739ae039 = {
    tokenize: $02923c4aac80c0b1$var$emphasis_tokenize,
    postProcess: $02923c4aac80c0b1$var$emphasis_post_process
};

});

parcelRegister("7qBJq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0756b4493ebf004$export$2e2bcd8739ae039; });
// Process [link](<to> "stuff")

var $jI54p = parcelRequire("jI54p");
function $e0756b4493ebf004$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = "";
    let title = "";
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jI54p.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $jI54p.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $jI54p.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $jI54p.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push("link_open", "a", 1);
        const attrs = [
            [
                "href",
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("1DdDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70adf24751fe6101$export$2e2bcd8739ae039; });
// Process ![image](<src> "title")

var $jI54p = parcelRequire("jI54p");
function $70adf24751fe6101$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = "";
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jI54p.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jI54p.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $jI54p.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $jI54p.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push("image", "img", 0);
        const attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("45X0j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea2b4421d566f852$export$2e2bcd8739ae039; });
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $ea2b4421d566f852$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $ea2b4421d566f852$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $ea2b4421d566f852$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($ea2b4421d566f852$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($ea2b4421d566f852$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("bqcHW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f987f5c041082bbd$export$2e2bcd8739ae039; });
// Process html tags

var $hlE45 = parcelRequire("hlE45");
function $f987f5c041082bbd$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $f987f5c041082bbd$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $f987f5c041082bbd$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $f987f5c041082bbd$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$f987f5c041082bbd$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $hlE45.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push("html_inline", "", 0);
        token.content = match[0];
        if ($f987f5c041082bbd$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($f987f5c041082bbd$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("hV1f7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca2ee28458bd946$export$2e2bcd8739ae039; });
// Process html entity - &#123;, &#xAF;, &quot;, ...
parcelRequire("86I8v");
var $i9nZH = parcelRequire("i9nZH");

var $jI54p = parcelRequire("jI54p");
const $eca2ee28458bd946$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $eca2ee28458bd946$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $eca2ee28458bd946$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($eca2ee28458bd946$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push("text_special", "", 0);
                token.content = (0, $jI54p.isValidEntityCode)(code) ? (0, $jI54p.fromCodePoint)(code) : (0, $jI54p.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($eca2ee28458bd946$var$NAMED_RE);
        if (match) {
            const decoded = (0, $i9nZH.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push("text_special", "", 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("2zvbN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea0c31c83592c83f$export$2e2bcd8739ae039; });
// For each opening emphasis-like marker find a matching closing one
//
function $ea0c31c83592c83f$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $ea0c31c83592c83f$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $ea0c31c83592c83f$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $ea0c31c83592c83f$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("gI3n6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d367c06e809c2252$export$2e2bcd8739ae039; });
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $d367c06e809c2252$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("xl7OJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d2dfec1b3400fff$export$2e2bcd8739ae039; });

var $crv9C = parcelRequire("crv9C");
//
// Helpers
//
// Merge objects
//
function $3d2dfec1b3400fff$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $3d2dfec1b3400fff$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $3d2dfec1b3400fff$var$isString(obj) {
    return $3d2dfec1b3400fff$var$_class(obj) === "[object String]";
}
function $3d2dfec1b3400fff$var$isObject(obj) {
    return $3d2dfec1b3400fff$var$_class(obj) === "[object Object]";
}
function $3d2dfec1b3400fff$var$isRegExp(obj) {
    return $3d2dfec1b3400fff$var$_class(obj) === "[object RegExp]";
}
function $3d2dfec1b3400fff$var$isFunction(obj) {
    return $3d2dfec1b3400fff$var$_class(obj) === "[object Function]";
}
function $3d2dfec1b3400fff$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
//
const $3d2dfec1b3400fff$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $3d2dfec1b3400fff$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $3d2dfec1b3400fff$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $3d2dfec1b3400fff$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $3d2dfec1b3400fff$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $3d2dfec1b3400fff$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $3d2dfec1b3400fff$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $3d2dfec1b3400fff$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $3d2dfec1b3400fff$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $3d2dfec1b3400fff$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $crv9C.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($3d2dfec1b3400fff$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($3d2dfec1b3400fff$var$isObject(val)) {
            if ($3d2dfec1b3400fff$var$isRegExp(val.validate)) compiled.validate = $3d2dfec1b3400fff$var$createValidator(val.validate);
            else if ($3d2dfec1b3400fff$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($3d2dfec1b3400fff$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $3d2dfec1b3400fff$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($3d2dfec1b3400fff$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $3d2dfec1b3400fff$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($3d2dfec1b3400fff$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $3d2dfec1b3400fff$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $3d2dfec1b3400fff$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $3d2dfec1b3400fff$var$createMatch(self, shift) {
    const match = new $3d2dfec1b3400fff$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $3d2dfec1b3400fff$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $3d2dfec1b3400fff$var$LinkifyIt)) return new $3d2dfec1b3400fff$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($3d2dfec1b3400fff$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $3d2dfec1b3400fff$var$assign({}, $3d2dfec1b3400fff$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $3d2dfec1b3400fff$var$assign({}, $3d2dfec1b3400fff$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $3d2dfec1b3400fff$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $3d2dfec1b3400fff$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $3d2dfec1b3400fff$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $3d2dfec1b3400fff$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($3d2dfec1b3400fff$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($3d2dfec1b3400fff$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $3d2dfec1b3400fff$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $3d2dfec1b3400fff$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $3d2dfec1b3400fff$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $3d2dfec1b3400fff$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $3d2dfec1b3400fff$export$2e2bcd8739ae039 = $3d2dfec1b3400fff$var$LinkifyIt;

});
parcelRegister("crv9C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7096a24a9ac888c4$export$2e2bcd8739ae039; });
parcelRequire("f3k1c");
var $6wflq = parcelRequire("6wflq");
var $3QTAs = parcelRequire("3QTAs");
var $jK7yf = parcelRequire("jK7yf");
var $9aS9E = parcelRequire("9aS9E");
function $7096a24a9ac888c4$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $6wflq.default).source;
    re.src_Cc = (0, $3QTAs.default).source;
    re.src_Z = (0, $jK7yf.default).source;
    re.src_P = (0, $9aS9E.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.{2,}[a-zA-Z0-9%/&]|" + "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + // allow `,,,` in paths
    ",(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    ";(?!" + re.src_ZCc + "|$)|" + // allow `!!!` in paths, but not at the end
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /* _root */  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
}

});


parcelRegister("fbObh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b0eecefa54762ac1$export$2e2bcd8739ae039; });
"use strict";
/** Highest positive signed 32-bit float value */ const $b0eecefa54762ac1$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $b0eecefa54762ac1$var$base = 36;
const $b0eecefa54762ac1$var$tMin = 1;
const $b0eecefa54762ac1$var$tMax = 26;
const $b0eecefa54762ac1$var$skew = 38;
const $b0eecefa54762ac1$var$damp = 700;
const $b0eecefa54762ac1$var$initialBias = 72;
const $b0eecefa54762ac1$var$initialN = 128; // 0x80
const $b0eecefa54762ac1$var$delimiter = "-"; // '\x2D'
/** Regular expressions */ const $b0eecefa54762ac1$var$regexPunycode = /^xn--/;
const $b0eecefa54762ac1$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $b0eecefa54762ac1$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $b0eecefa54762ac1$var$errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const $b0eecefa54762ac1$var$baseMinusTMin = $b0eecefa54762ac1$var$base - $b0eecefa54762ac1$var$tMin;
const $b0eecefa54762ac1$var$floor = Math.floor;
const $b0eecefa54762ac1$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $b0eecefa54762ac1$var$error(type) {
    throw new RangeError($b0eecefa54762ac1$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $b0eecefa54762ac1$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $b0eecefa54762ac1$var$mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($b0eecefa54762ac1$var$regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = $b0eecefa54762ac1$var$map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $b0eecefa54762ac1$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $b0eecefa54762ac1$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $b0eecefa54762ac1$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $b0eecefa54762ac1$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $b0eecefa54762ac1$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $b0eecefa54762ac1$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $b0eecefa54762ac1$var$floor(delta / $b0eecefa54762ac1$var$damp) : delta >> 1;
    delta += $b0eecefa54762ac1$var$floor(delta / numPoints);
    for(; delta > $b0eecefa54762ac1$var$baseMinusTMin * $b0eecefa54762ac1$var$tMax >> 1; k += $b0eecefa54762ac1$var$base)delta = $b0eecefa54762ac1$var$floor(delta / $b0eecefa54762ac1$var$baseMinusTMin);
    return $b0eecefa54762ac1$var$floor(k + ($b0eecefa54762ac1$var$baseMinusTMin + 1) * delta / (delta + $b0eecefa54762ac1$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $b0eecefa54762ac1$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $b0eecefa54762ac1$var$initialN;
    let bias = $b0eecefa54762ac1$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($b0eecefa54762ac1$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $b0eecefa54762ac1$var$error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $b0eecefa54762ac1$var$base;; k += $b0eecefa54762ac1$var$base){
            if (index >= inputLength) $b0eecefa54762ac1$var$error("invalid-input");
            const digit = $b0eecefa54762ac1$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $b0eecefa54762ac1$var$base) $b0eecefa54762ac1$var$error("invalid-input");
            if (digit > $b0eecefa54762ac1$var$floor(($b0eecefa54762ac1$var$maxInt - i) / w)) $b0eecefa54762ac1$var$error("overflow");
            i += digit * w;
            const t = k <= bias ? $b0eecefa54762ac1$var$tMin : k >= bias + $b0eecefa54762ac1$var$tMax ? $b0eecefa54762ac1$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $b0eecefa54762ac1$var$base - t;
            if (w > $b0eecefa54762ac1$var$floor($b0eecefa54762ac1$var$maxInt / baseMinusT)) $b0eecefa54762ac1$var$error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $b0eecefa54762ac1$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($b0eecefa54762ac1$var$floor(i / out) > $b0eecefa54762ac1$var$maxInt - n) $b0eecefa54762ac1$var$error("overflow");
        n += $b0eecefa54762ac1$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $b0eecefa54762ac1$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $b0eecefa54762ac1$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $b0eecefa54762ac1$var$initialN;
    let delta = 0;
    let bias = $b0eecefa54762ac1$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($b0eecefa54762ac1$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($b0eecefa54762ac1$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $b0eecefa54762ac1$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $b0eecefa54762ac1$var$floor(($b0eecefa54762ac1$var$maxInt - delta) / handledCPCountPlusOne)) $b0eecefa54762ac1$var$error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $b0eecefa54762ac1$var$maxInt) $b0eecefa54762ac1$var$error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $b0eecefa54762ac1$var$base;; k += $b0eecefa54762ac1$var$base){
                    const t = k <= bias ? $b0eecefa54762ac1$var$tMin : k >= bias + $b0eecefa54762ac1$var$tMax ? $b0eecefa54762ac1$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $b0eecefa54762ac1$var$base - t;
                    output.push($b0eecefa54762ac1$var$stringFromCharCode($b0eecefa54762ac1$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $b0eecefa54762ac1$var$floor(qMinusT / baseMinusT);
                }
                output.push($b0eecefa54762ac1$var$stringFromCharCode($b0eecefa54762ac1$var$digitToBasic(q, 0)));
                bias = $b0eecefa54762ac1$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $b0eecefa54762ac1$export$110c810e8727e62b = function(input) {
    return $b0eecefa54762ac1$var$mapDomain(input, function(string) {
        return $b0eecefa54762ac1$var$regexPunycode.test(string) ? $b0eecefa54762ac1$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $b0eecefa54762ac1$export$69111c4ea6e0c4a0 = function(input) {
    return $b0eecefa54762ac1$var$mapDomain(input, function(string) {
        return $b0eecefa54762ac1$var$regexNonASCII.test(string) ? "xn--" + $b0eecefa54762ac1$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $b0eecefa54762ac1$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": $b0eecefa54762ac1$export$c1700176c90f250f,
        "encode": $b0eecefa54762ac1$export$f999239d9b149395
    },
    "decode": $b0eecefa54762ac1$export$2f872c0f2117be69,
    "encode": $b0eecefa54762ac1$export$c564cdbbe6da493,
    "toASCII": $b0eecefa54762ac1$export$69111c4ea6e0c4a0,
    "toUnicode": $b0eecefa54762ac1$export$110c810e8727e62b
};
var $b0eecefa54762ac1$export$2e2bcd8739ae039 = $b0eecefa54762ac1$var$punycode;

});

parcelRegister("1lbw8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05f8ade1e60a9a1f$export$2e2bcd8739ae039; });
// markdown-it default options
var $05f8ade1e60a9a1f$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("jlXvj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8fe08aac6dcf338e$export$2e2bcd8739ae039; });
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $8fe08aac6dcf338e$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};

});

parcelRegister("9xiZC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64ae7b744aa51201$export$2e2bcd8739ae039; });
// Commonmark default options
var $64ae7b744aa51201$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};

});




parcelRegister("4ScXa", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", function () { return $38c640d197464cfc$export$c8dcbd316b71f8cf; });

var $fsmbH = parcelRequire("fsmbH");

var $9iLVX = parcelRequire("9iLVX");
function $38c640d197464cfc$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    var validParentTokens = [
        "th_open",
        "td_open",
        "list_item_open",
        "blockquote_open"
    ];
    /**
   * This function looks for strings that matches ![description](url) inside Inline-tokens.
   * It will then split the Inline-token with content before and after the image, example:
   *
   * Input (tokens):
   *   paragraph_open
   *   inline - content: Hello ![](image.jpg) World!
   *   paragraph_close
   * Output (tokens):
   *   paragraph_open
   *   inline - content: Hello
   *   paragraph_close
   *   media_single_open
   *   media
   *   media_single_close
   *   paragraph_open
   *   inline - content: World!
   *   paragraph_close
   *
   * This is applied before the inline content is parsed, to ensure that the formatting of
   * remaining inline content (bold, links, etc.) is kept intact!
   */ return function media(State) {
        var getUrl = function getUrl(str) {
            var res = State.md.helpers.parseLinkDestination(str, str.indexOf("(") + 1, str.length);
            if (res.ok) {
                var href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return "";
        };
        var createMediaTokens = function createMediaTokens(url) {
            var alt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
            var mediaSingleOpen = new State.Token("media_single_open", "", 1);
            var media = new State.Token("media", "", 0);
            media.attrs = [
                [
                    "url",
                    getUrl(url)
                ],
                [
                    "type",
                    "external"
                ],
                [
                    "alt",
                    alt
                ]
            ];
            var mediaSingleClose = new State.Token("media_single_close", "", -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
            if (!str || str.length === 0) return [];
            var inlineBefore = new State.Token("inline", "", 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [].concat((0, $9iLVX.default)(openingTokens), [
                inlineBefore
            ], (0, $9iLVX.default)(closingTokens));
        };
        var processedTokens = [];
        var newTokens = State.tokens.reduce(function(tokens, token, i, arr) {
            var matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === "inline" && matchAll.length) {
                var openingTokens = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                var closingTokens = openingTokens.map(function(token) {
                    return new State.Token(token.type.replace("_open", "_close"), token.tag, -1);
                }).reverse();
                var inlineContentStack = token.content;
                matchAll.forEach(function(match, j) {
                    var _match = (0, $fsmbH.default)(match, 3), matchString = _match[0], alt = _match[1], url = _match[2];
                    var start = inlineContentStack.indexOf(matchString);
                    var contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [].concat((0, $9iLVX.default)(subTree), (0, $9iLVX.default)(createInlineTokens(contentBefore, openingTokens, closingTokens)), (0, $9iLVX.default)(createMediaTokens(url, alt)));
                });
                if (inlineContentStack.length) subTree = [].concat((0, $9iLVX.default)(subTree), (0, $9iLVX.default)(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
                processedTokens = [].concat((0, $9iLVX.default)(processedTokens), (0, $9iLVX.default)(closingTokens.map(function(c) {
                    return c.type;
                })));
                tokens = [].concat((0, $9iLVX.default)(tokens.slice(0, cursor)), (0, $9iLVX.default)(subTree));
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $38c640d197464cfc$export$c8dcbd316b71f8cf = function markdownItMedia(md) {
    md.core.ruler.before("inline", "media", $38c640d197464cfc$var$createRule());
};

});
parcelRegister("fsmbH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b40aae88dd09f430$export$2e2bcd8739ae039; });

var $6fMfG = parcelRequire("6fMfG");

var $5PsHt = parcelRequire("5PsHt");

var $8ZjEi = parcelRequire("8ZjEi");

var $26dLd = parcelRequire("26dLd");
function $b40aae88dd09f430$export$2e2bcd8739ae039(r, e) {
    return (0, $6fMfG.default)(r) || (0, $5PsHt.default)(r, e) || (0, $8ZjEi.default)(r, e) || (0, $26dLd.default)();
}

});
parcelRegister("6fMfG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48d992a21927a896$export$2e2bcd8739ae039; });
function $48d992a21927a896$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5PsHt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43e7fa72e9d6e575$export$2e2bcd8739ae039; });
function $43e7fa72e9d6e575$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("8ZjEi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68b3431f1235bc95$export$2e2bcd8739ae039; });

var $1R2dE = parcelRequire("1R2dE");
function $68b3431f1235bc95$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1R2dE.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1R2dE.default)(r, a) : void 0;
    }
}

});
parcelRegister("1R2dE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $159c765dd977db56$export$2e2bcd8739ae039; });
function $159c765dd977db56$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("26dLd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1876d0d964cf1134$export$2e2bcd8739ae039; });
function $1876d0d964cf1134$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9iLVX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c5afa278f584eba$export$2e2bcd8739ae039; });

var $d3OFL = parcelRequire("d3OFL");

var $kosYj = parcelRequire("kosYj");

var $8ZjEi = parcelRequire("8ZjEi");

var $8aWzA = parcelRequire("8aWzA");
function $6c5afa278f584eba$export$2e2bcd8739ae039(r) {
    return (0, $d3OFL.default)(r) || (0, $kosYj.default)(r) || (0, $8ZjEi.default)(r) || (0, $8aWzA.default)();
}

});
parcelRegister("d3OFL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9822dcaf0572e894$export$2e2bcd8739ae039; });

var $1R2dE = parcelRequire("1R2dE");
function $9822dcaf0572e894$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $1R2dE.default)(r);
}

});

parcelRegister("kosYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed8c85b7773a21f2$export$2e2bcd8739ae039; });
function $ed8c85b7773a21f2$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("8aWzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f3cb141cbfc3d05$export$2e2bcd8739ae039; });
function $5f3cb141cbfc3d05$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("hiLjw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c988d1a1c3d7235d$export$2e2bcd8739ae039; });
function $c988d1a1c3d7235d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c988d1a1c3d7235d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c988d1a1c3d7235d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c988d1a1c3d7235d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c988d1a1c3d7235d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c988d1a1c3d7235d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c988d1a1c3d7235d$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ var $c988d1a1c3d7235d$var$citation = function citation(state) {
    var tokens = [];
    var citationIndexMap = {};
    var currentIndex = 1;
    var _iterator = $c988d1a1c3d7235d$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            if (token.type !== "inline" || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken) {
                if (childToken.type === "text" && $c988d1a1c3d7235d$var$CITATION_REGEX.test(childToken.content)) {
                    /**
             * Example content: `Hello [^1^][^1^].`
             * `parts` will be ['Hello ', '1', '', '1', '.']
             */ var parts = childToken.content.split($c988d1a1c3d7235d$var$CITATION_REGEX);
                    var newChildren = [];
                    /**
             * we want to remove consecutive citation
             * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
             * should be transformed to `Hello 1. How are you 1 2`
             */ var lastCitation = null;
                    var isLastCitationDuplicate = false;
                    // only want to add space in the next part after citation
                    // if the last citation is valid
                    parts.forEach(function(part, index) {
                        if (index % 2 === 0) {
                            // this is a text part
                            /**
                 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
                 * So it doesn't end up rendering empty space that will end up with multi empty spaces
                 * because previous valid citation already added 1 empty space
                 *
                 * Example: For `[^1^][^1^]`
                 * it will be split into parts: ['', '1', '', '1', ''],
                 * This code will skip any rendering for the last empty string (index=4)
                 * Because the empty string at index=2 already added 1 empty space from the code below
                 */ if (isLastCitationDuplicate && part.trim() === "") return;
                            if (part.trim() !== "") /**
                   * if the text part is not an empty string, we want to reset the last citation
                   * because the text part is a valid text, and not a space between citations
                   * so that we can render citation again, even if the next number is the same as the last number
                   *
                   * Example:
                   * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                   */ lastCitation = null;
                            var textToken = new state.Token("text", "", 0);
                            if (index === parts.length - 1) textToken.content = part;
                            else textToken.content = part + " ";
                            textToken.block = false;
                            textToken.level = childToken.level;
                            newChildren.push(textToken);
                        } else {
                            // this is a citation part
                            // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                            if (part === lastCitation) {
                                isLastCitationDuplicate = true;
                                return;
                            } else {
                                // always reset the duplicate flag
                                isLastCitationDuplicate = false;
                                lastCitation = part;
                            }
                            var citationToken = new state.Token("status", "", 0);
                            citationToken.content = "";
                            citationToken.block = false;
                            citationToken.level = childToken.level;
                            var citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                            citationToken.attrs = [
                                [
                                    "color",
                                    "blue"
                                ],
                                [
                                    "text",
                                    citationText
                                ],
                                // localId is used to identify the citation token in the DOM
                                // this overrides the uuid that is normally used
                                [
                                    "localId",
                                    "citation-".concat(citationText)
                                ]
                            ];
                            citationToken.content = citationText;
                            newChildren.push(citationToken);
                        }
                    });
                    tokenChildren.push.apply(tokenChildren, newChildren);
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $c988d1a1c3d7235d$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push("citation", $c988d1a1c3d7235d$var$citation);
};

});

parcelRegister("jy0KW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3b1c775ff745520$export$2e2bcd8739ae039; });
function $e3b1c775ff745520$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e3b1c775ff745520$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e3b1c775ff745520$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e3b1c775ff745520$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e3b1c775ff745520$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e3b1c775ff745520$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e3b1c775ff745520$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
var $e3b1c775ff745520$var$dataSculptor = function dataSculptor(state) {
    var tokens = [];
    var _iterator = $e3b1c775ff745520$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            if (token.type !== "inline" || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken) {
                if (childToken.type === "text" && $e3b1c775ff745520$var$SCULPTOR_REGEX.test(childToken.content)) {
                    var citationToken = new state.Token("status", "", 0);
                    citationToken.content = "";
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            "localId",
                            "data-sculptor"
                        ],
                        [
                            "text",
                            "data-sculptor"
                        ],
                        [
                            "color",
                            "blue"
                        ]
                    ];
                    var parts = childToken.content.split($e3b1c775ff745520$var$SCULPTOR_REGEX);
                    parts.forEach(function(part, index) {
                        if (index % 2 === 0) {
                            var textToken = new state.Token("text", "", 0);
                            textToken.content = part;
                            textToken.level = childToken.level;
                            tokenChildren.push(textToken);
                        } else tokenChildren.push(citationToken);
                    });
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $e3b1c775ff745520$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push("data-sculptor", $e3b1c775ff745520$var$dataSculptor);
};

});

parcelRegister("i9MpO", function(module, exports) {

$parcel$export(module.exports, "createLinkifyPlugin", function () { return $d37e9f870520104a$export$763ac077c9998026; });

var $cuMXM = parcelRequire("cuMXM");

var $jctNi = parcelRequire("jctNi");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
var $d37e9f870520104a$var$arrayReplaceAt = function arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
var $d37e9f870520104a$var$isLinkOpen = function isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
};
var $d37e9f870520104a$var$isLinkClose = function isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
};
var $d37e9f870520104a$export$8cd7d1ec2e6808da = function createLinkify(_ref) {
    var findFilepaths = _ref.findFilepaths, isLinkInMatches = _ref.isLinkInMatches;
    return function(state) {
        var blockTokens = state.tokens;
        var linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($cuMXM)))();
        for(var j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== "inline" || !linkify.pretest(blockTokens[j].content)) continue;
            var tokens = blockTokens[j].children;
            var htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(var i = tokens.length - 1; i >= 0; i--){
                var currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === "link_close") {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === "html_inline") {
                    if ($d37e9f870520104a$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($d37e9f870520104a$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === "text" && linkify.test(currentToken.content)) {
                    var _text = currentToken.content;
                    var links = (0, $jctNi.linkifyMatch)(_text);
                    if (!links.length) links = linkify.match(_text) || [];
                    // Now split string to nodes
                    var nodes = [];
                    var level = currentToken.level;
                    var lastPos = 0;
                    var _filepaths = findFilepaths(_text);
                    for(var ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, _filepaths)) continue;
                        var url = links[ln].url;
                        var fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        var urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                        else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                        else urlText = state.md.normalizeLinkText(urlText);
                        var pos = links[ln].index;
                        if (pos > lastPos) {
                            var _token = new state.Token("text", "", 0);
                            _token.content = _text.slice(lastPos, pos);
                            _token.level = level;
                            nodes.push(_token);
                        }
                        var token = new state.Token("link_open", "a", 1);
                        token.attrs = [
                            [
                                "href",
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = "linkify";
                        token.info = "auto";
                        nodes.push(token);
                        token = new state.Token("text", "", 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token("link_close", "a", -1);
                        token.level = --level;
                        token.markup = "linkify";
                        token.info = "auto";
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < _text.length) {
                        var _token2 = new state.Token("text", "", 0);
                        _token2.content = _text.slice(lastPos);
                        _token2.level = level;
                        nodes.push(_token2);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $d37e9f870520104a$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
};
var $d37e9f870520104a$export$763ac077c9998026 = function createLinkifyPlugin(params) {
    return function(md) {
        return md.core.ruler.push("custom-linkify", $d37e9f870520104a$export$8cd7d1ec2e6808da(params));
    };
};

});
parcelRegister("cuMXM", function(module, exports) {
"use strict";
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $918e446feb55443d$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $918e446feb55443d$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $918e446feb55443d$var$isString(obj) {
    return $918e446feb55443d$var$_class(obj) === "[object String]";
}
function $918e446feb55443d$var$isObject(obj) {
    return $918e446feb55443d$var$_class(obj) === "[object Object]";
}
function $918e446feb55443d$var$isRegExp(obj) {
    return $918e446feb55443d$var$_class(obj) === "[object RegExp]";
}
function $918e446feb55443d$var$isFunction(obj) {
    return $918e446feb55443d$var$_class(obj) === "[object Function]";
}
function $918e446feb55443d$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
////////////////////////////////////////////////////////////////////////////////
var $918e446feb55443d$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $918e446feb55443d$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $918e446feb55443d$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $918e446feb55443d$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $918e446feb55443d$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $918e446feb55443d$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $918e446feb55443d$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $918e446feb55443d$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $918e446feb55443d$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $918e446feb55443d$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("dxtpE"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($918e446feb55443d$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($918e446feb55443d$var$isObject(val)) {
            if ($918e446feb55443d$var$isRegExp(val.validate)) compiled.validate = $918e446feb55443d$var$createValidator(val.validate);
            else if ($918e446feb55443d$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($918e446feb55443d$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $918e446feb55443d$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($918e446feb55443d$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $918e446feb55443d$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($918e446feb55443d$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $918e446feb55443d$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $918e446feb55443d$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $918e446feb55443d$var$createMatch(self, shift) {
    var match = new $918e446feb55443d$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $918e446feb55443d$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $918e446feb55443d$var$LinkifyIt)) return new $918e446feb55443d$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($918e446feb55443d$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $918e446feb55443d$var$assign({}, $918e446feb55443d$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $918e446feb55443d$var$assign({}, $918e446feb55443d$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $918e446feb55443d$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $918e446feb55443d$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $918e446feb55443d$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $918e446feb55443d$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $918e446feb55443d$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $918e446feb55443d$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $918e446feb55443d$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $918e446feb55443d$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $918e446feb55443d$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $918e446feb55443d$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($918e446feb55443d$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($918e446feb55443d$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $918e446feb55443d$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $918e446feb55443d$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $918e446feb55443d$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $918e446feb55443d$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $918e446feb55443d$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $918e446feb55443d$var$LinkifyIt;

});
parcelRegister("dxtpE", function(module, exports) {
"use strict";




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("9ABC1")).source;
    re.src_Cc = (parcelRequire("hpbR5")).source;
    re.src_Z = (parcelRequire("ay1D7")).source;
    re.src_P = (parcelRequire("5Ulqw")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")(?!-|_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + "|[-]).|" + // allow `I'm_king` if no pair found
    "\\.{2,}[a-zA-Z0-9%/&]|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.(?!" + re.src_ZCc + "|[.]).|" + (opts && opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + ",(?!" + re.src_ZCc + ").|" + // allow `,,,` in paths
    ";(?!" + re.src_ZCc + ").|" + // allow `;` if not followed by space-like char
    "\\!+(?!" + re.src_ZCc + "|[!]).|" + // allow `!!!` in paths, but not at the end
    "\\?(?!" + re.src_ZCc + "|[?])." + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /*_root*/  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
};

});



parcelRegister("6IBtV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e43ed3139301bfb$export$2e2bcd8739ae039; });

var $9iLVX = parcelRequire("9iLVX");
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $4e43ed3139301bfb$var$createRule() {
    // Match any images that aren't inside single backticks
    var mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    var validParentTokens = [
        "th_open",
        "td_open",
        "list_item_open"
    ];
    return function media(State) {
        var getUrl = function getUrl(str) {
            var res = State.md.helpers.parseLinkDestination(str, str.indexOf("(") + 1, str.length);
            if (res.ok) {
                var href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return "";
        };
        var createMediaTokens = function createMediaTokens(url) {
            var mediaSingleOpen = new State.Token("media_single_open", "", 1);
            var media = new State.Token("media", "", 0);
            media.attrs = [
                [
                    "url",
                    getUrl(url)
                ],
                [
                    "type",
                    "external"
                ]
            ];
            var mediaSingleClose = new State.Token("media_single_close", "", -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
            if (!str || str.length === 0) return [];
            var inlineBefore = new State.Token("inline", "", 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [].concat((0, $9iLVX.default)(openingTokens), [
                inlineBefore
            ], (0, $9iLVX.default)(closingTokens));
        };
        var processedTokens = [];
        var newTokens = State.tokens.reduce(function(tokens, token, i, arr) {
            if (token.type === "inline" && mdImageRegex.test(token.content)) {
                var openingTokens = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                var closingTokens = openingTokens.map(function(token) {
                    return new State.Token(token.type.replace("_open", "_close"), token.tag, -1);
                }).reverse();
                var matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                var inlineContentStack = token.content;
                matches.forEach(function(match) {
                    var start = inlineContentStack.indexOf(match);
                    var contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [].concat((0, $9iLVX.default)(subTree), (0, $9iLVX.default)(createInlineTokens(contentBefore, openingTokens, closingTokens)), (0, $9iLVX.default)(createMediaTokens(match)));
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [].concat((0, $9iLVX.default)(subTree), (0, $9iLVX.default)(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
                processedTokens = [].concat((0, $9iLVX.default)(processedTokens), (0, $9iLVX.default)(closingTokens.map(function(c) {
                    return c.type;
                })));
                tokens = [].concat((0, $9iLVX.default)(tokens.slice(0, cursor)), (0, $9iLVX.default)(subTree));
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $4e43ed3139301bfb$export$2e2bcd8739ae039 = function(md) {
    md.core.ruler.before("inline", "media", $4e43ed3139301bfb$var$createRule());
};

});

parcelRegister("hCpnc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cd39aae2691a03d1$export$2e2bcd8739ae039; });
function $cd39aae2691a03d1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cd39aae2691a03d1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cd39aae2691a03d1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cd39aae2691a03d1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cd39aae2691a03d1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cd39aae2691a03d1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
var $cd39aae2691a03d1$var$isPeopleLink = function isPeopleLink(url) {
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
var $cd39aae2691a03d1$var$getAccountId = function getAccountId(url) {
    var match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
var $cd39aae2691a03d1$var$mentionLinks = function mentionLinks(state) {
    var tokens = [];
    var _iterator = $cd39aae2691a03d1$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            // We're only looking for inline children
            if (token.type !== "inline" || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken, i) {
                var _childToken$attrGet, _tokenChildren, _tokenChildren2;
                var url = (_childToken$attrGet = childToken.attrGet("href")) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : "";
                var discardedToken = [
                    "link_close",
                    "text"
                ].includes(childToken.type) && [
                    (_tokenChildren = tokenChildren[i - 1]) === null || _tokenChildren === void 0 ? void 0 : _tokenChildren.type,
                    (_tokenChildren2 = tokenChildren[i - 2]) === null || _tokenChildren2 === void 0 ? void 0 : _tokenChildren2.type
                ].includes("mention");
                // Discarded tokens are preserved as `null` so index
                // cross-referencing between processed and raw tokens may
                // be preserved, however null are filtered out later.
                if (discardedToken) {
                    tokenChildren.push(null);
                    return;
                }
                if (childToken.type === "link_open" && $cd39aae2691a03d1$var$isPeopleLink(url)) {
                    var _token$children$conte, _token$children2;
                    var mentionText = (_token$children$conte = (_token$children2 = token.children) === null || _token$children2 === void 0 || (_token$children2 = _token$children2[i + 1]) === null || _token$children2 === void 0 ? void 0 : _token$children2.content) !== null && _token$children$conte !== void 0 ? _token$children$conte : "";
                    var mentionToken = new state.Token("mention", "", 0);
                    mentionToken.content = "";
                    mentionToken.block = false;
                    mentionToken.level = childToken.level;
                    mentionToken.attrSet("id", "".concat($cd39aae2691a03d1$var$getAccountId(url)));
                    if (mentionText) mentionToken.attrSet("text", "@".concat(mentionText));
                    tokenChildren.push(mentionToken);
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $cd39aae2691a03d1$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push("mention", $cd39aae2691a03d1$var$mentionLinks);
};

});

parcelRegister("hyzpf", function(module, exports) {

$parcel$export(module.exports, "createSmartLinksPlugin", function () { return $cc81139364109d40$export$9625a798761643ac; });

var $9iLVX = parcelRequire("9iLVX");

var $680AV = parcelRequire("680AV");
function $cc81139364109d40$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $cc81139364109d40$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $cc81139364109d40$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $cc81139364109d40$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $cc81139364109d40$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $cc81139364109d40$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $cc81139364109d40$var$linkPatternStart = "\\bhttps?:\\/\\/(?:www\\.)?";
var $cc81139364109d40$var$linkPatternEnd = "[^\\s\\]\\)]*";
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
var $cc81139364109d40$var$linkRegex = {
    youtube: "".concat($cc81139364109d40$var$linkPatternStart, "youtube\\.com").concat($cc81139364109d40$var$linkPatternEnd),
    youtubeShortUrl: "".concat($cc81139364109d40$var$linkPatternStart, "youtu\\.be").concat($cc81139364109d40$var$linkPatternEnd),
    loomVideo: "".concat($cc81139364109d40$var$linkPatternStart, "loom\\.com\\/share\\/").concat($cc81139364109d40$var$linkPatternEnd),
    figmaFile: "".concat($cc81139364109d40$var$linkPatternStart, "figma\\.com\\/file\\/").concat($cc81139364109d40$var$linkPatternEnd),
    confluenceWhiteboard: "".concat($cc81139364109d40$var$linkPatternStart, ".*\\/wiki\\/spaces\\/.*\\/whiteboard\\/").concat($cc81139364109d40$var$linkPatternEnd),
    googleDoc: "".concat($cc81139364109d40$var$linkPatternStart, "docs\\.google\\.com\\/(document|presentation|spreadsheets)\\/d\\/").concat($cc81139364109d40$var$linkPatternEnd),
    googleForm: "".concat($cc81139364109d40$var$linkPatternStart, "docs\\.google\\.com\\/forms\\/d\\/").concat($cc81139364109d40$var$linkPatternEnd),
    microsoftForm: "".concat($cc81139364109d40$var$linkPatternStart, "forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=").concat($cc81139364109d40$var$linkPatternEnd),
    analyticsChart: "\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-".concat($cc81139364109d40$var$linkPatternEnd)
};
var $cc81139364109d40$var$supportedEmbedProviders = Object.values($cc81139364109d40$var$linkRegex).join("|");
var $cc81139364109d40$var$embedRegex = new RegExp($cc81139364109d40$var$supportedEmbedProviders, "g");
var $cc81139364109d40$var$embedInlineRegex = [
    "".concat($cc81139364109d40$var$linkPatternStart, "avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+").concat($cc81139364109d40$var$linkPatternEnd)
];
var $cc81139364109d40$var$createSmartLinks = function createSmartLinks(_ref) {
    var regexStorage = _ref.regexStorage;
    return function(state) {
        var _embedMatches;
        var tokens = [];
        var embedTokens = [];
        var embedMatches = [];
        var filteredTokens = [];
        var _iterator = $cc81139364109d40$var$_createForOfIteratorHelper(state.tokens), _step;
        try {
            var _loop = function _loop() {
                var _token$content;
                var token = _step.value;
                var processedTokenChildren = [];
                embedMatches = [].concat((0, $9iLVX.default)(embedMatches), (0, $9iLVX.default)(new Set((_token$content = token.content) === null || _token$content === void 0 ? void 0 : _token$content.trim().match($cc81139364109d40$var$embedRegex))));
                // Any block or embed Smart Card links will be in an "inline" token. If
                // the current token is anything other than "inline", or there's no child tokens
                // to process, then we add it to the list of tokens to keep and move forward
                if (token.type !== "inline" || !token.children) {
                    tokens.push(token);
                    return 1; // continue
                }
                outputToken = new state.Token("inline", "", 0);
                var tokensToAppend = [
                    outputToken
                ];
                if (token.children) {
                    var discardUntilIndex = -1;
                    token.children.forEach(function(childToken, i) {
                        var _childToken$attrGet, _token$children;
                        var discardedToken = i <= discardUntilIndex && [
                            "link_close",
                            "text"
                        ].includes(childToken.type);
                        if (discardedToken) return;
                        var url = (_childToken$attrGet = childToken.attrGet("href")) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : "";
                        var isInlineLink = url === ((_token$children = token.children) === null || _token$children === void 0 || (_token$children = _token$children[i + 1]) === null || _token$children === void 0 ? void 0 : _token$children.content);
                        if ((childToken === null || childToken === void 0 ? void 0 : childToken.type) === "link_open" && ((0, $680AV.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                            // Discard the next two tokens. We're now processing the opening node for a URL
                            // that will result in a new node that replaces it, therefore the subsequent link content and
                            // closing node are no longer needed
                            discardUntilIndex = i + 2;
                            if (token.level <= 1 && $cc81139364109d40$var$embedInlineRegex.some(function(r) {
                                return url.match(r);
                            })) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token("paragraph_close", "", 0));
                                processedTokenChildren = [];
                                var embedToken = new state.Token("embedCard", "", 0);
                                embedToken.content = "";
                                embedToken.block = true;
                                embedToken.attrSet("url", url);
                                embedToken.attrSet("layout", "center");
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token("paragraph_open", "", 0));
                                outputToken = new state.Token("inline", "", 0);
                                tokensToAppend.push(outputToken);
                                return;
                            }
                            var cardToken = new state.Token("inlineCard", "", 0);
                            cardToken.content = "";
                            cardToken.block = false;
                            cardToken.level = childToken.level;
                            cardToken.attrSet("url", url);
                            processedTokenChildren.push(cardToken);
                            return;
                        }
                        processedTokenChildren.push(childToken);
                    });
                }
                outputToken.children = processedTokenChildren;
                var blockTokensWithContent = tokensToAppend.filter(function(t) {
                    var _t$children;
                    return t.type !== "inline" || ((_t$children = t.children) === null || _t$children === void 0 ? void 0 : _t$children.length);
                });
                tokens.push.apply(tokens, (0, $9iLVX.default)(blockTokensWithContent));
            }, outputToken;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                if (_loop()) continue;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        for(var i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === "paragraph_open" && tokens[i + 1].type === "paragraph_close") i = i + 1;
        else filteredTokens.push(tokens[i]);
        if ((_embedMatches = embedMatches) !== null && _embedMatches !== void 0 && _embedMatches.length) (0, $9iLVX.default)(new Set(embedMatches)).forEach(function(match) {
            var embedToken = new state.Token("embedCard", "", 0);
            embedToken.content = "";
            embedToken.block = true;
            embedToken.attrSet("url", match);
            embedToken.attrSet("layout", "center");
            embedTokens.push(embedToken);
        });
        state.tokens = [].concat(filteredTokens, embedTokens);
        return;
    };
};
var $cc81139364109d40$export$9625a798761643ac = function createSmartLinksPlugin(params) {
    return function(md) {
        return md.core.ruler.push("inlineCard", $cc81139364109d40$var$createSmartLinks(params));
    };
};

});
parcelRegister("680AV", function(module, exports) {

$parcel$export(module.exports, "isSupportedByLinkingPlatform", function () { return $4763f383019dc3b8$export$4b1056d02426889c; });

var $9iLVX = parcelRequire("9iLVX");

var $eGJAO = parcelRequire("eGJAO");

var $f8O4u = parcelRequire("f8O4u");

var $fV0Sg = parcelRequire("fV0Sg");

var $9v5tP = parcelRequire("9v5tP");
var $4763f383019dc3b8$export$4b1056d02426889c = function isSupportedByLinkingPlatform(url, regexStorage) {
    var cachedProviderRegex = $4763f383019dc3b8$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    var regexPattern = new RegExp(cachedProviderRegex, "g");
    return regexPattern.test(url);
};
var $4763f383019dc3b8$export$90caa0c170ea581 = function getProviderRegexFromLs(regexStorage) {
    if (regexStorage.getItem((0, $9v5tP.LS_PROVIDER_KEY))) return JSON.parse("".concat(regexStorage.getItem((0, $9v5tP.LS_PROVIDER_KEY))));
    return "";
};
var $4763f383019dc3b8$export$5af966b3aa3b1d83 = function setProviderRegexLs(regexStorage, providerRegex) {
    regexStorage === null || regexStorage === void 0 || regexStorage.setItem((0, $9v5tP.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
var $4763f383019dc3b8$export$d08c351b3b4e4934 = /*#__PURE__*/ function() {
    var _ref = (0, $eGJAO.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f8O4u))).mark(function _callee(regexStorage, baseUrl) {
        var providerRegex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($f8O4u))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return $4763f383019dc3b8$export$ab8eaff0f2d596bd(baseUrl);
                case 2:
                    providerRegex = _context.sent;
                    $4763f383019dc3b8$export$5af966b3aa3b1d83(regexStorage, providerRegex);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function hydrateLinkingPlatformCache(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $4763f383019dc3b8$export$b7ac97ae80c7eb5a = function reduceProviderRegex(data) {
    var sources = data.providers.reduce(function(acc, provider) {
        var providerSources = provider.patterns.map(function(pattern) {
            return pattern.source;
        });
        return [].concat((0, $9iLVX.default)(acc), (0, $9iLVX.default)(providerSources));
    }, []);
    return sources.join("|");
};
var $4763f383019dc3b8$export$ab8eaff0f2d596bd = (0, $fV0Sg.default)(/*#__PURE__*/ (0, $eGJAO.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($f8O4u))).mark(function _callee2() {
    var baseUrl, response, data, _args2 = arguments;
    return (0, (/*@__PURE__*/$parcel$interopDefault($f8O4u))).wrap(function _callee2$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                baseUrl = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : "";
                _context2.prev = 1;
                _context2.next = 4;
                return fetch(baseUrl + (0, $9v5tP.PROVIDERS_API), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        type: "resolve"
                    })
                });
            case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.json();
            case 7:
                data = _context2.sent;
                return _context2.abrupt("return", !data ? "" : $4763f383019dc3b8$export$b7ac97ae80c7eb5a(data));
            case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", "");
            case 14:
            case "end":
                return _context2.stop();
        }
    }, _callee2, null, [
        [
            1,
            11
        ]
    ]);
})));

});
parcelRegister("eGJAO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab185ab94982842c$export$2e2bcd8739ae039; });
function $ab185ab94982842c$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $ab185ab94982842c$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $ab185ab94982842c$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $ab185ab94982842c$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("f8O4u", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $b05e717c6ae55f46$var$runtime = (parcelRequire("70XlH"))();
module.exports = $b05e717c6ae55f46$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $b05e717c6ae55f46$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $b05e717c6ae55f46$var$runtime;
    else Function("r", "regeneratorRuntime = r")($b05e717c6ae55f46$var$runtime);
}

});
parcelRegister("70XlH", function(module, exports) {

var $kiegv = parcelRequire("kiegv");

var $4xmTY = parcelRequire("4xmTY");

var $e0uxc = parcelRequire("e0uxc");

var $3137O = parcelRequire("3137O");

var $c7ADM = parcelRequire("c7ADM");

var $5M3rw = parcelRequire("5M3rw");

var $gVUEb = parcelRequire("gVUEb");
function $51b691f47fe4a030$var$_regeneratorRuntime() {
    "use strict";
    var r = $4xmTY(), e = r.m($51b691f47fe4a030$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $gVUEb(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $51b691f47fe4a030$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $kiegv(r, e);
            },
            AsyncIterator: $c7ADM,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $3137O : $e0uxc)(a(r), e, t, o, u);
            },
            keys: $5M3rw,
            values: $gVUEb
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $51b691f47fe4a030$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kiegv", function(module, exports) {
function $ec608ddc92482c4c$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $ec608ddc92482c4c$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4xmTY", function(module, exports) {

var $6wMZL = parcelRequire("6wMZL");
function $34dc0254e0c34d3f$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $6wMZL(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($6wMZL(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $6wMZL(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $6wMZL(u, "constructor", GeneratorFunctionPrototype), $6wMZL(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $6wMZL(GeneratorFunctionPrototype, o, "GeneratorFunction"), $6wMZL(u), $6wMZL(u, o, "Generator"), $6wMZL(u, n, function() {
        return this;
    }), $6wMZL(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $34dc0254e0c34d3f$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $34dc0254e0c34d3f$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6wMZL", function(module, exports) {
function $4c0bbca3fe13fb2b$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $4c0bbca3fe13fb2b$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $4c0bbca3fe13fb2b$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $4c0bbca3fe13fb2b$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $4c0bbca3fe13fb2b$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("e0uxc", function(module, exports) {

var $3137O = parcelRequire("3137O");
function $a328c0467412fd84$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $3137O(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $a328c0467412fd84$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("3137O", function(module, exports) {

var $4xmTY = parcelRequire("4xmTY");

var $c7ADM = parcelRequire("c7ADM");
function $2323e3aaffa472e3$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $c7ADM($4xmTY().w(r, e, t, o), n || Promise);
}
module.exports = $2323e3aaffa472e3$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c7ADM", function(module, exports) {

var $kiegv = parcelRequire("kiegv");

var $6wMZL = parcelRequire("6wMZL");
function $8d328f877afd0567$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $kiegv ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($6wMZL($8d328f877afd0567$var$AsyncIterator.prototype), $6wMZL($8d328f877afd0567$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $6wMZL(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $8d328f877afd0567$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5M3rw", function(module, exports) {
function $43441b1d21697a8f$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $43441b1d21697a8f$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gVUEb", function(module, exports) {

var $5uwTh = parcelRequire("5uwTh");
var $c53de922fc84957c$var$_typeof = $5uwTh.default;
function $c53de922fc84957c$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($c53de922fc84957c$var$_typeof(e) + " is not iterable");
}
module.exports = $c53de922fc84957c$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5uwTh", function(module, exports) {
function $3ff9447dc6c83294$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3ff9447dc6c83294$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3ff9447dc6c83294$var$_typeof(o);
}
module.exports = $3ff9447dc6c83294$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("9v5tP", function(module, exports) {

$parcel$export(module.exports, "PROVIDERS_API", function () { return $6eab4287d03e6b6b$export$57ad190cdc563df3; });
$parcel$export(module.exports, "LS_PROVIDER_KEY", function () { return $6eab4287d03e6b6b$export$56bec2f197c16818; });
var $6eab4287d03e6b6b$export$57ad190cdc563df3 = "/gateway/api/object-resolver/providers";
var $6eab4287d03e6b6b$export$56bec2f197c16818 = "aiMateSmartLinkProviders";

});



parcelRegister("k3Mis", function(module, exports) {

$parcel$export(module.exports, "pmToMd", function () { return $e9a98d2ab36dd84d$export$cd54a56af01ba875; });
$parcel$export(module.exports, "mdToPmSchema", function () { return $e9a98d2ab36dd84d$export$eb83d753215c78a2; });
var $e9a98d2ab36dd84d$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: "blockquote",
        paragraph: "paragraph",
        rule: "hr",
        // lheading (---, ===)
        heading: [
            "heading",
            "lheading"
        ],
        codeBlock: [
            "code",
            "fence"
        ],
        listItem: "list",
        image: "image"
    },
    marks: {
        em: "emphasis",
        strong: "text",
        link: [
            "link",
            "autolink",
            "reference",
            "linkify"
        ],
        strike: "strikethrough",
        code: "backticks"
    }
};
var $e9a98d2ab36dd84d$export$eb83d753215c78a2 = {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        attrs: function attrs(tok) {
            return {
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            };
        }
    },
    table: {
        block: "table"
    },
    tr: {
        block: "tableRow"
    },
    th: {
        block: "tableHeader"
    },
    td: {
        block: "tableCell"
    },
    s: {
        mark: "strike"
    },
    task_list: {
        block: "taskList"
    },
    task_item: {
        block: "taskItem",
        attrs: function attrs(tok) {
            return {
                state: tok.meta
            };
        }
    },
    hr: {
        node: "rule"
    },
    heading: {
        block: "heading",
        attrs: function attrs(tok) {
            return {
                level: +tok.tag.slice(1)
            };
        }
    },
    softbreak: {
        node: "hardBreak"
    },
    hardbreak: {
        node: "hardBreak"
    },
    code_block: {
        block: "codeBlock"
    },
    list_item: {
        block: "listItem"
    },
    bullet_list: {
        block: "bulletList"
    },
    code_inline: {
        mark: "code"
    },
    ordered_list: {
        block: "orderedList",
        attrs: function attrs(tok) {
            var order = +(tok.attrGet("order") || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: "codeBlock",
        // we trim any whitespaces around language definition
        attrs: function attrs(tok) {
            var _tok$info;
            return {
                language: ((_tok$info = tok.info) === null || _tok$info === void 0 ? void 0 : _tok$info.trim()) || null
            };
        }
    },
    image: {
        node: "image",
        attrs: function attrs(_tok) {
            return {};
        }
    },
    media_single: {
        block: "mediaSingle",
        attrs: function attrs() {
            return {};
        }
    },
    media: {
        node: "media",
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet("url"),
                type: "external"
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: "inlineCard",
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet("url")
            };
        }
    },
    blockCard: {
        node: "blockCard",
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet("url")
            };
        }
    },
    embedCard: {
        node: "embedCard",
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet("url")
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: "mention",
        attrs: function attrs(tok) {
            return {
                id: tok.attrGet("id"),
                text: tok.attrGet("text"),
                type: "mention"
            };
        }
    },
    status: {
        node: "status",
        attrs: function attrs(token) {
            return {
                text: token.attrGet("text"),
                color: token.attrGet("color"),
                localId: token.attrGet("localId")
            };
        }
    }
};

});

parcelRegister("lE051", function(module, exports) {

$parcel$export(module.exports, "filterSchemaMapping", function () { return $fc1d654e3c558768$export$155749302793c60c; });
$parcel$export(module.exports, "enableSchemaPlugins", function () { return $fc1d654e3c558768$export$a1cf9d9b96e16789; });

var $k3Mis = parcelRequire("k3Mis");
var $fc1d654e3c558768$export$155749302793c60c = function filterSchemaMapping(schema, map) {
    return Object.keys(map).reduce(function(newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
};
var $fc1d654e3c558768$export$a1cf9d9b96e16789 = function enableSchemaPlugins(md, schema) {
    for(var k in 0, $k3Mis.pmToMd){
        var key = k;
        for(var i in (0, $k3Mis.pmToMd)[key]){
            var idx = i;
            if (schema[key][idx]) md.enable((0, $k3Mis.pmToMd)[key][idx]);
        }
    }
};

});



parcelRegister("jZKXN", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("72glO")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("g0mpR")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("edRdB")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("kU000")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("1Csux")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("2ALIQ")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("27BIb")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("70uQI"))
]).then(()=>parcelRequire("5a2Ac"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});




parcelRegister("c7YE1", function(module, exports) {

$parcel$export(module.exports, "AISummaryLoadingAnimation", function () { return $7ed7d12a3bc76884$export$3445570560693912; });
/* ai-summary-loading-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dsYmM = parcelRequire("dsYmM");

var $kvKe4 = parcelRequire("kvKe4");
const $7ed7d12a3bc76884$export$3445570560693912 = ({ traceResponse: traceResponse })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx2vrvc _1wybdlk8 _syaz1fxt"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dsYmM.RovoIcon), {
                className: (0, $esG4f.default)([
                    "_12l2ftgi"
                ])
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_vwz4gktf"
                ]),
                children: traceResponse
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kvKe4.LoadingDotsAnimation), {})
        ]
    });
};
const $7ed7d12a3bc76884$var$aiSummaryLoadingAnimationWrapperStyle = null;

});
parcelRegister("dsYmM", function(module, exports) {

$parcel$export(module.exports, "RovoIcon", function () { return $3c36c2c0278568bb$export$e23ae35269442b4f; });
// Copy of search-ai/src/v2/common/ui/assets/Rovo.svg

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $loA2J = parcelRequire("loA2J");
const $3c36c2c0278568bb$export$e23ae35269442b4f = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", (0, $6iHNw._)((0, $7Knp0._)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L17.8968 4.16857C18.598 4.57283 19.032 5.32283 19.032 6.1308V13.8618C19.032 14.6729 18.6006 15.4196 17.8973 15.8237L12.8611 18.7293C12.8721 18.6984 12.8826 18.6672 12.8926 18.6358C12.9861 18.3462 13.0357 18.0401 13.0357 17.7272V9.99628C13.0357 8.93422 12.4704 7.95482 11.5484 7.425L10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7.26173 1.27069L2.22547 4.17636C1.5222 4.5804 1.09082 5.32709 1.09082 6.13826V13.8692C1.09082 14.6772 1.52475 15.4271 2.22593 15.8314L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594L8.57469 12.5752C7.65284 12.0453 7.08715 11.0657 7.08715 10.0037V2.27277C7.08715 1.96035 7.13657 1.65469 7.2298 1.36539C7.23992 1.33362 7.25057 1.30205 7.26173 1.27069Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L2.22593 15.8314C1.52475 15.4271 1.09082 14.6772 1.09082 13.8692V6.13826C1.09082 5.32709 1.5222 4.5804 2.22547 4.17636L7.26173 1.27069C7.25057 1.30205 7.23992 1.33362 7.2298 1.36539C7.13657 1.65469 7.08715 1.96035 7.08715 2.27277V10.0037C7.08715 11.0657 7.65284 12.0453 8.57469 12.5752L9.41444 13.0594Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L10.6181 6.88854Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8968 4.16857L16.6126 3.42764L10.6181 6.88854L11.5484 7.425C12.4704 7.95482 13.0357 8.93422 13.0357 9.99628V17.7272C13.0357 18.0401 12.9861 18.3462 12.8926 18.6358C12.8826 18.6672 12.8721 18.6984 12.8611 18.7293L17.8973 15.8237C18.6006 15.4196 19.032 14.6729 19.032 13.8618V6.1308C19.032 5.32283 18.598 4.57283 17.8968 4.16857Z",
                fill: "#AF59E1"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594Z",
                fill: "#6A9A23"
            })
        ]
    }));
};

});

parcelRegister("kvKe4", function(module, exports) {

$parcel$export(module.exports, "LoadingDotsAnimation", function () { return $e356784f7073b1d4$export$32ef2855359d928d; });
// Copy of platform/packages/search/search-ai/src/ai-answer-dialog/ai-answer-loading/rovo-generating-animation.tsx

var $loA2J = parcelRequire("loA2J");
const $e356784f7073b1d4$export$32ef2855359d928d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "3",
                cy: "14",
                r: "1",
                fill: "#1F69DA",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;1;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "7",
                cy: "14",
                r: "1",
                fill: "#C16CD4",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "11",
                cy: "14",
                r: "1",
                fill: "#F5A117",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;0;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            })
        ]
    });
};

});


parcelRegister("3nnYi", function(module, exports) {

$parcel$export(module.exports, "AIAnswerSearchBorder", function () { return $cc3f42b102ffcd39$export$f2207ab910ac3fa8; });
/* styled.tsx generated by @compiled/babel-plugin v0.28.8 */ // Updated with Confluence prism border (color-blocked) animation

var $7Knp0 = parcelRequire("7Knp0");

var $6iHNw = parcelRequire("6iHNw");

var $akGnX = parcelRequire("akGnX");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
const $cc3f42b102ffcd39$var$GlowWrapper = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { isLoading: isLoading, isStreaming: isStreaming } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "isLoading",
        "isStreaming"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_51v2mw": (0, $43MIc.default)(__cmplp.isLoading || __cmplp.isStreaming ? "conic-gradient(from 39deg at 50% 50%, #FCA700 0deg, #FCA700 72.69129753112793deg, #6A9A23 72.72729814052582deg, #6A9A23 167.89464354515076deg, #1868DB 167.93063879013062deg, #1868DB 252.66713619232178deg, #AF59E0 252.7031421661377deg, #AF59E0 360deg)" : "transparent"),
            "--_ymerfz": (0, $43MIc.default)(__cmplp.isLoading || __cmplp.isStreaming ? "rotateGlow 2s linear infinite" : "none")
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_kqswh2mm _1e0c1txw _1bsb1osq _2rko1b66 _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _19pk14id _2hwx14id _otyr14id _18u014id _1reo15vq _18m915vq _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _rfx31b66 _1s6ky832 _16qqrnmq _1dbx1m5u _154p105o _aetrb3bt _18postnw _9v7aidpf _1bqq1mrw _16r21l2m _11fnglyw _1a4fagmp",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$var$BorderWrapper = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    const { isLoading: isLoading, isStreaming: isStreaming } = __cmplp, __cmpldp = (0, $akGnX._)(__cmplp, [
        "isLoading",
        "isStreaming"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmpldp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_18md79h": (0, $43MIc.default)(__cmplp.isLoading || __cmplp.isStreaming ? "none" : `1px solid ${"var(--ds-border, #091E4224)"}`),
            "--_51v2mw": (0, $43MIc.default)(__cmplp.isLoading || __cmplp.isStreaming ? "conic-gradient(from 39deg at 50% 50%, #FCA700 0deg, #FCA700 72.69129753112793deg, #6A9A23 72.72729814052582deg, #6A9A23 167.89464354515076deg, #1868DB 167.93063879013062deg, #1868DB 252.66713619232178deg, #AF59E0 252.7031421661377deg, #AF59E0 360deg)" : "transparent"),
            "--_3cn0js": (0, $43MIc.default)(__cmplp.isLoading || __cmplp.isStreaming ? "rotateBorder 2s linear infinite" : "none")
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _2rko1b66 _bfhk1bhr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _1reo15vq _18m915vq _1pbykb7n _1bsb1osq _19it1un5 _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _rfx31b66 _1s6ky832 _16qquh9c _aetrb3bt _z0ai1hup _1qdg1hup _9v7at94y _18postnw _1bqq1mrw _14mj1b66 _1hfk1bhr _1a4fagmp",
            __cmplp.className
        ])
    }));
}); // Combined component that wraps both
const $cc3f42b102ffcd39$export$f2207ab910ac3fa8 = ({ isLoading: isLoading, isStreaming: isStreaming, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($cc3f42b102ffcd39$var$GlowWrapper, {
        isLoading: isLoading,
        isStreaming: isStreaming,
        children: /*#__PURE__*/ (0, $loA2J.jsx)($cc3f42b102ffcd39$var$BorderWrapper, {
            isLoading: isLoading,
            isStreaming: isStreaming,
            children: children
        })
    });
};
const $cc3f42b102ffcd39$export$a550342571a01571 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _19pkpxbi _zulpu2gc _1bsb1osq",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$90ec299a95f41a29 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: (0, $6iHNw._)((0, $7Knp0._)({}, __cmpls), {
            "--_1cfjque": (0, $43MIc.default)(__cmplp.width ? __cmplp.width : "100%"),
            "--_eop49q": (0, $43MIc.default)(__cmplp.height ? __cmplp.height : "16px")
        }),
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bsb1q4i _4t3iy8ug _2rkopd34 _11q71pw5 _y44v1sal",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _4t3iucft _vchhusvi _ca0q1ejb _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$636ea4c09615ceed = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_18u0v77o _syaz1wmz _11c82smr",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_80omtlke _1e0c1ule",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1ule _t9ec1hke",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$975a268f2c733e4 = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_11q7axro _94n5idpf _1e0c1ule _4t3i1jfw _19pkidpf _2hwxt94y _otyridpf _18u0t94y _kqsw1if8",
            __cmplp.className
        ])
    }));
});
const $cc3f42b102ffcd39$export$f243da7eac28085c = /*#__PURE__*/ (0, $iSvIT.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $akGnX._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, (0, $6iHNw._)((0, $7Knp0._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpu2gc _ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("2G4Ap", function(module, exports) {

$parcel$export(module.exports, "SearchHelper", function () { return $f6adc35bea74c8b1$export$3a4ead32446b35b2; });

var $fpzRv = parcelRequire("fpzRv");

var $98pMG = parcelRequire("98pMG");

var $cQk7Y = parcelRequire("cQk7Y");
const $f6adc35bea74c8b1$var$ALGOLIA_APP_ID = "CU5KFWE75C";
const $f6adc35bea74c8b1$var$ALGOLIA_SEARCH_API_KEY = "8cb0497a0549da256319b1b8178e5421";
const $f6adc35bea74c8b1$var$INSIGHTS_URL = `https://insights.algolia.io/1/events`;
const $f6adc35bea74c8b1$var$ATLASSIAN_APPS = [
    "jira",
    "confluence",
    "loom",
    "jira service management",
    "jira product discovery",
    "trello",
    "bitbucket",
    "customer service management",
    "statuspage",
    "rovo",
    "atlas",
    "compass",
    "sourcetree",
    "guard"
];
const $f6adc35bea74c8b1$var$ATLASSIAN_COLLECTIONS = [
    "teamwork collection",
    "strategy collection",
    "service collection",
    "software collection"
];
const $f6adc35bea74c8b1$var$ATLASSIAN_KEYWORDS = [
    "agile",
    "kanban",
    "scrum",
    "devops",
    "it service management",
    "project management",
    "roadmap",
    "git",
    "pricing",
    "cost",
    "billing",
    "atlassian intelligence",
    "statuspage",
    "marketplace",
    "templates",
    "gantt",
    "mcp",
    "tempo"
];
class $f6adc35bea74c8b1$export$3a4ead32446b35b2 {
    init() {
        this.bindAllSearchEvents();
    }
    receiveUpdate(callback) {
        this.callback = callback;
    }
    bindAllSearchEvents() {
        const onSearchComplete = (results)=>{
            this.callback(results);
        };
        this.helper.on("result", function({ results: results }) {
            onSearchComplete(results);
        });
    }
    goToNextPage() {
        this.helper.nextPage();
        this.helper.search();
    }
    search() {
        this.helper.search();
    }
    async sendClickEvent({ objectId: objectId, position: position, queryId: queryId, userToken: userToken }) {
        const eventData = {
            events: [
                {
                    eventType: "click",
                    eventName: "Result clicked after search on search page",
                    index: this.searchIndex,
                    userToken: userToken,
                    objectIDs: [
                        objectId
                    ],
                    positions: [
                        position
                    ],
                    queryID: queryId
                }
            ]
        };
        try {
            const response = await fetch($f6adc35bea74c8b1$var$INSIGHTS_URL, {
                method: "POST",
                headers: {
                    "X-Algolia-Application-Id": $f6adc35bea74c8b1$var$ALGOLIA_APP_ID,
                    "X-Algolia-API-Key": $f6adc35bea74c8b1$var$ALGOLIA_SEARCH_API_KEY,
                    "Content-Type": "text/plain;charset=UTF-8"
                },
                body: JSON.stringify(eventData)
            });
            if (!response.ok) throw new Error(`Error: Failed to send event to algolia : ${response.statusText}`);
        } catch (error) {
            console.error("Failed to send event to algolia:", error);
        }
    }
    removeFacet(facetKey) {
        this.helper.removeFacetRefinement(facetKey);
    }
    setFacet(facetKey, facet) {
        this.helper.removeFacetRefinement(facetKey);
        return this.helper.addFacetRefinement(facetKey, facet);
    }
    setQuery(params) {
        return this.helper.setQuery(params);
    }
    /**
   * Get the named entity query for a specific parameter.
   * Extracts specific keywords from query if it's longer than 3 words.
   * This helps to improve search accuracy for named entities, instead of lot of filler words.
   */ getNamedEntityQuery(query) {
        const lowerCaseQuery = query.toLowerCase();
        const words = lowerCaseQuery.split(" ");
        if (words.length <= 3) return query;
        const namedEntities = [
            ...$f6adc35bea74c8b1$var$ATLASSIAN_APPS,
            ...$f6adc35bea74c8b1$var$ATLASSIAN_COLLECTIONS,
            ...$f6adc35bea74c8b1$var$ATLASSIAN_KEYWORDS
        ];
        let returnQuery = undefined;
        for (const entity of namedEntities)if (lowerCaseQuery.includes(entity)) returnQuery ? returnQuery += " " + entity : returnQuery = entity;
        return returnQuery;
    }
    constructor(searchIndex, facets){
        this.searchIndex = searchIndex;
        const algoliaSearchClient = (0, $fpzRv.default)($f6adc35bea74c8b1$var$ALGOLIA_APP_ID, $f6adc35bea74c8b1$var$ALGOLIA_SEARCH_API_KEY);
        const isAnalyticsEnabled = (0, $cQk7Y.shouldEnableAlgoliaAnalytics)();
        this.helper = (0, (/*@__PURE__*/$parcel$interopDefault($98pMG)))(algoliaSearchClient, this.searchIndex, {
            // @ts-ignore - facet functionality
            facets: facets,
            clickAnalytics: isAnalyticsEnabled,
            // enables click analytics
            attributesToRetrieve: [
                "url",
                "title",
                "description",
                "locale",
                "category",
                "objectID"
            ]
        });
        this.init();
    }
}

});
parcelRegister("98pMG", function(module, exports) {
"use strict";

var $3uCyH = parcelRequire("3uCyH");

var $kuCDQ = parcelRequire("kuCDQ");

var $8nF8t = parcelRequire("8nF8t");

var $c976L = parcelRequire("c976L");

var $kyH0w = parcelRequire("kyH0w");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $6a68dc987dc08d88$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $3uCyH(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $6a68dc987dc08d88$var$algoliasearchHelper.version = (parcelRequire("9GKin"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $6a68dc987dc08d88$var$algoliasearchHelper.AlgoliaSearchHelper = $3uCyH;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $6a68dc987dc08d88$var$algoliasearchHelper.SearchParameters = $c976L;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $6a68dc987dc08d88$var$algoliasearchHelper.RecommendParameters = $kuCDQ;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $6a68dc987dc08d88$var$algoliasearchHelper.SearchResults = $kyH0w;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $6a68dc987dc08d88$var$algoliasearchHelper.RecommendResults = $8nF8t;
module.exports = $6a68dc987dc08d88$var$algoliasearchHelper;

});
parcelRegister("3uCyH", function(module, exports) {
"use strict";

var $b5x2Z = parcelRequire("b5x2Z");

var $bRkCS = parcelRequire("bRkCS");

var $h1XVP = parcelRequire("h1XVP");
var $28b2155db3085e03$require$escapeFacetValue = $h1XVP.escapeFacetValue;

var $b5asD = parcelRequire("b5asD");

var $iHkor = parcelRequire("iHkor");

var $gmDMq = parcelRequire("gmDMq");

var $bjutv = parcelRequire("bjutv");

var $kuCDQ = parcelRequire("kuCDQ");

var $8nF8t = parcelRequire("8nF8t");

var $7mXtJ = parcelRequire("7mXtJ");

var $c976L = parcelRequire("c976L");

var $kyH0w = parcelRequire("kyH0w");

var $67Dz9 = parcelRequire("67Dz9");

var $9GKin = parcelRequire("9GKin");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $28b2155db3085e03$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $9GKin + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $c976L.make(opts);
    this.recommendState = new $kuCDQ({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$b5asD($28b2155db3085e03$var$AlgoliaSearchHelper, $b5x2Z);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $7mXtJ._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $7mXtJ._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $kyH0w(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $kyH0w(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $iHkor({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $bjutv($7mXtJ._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $7mXtJ.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $28b2155db3085e03$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $28b2155db3085e03$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setCurrentPage = $28b2155db3085e03$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setPage = $28b2155db3085e03$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $c976L.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $c976L(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($gmDMq(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $28b2155db3085e03$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getCurrentPage = $28b2155db3085e03$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getPage = $28b2155db3085e03$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $7mXtJ._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $7mXtJ._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $kuCDQ());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $kyH0w(state, specificResults, self._searchResultsOptions);
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $67Dz9(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $8nF8t(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$28b2155db3085e03$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $9GKin + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $bRkCS(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $28b2155db3085e03$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $28b2155db3085e03$var$AlgoliaSearchHelper;

});
parcelRegister("b5x2Z", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $8129cbd276aefbb4$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $8129cbd276aefbb4$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$8129cbd276aefbb4$var$EventEmitter.prototype._events = undefined;
$8129cbd276aefbb4$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$8129cbd276aefbb4$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$8129cbd276aefbb4$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$8129cbd276aefbb4$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$8129cbd276aefbb4$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $8129cbd276aefbb4$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($8129cbd276aefbb4$var$isUndefined(handler)) return false;
    if ($8129cbd276aefbb4$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($8129cbd276aefbb4$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$8129cbd276aefbb4$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$8129cbd276aefbb4$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $8129cbd276aefbb4$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($8129cbd276aefbb4$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($8129cbd276aefbb4$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$8129cbd276aefbb4$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $8129cbd276aefbb4$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$8129cbd276aefbb4$var$EventEmitter.prototype.on = $8129cbd276aefbb4$var$EventEmitter.prototype.addListener;
$8129cbd276aefbb4$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$8129cbd276aefbb4$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$8129cbd276aefbb4$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$8129cbd276aefbb4$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $8129cbd276aefbb4$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($8129cbd276aefbb4$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$8129cbd276aefbb4$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($8129cbd276aefbb4$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$8129cbd276aefbb4$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($8129cbd276aefbb4$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$8129cbd276aefbb4$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($8129cbd276aefbb4$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$8129cbd276aefbb4$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $8129cbd276aefbb4$var$isFunction(arg) {
    return typeof arg === "function";
}
function $8129cbd276aefbb4$var$isNumber(arg) {
    return typeof arg === "number";
}
function $8129cbd276aefbb4$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $8129cbd276aefbb4$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("bRkCS", function(module, exports) {
"use strict";

var $b5x2Z = parcelRequire("b5x2Z");

var $b5asD = parcelRequire("b5asD");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $8a24a4de1c81f2c5$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$b5asD($8a24a4de1c81f2c5$var$DerivedHelper, $b5x2Z);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $8a24a4de1c81f2c5$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$8a24a4de1c81f2c5$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$8a24a4de1c81f2c5$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
module.exports = $8a24a4de1c81f2c5$var$DerivedHelper;

});
parcelRegister("b5asD", function(module, exports) {
"use strict";
function $811846a069fb51a9$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $811846a069fb51a9$var$inherits;

});


parcelRegister("h1XVP", function(module, exports) {
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $c66104db7e555c53$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $c66104db7e555c53$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
module.exports = {
    escapeFacetValue: $c66104db7e555c53$var$escapeFacetValue,
    unescapeFacetValue: $c66104db7e555c53$var$unescapeFacetValue
};

});

parcelRegister("iHkor", function(module, exports) {
"use strict";
function $d9cc0fca7ba0335a$var$clone(value) {
    if (typeof value === "object" && value !== null) return $d9cc0fca7ba0335a$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $d9cc0fca7ba0335a$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $d9cc0fca7ba0335a$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($d9cc0fca7ba0335a$var$isObjectOrArrayOrFunction(targetVal) && $d9cc0fca7ba0335a$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $d9cc0fca7ba0335a$var$_merge(targetVal, sourceVal);
        else target[key] = $d9cc0fca7ba0335a$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $d9cc0fca7ba0335a$var$merge(target) {
    if (!$d9cc0fca7ba0335a$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($d9cc0fca7ba0335a$var$isObjectOrArrayOrFunction(source)) $d9cc0fca7ba0335a$var$_merge(target, source);
    }
    return target;
}
module.exports = $d9cc0fca7ba0335a$var$merge;

});

parcelRegister("gmDMq", function(module, exports) {
"use strict";
function $be9d8ee17ff0c4ec$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $be9d8ee17ff0c4ec$var$objectHasKeys;

});

parcelRegister("bjutv", function(module, exports) {
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $83c91bc33ea6a171$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $83c91bc33ea6a171$var$_objectWithoutPropertiesLoose;

});

parcelRegister("kuCDQ", function(module, exports) {
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $eeb4956f79185e67$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$eeb4956f79185e67$var$RecommendParameters.prototype = {
    constructor: $eeb4956f79185e67$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $eeb4956f79185e67$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $eeb4956f79185e67$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName
            });
            delete query.$$id;
            return query;
        });
    }
};
module.exports = $eeb4956f79185e67$var$RecommendParameters;

});

parcelRegister("8nF8t", function(module, exports) {
"use strict";
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $61a06167db2fbfdb$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$61a06167db2fbfdb$var$RecommendResults.prototype = {
    constructor: $61a06167db2fbfdb$var$RecommendResults
};
module.exports = $61a06167db2fbfdb$var$RecommendResults;

});

parcelRegister("7mXtJ", function(module, exports) {
"use strict";

var $iHkor = parcelRequire("iHkor");
function $55d8b9ac9f64e235$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $55d8b9ac9f64e235$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $55d8b9ac9f64e235$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $55d8b9ac9f64e235$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $55d8b9ac9f64e235$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($55d8b9ac9f64e235$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $55d8b9ac9f64e235$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $55d8b9ac9f64e235$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $55d8b9ac9f64e235$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf("*") > -1 ? [
                "*"
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $55d8b9ac9f64e235$var$sortObject($iHkor({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $55d8b9ac9f64e235$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $55d8b9ac9f64e235$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $55d8b9ac9f64e235$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $55d8b9ac9f64e235$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $55d8b9ac9f64e235$var$sortObject($iHkor({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $55d8b9ac9f64e235$var$sortObject($iHkor({}, $55d8b9ac9f64e235$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $55d8b9ac9f64e235$var$requestBuilder;

});

parcelRegister("c976L", function(module, exports) {
"use strict";

var $62FB7 = parcelRequire("62FB7");

var $bCApz = parcelRequire("bCApz");

var $bOz0Y = parcelRequire("bOz0Y");

var $iHkor = parcelRequire("iHkor");

var $gmDMq = parcelRequire("gmDMq");

var $bjutv = parcelRequire("bjutv");

var $bx3SQ = parcelRequire("bx3SQ");

var $6tebk = parcelRequire("6tebk");

var $2XnKq = parcelRequire("2XnKq");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $8d7bd6d06cbb0b0d$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $8d7bd6d06cbb0b0d$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $8d7bd6d06cbb0b0d$var$findArray(array, searchedValue) {
    return $bCApz(array, function(currentValue) {
        return $8d7bd6d06cbb0b0d$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $8d7bd6d06cbb0b0d$var$SearchParameters(newParameters) {
    var params = newParameters ? $8d7bd6d06cbb0b0d$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$6tebk(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $8d7bd6d06cbb0b0d$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $8d7bd6d06cbb0b0d$var$SearchParameters.PARAMETERS = Object.keys(new $8d7bd6d06cbb0b0d$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $8d7bd6d06cbb0b0d$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $8d7bd6d06cbb0b0d$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $iHkor(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $8d7bd6d06cbb0b0d$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $8d7bd6d06cbb0b0d$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $8d7bd6d06cbb0b0d$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $gmDMq(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($gmDMq(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$8d7bd6d06cbb0b0d$var$SearchParameters.prototype = {
    constructor: $8d7bd6d06cbb0b0d$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $2XnKq.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $2XnKq.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $2XnKq.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $2XnKq.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $bx3SQ(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $iHkor({}, this.numericRefinements);
        mod[attribute] = $iHkor({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $8d7bd6d06cbb0b0d$var$isEqualNumericRefinement(value.val, $bx3SQ(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$gmDMq(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $bjutv(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($2XnKq.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $2XnKq.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($2XnKq.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $2XnKq.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($2XnKq.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $2XnKq.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$2XnKq.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $2XnKq.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$2XnKq.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $2XnKq.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$2XnKq.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $2XnKq.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $2XnKq.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $2XnKq.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $2XnKq.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $62FB7({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $62FB7({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $62FB7({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $2XnKq.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $2XnKq.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $2XnKq.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $bx3SQ(value);
        var isAttributeValueDefined = $8d7bd6d06cbb0b0d$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $bOz0Y(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $bOz0Y(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $8d7bd6d06cbb0b0d$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $8d7bd6d06cbb0b0d$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $bjutv(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $bCApz(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $8d7bd6d06cbb0b0d$var$SearchParameters;

});
parcelRegister("62FB7", function(module, exports) {
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("bCApz", function(module, exports) {
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("bOz0Y", function(module, exports) {
"use strict";
function $899f866f79a62d25$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $899f866f79a62d25$var$intersection;

});

parcelRegister("bx3SQ", function(module, exports) {
"use strict";
function $8655c9f3af65334c$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($8655c9f3af65334c$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
module.exports = $8655c9f3af65334c$var$valToNumber;

});

parcelRegister("6tebk", function(module, exports) {
"use strict";
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("2XnKq", function(module, exports) {
"use strict";

var $62FB7 = parcelRequire("62FB7");

var $gmDMq = parcelRequire("gmDMq");

var $bjutv = parcelRequire("bjutv");
var $2273834d218f638c$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($2273834d218f638c$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $62FB7({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $2273834d218f638c$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $2273834d218f638c$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($2273834d218f638c$var$lib.isRefined(refinementList, attribute, value)) return $2273834d218f638c$var$lib.removeRefinement(refinementList, attribute, value);
        return $2273834d218f638c$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$gmDMq(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $bjutv(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $2273834d218f638c$var$lib;

});


parcelRegister("kyH0w", function(module, exports) {
"use strict";

var $hc7wf = parcelRequire("hc7wf");

var $62FB7 = parcelRequire("62FB7");

var $h1XVP = parcelRequire("h1XVP");

var $bCApz = parcelRequire("bCApz");

var $bSp4A = parcelRequire("bSp4A");

var $2tZQW = parcelRequire("2tZQW");

var $iHkor = parcelRequire("iHkor");

var $2ozwp = parcelRequire("2ozwp");
var $ef7858029f6e38ce$var$escapeFacetValue = $h1XVP.escapeFacetValue;
var $ef7858029f6e38ce$var$unescapeFacetValue = $h1XVP.unescapeFacetValue;

var $8iPXz = parcelRequire("8iPXz");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $ef7858029f6e38ce$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $ef7858029f6e38ce$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $ef7858029f6e38ce$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $bCApz(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $ef7858029f6e38ce$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $iHkor({
        persistHierarchicalRootCount: false
    }, options);
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $ef7858029f6e38ce$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $ef7858029f6e38ce$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $ef7858029f6e38ce$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $bSp4A(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $ef7858029f6e38ce$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $ef7858029f6e38ce$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $hc7wf(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $bSp4A(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $bSp4A(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $iHkor({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $62FB7({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $ef7858029f6e38ce$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($ef7858029f6e38ce$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $bSp4A(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $bSp4A(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $62FB7(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($8iPXz(state));
    /**
   * @type {Array}
   */ this.facets = $hc7wf(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $hc7wf(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $ef7858029f6e38ce$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $bCApz(this.facets, predicate) || $bCApz(this.disjunctiveFacets, predicate) || $bCApz(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $ef7858029f6e38ce$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $bCApz(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $ef7858029f6e38ce$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $bCApz(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $ef7858029f6e38ce$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $bCApz(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $ef7858029f6e38ce$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $ef7858029f6e38ce$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $ef7858029f6e38ce$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $ef7858029f6e38ce$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $ef7858029f6e38ce$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $ef7858029f6e38ce$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $62FB7({
        data: sortedChildren
    }, node);
    return newNode;
}
$ef7858029f6e38ce$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $ef7858029f6e38ce$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $ef7858029f6e38ce$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($2ozwp(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $ef7858029f6e38ce$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $ef7858029f6e38ce$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $ef7858029f6e38ce$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $62FB7({}, opts, {
        sortBy: $ef7858029f6e38ce$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $ef7858029f6e38ce$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $ef7858029f6e38ce$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $ef7858029f6e38ce$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $2tZQW(options.sortBy, $ef7858029f6e38ce$var$SearchResults.DEFAULT_SORT);
            return $2ozwp(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $ef7858029f6e38ce$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $ef7858029f6e38ce$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $ef7858029f6e38ce$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $ef7858029f6e38ce$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $ef7858029f6e38ce$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $bCApz(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $ef7858029f6e38ce$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($ef7858029f6e38ce$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($ef7858029f6e38ce$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($ef7858029f6e38ce$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($ef7858029f6e38ce$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $ef7858029f6e38ce$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $bCApz(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $ef7858029f6e38ce$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $bCApz(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $bCApz(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $ef7858029f6e38ce$var$SearchResults;

});
parcelRegister("hc7wf", function(module, exports) {
"use strict";
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("bSp4A", function(module, exports) {
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("2tZQW", function(module, exports) {
"use strict";

var $bCApz = parcelRequire("bCApz");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $bCApz(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("2ozwp", function(module, exports) {
"use strict";
function $1be96085f9fd3a5b$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $1be96085f9fd3a5b$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $1be96085f9fd3a5b$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $1be96085f9fd3a5b$var$orderBy;

});

parcelRegister("8iPXz", function(module, exports) {
"use strict";
module.exports = $60b84f545edbe4c3$var$generateTrees;

var $h1XVP = parcelRequire("h1XVP");

var $bCApz = parcelRequire("bCApz");

var $2tZQW = parcelRequire("2tZQW");

var $2ozwp = parcelRequire("2ozwp");
var $60b84f545edbe4c3$var$escapeFacetValue = $h1XVP.escapeFacetValue;
var $60b84f545edbe4c3$var$unescapeFacetValue = $h1XVP.unescapeFacetValue;
function $60b84f545edbe4c3$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $2tZQW(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $60b84f545edbe4c3$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $60b84f545edbe4c3$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $bCApz(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $60b84f545edbe4c3$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $2ozwp(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $60b84f545edbe4c3$var$format(facetCount, facetValue, hierarchicalSeparator, $60b84f545edbe4c3$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $60b84f545edbe4c3$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $60b84f545edbe4c3$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $60b84f545edbe4c3$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("67Dz9", function(module, exports) {
"use strict";

var $bCApz = parcelRequire("bCApz");

var $1SgAp = parcelRequire("1SgAp");
function $4752167f287e4392$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $4752167f287e4392$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $4752167f287e4392$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $bCApz($1SgAp(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
module.exports = $4752167f287e4392$var$sortAndMergeRecommendations;

});
parcelRegister("1SgAp", function(module, exports) {
// @MAJOR: remove this function and use Array.prototype.flat
module.exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};

});


parcelRegister("9GKin", function(module, exports) {
"use strict";
module.exports = "3.21.0";

});




parcelRegister("cr5Az", function(module, exports) {
$parcel$export(module.exports, "Result", function () { return (parcelRequire("5bIhp")).Result; });
parcelRequire("kxMYq");
parcelRequire("2G4Ap");
parcelRequire("5bIhp");

});
parcelRegister("5bIhp", function(module, exports) {

$parcel$export(module.exports, "Result", function () { return $91456ef71a6a52a2$export$8fdcabde73f49165; });
/* result.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $g9kzu = parcelRequire("g9kzu");

var $cRwVc = parcelRequire("cRwVc");
const $91456ef71a6a52a2$export$8fdcabde73f49165 = ({ index: index, title: title, description: description, href: href, objectId: objectId, queryId: queryId, onSearchLinkClick: onSearchLinkClick, isExperimentVariant: isExperimentVariant = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $g9kzu.useAnalyticsEvents)();
    const decodeHtml = (html)=>{
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const handleSearchResultClick = (objectId, index, linkUrl, queryId)=>{
        onSearchLinkClick(objectId, index);
        createAnalyticsEvent({
            eventName: "searchResult",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "searchResults",
            source: "searchPage",
            eventContainer: "searchResults",
            attributes: {
                product: "search",
                objectId: objectId,
                linkUrl: linkUrl,
                rank: index,
                queryId: queryId
            }
        }).fire();
    };
    const isNonVariantFirstResult = !isExperimentVariant && index === 0;
    const isNonVariantOtherResult = !isExperimentVariant && index !== 0;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            isExperimentVariant && "_1bsb1osq _1rjcf6fq _1ilv7vkz _133i1crf",
            isNonVariantFirstResult && "_1rjc1ul9 _1bsb1osq _133io7ao",
            isNonVariantOtherResult && "_1rjc1ul9 _1bsb1osq _mqm2k7bd _133io7ao"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                "data-testid": `result-id-${index}`,
                href: href,
                onClick: (event)=>{
                    const relativeUrlPath = href.split("https://www.atlassian.com")[1] || href;
                    handleSearchResultClick(objectId, index + 1, href, queryId);
                    event.preventDefault();
                    window.location.href = relativeUrlPath;
                },
                className: (0, $esG4f.default)([
                    isExperimentVariant && "_syaz17la _179rokh7 _1e0c1o8l _30l31ep1 _10531q5l _vlg11368",
                    !isExperimentVariant && "_syaz17la _179rokh7 _1e0c1o8l _15em3pt6 _1053cm6p _yoqs1a2i"
                ]),
                style: {
                    "--_1r6llbg": (0, $43MIc.default)((0, $cRwVc.default)("color.primary.blue")),
                    "--_1pjqntz": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.blue800")),
                    "--_jv9otz": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.purple800")),
                    "--_5re7s0": (0, $43MIc.default)((0, $cRwVc.default)("color.extended.purple900")),
                    "--_1fb7i9d": (0, $43MIc.default)((0, $cRwVc.default)("color.primary.purple"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    className: (0, $esG4f.default)([
                        isExperimentVariant && "_1mouidpf _1wyb1tcg _1cqsgktf _1bys1ou6",
                        !isExperimentVariant && "_1mouidpf _1wyb1k92 _1cqs1j6v"
                    ]),
                    children: decodeHtml(title)
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    isExperimentVariant && "_1e0c1ule _syaz18q9 _1wyb7vkz _vwz41tcg _1mou1ynf _1cqsdlk8 _1bysgktf",
                    !isExperimentVariant && "_1e0c1ule _syaz18q9 _1wybdlk8 _vwz4gktf _1mou1ynf"
                ]),
                style: {
                    "--_nmjf06": (0, $43MIc.default)((0, $cRwVc.default)("color.secondary.navy"))
                },
                children: decodeHtml(description)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    isExperimentVariant && "_1e0c1ule _syazmmjq _1wybdlk8 _vwz4gktf _slp31hna",
                    !isExperimentVariant && "_1e0c1ule _syazefi9 _1wyb1crf _vwz4gktf _sugaglyw"
                ]),
                style: {
                    "--_1ayut75": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.light500")),
                    "--_19aes6n": (0, $43MIc.default)((0, $cRwVc.default)("color.neutral.dark700"))
                },
                children: href
            })
        ]
    });
};
const $91456ef71a6a52a2$var$resultContainerCss = null;
const $91456ef71a6a52a2$var$resultContainerTopCss = null;
const $91456ef71a6a52a2$var$variantResultContainerCss = null;
const $91456ef71a6a52a2$var$resultLinkCss = null;
const $91456ef71a6a52a2$var$variantResultLinkCss = null;
const $91456ef71a6a52a2$var$variantResultLinkTextCss = null;
const $91456ef71a6a52a2$var$resultLinkTextCss = null;
const $91456ef71a6a52a2$var$variantResultDescriptionCss = null;
const $91456ef71a6a52a2$var$resultDescriptionCss = null;
const $91456ef71a6a52a2$var$variantResultUrlCss = null;
const $91456ef71a6a52a2$var$resultUrlCss = null;

});





//# sourceMappingURL=index.9779a505.js.map
